import baseDomain, {
  courseAssets,
  extraImage,
  homeAssets,
  nutriDiet,
} from '../../../assets/images/imageAsset'
import { iybCourse } from '../../../assets/images/imageAsset';
import BA_yoga_1 from '../../../../StaticSite/utils/images/BA_yoga_1.jpeg'
import deailsPage_3_ttc from '../images/deailsPage_3_ttc.jpg'
import card_ba from '../images/card_ba.jpg'
import Ma_New_card from '../images/MA_card.jpg'
import swadhyay from '../images/swadhyay.jpg'
import integral_chakra from '../images/integral_chakra.png'

import Emo_energy from '../images/Emo_energy.jpg'
import new_certificate_course from '../images/new_certificate_course.webp'
import level1 from '../images/level1.webp'


const ttc200hr = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: 'one-month-ttc',
    // templateId: 'COURSE200_1M_TTC',
    templateId: {
      templateOnline: 'COURSE200_1M_ONLINE_TTC',
      templateOffline: {
        templateResidential: 'COURSE200_RES_TTC',
        templateNonResidential: 'COURSE200_NONRES_TTC',
      },
    },
    weekDays: true,
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQ+Batch+01+BTTC.pdf",
    batch: 1,
    metaDescription:
      'Comprehensive training to build a strong foundation in yoga teaching.',
    image: `${baseDomain}${courseAssets.courseAsset38}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: true,
    rating: 5,
    colorCode: '#E38F73',

    timing: 'Monday to Saturday: 10:00 am - 6:00 pm (IST)',
    fees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 63000, nonResidentialFee: 34500 },
    },
    newFees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 63000, nonResidentialFee: 34500 },
    },
    clevertapData: {
      name: '200 hours Yoga TTC Batch - 1 english - 1 month',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    category: 'ttc',
    title: '200-Hours Basic Yoga Teacher Training Course – BTTC 1 Month (Batch 1 Online & On Campus - English)',
    dates: [

      // '1st Jan to 31st Jan 2024',
      // '1st Feb to 29th Feb 2024',
      // '1st Mar to 31st Mar 2024',
      // '1st Apr to 30th Apr 2024',
      // '1st May to 31st May 2024',
      // '1st Jun to 30th Jun 2024 ',
      // '1st Jul to 31st Jul 2024 ',
      // '1st Aug to 31st Aug 2024',
      // '1st Sep to 30th Sep 2024 ',
      // '1st Oct to 31st Oct 2024',
      // '2nd Nov to 30th Nov 2024',
      // '2nd Dec to 31st Dec 2024',
      // '1st Jan to 31st Jan 2025',
      // '1st Feb to 28th Feb 2025',
      // '1st Mar to 31st Mar 2025',
      // '1st Apr to 30th Apr 2025',
      // '1st May to 31st May 2025',
      // '2nd Jun to 30th Jun 2025',
      // '1st Jul to 31st Jul 2025',
      // '1st Aug to 30th Aug 2025',
      // '1st Sep to 30th Sep 2025',
      // '1st Oct to 31st Oct 2025',
      // '1st Nov to 29th Nov 2025',
      // '1st Dec to 31st Dec 2025',
      // '1st Jan to 31st Jan 2026',
      // '2nd February to 28th February 2026',
      // '2nd March to 31st March 2026',
      // '1st April to 30th April 2026',
      // '1st May to 31st May 2026',
      // '1st June to 30th June 2026',
      // '1st July to 31st July 2026',
      '1st August to 30th August 2026',
      '1st September to 30th September 2026',
      '1st October to 31st October 2026',
      '2nd November to 29th November 2026',
      '1st December to 31st December 2026'

    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: true,

    tenure: '1 month',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time: [
      '10:00 am - 6:00 pm (IST)'
    ],

    enrollInfo: {
      duration: "1 month",
      timings: [
        {
          day: "Monday to Saturday",
          time: "10:00 am - 6:00 pm (IST)"
        }
      ]
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: true,
      residentialMode: true
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 200) and YCB Level 1.',
            'The 200 Hour Yoga Teacher Training Course builds a strong foundation in Traditional Yoga, introducing students to Asanas, Pranayamas, basic Meditation, and the philosophy of Patanjali’s Yoga Sutra and Hatha Yoga Pradipika. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program serves as a first step into authentic yoga studies and personal transformation.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 200 Hour Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Build a solid foundation in Yogic philosophy, Yoga Asanas, Pranayama (Yogic Breathing) and meditation. This course helps you understand the science behind the practices while cultivating a foundation for spiritual life fostering strength, flexibility, and emotional resilience.',
              subItems: [],
            },
            {
              listItem:
                'Begin the inner journey of self-discipline, observation, and Yogic living. Learn how to carry yogic values into your daily routine, relationships, and lifestyle—leading to noticeable positive changes in all aspects of life.',
              subItems: [],
            },
            {
              listItem:
                'Gain the tools to guide Yoga Classes with clarity and compassion for healthy individuals. You’ll learn to hold space for others and share this transformative knowledge—opening up a meaningful and flexible teaching path anywhere in the world.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '200 hrs Batch 1 - One Month Yoga TTC (Online & On Campus – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Monday to Saturday: 10:00 am - 6:00 pm (IST)'],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'On Campus (non-Residential): Rs. 33,000/- (Inclusive of course fee, study material, lunch, and snacks).',
      //         subItems: [],
      //       },
      //        {
      //         listItem:
      //           'On Campus (residential): Rs. 60,000/- (Inclusive of course fee, study material, accommodation on triple occupancy basis and 4 meals a day).',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 29,000.',
              subItems: [],
            },
            {
              listItem:
                'On Campus (non-Residential): Rs. 34,500/- (Inclusive of course fee, study material, lunch, and snacks).',
              subItems: [],
            },
            {
              listItem:
                'On Campus (residential): Rs. 63,000/- (Inclusive of course fee, study material, accommodation on triple occupancy basis and 4 meals a day).',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
              subItems: [],
            },
            {
              listItem:
                'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
              subItems: [],
            },
            {
              listItem:
                'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Structure: 200-Hour Teacher Training Program',
          text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.']
        }
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course curriculum here:',
      //     url: 'https://drive.google.com/drive/folders/1X7Ij_bUK2V2lSCCxb0eMwYscOz78SvpC',
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Students are expected to attend all sessions during the one-month course. In case of an emergency, they may avail the attendance policy, which allows up to 3 days of leave for the entire course.',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
                'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
                'Qualified to register with Yoga Alliance (RYT 200)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'

              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On-Campus Final exams (both theory and practical’s) will be conducted on the last working day of each month, or as announced (in case of exigencies), between 10am (IST) and 2 pm IST.',
                'A Mock test will be held 7 -14 days prior to the course end date, to familiarise students with the exam process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },


    ],
    teaching: [

    ],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },

      {
        type: 'u-list',
        content: {
          title:
            'Our Amenities / Our Facilities',
          points: [
            {
              listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
              subItems: [],
            },
            {
              listItem:
                'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
              subItems: [],
            },
            {
              listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
              subItems: [],
            },
            {
              listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
              subItems: [],
            },
            {
              listItem:
                'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
              subItems: [],
            },
            {
              listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
            {
              listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
              subItems: [],
            },
            {
              listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
              subItems: [],
            },
            {
              listItem:
                'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
              subItems: [],
            },
            {
              listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
              subItems: [],
            },
            {
              listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
              subItems: [],
            },
            {
              listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
              subItems: [],
            },
            {
              listItem: 'Internet Room: Shared internet facility available for residential students.',
              subItems: [],
            },
          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "01 Month",
      mode: "Online & On Campus",
      language: "English",
      timing: "10:00 am - 6:00 pm (IST)",
      days: "Monday - Saturday",
      navigate: "/one-month-ttc",
    },
  },
  2: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: '200-hrs-part-time-ttc-on-campus-english',
    join: true,
    // templateId: 'COURSE200_1M_TTC2',
    templateId: {
      templateOnline: 'COURSE_200_HRS_ONLINE_CONFIRMATION_MAIL',
      templateOffline: {
        templateResidential: 'COURSE_200_HRS_RESIDENTIAL_CONFIRMATION_MAIL',
        templateNonResidential: 'COURSE_200_HRS_NONRESIDENTIAL_CONFIRMATION_MAIL',
      },
    },
    batch: 2,
    metaDescription: 'Comprehensive training to build a strong foundation in yoga teaching.',
    image: `${baseDomain}${courseAssets.courseAsset38}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#E38F73',
    timing: 'Monday to Friday : 12:00 noon - 4:00 pm (IST)',
    fees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 94500, nonResidentialFee: 34500 },
    },
    newFees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 94500, nonResidentialFee: 34500 },
    },
    category: 'ttc',
    title: '200-Hour Yoga Teacher Training Course - 2 Months Yoga TTC Online & On Campus - English - Batch 2',
    clevertapData: {
      name: '200 hours Yoga TTC Batch - 2 - english - 2 month',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQ+Batch+02+BTTC.pdf",
    dates: [
      // '12th Feb – 6th Apr 2024',
      // '15th Apr – 8th Jun 2024',
      // '10th Jun – 3rd Aug 2024',
      // '5th Aug – 28th Sep 2024',
      // '7th Oct – 30th Nov 2024',
      // '9th Dec – 1st Feb 2025',
      // '10th Feb - 5th Apr 2025',
      // '14th Apr - 7th Jun 2025',
      // '16th Jun - 9th Aug 2025',
      // '18th Aug - 11th Oct 2025',
      // '21st Oct - 13th Dec 2025',
      // '22nd Dec - 14th Feb 2026',
      // '27th Oct to 20th Dec 2025',
      // '29th Dec to 21st Feb 2026',
      // '23rd Feb to 18th Apr 2026',
      // '20th Apr to 13th Jun 2026',
      // '22nd Jun to 15th Aug 2026',
      '17th Aug to 10th Oct 2026',
      '12th Oct to 5th Dec 2026',
      '7th Dec to 30th Jan 2027'
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: true,
    certficate: false,

    tenure: '2 month',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Friday'
    ],
    time: [
      '12:00 noon - 4:00 pm (IST)'
    ],

    enrollInfo: {
      duration: "2 months",
      timings: [
        {
          day: "Monday to Friday",
          time: "12:00 noon - 4:00 pm (IST)"
        }
      ]
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: true,
      residentialMode: true
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 200) and YCB Level 1.',
            'The 200 Hour Yoga Teacher Training Course builds a strong foundation in Traditional Yoga, introducing students to Asanas, Pranayamas, basic Meditation, and the philosophy of Patanjali’s Yoga Sutra and Hatha Yoga Pradipika. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program serves as a first step into authentic yoga studies and personal transformation.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 200 Hour Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Build a solid foundation in Yogic philosophy, Yoga Asanas, Pranayama (Yogic Breathing) and meditation. This course helps you understand the science behind the practices while cultivating a foundation for spiritual life fostering strength, flexibility, and emotional resilience.',
              subItems: [],
            },
            {
              listItem:
                'Begin the inner journey of self-discipline, observation, and Yogic living. Learn how to carry yogic values into your daily routine, relationships, and lifestyle—leading to noticeable positive changes in all aspects of life.',
              subItems: [],
            },
            {
              listItem:
                'Gain the tools to guide Yoga Classes with clarity and compassion for healthy individuals. You’ll learn to hold space for others and share this transformative knowledge—opening up a meaningful and flexible teaching path anywhere in the world.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '200 hrs Batch 2 - Two Month Yoga TTC (Online & On Campus – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Monday to Friday: 12:00 pm - 4:00 pm (IST)'],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'On Campus (non-Residential): Rs. 33,000/- (Inclusive of course fee, study material, and snacks).',
      //         subItems: [],
      //       },
      //        {
      //         listItem:
      //           'On Campus (residential): Rs. 90,000/- (Inclusive of course fee, study material, accommodation on triple occupancy basis and 4 meals a day).',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 29,000.',
              subItems: [],
            },
            {
              listItem:
                'On Campus (non-Residential): Rs. 34,500/- (Inclusive of course fee, study material, and snacks).',
              subItems: [],
            },
            {
              listItem:
                'On Campus (residential): Rs. 94,500/- (Inclusive of course fee, study material, accommodation on triple occupancy basis and 4 meals a day).',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
              subItems: [],
            },
            {
              listItem:
                'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
              subItems: [],
            },
            {
              listItem:
                'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Structure: 200-Hour Teacher Training Program',
          text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Students are expected to attend all sessions during the two-months course. In case of an emergency, they may avail the attendance policy, which allows up to 6 days of leave for the entire course.',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
                'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
                'Qualified to register with Yoga Alliance (RYT 200)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'

              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: [
                'On Campus/ Online Final exams will be conducted on the 1st Sat and the 3rd Saturday of each month or as announced (in case of exigencies), subject to a minimum quorum of 8 students.',
                'A mock test will be conducted 7–14 days before the final exam, typically on a Saturday, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },


    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },

      {
        type: 'u-list',
        content: {
          title:
            'Our Amenities / Our Facilities',
          points: [
            {
              listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
              subItems: [],
            },
            {
              listItem:
                'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
              subItems: [],
            },
            {
              listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
              subItems: [],
            },
            {
              listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
              subItems: [],
            },
            {
              listItem:
                'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
              subItems: [],
            },
            {
              listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
            {
              listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
              subItems: [],
            },
            {
              listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
              subItems: [],
            },
            {
              listItem:
                'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
              subItems: [],
            },
            {
              listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
              subItems: [],
            },
            {
              listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
              subItems: [],
            },
            {
              listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
              subItems: [],
            },
            {
              listItem: 'Internet Room: Shared internet facility available for residential students.',
              subItems: [],
            },
          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "02 Months",
      mode: "Online & On Campus",
      language: "English",
      timing: "12:00 noon - 4:00 pm (IST)",
      days: "Monday - Friday",
      navigate: "/200-hrs-part-time-ttc-on-campus-english",
    },
  },
  3: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: '200-hrs-part-time-ttc-online-english',
    // templateId: 'COURSE200_2M_TTC2',
    templateId: {
      templateOnline: 'COURSE200_2M_ONLINE_TTC',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 3,
    metaDescription:
      'Comprehensive training to build a strong foundation in yoga teaching.',
    textDescription: 'You will see a marked improvement in your life, relationships and work.',
    image: `${baseDomain}${courseAssets.courseAsset38}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#E38F73',
    timing:
      'Monday to Saturday: Morning: 7:00 am - 8:30 am (IST) and Evening : 6:30 pm - 8:30 pm (IST) (Both the time slots are mandatory)',
    fees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQ+Batch+03+BTTC.pdf",
    category: 'ttc',
    title: '200-Hour Yoga Teacher Training Course - 2 Months Yoga TTC Online - English - Batch 3',
    clevertapData: {
      name: '200 hours Yoga TTC Batch - 3 - english - 2 month',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    dates: [
      // '8th Jan – 2nd Mar 2024',
      // '11th Mar – 4th May 2024',
      // '13th May – 6th Jul 2024',
      // '15th Jul – 7th Sep 2024',
      // '16th Sep – 9th Nov 2024',
      // '18th Nov – 11th Jan 2025',
      // '19th Feb - 8th Jun 2024',
      // '17th Jun - 5th Oct 2024',
      // '14th Oct - 1st Feb 2025',
      // '20th Jan - 15th Mar 2025',
      // '24th Mar - 17th May 2025',
      // '26th May - 19th Jul 2025',
      // '28th Jul - 20th Sep 2025',
      // '29th Sep - 22nd Nov 2025',
      // '25th Nov - 18th Jan 2026',
      // '6th Oct - 29th Nov 2025',
      //  '8th Dec to 31st Jan 2026',
      //  '16th Feb to 11th Apr 2026',
      //  '27th Apr to 20th Jun 2026',
      '6th Jul to 29th Aug 2026',
      '7th Sep to 31st Oct 2026',
      '16th Nov to 9th Jan 2027'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '2 month',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time:
      [
        'Morning: 7:00 am - 8:30 am (IST)',
        'Evening : 6:30 pm - 8:30 pm (IST)'
      ],

    enrollInfo: {
      duration: "2 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "Morning: 7:00 am - 8:30 am (IST)"
        },
        {
          day: "Monday to Saturday",
          time: "Evening : 6:30 pm - 8:30 pm (IST) "
        }
      ],
      message: "(Both the time slots are mandatory)",
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 200) and YCB Level 1.',
            'The 200 Hour Yoga Teacher Training Course builds a strong foundation in Traditional Yoga, introducing students to Asanas, Pranayamas, basic Meditation, and the philosophy of Patanjali’s Yoga Sutra and Hatha Yoga Pradipika. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program serves as a first step into authentic yoga studies and personal transformation.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 200 Hour Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Build a solid foundation in Yogic philosophy, Yoga Asanas, Pranayama (Yogic Breathing) and meditation. This course helps you understand the science behind the practices while cultivating a foundation for spiritual life fostering strength, flexibility, and emotional resilience.',
              subItems: [],
            },
            {
              listItem:
                'Begin the inner journey of self-discipline, observation, and Yogic living. Learn how to carry yogic values into your daily routine, relationships, and lifestyle—leading to noticeable positive changes in all aspects of life.',
              subItems: [],
            },
            {
              listItem:
                'Gain the tools to guide Yoga Classes with clarity and compassion for healthy individuals. You’ll learn to hold space for others and share this transformative knowledge—opening up a meaningful and flexible teaching path anywhere in the world.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '200 hrs Batch 3 - Two Month Yoga TTC (Online – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Monday to Saturday: Morning- 7:00 am to 8:30 am & Evening- 6:30 pm - 8:00 pm (IST) (Mandatory to attend both the slots)'],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500 (Inclusive of Course fee and Study material)',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 29,000 (Inclusive of Course fee and Study material)',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
              subItems: [],
            },
            {
              listItem:
                'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
              subItems: [],
            },
            {
              listItem:
                'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Structure: 200-Hour Teacher Training Program',
          text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Students are expected to attend all sessions during the two-months course. In case of an emergency, they may avail the attendance policy, which allows up to 6 days of leave for the entire course.',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
                'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
                'Qualified to register with Yoga Alliance (RYT 200)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'

              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Sat and the 3rd Saturday of each month or as announced (in case of exigencies), subject to a minimum quorum of 8 students.',
                'A mock test will be conducted 7–14 days before the final exam, typically on a Saturday, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "02 Months",
      mode: "Online",
      language: "English",
      timing: "Morning: 7:00am - 8:30am and Evening : 6:30pm - 8:30pm (IST)",
      days: "Monday - Saturday",
      navigate: "/200-hrs-part-time-ttc-online-english",
    },
  },
  4: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: '200-hrs-part-time-ttc-online',
    join: true,
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC+(2).pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQ+Batch+04+BTTC.pdf",
    // templateId: 'COURSE200_2M_TTC_HINDI',
    templateId: {
      templateOnline: 'COURSE200_2M_ONLINE_HINDI_TTC',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 4,
    metaDescription: 'Comprehensive training to build a strong foundation in yoga teaching.',
    image: `${baseDomain}${courseAssets.courseAsset38}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#E38F73',
    timing: 'Monday to Saturday: 1:00 pm - 4:30 pm (IST)',
    fees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'ttc',
    title: '200-Hour Yoga Teacher Training Course - 2 Months Yoga TTC Online - Hindi - Batch 4',
    clevertapData: {
      name: '200 hours Yoga TTC Batch - 4 - hindi - 2 month',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    dates: [
      // '15th Jan to 9th Mar 2024',
      // '18th Mar to 11th May 2024',
      // '20th May to 13th Jul 2024',
      // '22nd Jul to 14th Sep 2024',
      // '23rd Sep to 16th Nov 2024',
      // '14th Oct to 7th Dec 2024',
      // '25th Nov to 18th Jan 2025'
      // '17th Feb to 12th Apr 2025',
      // '5th May to 28th Jun 2025',
      // '7th Jul to 30th Aug 2025',
      // '6th Oct to 29th Nov 2025',
      // '3rd Nov to 27th Dec 2025',
      // '9th Mar to 2nd May 2026',
      '13th Jul to 5th Sept 2026',
      '14th Sep to 7th Nov 2026',
      '23rd Nov to 16th Jan 2027'

    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '2 month',
    courseType: '(RYT 200- Basic)',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time: [
      '1:00 pm - 4:30 pm (IST)'
    ],

    enrollInfo: {
      duration: "2 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "1:00 pm - 4:30 pm (IST)"
        },
      ],
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 200) and YCB Level 1.',
            'The 200 Hour Yoga Teacher Training Course builds a strong foundation in Traditional Yoga, introducing students to Asanas, Pranayamas, basic Meditation, and the philosophy of Patanjali’s Yoga Sutra and Hatha Yoga Pradipika. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program serves as a first step into authentic yoga studies and personal transformation.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 200 Hour Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Build a solid foundation in Yogic philosophy, Yoga Asanas, Pranayama (Yogic Breathing) and meditation. This course helps you understand the science behind the practices while cultivating a foundation for spiritual life fostering strength, flexibility, and emotional resilience.',
              subItems: [],
            },
            {
              listItem:
                'Begin the inner journey of self-discipline, observation, and Yogic living. Learn how to carry yogic values into your daily routine, relationships, and lifestyle—leading to noticeable positive changes in all aspects of life.',
              subItems: [],
            },
            {
              listItem:
                'Gain the tools to guide Yoga Classes with clarity and compassion for healthy individuals. You’ll learn to hold space for others and share this transformative knowledge—opening up a meaningful and flexible teaching path anywhere in the world.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '200 hrs Batch 4 - Two Month Yoga TTC (Online – Hindi)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Monday to Saturday: 1:00 pm - 4:30 pm (IST)'],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500 (Inclusive of Course fee and Study material)',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 29,000 (Inclusive of Course fee and Study material)',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
              subItems: [],
            },
            {
              listItem:
                'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
              subItems: [],
            },
            {
              listItem:
                'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Structure: 200-Hour Teacher Training Program',
          text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Students are expected to attend all sessions during the two-months course. In case of an emergency, they may avail the attendance policy, which allows up to 6 days of leave for the entire course.',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
                'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
                'Qualified to register with Yoga Alliance (RYT 200)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'

              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Sat and the 3rd Saturday of each month or as announced (in case of exigencies), subject to a minimum quorum of 8 students.',
                'A mock test will be conducted 7–14 days before the final exam, typically on a Saturday, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "02 Month",
      mode: "Online ",
      language: "Hindi",
      timing: "1:00 pm - 4:30 pm (IST)",
      days: "Monday - Saturday",
      navigate: "/200-hrs-part-time-ttc-online",
    },
  },
  5: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekends: true,
    key: 'weekend-teacher-training-course',
    weekDays: true,
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQ+BATCH+05+BTTC.pdf",
    // templateId: 'COURSE200_3M_TTC',
    templateId: {
      templateOnline: 'COURSE200_WEEKEND_TTC',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 5,
    metaDescription:
      'Comprehensive training to build a strong foundation in yoga teaching.',
    image: `${baseDomain}${courseAssets.courseAsset38}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: true,
    rating: 5,
    colorCode: '#E38F73',
    timing:
      'Saturday & Sunday: Saturday Sessions: 10:00 am – 8:30 pm (IST) and Sunday Sessions 10:00 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'ttc',
    title: '200-Hour Yoga Teacher Training Course - 3 Months Weekend Yoga TTC Online - English - Batch 5',
    clevertapData: {
      name: '200 hours Yoga TTC weekebd Batch - 5 - english - 3 month',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    dates: [
      // '20th Jan to 7th Apr 2024',
      // '13th Apr to 30th Jun 2024',
      // '6th Jul to 22nd Sep 2024',
      // '28th Sep to 15th Dec 2024 ',
      // '5th Oct to 22nd Dec 2024 ',
      // "22nd Mar to 8th Jun 2025",
      // "14th Jun to 31st Aug 2025",
      // "6th Sep to 23rd Nov 2025",
      // "29th Nov to 15th Feb 2026",
      // '28th Feb to 17th May 2026',
      // '23rd May 2026 to 9th Aug 2026',
      '29th Aug to 15th Nov 2026',
      '28th Nov to 14th Feb 2027'
      // '15th Mar to 1st Jun 2025',
      // '7th Jun to 24th Aug 2025',
      // '30th Aug to 16th Nov 2025',
      // '22nd Nov to 8th Feb 2026'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '3 month',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      'Saturday Sessions: 10:00 am – 8:30 pm (IST)',
      'Sunday Sessions 10:00 am – 1:30 pm (IST)'
    ],

    enrollInfo: {
      duration: "3 months",
      timings: [
        {
          day: "Saturday & Sunday",
          time: "Saturday Sessions: 10:00 am – 8:30 pm (IST)"
        },
        {
          day: "Saturday & Sunday",
          time: "Sunday Sessions 10:00 am – 1:30 pm (IST)"
        }
      ]
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 200) and YCB Level 1.',
            'The 200 Hour Yoga Teacher Training Course builds a strong foundation in Traditional Yoga, introducing students to Asanas, Pranayamas, basic Meditation, and the philosophy of Patanjali’s Yoga Sutra and Hatha Yoga Pradipika. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program serves as a first step into authentic yoga studies and personal transformation.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 200 Hour Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Build a solid foundation in Yogic philosophy, Yoga Asanas, Pranayama (Yogic Breathing) and meditation. This course helps you understand the science behind the practices while cultivating a foundation for spiritual life fostering strength, flexibility, and emotional resilience.',
              subItems: [],
            },
            {
              listItem:
                'Begin the inner journey of self-discipline, observation, and Yogic living. Learn how to carry yogic values into your daily routine, relationships, and lifestyle—leading to noticeable positive changes in all aspects of life.',
              subItems: [],
            },
            {
              listItem:
                'Gain the tools to guide Yoga Classes with clarity and compassion for healthy individuals. You’ll learn to hold space for others and share this transformative knowledge—opening up a meaningful and flexible teaching path anywhere in the world.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '200 hrs Batch 5 - Three Month Yoga TTC (Online – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Saturday & Sunday: Saturday: 10:00 am - 8:30 pm (IST) & Sunday: 10:00 am - 1:30 pm (IST)'],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500 (Inclusive of Course fee and Study material)',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 29,000 (Inclusive of Course fee and Study material)',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
              subItems: [],
            },
            {
              listItem:
                'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
              subItems: [],
            },
            {
              listItem:
                'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Structure: 200-Hour Teacher Training Program',
          text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Students are expected to attend all sessions during the three-months course. In case of an emergency, they may avail the attendance policy, which allows up to 6 days of leave for the entire course.',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
                'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
                'Qualified to register with Yoga Alliance (RYT 200)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'

              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Sat and the 3rd Saturday of each month or as announced (in case of exigencies), subject to a minimum quorum of 8 students.',
                'A mock test will be conducted 7–14 days before the final exam, typically on a Saturday, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "03 Months",
      mode: "Online",
      language: "English",
      timing: "Saturday: 10:00 am – 8:30 pm (IST) and Sunday: 10:00 am – 1:30 pm (IST)",
      days: "Saturday & Sunday",
      navigate: "/weekend-teacher-training-course",
    },
  },
  6: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: '200-hrs-part-time-ttc-online-batch-6',
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQ+BATCH+06+BTTC.pdf",
    // templateId: 'COURSE200_2M_TTC2',
    templateId: {
      templateOnline: 'COURSE200_2M_ONLINE_TTC_BATCH_6',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 6,
    metaDescription:
      'Comprehensive training to build a strong foundation in yoga teaching.',
    textDescription: 'You will see a marked improvement in your life, relationships and work.',
    image: `${baseDomain}${courseAssets.courseAsset38}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#E38F73',
    timing:
      'Monday to Saturday 5:00 am to 7:30 am (IST)',
    fees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 29000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'ttc',
    title: '200-Hour Yoga Teacher Training Course - 3 Months Yoga TTC Online - English - Batch 6',
    clevertapData: {
      name: '200 hours Yoga TTC Batch - 6- english - 2 month',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    dates: [
      // '8th Jan – 2nd Mar 2024',
      // '11th Mar – 4th May 2024',
      // '13th May – 6th Jul 2024',
      // '15th Jul – 7th Sep 2024',
      // '16th Sep – 9th Nov 2024',
      // '18th Nov – 11th Jan 2025',
      // '19th Feb - 8th Jun 2024',
      // '17th Jun - 5th Oct 2024',
      // '14th Oct - 1st Feb 2025',
      // '20th Jan - 15th Mar 2025',
      // '24th Mar - 17th May 2025',
      // '26th May - 19th Jul 2025',
      // '28th Jul - 20th Sep 2025',
      // '29th Sep - 22nd Nov 2025',
      // '19th May - 9th August 2025',
      // '9th Jun  - 30th August 2025'
      // '8th Sept to 29th Nov',
      // '8th Dec to 28th Feb 2026',
      // '16th Mar to 6th Jun 2026',
      // '15th Jun to 5th Sept 2026',
      '14th Sep to 5th Dec 2026',
      '14th Dec to 6th Mar 2027'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '3 month',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time:
      [
        '5:00 am to 7:30 am (IST)',

      ],

    enrollInfo: {
      duration: "3 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "5:00 am to 7:30 am"
        },
        // {
        //   day: "Monday to Saturday",
        //   time: "Evening : 6:30 pm - 8:30 pm (IST) "
        // }
      ],
      message: "(Both the time slots are mandatory)",
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 200) and YCB Level 1.',
            'The 200 Hour Yoga Teacher Training Course builds a strong foundation in Traditional Yoga, introducing students to Asanas, Pranayamas, basic Meditation, and the philosophy of Patanjali’s Yoga Sutra and Hatha Yoga Pradipika. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program serves as a first step into authentic yoga studies and personal transformation.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 200 Hour Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Build a solid foundation in Yogic philosophy, Yoga Asanas, Pranayama (Yogic Breathing) and meditation. This course helps you understand the science behind the practices while cultivating a foundation for spiritual life fostering strength, flexibility, and emotional resilience.',
              subItems: [],
            },
            {
              listItem:
                'Begin the inner journey of self-discipline, observation, and Yogic living. Learn how to carry yogic values into your daily routine, relationships, and lifestyle—leading to noticeable positive changes in all aspects of life.',
              subItems: [],
            },
            {
              listItem:
                'Gain the tools to guide Yoga Classes with clarity and compassion for healthy individuals. You’ll learn to hold space for others and share this transformative knowledge—opening up a meaningful and flexible teaching path anywhere in the world.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '200-Hour Yoga Teacher Training Online Course - 3 Months TTC Online - English - Batch 6',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Monday to Saturday: 5:00 am - 7:30 am (IST)'],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500 (Inclusive of Course fee and Study material)',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 29,000 (Inclusive of Course fee and Study material)',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
              subItems: [],
            },
            {
              listItem:
                'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
              subItems: [],
            },
            {
              listItem:
                'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Structure: 200-Hour Teacher Training Program',
          text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Students are expected to attend all sessions during the three-months course. In case of an emergency, they may avail the attendance policy, which allows up to 6 days of leave for the entire course.',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
                'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
                'Qualified to register with Yoga Alliance (RYT 200)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'

              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Sat and the 3rd Saturday of each month or as announced (in case of exigencies), subject to a minimum quorum of 8 students.',
                'A mock test will be conducted 7–14 days before the final exam, typically on a Saturday, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },



    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },

    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "03 Months",
      mode: "Online",
      language: "English",
      timing: "5:00 am to 7:30 am (IST)",
      days: "Monday - Saturday",
      navigate: "/200-hrs-part-time-ttc-online-batch-6",
    },
  },
  // 6: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   key: '200-hrs-part-time-ttc-online-english-batch-6',
  //   // templateId: 'COURSE200_2M_TTC',
  //   templateId: {
  //     templateOnline: 'COURSE200_2M_ONLINE_TTC_BATCH5',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   batch: 6,
  //   metaDescription:
  //     'You will learn the tools to master your physical, mental and spiritual well-being. You will see a marked improvement in your life, relationships and work.',
  //   image: `${baseDomain}${courseAssets.courseAsset38}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset101}`,
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#E38F73',
  //   timing: 'Monday to Saturday: 4:30 pm – 8:00 pm (IST)',
  //   fees: {
  //     onlineFee: 27500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'ttc',
  //   title: '200 Hours Yoga TTC - 2 Months Online Yoga Teacher Training Course - English - Batch 6 ',
  //   dates: [
  //     // '29th July to 21st September 2024',
  //     '2nd Dec to 25th Jan 2025',
  //     '3rd Feb to 29th Mar 2025',
  //     '7th Apr to 31st May 2025',
  //     '9th Jun to 2nd Aug 2025',
  //     '11th Aug to 4th Oct 2025',
  //     '13th Oct to 6th Dec 2025',
  //     '15th Dec to 7th Feb 2026',
  //   ],
  //   online: true,
  //   onCampus: false,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,

  //   tenure: '2 month',
  //   courseType: '(RYT 200- Basic)',
  //   language: 'English',
  //   preRequisite: 'None',
  //   courseCategory: 'Educational',
  //   courseSubType: '200 Hour Yoga Teacher Training',
  //   newName: '200 Hours - Basic Yoga Teacher Training Course (YTTC)',
  //   days: [
  //     'Monday to Saturday'
  //   ],
  //   time: [
  //     '4:30 pm – 8:00 pm (IST)'
  //   ],

  //   enrollInfo: {
  //     duration: "2 months",
  //     timings: [
  //       {
  //         day: "Monday to Saturday",
  //         time: "4:30 pm – 8:00 pm (IST)"
  //       }
  //     ]
  //   },

  //   courseCertificate: 'TTC/Certificate',
  //   onlineInfo: {
  //     courseMode: true,
  //   },
  //   residentialInfo: {
  //     courseMode: false,
  //     residentialMode: false
  //   },
  //   nonResidentialInfo: {
  //     courseMode: false,
  //     nonResidentialMode: false
  //   },


  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'With over 1,00,000 successfully certified students, the 200 Hours Online Yoga Teacher Training Course at The Yoga Institute covers the nuances of Traditional Yoga. This includes an introduction to the study of principal Yoga Asanas, Pranayamas, Meditation, Kriyas, Patanjali’s Yoga Sutra, and Hatha Yoga Pradipika. Further, complete immersion into practical experiences of the concept studies, public speaking, the methodology of teaching, etc. are covered. Strategically designed by the founder Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J Yogendra, the Online Teacher Training Course  serves as a valuable‘ life school’ to those seeking balance and fulfilment in life.'
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Benefits of 200 Hours Online Yoga Teacher Training Course',
  //         points: [
  //           {
  //             listItem:
  //               'You will learn the tools to master your physical, mental and spiritual well-being. You will see a marked improvement in your life, relationships and work.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'A new career avenue opens up for you where you can pass on the knowledge to others and facilitate their wellness journeys. The art of Yoga is something you can teach anywhere, no matter where you are.',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Course',
  //         text: ['200 hrs Yoga TTC Batch 6 - 2 Months TTC Online - English'],
  //       },
  //     },
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'Duration',
  //     //     text: [],
  //     //   },
  //     // },
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'Date',
  //     //     text: [''],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Timings',
  //         text: ['Monday to Saturday: 4:30 pm – 8:00 pm (IST)'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['Rs. 27,500/-'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Prerequisites',
  //         text: ['None'],
  //       },
  //     },
  //   ],
  //   curriculum: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Online Yoga Teacher Training Course Curriculum',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'A – KNOWLEDGE',
  //         points: [
  //           {
  //             listItem: 'Introduction to Yoga and Yogic Practices.',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Introduction to Hatha Yoga.',
  //             subItems: [
  //               'Introduction to important Hatha Yoga Texts with special reference to Hatha Yoga Pradipika.',
  //             ],
  //           },
  //           {
  //             listItem: 'Introduction to Patanjali Yoga Sutras.',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Bhavas of the Buddhi – Basis of Yoga Education.',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Introduction to Anatomy and Physiology.',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Introduction to Human Systems, Yoga and Health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Yoga for wellness – prevention and promotion of positive health',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Yoga and stress management.',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'B-SKILL',
  //         points: [
  //           {
  //             listItem: 'Sahajbhava Asanas',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Shat Karmas',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Surya Namaskar (Sun Salutation)',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Yoga Asanas',
  //             subItems: [
  //               'Knowledge of selected postures and demonstrated ability to perform these postures – meditative and cultural (dynamic and static versions).',
  //               'Selected psychophysical and conceptual techniques pioneered by The Yoga Institute.',
  //             ],
  //           },
  //           {
  //             listItem: 'Pranayamas',
  //             subItems: [
  //               'Knowledge, teaching, and demonstrated ability to select Pranayamas.',
  //             ],
  //           },
  //           {
  //             listItem: 'Practices leading to Yoga Meditation',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Communication and Teaching Practice',
  //             subItems: [
  //               'Understanding and practice of basic skills of public speaking.',
  //               'Familiarity and demonstration ability to apply teaching methods.',
  //               'Adapt the above to unique styles of learning.',
  //               'Provide supportive and effective feedback.',
  //               'Acknowledge the aspirant’s progress and ability to cope with difficulties.',
  //             ],
  //           },
  //           {
  //             listItem: 'Principles and skills for working with groups.',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'url',
  //       content: {
  //         text: 'Access the detailed curriculum here:',
  //         url: 'https://ecom-static-site-prod.s3.ap-south-1.amazonaws.com/courses_pdf/200hr.pdf',
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Course Attendance Criteria',
  //         points: [
  //           {
  //             listItem:
  //               'A yoga student is required to have a minimum 80% attendance',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'After qualifying the attendance criteria, students can appear for the exam (100 marks). Details below:',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'table',
  //       content: {
  //         title: '',
  //         tableHeading: ['Details', 'Marks', 'Minimum Score Req.'],
  //         tableData: [['Theory Component', '50', '50%']],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'On successfully passing the exam, students will be .',
  //         points: [
  //           {
  //             listItem: 'Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute',
  //             subItems: []
  //           },
  //           {
  //             listItem: 'Qualified by Yoga Certification Board (AYUSH Level-1)',
  //             subItems: []
  //           },
  //           {
  //             listItem: 'Eligible to apply with Yoga Alliance USA (RYT 200)',
  //             subItems: []
  //           }
  //         ]
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title:
  //           'Post qualification, a number of opportunities are open to you, like:',
  //         points: [
  //           {
  //             listItem: 'Working with schools and teaching children',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Opening your own yoga center for healthy adults and children',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Working with corporates for their wellness programs',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Personal yoga coaching',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Exam Details',
  //         text: [],
  //       }
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title:
  //           '',
  //         points: [
  //           {
  //             listItem: 'Students will be eligible to appear for the Final certification exams only if they have completed all the required course submissions, class work and the required attendance',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Students will have to appear for the final exams within 60 days from the course end date.',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
  //             subItems: ['In the 2nd attempt, they will be exempted from either theory or practical’s, if they have cleared it in their 1st attempt.',
  //               'They will have to appear for both in case of a 3rd attempt.'
  //             ],
  //           },
  //           {
  //             listItem: 'Examiners will evaluate students only as per the final approved list.',
  //             subItems: [],
  //           },


  //         ],

  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'All Exams / tests will be conducted online.',
  //         points: [
  //           {
  //             listItem: 'Students, after submission, can log out only with the explicit permission of the examiner.',
  //             subItems: [
  //               'For practical’s - students will have to wait till the exams of all students are completed.',
  //               'The examiner may call out students at random and not necessarily in alphabetic order'
  //             ],
  //           },

  //         ],
  //       }
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Exam Schedule ',
  //         points: [
  //           {
  //             listItem: 'Final exams will be conducted online on the 1st Sat and the 3rd Sat of each month or as announced (in case of exigencies), subject to a quorum of 8 students.',
  //             subItems: [
  //               'Theory exams will be conducted online at 5pm (IST)',
  //               'Practical exams will be conducted at 3.30 pm (IST) / 6.30 pm (IST), subject to quorum.'
  //             ],
  //           },
  //           {
  //             listItem: 'A Mock test will be held 7 -14 days prior to the course end date, to familiarise students with the exam process.',
  //             subItems: [

  //             ],
  //           },

  //         ],
  //       }
  //     }
  //   ],
  //   teaching: [
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Course Attendance Criteria',
  //         points: [
  //           {
  //             listItem:
  //               'A student is required to have a minimum 80% attendance',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'After qualifying the attendance criteria, students can appear for the exam (100 marks). Details below:',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'table',
  //       content: {
  //         title: '',
  //         tableHeading: ['Details', 'Marks', 'Minimum Score Req.'],
  //         tableData: [['Theory Component', '50', '50%']],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'On successfully passing the exam, students will be awarded a certificate – Basic Teacher Training Certificate (200 hours) by The Yoga Institute, which is recognized by Yoga Certification Board (AYUSH Level-1) and Yoga Alliance USA (RYT 200).',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title:
  //           'Post qualification, a number of opportunities are open to you, like:',
  //         points: [
  //           {
  //             listItem: 'Working with schools and teaching children',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Opening your own yoga center for healthy adults and children',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Working with corporates for their wellness programs',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Personal yoga coaching',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //   ],
  //   offerings: [
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: '',
  //         points: [
  //           {
  //             listItem:
  //               'You will have an opportunity to directly interact with spiritual Guru Dr. Hansaji Yogendra. She is available to attend to your queries and give counsel.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Our expert trainers for the TTC Course, over 40 in number, have mastered the yogic way of life and are proficient in passing on their learnings in a simple and practical way. Armed with decades of experience, they offer tremendous value and insight to new learners.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Apart from the main yoga curriculum, you will learn immensely from the class experience itself. You will meet people with diverse backgrounds and experiences that you can gain insights from. There will be sadhakas of all age groups – right from teenagers to senior citizens. Every person has had a unique experience in life and it will be enriching to know all these stories.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'quote',
  //       content: {
  //         title: '',
  //         text: [
  //           'This is an exclusive experience, and the wisdom you gain here will guide you all your life!',
  //         ],
  //       },
  //     },
  //   ],
  //   regsitraion: [],
  //   faq: [],
  //   moreInfo: {
  //     duration: "02 Months",
  //     mode: "Online",
  //     language: "English",
  //     timing: "4:30pm – 8:00pm (IST)",
  //     days: "Monday - Saturday",
  //     navigate: "/200-hrs-part-time-ttc-online-english-batch-6",
  //   },
  // },
}

const ttc500hr = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekDays: true,
    key: '500-hrs-online-yoga-teacher-training-course-intermediate-level',
    // templateId: 'COURSE500_3M_TTC',
    templateId: {
      templateOnline: 'COURSE500_3M_ON_TTC',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 1,
    faqurl: 'https://nispand.s3.ap-south-1.amazonaws.com/FAQ+ITTC.pdf',
    metaDescription:
      'Advanced training, deepen practice with in-depth teaching skills.',
    mostPopular: true,
    rating: 5,
    colorCode: '#D88068',
    timing:
      'Monday to Saturday: Morning: 7:00 am - 8:30 am (IST) and Evening: 4:30 pm - 8:30 pm (IST) (Both time slots are mandatory)',
    fees: {
      onlineFee: 44000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 44000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'ttc',
    title: '500 Hours Intermediate Yoga Teacher Training Course – ITTC 3 Months (Online – English)',
    clevertapData: {
      name: '500 hours Yoga TTC - english - 3 month',
      courseType: 'TTC',
      courseSubType: '500 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: 'Intermediate TTC (500 Hour Courses)',
      coursePreRequisite: ''
    },
    curriculumUrl: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+ITTC.pdf',
    image: `${deailsPage_3_ttc}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/500-Hour+Yoga+Teacher+Training+Online+Course+-+3+Months+Yoga+TTC+-+English.jpg`,
    dates: [
      // '12th Feb  - 4th May 2024',
      // '13th May - 3rd Aug 2024',
      // '12th Aug - 2nd Nov 2024',
      // '11th Nov - 1st Feb 2025',
      // '17th Feb - 10th May 2025',
      // '19th May - 9th Aug 2025',
      // '18th Aug - 8th Nov 2025',
      // '17th Nov to 7th  Feb 2026',
      // '16th Feb to 9th May 2026',
      // '18th May to 8th Aug 2026',
      '17th Aug to 7th Nov 2026',
      '16th Nov to 6th  Feb 2027',

    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '3 month',
    courseType: 'Intermediate TTC (500 Hour Courses)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '500 Hour Yoga Teacher Training',
    newName: '500 Hours - Intemediate Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time: [
      'Morning: 7:00 am - 8:30 am (IST)',
      'Evening: 4:30 pm - 8:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "3 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "Morning: 7:00 am - 8:30 am (IST)"
        },
        {
          day: "Monday to Saturday",
          time: "Evening: 4:30 pm - 8:30 pm (IST)"
        },
      ],
      message: "(Both time slots are mandatory)"
    },
    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 500) and YCB Level 2.',
            'The 500 Hour Yoga Teacher Training Course deepens knowledge and practice with a comprehensive study of Asanas, Pranayamas, Kriyas, and Meditation techniques. Students engage in a broader exploration of Yoga philosophy, develop teaching methodology, and learn to integrate yogic principles into everyday life. With guidance from Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, this program strengthens both personal discipline and teaching confidence.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 500 Hour three months Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Strengthen your personal practice and teaching foundation with a deeper understanding of Yoga Asanas, Pranayama, Kriyas, and meditation techniques.',
              subItems: [],
            },
            {
              listItem:
                'Expand your understanding of Yoga philosophy by exploring important texts and core concepts that offer guidance for both personal growth and teaching.',
              subItems: [],
            },
            {
              listItem:
                'Build confidence to teach by guiding mixed-level groups, giving safe variations, and handling common student challenges.',
              subItems: [],
            },
            {
              listItem:
                'Learn to design balanced sessions and programs with posture, breath, relaxation, and meditation.',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '500 hrs – 3 Months Yoga ITTC (Online – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Timings',
          points: [
            {
              listItem:
                'Monday to Saturday: Morning Slot: 7:00 am to 8:30 am (IST) and Evening Slot: 4:30 pm to 8:30 pm (IST) (Both time slots are mandatory)',
              subItems: [],
            },
            {
              listItem:
                'Additional Engagements: On certain Sundays, students will be required to participate in scheduled activities or sessions.',
              subItems: [],
            },

          ],
        },
      },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'INR 40,000',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'INR 44,000',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Minimum age requirement: 18 years.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Mode of Learning',
          text: ['ONLINE: All classes to be attended online.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Ideal for becoming a Yoga Teacher with expansive skills and reach a wider, more diverse audience',
              subItems: [],
            },
            {
              listItem:
                'Enables you to teach school children, adults, corporates, and individuals with minor health conditions.',
              subItems: [],
            },
            {
              listItem:
                'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while leading sessions for school children, adults, corporates, individuals with minor ailments, and wellness communities. You can also conduct small group classes, one-on-one sessions, workshops, and outreach programs, with work opportunities in schools, corporates, NGOs, and wellness environments.',
              subItems: [],
            },
            {
              listItem:
                'Deepens understanding of classical texts, supporting students’ inner growth.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'A student is required to have a minimum 80% attendance.',
              subItems: [],
            },
            {
              listItem: 'Completing assignments as given (submissions & presentations).',
              subItems: [],
            },
            {
              listItem: 'Program Structure – 500 Hours:',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['This comprehensive 500-hour Teacher Training Course is thoughtfully structured to provide a balanced and immersive learning experience.']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Classroom Engagement: Approximately 420 hours are dedicated to in-depth classroom interaction. This includes lectures, guided practice, discussions, and hands-on learning facilitated by experienced faculty.',
              subItems: [],
            },
            {
              listItem: 'Experiential Learning: The remaining hours are thoughtfully allocated to assignments, camps, reach out initiatives, practical sessions, exposure visits, and other structured activities that promote real-world application, self-reflection, and integrated learning.',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required pre requisites, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Intermediate Yoga Teacher Training Certificate (500 hours) by The Yoga Institute.',
                'Conforming to the YCB cert level 2',
                'Qualified to register with Yoga Alliance (RYT 500)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will be eligible to appear for the Final exams only if they have completed all the required course submissions, class work and the required attendance.',
                'Students will have to appear for the final exams within 90 days from the course completion date.',

                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt. ',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },



              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['Online final exams will be held on designated Fridays.',
                'A mock test will be conducted 7/10 days before the final exams.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
}

const ttc900hr = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekDays: true,
    key: '3-months-advanced-teacher-training-course',
    curriculumUrl: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+3M+ATTC+.pdf',
    faqurl: 'https://nispand.s3.ap-south-1.amazonaws.com/FAQ+3M+ATTC.pdf',
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'COURSE900_3M_ONLINE_NONRES_TTC',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 1,

    metaDescription:
      'Master-level training to achieve profound expertise in yoga & teaching.',
    title: '900 Hours Advanced Yoga Teacher Training Course – ATTC 3 Months (On Campus – English)',

    image: `${baseDomain}${courseAssets.courseAsset40}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/900hrs_246+X+135.jpg`,

    mostPopular: false,
    rating: 5,

    colorCode: '#C9705F',
    timing: 'Monday to Saturday: 6:30 am to 8:00 pm.',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 199500, nonResidentialFee: 110000 },
    },
    newFees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 199500, nonResidentialFee: 110000 },
    },
    category: 'ttc',
    clevertapData: {
      name: '900 hours Yoga TTC - english - 3 month',
      courseType: 'TTC',
      courseSubType: '900 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: 'Advance TTC (900 Hour Courses)',
      coursePreRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course'
    },
    dates: [
      // '27th Jan to 21st Apr 2024',
      // '27th Apr to 21st Jul 2024',
      // '27th Jul to 20th Oct 2024',
      // '26th Oct to 20th Jan 2025',
      // '25th Jan to 20th Apr 2025',
      // '26th Apr to 20th Jul 2025',
      // '26th Jul to 19th Oct 2025',
      // '25th Oct to 18th Jan 2026',
      // '24th Jan to 19th April 2026',
      // '25th April to 19th July 2026',
      '25th July to 18th Oct 2026',
      '24th Oct to 17th Jan 2027',

    ],
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: true,
    certficate: false,

    tenure: '3 month',
    courseType: 'Advance TTC (900 Hour Courses)',
    language: 'English',
    preRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course',
    courseCategory: 'Educational',
    courseSubType: '900 Hour Yoga Teacher Training',
    newName: '900 Hours - Advanced Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time: [
      '6:30 am to 8:00 pm'
    ],
    enrollInfo: {
      duration: "3 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "6:30 am to 8:00 pm"
        }
      ],
      message: "Holiday on all Sundays"
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: true,
      residentialMode: true
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 500) and YCB Level 3.',
            'The 900 Hour Advanced Yoga Teacher Training Course offers profound mastery over Traditional Yoga. It emphasizes precision in practice, advanced Kriyas, in-depth study of scriptures, and experiential learning of Yoga as a way of life. Complete immersion into teaching, public speaking, and life-school training makes this course a transformative journey. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, it shapes dedicated practitioners into confident ambassadors of Yoga worldwide.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 900 Hour Three Months Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Immersive training to deepen spiritual growth through asanas, pranayama, kriyas, dharana, dhyana, and classical texts.',
              subItems: [],
            },
            {
              listItem:
                'Gain a clear, grounded understanding of Yoga philosophy, making it easier to apply its teachings in life and teaching.',
              subItems: [],
            },
            {
              listItem:
                'Learn how to guide others with confidence, compassion, and humility. You’ll be equipped to hold space for growth and healing, offer thoughtful guidance, and design long-term programs that truly support your students.',
              subItems: [],
            },
            {
              listItem:
                'Go beyond techniques to live Yoga fully, developing into an authentic teacher with clarity and care.',
              subItems: [],
            },
            {
              listItem:
                'A unique 900-hour course offering a deep, structured path for serious practitioners to teach from true experience.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '900 hrs – Three Months Yoga ATTC (On Campus – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Timings',
          points: [
            {
              listItem:
                'Class Timings: Monday to Saturday, 6:30 am – 8:00 pm (IST)',
              subItems: [],
            },
            {
              listItem:
                'Additional Engagements: On certain Sundays, students will be required to participate in scheduled activities or sessions.',
              subItems: [],
            },

          ],
        },
      },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'On Campus (non-residential): INR 1,10,000/- (Inclusive of course fee, study material, 4 meals a day and 7 Days Health Camp)',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'On Campus (residential): INR 1,90,000/- (Inclusive of course fee, study material, accommodation on triple occupancy basis, 4 meals a day and 7 Days Health Camp',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'On Campus (non-residential): INR 1,10,000/- (Inclusive of course fee, study material, 4 meals a day and 7 Days Health Camp)',
              subItems: [],
            },
            {
              listItem:
                'On Campus (residential): INR 1,99,500/- (Inclusive of course fee, study material, accommodation on triple occupancy basis, 4 meals a day and 7 Days Health Camp',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Completion of any ONE below basic course (undertaken at The Yoga Institute only): '],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '7-days Health Camp.',
              subItems: [],
            },
            {
              listItem:
                '200-hour TTC.',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Mode of Learning',
          text: ['ONCAMPUS: All classes to be attended on campus.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Ideal to become a Yoga Teacher who can help students manage health conditions like diabetes, hypertension, and back pain, while offering spiritual guidance for overall well-being.',
              subItems: [],
            },
            {
              listItem:
                'Specialize in yoga sessions for health management and spiritual growth, with opportunities to work in clinics, hospitals, rehabilitation centres, and integrative health setups. Evolve into a yoga-based health consultant, TTC faculty, or wellness program designer.',
              subItems: [],
            },
            {
              listItem:
                'Perfect for establishing a specialized yoga studio with advanced Yoga classes focused on managing health conditions, in-dept Yoga Asana classes and providing tailored Yoga classes for individual needs.',
              subItems: [],
            },
            {
              listItem:
                'Empowers you to integrate yogic philosophy into healing practices, providing profound spiritual guidance and support.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'A student is required to have a minimum 80% attendance.',
              subItems: [],
            },
            {
              listItem: 'Completing assignments as given (submissions & presentations).',
              subItems: [],
            },
            {
              listItem: 'Program Structure-900 Hours: ',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['This comprehensive 900-hour Teacher Training Course is thoughtfully structured to provide a balanced and immersive learning experience.']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Classroom Engagement: Approximately 550 hours are dedicated to in-depth classroom interaction. This includes lectures, guided practice, discussions, and hands-on learning facilitated by experienced faculty.',
              subItems: [],
            },
            {
              listItem: 'Experiential Learning: The remaining hours are thoughtfully allocated to assignments, camps, reach out initiatives, practical sessions, exposure visits, and other structured activities that promote real-world application, self-reflection, and integrated learning.',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'table',

        content: {
          title: '',

          tableHeading: [],

          tableData: [
            [
              'Guided Learning Sessions & Orientation Programs',

              '550 hours',
            ],

            [
              'Applied Practice through Wellness Camps & Initiatives',

              '135 hours',
            ],

            [
              'Self-directed Study, Coursework & Assessments',

              '225 hours',
            ],

            ['Total Program Engagement', '910 hours'],
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required pre requisites, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Advanced Yoga Teacher Training Certificate (900 hours) by The Yoga Institute.',
                'Qualified by Yoga Certification Board (AYUSH Level-3)',
                'Eligible to apply with Yoga Alliance USA (RYT 500)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will be eligible to appear for the Final exams only if they have completed all the required course submissions, class work and the required attendance.',
                'Students will have to appear for the final exams within 60 days from the course completion date.',

                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt. ',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },



              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final Exams will be conducted on the 3rd Thursday of the month in Jan, April, July and Oct.',
                'A mock test will be conducted to familiarize students with the examination process.',
                'The examination dates/timings will be announced in advance by the course coordinator in the class.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 40 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },

      {
        type: 'u-list',
        content: {
          title:
            'Our Amenities / Our Facilities',
          points: [
            {
              listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
              subItems: [],
            },
            {
              listItem:
                'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
              subItems: [],
            },
            {
              listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
              subItems: [],
            },
            {
              listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
              subItems: [],
            },
            {
              listItem:
                'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
              subItems: [],
            },
            {
              listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
            {
              listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
              subItems: [],
            },
            {
              listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
              subItems: [],
            },
            {
              listItem:
                'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
              subItems: [],
            },
            {
              listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
              subItems: [],
            },
            {
              listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
              subItems: [],
            },
            {
              listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
              subItems: [],
            },
            {
              listItem: 'Internet Room: Shared internet facility available for residential students.',
              subItems: [],
            },
          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
  2: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: 'one-year-ttc',
    curriculumUrl: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+1Y+ATTC.pdf',
    faqurl: 'https://nispand.s3.ap-south-1.amazonaws.com/FAQ+1Y+TTC.pdf',

    // templateId: 'COURSE900_1Y_TTC',
    templateId: {
      templateOnline: 'COURSE900_1Y_ON_HINDI_TTC',
      templateOffline: {
        templateResidential: 'COURSE900_1Y_RES_TTC',
        templateNonResidential: 'COURSE900_1Y_NONRES_HINDI_TTC',
      },
    },
    batch: 1,
    metaDescription:
      'Master-level training to achieve profound expertise in yoga & teaching.',
    title: '900 Hours Advanced Yoga Teacher Training Course – ATTC  1 Year (Online & On Campus – Hindi)',
    image: `${baseDomain}${courseAssets.courseAsset40}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/900hrs_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#C9705F',
    timing: 'Monday to Friday : 1:30 pm - 4:00 pm (IST)',
    fees: {
      onlineFee: 60000,
      offlineFee: { residentialFee: 60000, nonResidentialFee: 60000 },
    },
    newFees: {
      onlineFee: 60000,
      offlineFee: { residentialFee: 60000, nonResidentialFee: 60000 },
    },
    category: 'ttc',
    clevertapData: {
      name: '900 Hours 1 year advance Yoga TTC - hindi',
      courseType: 'TTC',
      courseSubType: '900 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: 'Advance TTC (900 Hour Courses)',
      coursePreRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course'
    },
    dates: [

      // '1st Jan 2024',
      // '1st Feb 2024',
      // '1st Mar 2024',
      // '1st Apr 2024',
      // '1st May 2024',
      // '1st Jun 2024',
      // '1st Jul 2024',
      // '1st Aug 2024',
      // '1st Sep 2024',
      // '1st Oct 2024',
      // '1st Nov 2024',
      // '1st Dec 2024',
      // '1st Jan 2025',
      // '3rd Feb 2025',
      // '3rd Mar 2025',
      // '1st Apr 2025',
      // '1st May 2025',
      // '2nd Jun 2025',
      // '1st Jul 2025',
      // '1st Aug 2025',
      // '1st Sep 2025',
      // '1st Oct 2025',
      // '3rd Nov 2025',
      // '1st Dec 2025',
      // '1st January 2026',
      // '2nd February 2026',
      // '2nd March 2026',
      // '1st April 2026',
      // '1st June 2026',
      '1st July 2026',
      '3rd August 2026',
      '1st September 2026',
      '1st October2026',
      '2nd November 2026',
      '1st December 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '1 year',
    courseType: 'Advance TTC (900 Hour Courses)',
    language: 'Hindi',
    preRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course',
    courseCategory: 'Educational',
    courseSubType: '900 Hour Yoga Teacher Training',


    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },
    newName: '900 Hours - Advanced Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Friday',
    ],
    time: [
      '1:30 pm - 4:00 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 year",
      timings: [
        {
          day: "Monday to Friday",
          time: "1:30 pm - 4:00 pm (IST)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 500) and YCB Level 3.',
            'The 900 Hour Advanced Yoga Teacher Training Course offers profound mastery over Traditional Yoga. It emphasizes precision in practice, advanced Kriyas, in-depth study of scriptures, and experiential learning of Yoga as a way of life. Complete immersion into teaching, public speaking, and life-school training makes this course a transformative journey. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, it shapes dedicated practitioners into confident ambassadors of Yoga worldwide.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 900 Hour Three Months Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Immersive training to deepen spiritual growth through asanas, pranayama, kriyas, dharana, dhyana, and classical texts.',
              subItems: [],
            },
            {
              listItem:
                'Gain a clear, grounded understanding of Yoga philosophy, making it easier to apply its teachings in life and teaching.',
              subItems: [],
            },
            {
              listItem:
                'Learn how to guide others with confidence, compassion, and humility. You’ll be equipped to hold space for growth and healing, offer thoughtful guidance, and design long-term programs that truly support your students.',
              subItems: [],
            },
            {
              listItem:
                'Go beyond techniques to live Yoga fully, developing into an authentic teacher with clarity and care.',
              subItems: [],
            },
            {
              listItem:
                'A unique 900-hour course offering a deep, structured path for serious practitioners to teach from true experience.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '900 hrs – One Year Yoga ATTC (Online & On Campus – Hindi)'
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Timings',
          points: [
            {
              listItem:
                'Monday to Friday: 1:30 pm - 4:00 pm (IST)',
              subItems: [],
            },
            {
              listItem:
                'Additional Engagements: On certain Sundays, students will be required to participate in scheduled activities or sessions.',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'INR 60,000 (Inclusive of course fee and study material).',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Duration & Extension',
          points: [
            {
              listItem:
                'This is a 1-year course.',
              subItems: [],
            },
            {
              listItem:
                'A complimentary extension of up to 4 months is offered to all students to help them complete the 1-year course, if needed.',
              subItems: [],
            },
            {
              listItem:
                'After this 16-months period (12 months + 4-month complimentary extension), a nominal fee of INR 2,000 per month will be applicable until the course is completed.',
              subItems: [],
            },




          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Completion of any ONE below basic course (undertaken at The Yoga Institute only): '],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '7-days Health Camp.',
              subItems: [],
            },
            {
              listItem:
                '21-days Better Living Course.',
              subItems: [],
            },
            {
              listItem:
                '200-hour TTC.',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['You can apply for the 1-year TTC within three months of finishing any of these prerequisite courses.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Mode of Learning',
          points: [
            {
              listItem:
                'ONCAMPUS: All classes to be attended on campus.',
              subItems: [],
            },
            {
              listItem:
                'ONLINE: All classes will be online except the 15 days which are to be done mandatorily on campus post completion of 175 days of attendance (program details will be shared after admission. Accommodation facility is available for the camp)',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Ideal to become a Yoga Teacher who can help students manage health conditions like diabetes, hypertension, and back pain, while offering spiritual guidance for overall well-being.',
              subItems: [],
            },
            {
              listItem:
                'Specialize in yoga sessions for health management and spiritual growth, with opportunities to work in clinics, hospitals, rehabilitation centres, and integrative health setups. Evolve into a yoga-based health consultant, TTC faculty, or wellness program designer.',
              subItems: [],
            },
            {
              listItem:
                'Perfect for establishing a specialized yoga studio with advanced Yoga classes focused on managing health conditions, in-dept Yoga Asana classes and providing tailored Yoga classes for individual needs.',
              subItems: [],
            },
            {
              listItem:
                'Empowers you to integrate yogic philosophy into healing practices, providing profound spiritual guidance and support.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Attendance Criteria',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note: For the month of May, it will be a holiday and no classes will be held.',
          text: ['']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Attending a minimum 210 days of classes.',
              subItems: [],
            },
            {
              listItem: 'Volunteering at Camps, Workshops, Satsangs, Reach-Out Initiatives',
              subItems: [],
            },
            {
              listItem: 'Completing assignments as given (submissions & presentations)',
              subItems: [],
            },
            {
              listItem: 'Program Structure-900 Hours: ',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['This comprehensive 900-hour Teacher Training Course is thoughtfully structured to provide a balanced and immersive learning experience.']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Classroom Engagement: Approximately 550 hours are dedicated to in-depth classroom interaction. This includes lectures, guided practice, discussions, and hands-on learning facilitated by experienced faculty.',
              subItems: [],
            },
            {
              listItem: 'Experiential Learning: The remaining hours are thoughtfully allocated to assignments, camps, reach out initiatives, practical sessions, exposure visits, and other structured activities that promote real-world application, self-reflection, and integrated learning.',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'table',

        content: {
          title: '',

          tableHeading: [],

          tableData: [
            [
              'Guided Learning Sessions & Orientation Programs',

              '550 hours',
            ],

            [
              'Applied Practice through Wellness Camps & Initiatives',

              '135 hours',
            ],

            [
              'Self-directed Study, Coursework & Assessments',

              '225 hours',
            ],

            ['Total Program Engagement', '910 hours'],
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required pre requisites, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Advanced Yoga Teacher Training Certificate (900 hours) by The Yoga Institute.',
                'Conforming to the YCB certification level 3',
                'Qualified to register with Yoga Alliance (RYT 500)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will be eligible to appear for the Final exams only if they have completed all the required course submissions, class work and the required attendance.',
                'Students will have to appear for the final exams within 90 days from the course completion date.',

                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt. ',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa. ',

                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'



              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Wednesday of every month or as announced (in case of exigencies), subject to a minimum quorum of 8 students. Exams will be conducted on the 3rd Thursday of the month in Jan, April, July and Oct.',
                'A mock test will be conducted on the last Wednesday of every month, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 40 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
      {
        type: 'u-list',
        content: {
          title:
            'Our Amenities / Our Facilities',
          points: [
            {
              listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
              subItems: [],
            },
            {
              listItem:
                'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
              subItems: [],
            },
            {
              listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
              subItems: [],
            },
            {
              listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
              subItems: [],
            },
            {
              listItem:
                'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
              subItems: [],
            },
            {
              listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
            {
              listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
              subItems: [],
            },
            {
              listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
              subItems: [],
            },
            {
              listItem:
                'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
              subItems: [],
            },
            {
              listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
              subItems: [],
            },
            {
              listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
              subItems: [],
            },
            // {
            //   listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
            //   subItems: [],
            // },
            // {
            //   listItem: 'Internet Room: Shared internet facility available for residential students.',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
  3: {
    // templateId: 'COURSE900_1Y_TTC',
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: 'two-year-ttc',
    curriculumUrl: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+2Y+ATTC+(1).pdf',
    faqurl: 'https://nispand.s3.ap-south-1.amazonaws.com/FAQ+2Y+ATTC.pdf',
    // templateId: 'COURSE900_2Y_TTC',
    templateId: {
      templateOnline: 'COURSE900_2Y_ON_TTC',
      templateOffline: {
        templateResidential: 'COURSE900_2Y_RES_TTC',
        templateNonResidential: 'COURSE900_2Y_NONRES_TTC',
      },
    },
    batch: 1,

    metaDescription:
      'Master-level training to achieve profound expertise in yoga & teaching.',
    title: '900 Hours Yoga ATTC – 2 Year Yoga Teacher Training Course Online & On Campus – English',

    image: `${baseDomain}${courseAssets.courseAsset40}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/900hrs_246+X+135.jpg`,

    mostPopular: false,
    rating: 5,
    colorCode: '#C9705F',
    timing:
      'Saturday & Sunday: Saturday: 4:30 pm – 7.30 pm (IST) and Sunday: 9:30 am – 1:30 pm (IST) (Both time slots are mandatory)',
    fees: {
      onlineFee: 60000,
      offlineFee: { residentialFee: 60000, nonResidentialFee: 60000 },
    },
    newFees: {
      onlineFee: 60000,
      offlineFee: { residentialFee: 60000, nonResidentialFee: 60000 },
    },
    category: 'ttc',
    clevertapData: {
      name: '900 Hour 2 year advance Yoga TTC - english',
      courseType: 'TTC',
      courseSubType: '900 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: 'Advance TTC (900 Hour Courses)',
      coursePreRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course'
    },
    dates: [
      // '3rd Aug 2024',
      // '7th Dec 2024',
      // '5th Apr 2025',
      // '2nd Aug 2025',
      // '6th Dec 2025',
      // '4th April 2026',
      '1st  August 2026',
      '5th December 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '2 year',
    courseType: 'Advance TTC (900 Hour Courses)',
    language: 'English',
    preRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course',
    courseCategory: 'Educational',
    courseSubType: '900 Hour Yoga Teacher Training',
    newName: '900 Hours - Advanced Yoga Teacher Training Course (YTTC)',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      'Saturday: 4:30 pm – 7.30 pm (IST)',
      'Sunday: 9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "2 years",
      timings: [
        {
          day: "Saturday & Sunday",
          time: "Saturday: 4:30 pm – 7.30 pm (IST)"
        },
        {
          day: "Saturday & Sunday",
          time: "Sunday: 9:30 am – 1:30 pm (IST)"
        }
      ],
      message: "(Both time slots are mandatory)"
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 500) and YCB Level 3.',
            'The 900 Hour Advanced Yoga Teacher Training Course offers profound mastery over Traditional Yoga. It emphasizes precision in practice, advanced Kriyas, in-depth study of scriptures, and experiential learning of Yoga as a way of life. Complete immersion into teaching, public speaking, and life-school training makes this course a transformative journey. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, it shapes dedicated practitioners into confident ambassadors of Yoga worldwide.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 900 Hour Three Months Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Immersive training to deepen spiritual growth through asanas, pranayama, kriyas, dharana, dhyana, and classical texts.',
              subItems: [],
            },
            {
              listItem:
                'Gain a clear, grounded understanding of Yoga philosophy, making it easier to apply its teachings in life and teaching.',
              subItems: [],
            },
            {
              listItem:
                'Learn how to guide others with confidence, compassion, and humility. You’ll be equipped to hold space for growth and healing, offer thoughtful guidance, and design long-term programs that truly support your students.',
              subItems: [],
            },
            {
              listItem:
                'Go beyond techniques to live Yoga fully, developing into an authentic teacher with clarity and care.',
              subItems: [],
            },
            {
              listItem:
                'A unique 900-hour course offering a deep, structured path for serious practitioners to teach from true experience.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '900 hrs – Two Year Yoga ATTC (Online & On Campus – English)'
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Timings',
          points: [
            {
              listItem:
                'Saturday & Sunday: Saturday: 4:30 pm -7.30 pm (IST) and Sunday: 9:30 am – 1:30 pm (IST) ',
              subItems: [],
            },
            {
              listItem:
                'Additional Engagements: On certain Sundays, students will be required to participate in scheduled activities or sessions.',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'INR 60,000 (Inclusive of course fee and study material).',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Duration & Extension',
          points: [
            {
              listItem:
                'This is a 2-year course.',
              subItems: [],
            },
            {
              listItem:
                'A complimentary extension of up to 8 months is offered to all students to help them complete the 2-year course, if needed.',
              subItems: [],
            },
            {
              listItem:
                'After this 32-months period (24 months + 8-month complimentary extension), a nominal fee of INR 2,000 per month will be applicable until the course is completed.',
              subItems: [],
            },




          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Completion of any ONE below basic course (undertaken at The Yoga Institute only): '],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '7-days Health Camp.',
              subItems: [],
            },
            {
              listItem:
                '21-days Better Living Course.',
              subItems: [],
            },
            {
              listItem:
                '200-hour TTC.',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['You can apply for the two-year TTC within three months of finishing any of these prerequisite courses.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Mode of Learning',
          points: [
            {
              listItem:
                'ONCAMPUS: All classes to be attended on campus.',
              subItems: [],
            },
            {
              listItem:
                'ONLINE: All classes will be online except the 15 days which are to be done mandatorily on campus post completion of 175 days of attendance (program details will be shared after admission. Accommodation facility is available for the camp)',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Ideal to become a Yoga Teacher who can help students manage health conditions like diabetes, hypertension, and back pain, while offering spiritual guidance for overall well-being.',
              subItems: [],
            },
            {
              listItem:
                'Specialize in yoga sessions for health management and spiritual growth, with opportunities to work in clinics, hospitals, rehabilitation centres, and integrative health setups. Evolve into a yoga-based health consultant, TTC faculty, or wellness program designer.',
              subItems: [],
            },
            {
              listItem:
                'Perfect for establishing a specialized yoga studio with advanced Yoga classes focused on managing health conditions, in-dept Yoga Asana classes and providing tailored Yoga classes for individual needs.',
              subItems: [],
            },
            {
              listItem:
                'Empowers you to integrate yogic philosophy into healing practices, providing profound spiritual guidance and support.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },

      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Attending a minimum 192 days of classes.',
              subItems: [],
            },
            {
              listItem: 'Volunteering at Camps, Workshops, Satsangs, Reach-Out Initiatives',
              subItems: [],
            },
            {
              listItem: 'Completing assignments as given (submissions & presentations)',
              subItems: [],
            },
            {
              listItem: 'Program Structure-900 Hours: ',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['This comprehensive 900-hour Teacher Training Course is thoughtfully structured to provide a balanced and immersive learning experience.']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Classroom Engagement: Approximately 550 hours are dedicated to in-depth classroom interaction. This includes lectures, guided practice, discussions, and hands-on learning facilitated by experienced faculty.',
              subItems: [],
            },
            {
              listItem: 'Experiential Learning: The remaining hours are thoughtfully allocated to assignments, camps, reach out initiatives, practical sessions, exposure visits, and other structured activities that promote real-world application, self-reflection, and integrated learning.',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'table',

        content: {
          title: '',

          tableHeading: [],

          tableData: [
            [
              'Guided Learning Sessions & Orientation Programs',

              '550 hours',
            ],

            [
              'Applied Practice through Wellness Camps & Initiatives',

              '135 hours',
            ],

            [
              'Self-directed Study, Coursework & Assessments',

              '225 hours',
            ],

            ['Total Program Engagement', '910 hours'],
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required pre requisites, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Advanced Yoga Teacher Training Certificate (900 hours) by The Yoga Institute.',
                'Conforming to the YCB certification level 3',
                'Qualified to register with Yoga Alliance (RYT 500)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will be eligible to appear for the Final exams only if they have completed all the required course submissions, class work and the required attendance.',
                'Students will have to appear for the final exams within 90 days from the course completion date.',

                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt. ',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa. ',

                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'



              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Wednesday of every month or as announced (in case of exigencies), subject to a minimum quorum of 8 students. Exams will be conducted on the 3rd Thursday of the month in Jan, April, July and Oct.',
                'A mock test will be conducted on the last Wednesday of every month, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },



    ],
    teaching: [],
    offerings: [

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 40 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
      {
        type: 'u-list',
        content: {
          title:
            'Our Amenities / Our Facilities',
          points: [
            {
              listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
              subItems: [],
            },
            {
              listItem:
                'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
              subItems: [],
            },
            {
              listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
              subItems: [],
            },
            {
              listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
              subItems: [],
            },
            {
              listItem:
                'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
              subItems: [],
            },
            {
              listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
            {
              listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
              subItems: [],
            },
            {
              listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
              subItems: [],
            },
            {
              listItem:
                'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
              subItems: [],
            },
            {
              listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
              subItems: [],
            },
            {
              listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
              subItems: [],
            },
            // {
            //   listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
            //   subItems: [],
            // },
            // {
            //   listItem: 'Internet Room: Shared internet facility available for residential students.',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
  4: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: '900-hours-advanced-teacher-training-course',
    curriculumUrl: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+4M+ATTC.pdf',
    faqurl: 'https://nispand.s3.ap-south-1.amazonaws.com/FAQ+4M+ATTC.pdf',
    // templateId: 'COURSE900_4M_TTC',
    templateId: {
      templateOnline: 'COURSE900_4M_ON_TTC',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 1,

    metaDescription:
      'Master-level training to achieve profound expertise in yoga & teaching.',
    title: '900 Hours Yoga ATTC – 4 Months Online Yoga Teacher Training Course – English',
    image: `${baseDomain}${courseAssets.courseAsset40}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/900hrs_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#C9705F',
    timing:
      'Monday to Saturday: Morning: 7:00 am to 9:00 am (IST) and Evening: 4:30 pm to 8:00 pm (IST) (Both the time slots are mandatory)',
    fees: {
      onlineFee: 80000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 80000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'ttc',
    clevertapData: {
      name: '900 hours Yoga TTC - english - 4 month',
      courseType: 'TTC',
      courseSubType: '900 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: 'Advance TTC (900 Hour Courses)',
      coursePreRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course'
    },
    dates: [
      // '17th Jun - 5th Oct 2024', 
      // '14th Oct 2024 - 1st Feb 2025',
      // '10th Feb - 31st May 2025',
      // '9th Jun - 27th Sep 2025',
      // '8th Dec to 28th Mar 2026',
      // '6th April to 25th July 2026',
      '3rd August to 21st Nov 2026',
      '30th Nov to 20th March 2027',
    ]
    ,
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '4 month',
    courseType: 'Advance TTC (900 Hour Courses)',
    language: 'English',
    preRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course',
    courseCategory: 'Educational',
    courseSubType: '900 Hour Yoga Teacher Training',
    newName: '900 Hours - Advanced Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time: [
      'Morning: 7:00 am to 9:00 am (IST)',
      'Evening: 4:30 pm to 8:00 pm (IST)'
    ],
    enrollInfo: {
      duration: "4 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "Morning: 7:00 am to 9:00 am (IST)"
        },
        {
          day: "Monday to Saturday",
          time: "Evening: 4:30 pm to 8:00 pm (IST)"
        }
      ],
      message: "(Both the time slots are mandatory)"
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 500) and YCB Level 3.',
            'The 900 Hour Advanced Yoga Teacher Training Course offers profound mastery over Traditional Yoga. It emphasizes precision in practice, advanced Kriyas, in-depth study of scriptures, and experiential learning of Yoga as a way of life. Complete immersion into teaching, public speaking, and life-school training makes this course a transformative journey. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, it shapes dedicated practitioners into confident ambassadors of Yoga worldwide.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 900 Hour Three Months Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Immersive training to deepen spiritual growth through asanas, pranayama, kriyas, dharana, dhyana, and classical texts.',
              subItems: [],
            },
            {
              listItem:
                'Gain a clear, grounded understanding of Yoga philosophy, making it easier to apply its teachings in life and teaching.',
              subItems: [],
            },
            {
              listItem:
                'Learn how to guide others with confidence, compassion, and humility. You’ll be equipped to hold space for growth and healing, offer thoughtful guidance, and design long-term programs that truly support your students.',
              subItems: [],
            },
            {
              listItem:
                'Go beyond techniques to live Yoga fully, developing into an authentic teacher with clarity and care.',
              subItems: [],
            },
            {
              listItem:
                'A unique 900-hour course offering a deep, structured path for serious practitioners to teach from true experience.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '900 hrs – 4 Months Yoga ATTC (Online – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Timings',
          points: [
            {
              listItem:
                'Monday to Saturday: Morning Slot: 7:00 am to 9:00 am (IST) and Evening Slot: 4:30 pm to 8:00 pm (IST) (Both time slots are mandatory)',
              subItems: [],
            },
            {
              listItem:
                'Additional Engagements: On certain Sundays, students will be required to participate in scheduled activities or sessions.',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'INR 80,000 (Inclusive of course fee and study material).',
              subItems: [],
            },


          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Prerequisites',
      //     text: ['Completion of any ONE below basic course (undertaken at The Yoga Institute only): '],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //      points: [
      //       {
      //         listItem:
      //           '7-days Health Camp.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '21-days Better Living Course.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '200-hour TTC.',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Mode of Learning',
          text: ['ONLINE: All classes to be attended on line.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Ideal to become a Yoga Teacher who can help students manage health conditions like diabetes, hypertension, and back pain, while offering spiritual guidance for overall well-being.',
              subItems: [],
            },
            {
              listItem:
                'Specialize in yoga sessions for health management and spiritual growth, with opportunities to work in clinics, hospitals, rehabilitation centres, and integrative health setups. Evolve into a yoga-based health consultant, TTC faculty, or wellness program designer.',
              subItems: [],
            },
            {
              listItem:
                'Perfect for establishing a specialized yoga studio with advanced Yoga classes focused on managing health conditions, in-dept Yoga Asana classes and providing tailored Yoga classes for individual needs.',
              subItems: [],
            },
            {
              listItem:
                'Empowers you to integrate yogic philosophy into healing practices, providing profound spiritual guidance and support.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'A student is required to have a minimum 80% attendance.',
              subItems: [],
            },
            {
              listItem: 'Completing assignments as given (submissions & presentations).',
              subItems: [],
            },
            {
              listItem: 'Program Structure-900 Hours: ',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['This comprehensive 900-hour Teacher Training Course is thoughtfully structured to provide a balanced and immersive learning experience.']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Classroom Engagement: Approximately 550 hours are dedicated to in-depth classroom interaction. This includes lectures, guided practice, discussions, and hands-on learning facilitated by experienced faculty.',
              subItems: [],
            },
            {
              listItem: 'Experiential Learning: The remaining hours are thoughtfully allocated to assignments, camps, reach out initiatives, practical sessions, exposure visits, and other structured activities that promote real-world application, self-reflection, and integrated learning.',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'table',

        content: {
          title: '',

          tableHeading: [],

          tableData: [
            [
              'Guided Learning Sessions & Orientation Programs',

              '550 hours',
            ],

            [
              'Applied Practice through Wellness Camps & Initiatives',

              '135 hours',
            ],

            [
              'Self-directed Study, Coursework & Assessments',

              '225 hours',
            ],

            ['Total Program Engagement', '910 hours'],
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required pre requisites, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Advanced Yoga Teacher Training Certificate (900 hours) by The Yoga Institute.',
                'Conforming to the YCB cert level 3',
                'Qualified to register with Yoga Alliance (RYT 500)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will be eligible to appear for the Final exams only if they have completed all the required course submissions, class work and the required attendance.',
                'Students will have to appear for the final exams within 90 days from the course completion date.',

                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt. ',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },



              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['Online Final exams will be conducted on the 1st Wednesday of every month or as announced (in case of exigencies), subject to a minimum quorum of 8 students. Exams will be conducted on the 3rd Thursday of the month in Jan, April, July and Oct.',
                'A mock test will be conducted on the last Wednesday of every month, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 40 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
              subItems: []
            },
            {
              listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
  5: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: 'seven-month-ttc',
    curriculumUrl: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+7M+ATTC.pdf',
    faqurl: 'https://nispand.s3.ap-south-1.amazonaws.com/FAQ+7M+ATTC.pdf',
    // templateId: 'COURSE900_7M_TTC',
    templateId: {
      templateOnline: 'COURSE900_7M_ON_TTC',
      templateOffline: {
        templateResidential: 'COURSE900_7M_RES_TTC',
        templateNonResidential: 'COURSE900_7M_NONRES_TTC',
      },
    },
    batch: 1,

    metaDescription:
      'Master-level training to achieve profound expertise in yoga & teaching.',
    title: '900 Hours Advanced Yoga Teacher Training Course – ATTC  7 Months (Online & On Campus – English)',

    image: `${baseDomain}${courseAssets.courseAsset40}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/900hrs_246+X+135.jpg`,

    mostPopular: true,
    rating: 5,
    colorCode: '#C9705F',
    timing: 'Monday to Saturday: 5:00 p.m. - 8:00 p.m. (IST)',
    fees: {
      onlineFee: 60000,
      offlineFee: { residentialFee: 60000, nonResidentialFee: 60000 },
    },
    newFees: {
      onlineFee: 60000,
      offlineFee: { residentialFee: 60000, nonResidentialFee: 60000 },
    },
    category: 'ttc',
    clevertapData: {
      name: '900 hours Yoga TTC - english - 7 month',
      courseType: 'TTC',
      courseSubType: '900 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: 'Advance TTC (900 Hour Courses)',
      coursePreRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course'
    },
    dates: [
      // '1st Jan 2024',
      // '1st Feb 2024',
      // '1st Mar 2024',
      // '1st Apr 2024',
      // '1st May 2024',
      // '1st Jun 2024',
      // '1st Jul 2024',
      // '1st Aug 2024',
      // '1st Sep 2024',
      // '1st Oct 2024',
      // '1st Nov 2024',
      // '2nd Dec 2024',
      // '1st Jan 2025',
      // '1st Feb 2025',
      // '1st Mar 2025',
      // '1st Apr 2025',
      // '1st May 2025',
      // '2nd Jun 2025',
      // '1st Jul 2025',
      // '1st Aug 2025',
      // '1st Sep 2025',
      // '1st Oct 2025',
      // '1st Nov 2025',
      // '1st Dec 2025',
      // '1st January 2026',
      // '2nd February 2026',
      // '2nd March 2026',
      // '1st April 2026',
      // '1st May 2026',
      // '1st June 2026',
      '1st July 2026',
      '1st August 2026',
      '1st September 2026',
      '1st October2026',
      '2nd November 2026',
      '1st December 2026',

    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '7 month',
    courseType: 'Advance TTC (900 Hour Courses)',
    language: 'English',
    preRequisite: '7 Days Health Camp, 21 Days Better Living Course, 200 Hours Teacher Training Course',
    courseCategory: 'Educational',
    courseSubType: '900 Hour Yoga Teacher Training',
    newName: '900 Hours - Advanced Yoga Teacher Training Course (YTTC)',
    days: [
      'Monday to Saturday'
    ],
    time: [
      '5:00 p.m. - 8:00 p.m. (IST)'
    ],
    enrollInfo: {
      duration: "7 months",
      timings: [
        {
          day: "Monday to Saturday",
          time: "5:00 p.m. - 8:00 p.m. (IST)"
        }
      ]
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Established in 1918, The Yoga Institute pioneered the world’s first Yoga Teacher Training Course in 1953 and has since trained over 150,000 teachers. Our certifications are globally recognized through Yoga Alliance (RYT 500) and YCB Level 3.',
            'The 900 Hour Advanced Yoga Teacher Training Course offers profound mastery over Traditional Yoga. It emphasizes precision in practice, advanced Kriyas, in-depth study of scriptures, and experiential learning of Yoga as a way of life. Complete immersion into teaching, public speaking, and life-school training makes this course a transformative journey. Designed by Shri Yogendraji, Smt. Sita Devi Yogendra, Dr. Jayadeva Yogendra, and Dr. Hansaji J. Yogendra, it shapes dedicated practitioners into confident ambassadors of Yoga worldwide.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of 900 Hour Three Months Yoga Teacher Training Course',
          points: [
            {
              listItem:
                'Immersive training to deepen spiritual growth through asanas, pranayama, kriyas, dharana, dhyana, and classical texts.',
              subItems: [],
            },
            {
              listItem:
                'Gain a clear, grounded understanding of Yoga philosophy, making it easier to apply its teachings in life and teaching.',
              subItems: [],
            },
            {
              listItem:
                'Learn how to guide others with confidence, compassion, and humility. You’ll be equipped to hold space for growth and healing, offer thoughtful guidance, and design long-term programs that truly support your students.',
              subItems: [],
            },
            {
              listItem:
                'Go beyond techniques to live Yoga fully, developing into an authentic teacher with clarity and care.',
              subItems: [],
            },
            {
              listItem:
                'A unique 900-hour course offering a deep, structured path for serious practitioners to teach from true experience.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            '900 hrs – Seven Months Yoga ATTC (Online & On Campus – English)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Timings',
          points: [
            {
              listItem:
                'Monday to Saturday: 5:00 pm - 8:00 pm (IST)',
              subItems: [],
            },
            {
              listItem:
                'Additional Engagements: On certain Sundays, students will be required to participate in scheduled activities or sessions.',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'INR 60,000 (Inclusive of course fee and study material).',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Duration & Extension',
          points: [
            {
              listItem:
                'This is a 7-month course.',
              subItems: [],
            },
            {
              listItem:
                'A complimentary extension of up to 3 months is offered to all students to help them complete the 7-month course, if needed.',
              subItems: [],
            },
            {
              listItem:
                'After this 10-month period (7 months + 3-month complimentary extension), a nominal fee of INR 2,000 per month will be applicable until the course is completed.',
              subItems: [],
            },




          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['Completion of any ONE below basic course (undertaken at The Yoga Institute only): '],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '7-days Health Camp.',
              subItems: [],
            },
            {
              listItem:
                '21-days Better Living Course.',
              subItems: [],
            },
            {
              listItem:
                '200-hour TTC.',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['You can apply for the 7-month TTC within three months of finishing any of these prerequisite courses.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Mode of Learning',
          points: [
            {
              listItem:
                'ONCAMPUS: All classes to be attended on campus.',
              subItems: [],
            },
            {
              listItem:
                'ONLINE: All classes will be online except the 15 days which are to be done mandatorily on campus post completion of 175 days of attendance (program details will be shared after admission. Accommodation facility is available for the camp for a nominal fee)',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Post Qualification Opportunities',
          points: [
            {
              listItem:
                'Ideal to become a Yoga Teacher who can help students manage health conditions like diabetes, hypertension, and back pain, while offering spiritual guidance for overall well-being.',
              subItems: [],
            },
            {
              listItem:
                'Specialize in yoga sessions for health management and spiritual growth, with opportunities to work in clinics, hospitals, rehabilitation centres, and integrative health setups. Evolve into a yoga-based health consultant, TTC faculty, or wellness program designer.',
              subItems: [],
            },
            {
              listItem:
                'Perfect for establishing a specialized yoga studio with advanced Yoga classes focused on managing health conditions, in-dept Yoga Asana classes and providing tailored Yoga classes for individual needs.',
              subItems: [],
            },
            {
              listItem:
                'Empowers you to integrate yogic philosophy into healing practices, providing profound spiritual guidance and support.',
              subItems: [],
            },
          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Attendance Criteria',
          points: [
            {
              listItem: 'Attending a minimum 210 days of classes.',
              subItems: [],
            },
            {
              listItem: 'Volunteering at Camps, Workshops, Satsangs, Reach-Out Initiatives',
              subItems: [],
            },
            {
              listItem: 'Completing assignments as given (submissions & presentations)',
              subItems: [],
            },
            {
              listItem: 'Program Structure-900 Hours: ',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['This comprehensive 900-hour Teacher Training Course is thoughtfully structured to provide a balanced and immersive learning experience.']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: '550 hours of classroom engagement combine hands-on training with in-depth inquiry into the applied philosophy of Yoga and its various aspects. Practical sessions focus on building skills and fostering personal transformation, while lectures offer a deep, structured exploration of philosophical foundations essential to meaningful growth in both practice and teaching.',
              subItems: [],
            },
            {
              listItem: 'The remaining hours are dedicated to assignments, camps, outreach initiatives, exposure visits, and other structured activities that reflect the essence of yoga as a path of self-inquiry and real-life application. These experiences deepen personal insight and help future teachers integrate yogic principles meaningfully into their teaching and daily life.',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'table',

        content: {
          title: '',

          tableHeading: [],

          tableData: [
            [
              'Guided Learning Sessions & Orientation Programs',

              '550 hours',
            ],

            [
              'Applied Practice through Wellness Camps & Initiatives',

              '135 hours',
            ],

            [
              'Self-directed Study, Coursework & Assessments',

              '225 hours',
            ],

            ['Total Program Engagement', '910 hours'],
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Examination & Certification',
          points: [
            {
              listItem:
                'Upon successful completion of the attendance criteria and submission of the required pre requisites, the student will be eligible to appear for the examination.',
              subItems: [],
            },
            {
              listItem:
                'Students who pass the final exam successfully, will be:',
              subItems: ['Awarded a certificate – Advanced Yoga Teacher Training Certificate (900 hours) by The Yoga Institute.',
                'Conforming to the YCB certification level 3',
                'Qualified to register with Yoga Alliance (RYT 500)'
              ],
            },
            {
              listItem:
                'Exam Details',
              subItems: ['Students will be eligible to appear for the Final exams only if they have completed all the required course submissions, class work and the required attendance.',
                'Students will have to appear for the final exams within 90 days from the course completion date.',

                {
                  subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
                  leafItems: [
                    'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt. ',
                    'They will have to appear for both in case of a 3rd attempt.'
                  ]
                },
                {
                  subItem: 'Students can register for either Online or On-Campus exams.',
                  leafItems: [
                    'Once finalized, students will not be permitted to switch from online to on campus and vice versa. ',

                  ]
                },
                'Examiners will evaluate students only as per the final approved list.'



              ],
            },
            {
              listItem:
                'Exam Schedule',
              subItems: ['On Campus/ Online Final exams will be conducted on the 1st Wednesday of every month or as announced (in case of exigencies), subject to a minimum quorum of 8 students. Exams will be conducted on the 3rd Thursday of the month in Jan, April, July and Oct.',
                'A mock test will be conducted on the last Wednesday of every month, to familiarize students with the examination process.',
                'The examination timings will be announced in advance by the course coordinator.'
              ],
            },
          ],
        },
      },




    ],
    teaching: [],
    offerings: [
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
              subItems: []
            },
            {
              listItem: 'Our team of over 40 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
              subItems: []
            },
            {
              listItem: 'As the first yoga school recognised by the Government of India to conduct Teacher Training Courses, we bring over 100 years of research-backed experience, supported by in-house publications & study material that enrich and deepen the learning process.',
              subItems: []
            },
            {
              listItem: 'The immersive class environment fosters peer learning through meaningful interactions with Sadhakas from diverse backgrounds, helping develop clarity, empathy, and mindfulness in real-life and teaching situations.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
        },
      },
      {
        type: 'u-list',
        content: {
          title:
            'Our Amenities / Our Facilities',
          points: [
            {
              listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
              subItems: [],
            },
            {
              listItem:
                'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
              subItems: [],
            },
            {
              listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
              subItems: [],
            },
            {
              listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
              subItems: [],
            },
            {
              listItem:
                'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
              subItems: [],
            },
            {
              listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
            {
              listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
              subItems: [],
            },
            {
              listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
              subItems: [],
            },
            {
              listItem:
                'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
              subItems: [],
            },
            {
              listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
              subItems: [],
            },
            {
              listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
              subItems: [],
            },
            // {
            //   listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
            //   subItems: [],
            // },
            // {
            //   listItem: 'Internet Room: Shared internet facility available for residential students.',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
}

const camps = {
  // 1: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  // textdescription1:'',
  // textdescription2:'',
  // textdescription3:'',
  // textdescription4:'',
  // textdescription5:'',
  //   title: 'Bhava Workshop',
  //   key: 'bhava-workshop',
  //   batch: 1,
  //   mostPopular: false,
  //   rating: 5,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: ''
  //     }
  //   },
  //   colorCode: '#EDBE66',
  //   timing: '9.30 AM to 5.30 PM',
  //   fees: {
  //     onlineFee: 500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
  //   image: `${baseDomain}${courseAssets.courseAsset8}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset112}`,
  //   dates: ['27th Aug 2022', '22nd Oct 2022', '26th Dec 2022'],
  //   online: true,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this workshop for?',
  //         text: [
  //           'All of life comes down to your attitude. Your attitude determines each and every event of your life. So if you can master the right attitude, there is nothing that you will not be able to do. In Yoga, the concept of bhavas has a lot of significance in life. It means an attitude. This workshop by The Yoga Institute is uniquely designed to systematically present to you the fundamental bhavas or attitudes that one should possess to live a life full of clarity, purpose, insight and understanding. This will enhance your relationships, your work, your health, your overall well-being.                   ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'The right bhavas augment the subtle and gross energies and help us deal with daily stresses and make the spiritual experience more profound. -Dr. Hansaji Yogendra ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Effective tools and techniques to help you manage your life',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Diet guidelines to manage your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Offered with the program',
  //         points: [
  //           {
  //             listItem: 'Booklet with guidelines  ',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Wholesome Sattvik lunch',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Healthy snacks  ',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['9.30 AM to 5.30 PM'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 500'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //   ],
  // },

  2: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Cardiac & Hypertension Yoga Workshop - Online & On Campus',
    weekDays: true,
    key: 'cardiac-hypertension-workshop',
    tenure: '1 day',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    mostPopular: false,
    rating: 5,
    colorCode: '#DDAB58',
    timing: '9:30 am – 5:30 pm (IST)',
    fees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    newFees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    category: 'camps',
    clevertapData: {
      name: 'Cardiac & Hypertension Yoga Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    metaDescription:
      'Specialized yoga camp for heart health & hypertension management.',
    image: `${baseDomain}${courseAssets.courseAsset111}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/cardiac-_-hypertension-yoga-camp-the-yoga-institute_+246+X+135.jpg`,
    dates: [
      // '4th May 2025', 
      // '6th Jul 2025', 
      // '7th Sep 2025', 
      // '2nd Nov 2025',
      // '4th January 2026',
      // '1st March 2026',
      // '3rd May 2026',
      '6th September 2026',
      '1st November 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Cardiac & Hypertension Yoga Workshop',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 Day",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga workshop for?',
          text: [
            'The heart, which has always been a symbol of light and love, of joy and happiness, has recently been heaped with relentless abuse. This yoga for Hypertension & Cardiac workshop / camp has been thoughtfully designed by Dr. Hansaji Yogendra for individuals struggling with hypertension and heart ailments. India has one of the highest burdens of cardiovascular disease worldwide. It is thought to be incurable, but we at The Yoga Institute have formulated a holistic and yogic pathway with ancient knowledge, where the mind, body and soul are aligned to overcome this.',
            'In collaboration with medical specialists, we have conducted various researches on the beneficial effects of our techniques on individuals with coronary artery blockages, ischemic chest pains, HBP, Myocardial Infarction, and have found promising results among patients.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'High blood pressure is a lifestyle disorder. It can be corrected, it can be improved and an individual can come out of it. All you have to do is put in the right effort. - Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Powerful and effective asana, pranayama, and relaxation techniques to alleviate heart ailments',
              subItems: [],
            },
            {
              listItem: 'Diet guidelines for a healthy and happy heart',
              subItems: [],
            },
            {
              listItem: 'Insightful yoga session with heart specialist',
              subItems: [],
            },
            {
              listItem:
                'Lifestyle tips by spiritual guru Dr. Hansaji Yogendra who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Stress Management',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 1000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeve-less T-shirts are not permitted as per the Institute dress code.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },

  3: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Diabetes Yoga Camp - Online & On Campus',
    key: 'diabetes-camp',
    weekDays: true,
    // batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    dates: [
      // '6th Apr 2025',
      //  '1st Jun 2025', 
      //  '3rd Aug 2025', 
      //  '5th Oct 2025', 
      //  '7th Dec 2025',
      // '1st February 2026',
      // '5th April 2026',
      // '7th June 2026',
      '2nd August 2026',
      '4th October 2026',
      '6th December 2026',
    ],
    mostPopular: false,
    rating: 5,
    colorCode: '#CE9B51',
    timing: '9:30 am – 5:30 pm (IST)',
    clevertapData: {
      name: 'Diabetes Yoga Camp - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    fees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    newFees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    category: 'camps',
    metaDescription:
      'Specialized yoga camp to manage diabetes with guided practices.',
    image: `${baseDomain}${courseAssets.courseAsset7}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/0A8A4816+_+246+X+135.jpg`,
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '1 Day',
    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Diabetes Yoga Camp',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],

    enrollInfo: {
      duration: "1 Day",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Camp for?',
          text: [
            'Diabetes is an insidious disease that can remain symptomless and undetected for years. The modern management of diabetes works more at the physical level; it is only Yoga that has the capability to influence the psychopathogenesis as well. Carefully curated by our Director Dr. Hansaji Yogendra, the aim of this yoga health camp is to train you in yogic dinacharya and ritucharya to help you take charge of your diabetes through proper self-management. Whether you have been recently diagnosed or are working with diabetes for a while, this yoga for diabetes camp will give you valuable tools to enhance your life. The Yoga Institute’s work in the area of diabetes since the last 60 years has received immense recognition in the community.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'Diabetes is best controlled not by fear and dread but by knowledge, self-assurance, and a positive attitude.  - Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Wholesome tools and techniques to help you manage your condition completely',
              subItems: [],
            },
            {
              listItem:
                'Specific yoga asanas for diabetes, pranayama, and relaxation techniques to enhance your health',
              subItems: [],
            },
            {
              listItem: 'Diet guidelines to manage your health',
              subItems: [],
            },
            {
              listItem: 'Insightful yoga session with diabetes specialist',
              subItems: [],
            },
            {
              listItem:
                'Lifestyle tips by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 1000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeve-less T-shirts are not permitted as per the Institute dress code',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
  },

  // 4: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  // textdescription1:'',
  // textdescription2:'',
  // textdescription3:'',
  // textdescription4:'',
  // textdescription5:'',
  //   title: 'Diet Workshop',
  //   key: 'diet-workshop',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: ''
  //     }
  //   },
  //   dates: [],
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#EDBE66',
  //   timing: '9:30 am – 5:30 pm (IST)',
  //   fees: {
  //     onlineFee: 500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Wholesome tools and techniques to help you manage your condition completely',
  //   image: `${baseDomain}${courseAssets.courseAsset85}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset85}`,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this workshop for?',
  //         text: [
  //           'Do you find yourself juggling multiple responsibilities every day? Do you feel you are not able to focus consciously on your meals? You are not alone! A lot of us, with our erratic lifestyles, eat whatever is quick to manage and thus end up really creating imbalances in our bodily energies. At the Yoga Institute’s Diet Workshop, we will give you the wisdom of ancient Sattvik ahar, which is really easy to prepare and which will bring your physical, spiritual and mental energies in balance.                   ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'Sattvic means purity, health, harmony and well-being. Sattvik food has the power to safeguard us against many modern-day ailments. - Dr. Hansaji Yogendra ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Effective tools and techniques to help you manage your life',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Easy high-fibre Sattvik recipes',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Diet guidelines to manage your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     // {
  //     //   type: 'u-list',
  //     //   content: {
  //     //     title: 'Offered with the program',
  //     //     points: [
  //     //       {
  //     //         listItem: 'Booklet with guidelines  ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Wholesome Sattvik lunch',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Healthy snacks  ',
  //     //         subItems: [],
  //     //       },
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: [' 5:00 pm – 8:00 pm (IST)'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 500'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           // {
  //           //   listItem:
  //           //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
  //           //   subItems: [],
  //           // },
  //         ],
  //       },
  //     },
  //   ],
  // },

  // 5: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  // textdescription1:'',
  // textdescription2:'',
  // textdescription3:'',
  // textdescription4:'',
  // textdescription5:'',
  //   title: 'Digestion Camp',
  //   key: 'digestion-camp',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#DDAB58',
  //   timing: '9.30 AM to 5.30 PM',
  //   fees: {
  //     onlineFee: 500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Specific pranayama, and relaxation techniques to enhance your wellbeing',
  //   image: `${baseDomain}${courseAssets.courseAsset13}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset106}`,
  //   dates: [],
  //   online: true,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this workshop for?',
  //         text: [
  //           'Given our fast-paced and unhealthy lifestyles, it is no wonder that most of us struggle with our digestive systems – be it diarrhea, IBS, constipation, ulcers, acidity, and celiac disease. Fortunately, yoga shows us a holistic path out of this towards well-being and total health. At The Yoga Institute, we have designed a powerful health camp to help you tackle all your troubles with digestion. With the aid of Sattvik ahar, yogic guidelines, effective asanas, in no time your digestion will be your friend and not your enemy.                   ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'If your digestion is good, all the cells in your body will be happy and free of disease. -Dr. Hansaji Yogendra ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Yoga Sadhana: Specific pranayama, and relaxation techniques to enhance your wellbeing',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Diet guidelines',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Health counseling',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Lifestyle tips by spiritual guru Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     // {
  //     //   type: 'u-list',
  //     //   content: {
  //     //     title: 'Offered with the program',
  //     //     points: [
  //     //       {
  //     //         listItem: 'Booklet with guidelines  ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Wholesome Sattvik lunch',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Healthy snacks  ',
  //     //         subItems: [],
  //     //       },
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['9.30 AM to 5.30 PM'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 500'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           // {
  //           //   listItem:
  //           //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
  //           //   subItems: [],
  //           // },
  //         ],
  //       },
  //     },
  //   ],
  // },

  // 6: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  // textdescription1:'',
  // textdescription2:'',
  // textdescription3:'',
  // textdescription4:'',
  // textdescription5:'',
  //   title: 'Karma Yoga',
  //   key: 'karma-yoga-course',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#CE9B51',
  //   timing: '9.30 AM to 5.30 PM',
  //   fees: {
  //     onlineFee: 500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'camps',
  //   metaDescription: 'Diet guidelines to manage your health',
  //   image: `${baseDomain}${courseAssets.courseAsset10}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset10}`,
  //   dates: [],
  //   online: true,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this workshop for?',
  //         text: [
  //           'This beautifully technique of Karma Yoga presented in Bhagvada Gita is relevant even today. It is a system that can help us be focused and efficient throughout the day in a time when are attentions ae divided among a multitude of tasks and responsibilities. This camp will give you a formula to manage your state of mind in your work and will help u attain success and efficiency in all activity. We hope to see you soon!                   ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'Mere doing is not action. The intent behind every action is important. ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Effective tools and techniques to help you manage your life',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Easy high-fibre Sattvik recipes',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Diet guidelines to manage your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     // {
  //     //   type: 'u-list',
  //     //   content: {
  //     //     title: 'Offered with the program',
  //     //     points: [
  //     //       {
  //     //         listItem: 'Booklet with guidelines  ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Wholesome Sattvik lunch',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Healthy snacks  ',
  //     //         subItems: [],
  //     //       },
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['9.30 AM to 5.30 PM'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 500'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           // {
  //           //   listItem:
  //           //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
  //           //   subItems: [],
  //           // },
  //         ],
  //       },
  //     },
  //   ],
  // },

  // 7: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Life Management Yoga Camp - On Campus',
  //   weekDays: true,
  //   key: 'life-management-camp',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#EDBE66',
  //   timing: '9:30 am – 5:30 pm (IST)',
  //   fees: {
  //     onlineFee: 1000,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Enhance state of mind with pranayama, yoga asana and relaxation techniques',
  //   image: `${baseDomain}${courseAssets.courseAsset8}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset112}`,
  //   dates: [],
  //   online: false,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,

  //   tenure: '',
  //   courseType: 'Camps & Workshop',
  //   language: 'English',
  //   preRequisite: 'None',
  //   courseCategory: 'Self Help',
  //   courseSubType: 'Camps & Workshops',
  //   newName: 'Life Management Yoga Camp',
  //   days: [''],
  //   time: [
  //     '9:30 am – 5:30 pm (IST)'
  //   ],



  //   enrollInfo: {
  //     duration: "1 Day",
  //     timings: [
  //       {
  //         day: "Time",
  //         time: "9:30 am – 5:30 pm (IST)"
  //       }
  //     ]
  //   }
  //   ,

  //   courseCertificate: 'NO',
  //   onlineInfo: {
  //     courseMode: false,
  //   },
  //   residentialInfo: {
  //     courseMode: false,
  //     residentialMode: false
  //   },
  //   nonResidentialInfo: {
  //     courseMode: true,
  //     nonResidentialMode: true
  //   },
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this yoga camp for?',
  //         text: [
  //           'If you think about it, most of the time we are living our life without consciously thinking about what we are doing and why we are doing it. It is only when we face a problem of some kind, that we are forced to stop and take stock of things. This kind of approach does us no good. If you feel that you are stuck in life, or don’t know what to do next, or feel like your life is going nowhere, this is the camp for you! Here is a Life management yoga camp by The Yoga Institute to give you direction and discipline to go through your life happily, joyfully and with balance. Designed with the wisdom of ancient Indian teachings, there’s a whole treasure chest of tools waiting for you at this camp. Hope to see you soon!'
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'Life is a choice between B and D. Birth and Death. We are in control of C. That is the Choices we make, so make the right choices and live a happy life. -Dr. Hansaji Yogendra',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Effective tools and techniques to help you manage your life',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Specific pranayama, yoga asana and relaxation techniques to enhance your state of mind',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Yogic Diet guidelines to manage your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Offered with the program',
  //         points: [
  //           {
  //             listItem: 'Booklet with guidelines',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Wholesome Sattvik lunch',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Healthy snacks',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['9:30 am – 5:30 pm (IST)'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 1000 (Inclusive Lunch and Snacks)'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Campers are requested to have their breakfast and medication (as prescribed by their doctor).',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //   ],
  // },

  // 8: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  // textdescription1:'',
  // textdescription2:'',
  // textdescription3:'',
  // textdescription4:'',
  // textdescription5:'',
  //   title: 'Meditation Camp',
  //   key: 'meditation-camp',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#DDAB58',
  //   timing: '9.30 AM to 5.30 PM',
  //   fees: {
  //     onlineFee: 500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
  //   image: `${baseDomain}${courseAssets.courseAsset9}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset9}`,
  //   dates: [],
  //   online: true,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this workshop for?',
  //         text: [
  //           'The Meditation Camp at The Yoga Institute will take you into a deep ocean of silence, focus and peace. Here, we will give you the tools to handle your daily stresses and challenges. With the unique techniques developed at The Yoga Institute, you will learn to be less reactive and more responsive to all of life’s situations and events. You will experience the power of tranquility in every aspect of your life. You will become a new person who is balanced no matter the situation they are in.                ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'A meditative state can bring a change in your approach toward life and efficiency in work. -Dr. Hansaji Yogendra ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Effective tools and techniques to help you manage your life',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Diet guidelines to manage your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     // {
  //     //   type: 'u-list',
  //     //   content: {
  //     //     title: 'Offered with the program',
  //     //     points: [
  //     //       {
  //     //         listItem: 'Booklet with guidelines  ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Wholesome Sattvik lunch',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Healthy snacks  ',
  //     //         subItems: [],
  //     //       },
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['9.30 AM to 5.30 PM'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 500'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           // {
  //           //   listItem:
  //           //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
  //           //   subItems: [],
  //           // },
  //         ],
  //       },
  //     },
  //   ],
  // },

  9: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Pranayama Workshop - On Campus & Online',
    key: 'pranayama-workshop',
    tenure: '1 day',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    clevertapData: {
      name: 'Pranayama Workshop - On Campus & Online',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    dates: [
      // '11th May 2025', 
      // '13th Jul 2025', 
      // '14th Sep 2025', 
      // '9th Nov 2025',
      // '11th January 2026',
      // '8th March 2026',
      // '10th May 2026',
      '12th July 2026',
      '13th September 2026',
      '8th November 2026'
    ],
    mostPopular: false,
    rating: 5,
    colorCode: '#CE9B51',
    timing: '8:00 am – 11:00 am (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription:
      'Deepen your breathwork practice with guided pranayama training.',
    image: `${baseDomain}${courseAssets.courseAsset37}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/pranayama-workshop-the-yoga-institute_+246+X+135.jpg`,
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Prayanama Workshop',
    days: [''],
    time: [
      '8:00 am – 11:00 am (IST)'
    ],


    enrollInfo: {
      duration: "Half day (4 hours)",
      timings: [
        {
          day: "Time",
          time: "8:00 am – 11:00 am (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga workshop for?',
          text: [
            'Prana, the essence of life, regulates your biological system. Bio-energy is the key to your physical, mental, and spiritual well-being. Pranayama, the yogic system of regulating your life force, will help you regulate your being, keeping you meditative and balanced. At The Yoga Institute, we have pioneered specific yoga breathing techniques and pranayama techniques to help you enhance the quality of your breath and life. Come, experience the power of pranayama with us!',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            '“Master the control over your prana to experience quietude and inner harmony” - Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Effective tools and techniques to help you manage your life',
              subItems: [],
            },
            {
              listItem:
                'Specific pranayama techniques, yoga asana and relaxation practices to enhance your state of mind',
              subItems: [],
            },
            {
              listItem: 'Yogic Diet guidelines to manage your health',
              subItems: [],
            },
            {
              listItem:
                'Tips to maintain health by our spiritual guru and Institute’s Director, Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['8:00 am – 11:00 am (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 500'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
  },

  10: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Pregnancy Yoga Camp For Ante & Post Natal - Online & On Campus',
    key: 'pregnancy-camp-for-ante-post-natal',
    tenure: '2 days',
    batch: 1,
    join: true,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    clevertapData: {
      name: 'Pregnancy Yoga Camp For Ante & Post Natal - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    dates: [
      // '14th Dec & 15th Dec 2024',
      // '20th Jan & 21st Jan 2025',
      // '15th Feb & 16th Feb 2025',
      // '17th Mar & 18th Mar 2025',
      // '19th Apr & 20th Apr 2025',
      // '19th May & 20th May 2025',
      // '21st Jun & 22nd Jun 2025',
      // '21st Jul & 22nd Jul 2025',
      // '16th Aug & 17th Aug 2025',
      // '15th Sep & 16th Sep 2025',
      // '18th Oct to 19th Oct 2025',
      // '17th Nov to 18th Nov 2025',
      // '20th Dec to 21st Dec 2025',
      // '19th Jan to 20th January 2026',
      // '21st Feb to 22nd February 2026',
      // '16th Mar to 17th March 2026',
      // '18th Apr to 19th April 2026',
      // '18th to 19th May 2026',
      // '20th to 21st June 2026',
      '20th to 21st July 2026',
      '15th to 16th August 2026',
      '21st to 22nd September 2026',
      '17th to 18th October 2026',
      '16th to 17th November 2026',
      '19th to 20th December 2026',
    ],
    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 5:30 pm (IST)',
    fees: {
      onlineFee: 2000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2000 },
    },
    newFees: {
      onlineFee: 2000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2000 },
    },
    category: 'camps',
    metaDescription: 'Expert-guided yoga for prenatal care, childbirth & postnatal healing.',
    image: `${baseDomain}${courseAssets.courseAsset11}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/pregnancy-yoga-camp-for-ante-post+_+246+X+135.jpg`,
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Pregnancy Yoga Camp For Ante & Post Natal',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "2 days",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga camp for?',
          text: [
            'Parenthood is a career that never ends and the ancient path of yoga has great lessons to offer on this path. At The Yoga Institute, we have pioneered yoga techniques that are simple, scientific and useful for expecting mothers. You will be able to experience a happy and healthy pregnancy and easy delivery by following simple yoga techniques and practical guidance at our Pregnancy Yoga Camp. Come – join us, learn and practice simple yoga techniques for a happier pregnancy, delivery and baby!'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'The birth of a baby is an affirmation of life. A new baby is perhaps the greatest of teachers and an opportunity to see the continuity that life is -Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Specific pranayama, asana and relaxation techniques to enhance your state of mind',
              subItems: [],
            },
            {
              listItem: 'Yogic Diet guidelines to manage your health',
              subItems: [],
            },
            {
              listItem: 'Insightful yoga session with a medical specialists.',
              subItems: [],
            },
            {
              listItem:
                'Lifestyle tips by spiritual guru Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 2,000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: ['*Please note, the pregnancy yoga camp is open only for women after 3 months of pregnancy till the 9 months of pregnancy.'],
        },
      },
    ],
  },

  // 11: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Respiratory Yoga Workshop - On Campus',
  //   key: 'respiratory-workshop',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   }, text: ['INR 2,000'],
  //   dates: ['14th Dec 2024'],
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#DDAB58',
  //   timing: '9:30 am – 5:30 pm (IST)',
  //   fees: {
  //     onlineFee: 1000,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
  //   },
  //   category: 'camps',
  //   metaDescription: 'Insightful yoga session with a specialist',
  //   image: `${baseDomain}${courseAssets.courseAsset83}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset83}`,
  //   online: false,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,

  //   tenure: '',
  //   courseType: 'Camps & Workshop',
  //   language: 'English',
  //   preRequisite: 'None',
  //   courseCategory: 'Self Help',
  //   courseSubType: 'Camps & Workshops',
  //   newName: 'Respiratory Yoga Workshop',
  //   days: [''],
  //   time: [
  //     '9:30 am – 5:30 pm (IST)'
  //   ],
  //   enrollInfo: {
  //     duration: "1 Day",
  //     timings: [
  //       {
  //         day: "Time",
  //         time: "9:30 am – 5:30 pm (IST)"
  //       }
  //     ]
  //   }
  //   ,

  //   courseCertificate: 'NO',
  //   onlineInfo: {
  //     courseMode: false,
  //   },
  //   residentialInfo: {
  //     courseMode: false,
  //     residentialMode: false
  //   },
  //   nonResidentialInfo: {
  //     courseMode: true,
  //     nonResidentialMode: true
  //   },

  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this yoga workshop for?',
  //         text: [
  //           'Prana is the vital energy or life force, which exists in all of us. The fight against respiratory problems begins with a strong will to overcome one’s disability and has to be backed by an implicit faith in oneself. With a strong emphasis on ancient yogic knowledge and techniques, The Yoga Institute has been conducting powerful Respiratory Camps since 1987. In these camps, participants are taught yoga breathing techniques and pranayama techniques for improving lung capacity and function, mind-body balance, increased calmness and healing. Respiratory health has been well-documented in traditional systems of well-being over several millennia. The Yogic life strengthens your will, augments your faith in yourself and opens air passages. How soon you can breathe with ease and on your own, depends on yourself. What are you waiting for? Begin now!'
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           '“If you learn to breathe the right way, your life will be longer” - Dr. Hansaji Yogendra',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Specific pranayama techniques, and relaxation practices to enhance your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Dietary guidelines for overall health',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Insightful yoga session with a specialist',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru and Institute’s Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Offered with the program',
  //         points: [
  //           {
  //             listItem: 'Booklet with guidelines',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Wholesome Sattvik lunch',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Healthy snacks',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['9:30 am – 5:30 pm (IST)'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 1000 (Inclusive Lunch and Snacks)'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Campers are requested to have their breakfast and medication (as prescribed by their doctor).',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //   ],
  // },

  // 12: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Senior Citizen Yoga Workshop - On Campus',
  //   key: 'senior-citizen-workshop',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   dates: [],
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#CE9B51',
  //   timing: '10.00 am to 1:00 pm (IST)',
  //   fees: {
  //     onlineFee: 0,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Specific pranayama, yoga asana and relaxation techniques to enhance your state of mind',
  //   image: `${baseDomain}${courseAssets.courseAsset12}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset12}`,
  //   online: false,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,

  //   tenure: '',
  //   courseType: 'Camps & Workshop',
  //   language: 'English',
  //   preRequisite: 'None',
  //   courseCategory: 'Self Help',
  //   courseSubType: 'Camps & Workshops',
  //   newName: 'Senior Citizen Yoga Workshop',
  //   days: [''],
  //   time: [
  //     '10.00 am to 1:00 pm (IST)'
  //   ],


  //   enrollInfo: {
  //     duration: "Half Day",
  //     timings: [
  //       {
  //         day: "Time",
  //         time: "10.00 am to 1:00 pm (IST)"
  //       }
  //     ]
  //   }
  //   ,

  //   courseCertificate: 'NO',
  //   onlineInfo: {
  //     courseMode: false,
  //   },
  //   residentialInfo: {
  //     courseMode: false,
  //     residentialMode: false
  //   },
  //   nonResidentialInfo: {
  //     courseMode: true,
  //     nonResidentialMode: true
  //   },


  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is this yoga workshop for?',
  //         text: [
  //           'Aging is a natural and unavoidable part of life but how you handle yourself at every age can determine the quality of your life. If you are looking to improve your quality of life at a mature age, this yoga for senior citizens camp will have immense value for you. At The Yoga Institute, we teach specially simplified asana that you can do with ease and enhance your wellbeing. These yoga techniques will help you keep your body system strong and help you live a fuller life'
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What can you expect?',
  //         text: [
  //           'Age is just a number! To live a long and healthy life, take care of your mental and physical health. -Dr. Hansaji Yogendra',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Program Offerings',
  //         points: [
  //           {
  //             listItem:
  //               'Effective tools and techniques to help you manage your life',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Specific pranayama, yoga asana and relaxation techniques to enhance your state of mind',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Yogic Diet guidelines to manage your health',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Fitness tips',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     // {
  //     //   type: 'u-list',
  //     //   content: {
  //     //     title: 'Offered with the program',
  //     //     points: [
  //     //       {
  //     //         listItem: 'Booklet with guidelines  ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Wholesome Sattvik lunch',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem: 'Healthy snacks  ',
  //     //         subItems: [],
  //     //       },
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Time',
  //         text: ['10.00 am to 1:00 pm (IST)'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['INR 500 (Inclusive Lunch and Snacks)'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Guidelines',
  //         points: [
  //           {
  //             listItem:
  //               'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
  //             subItems: [],
  //           },
  //           // {
  //           //   listItem:
  //           //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
  //           //   subItems: [],
  //           // },
  //         ],
  //       },
  //     },
  //   ],
  // },

  13: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Stress Management Yoga Camp - Online & On Campus',
    key: 'stress-management-camp',
    tenure: '1 day',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    clevertapData: {
      name: 'Stress Management Yoga Camp - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    dates: [
      // '13th Apr 2025', 
      // '11th May 2025', 
      // '8th Jun 2025', 
      // '13th Jul 2025', 
      // '10th Aug 2025', 
      // '14th Sep 2025', 
      // '12th Oct 2025', 
      // '9th Nov 2025',
      //  '14th Dec 2025',
      // '11th January 2026',
      // '8th February 2026',
      // '8th March 2026',
      // '12th April 2026',
      // '10th May 2026',
      // '14th June 2026',
      '12th July 2026',
      '9th August 2026',
      '13th September 2026',
      '11th October 2026',
      '8th November 2026',
      '13th December 2026',
    ],
    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 5:30 pm (IST)',
    fees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    newFees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    category: 'camps',
    metaDescription:
      'Master pranayama, asanas & relaxation techniques to manage stress effectively.',
    image: `${baseDomain}${courseAssets.courseAsset13}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/stress-management-yoga-camp_+246+X+135.jpg`,
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Stress Management Yoga Camp',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga workshop for?',
          text: [
            'Stress is the “wear and tear” our bodies experience as we adjust to our continually changing environment. It has physical and emotional effects on us and can create positive or negative feelings. Stress loses its sting when the balanced mind perceives a stressful situation from a different scale of observation. Our goal here at the Yoga Institute is not to eliminate stress but to learn how to manage it and how to use it to help us. Learn to lead a healthy life under stressful situations at our 1-day Yoga for Stress Management camp.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'Positivity and certainty are the cornerstones of a normal healthy mind. -Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Yoga Sadhana: Specific pranayama, and relaxation techniques to enhance your wellbeing',
              subItems: [],
            },
            {
              listItem: 'Yogic Diet guidelines',
              subItems: [],
            },
            {
              listItem: 'Health counselling',
              subItems: [],
            },
            {
              listItem:
                'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 1000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
  },

  14: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Weight Loss Yoga Workshop - Online & On campus',
    key: 'weight-management-workshop',
    tenure: '1 day',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    dates: [
      // '5th Apr 2025', 
      // '3rd May 2025', 
      // '7th Jun 2025', 
      // '5th Jul 2025', 
      // '2nd Aug 2025', 
      // '6th Sep 2025', 
      // '4th Oct 2025', 
      // '1st Nov 2025', 
      // '6th Dec 2025',
      // '3rd January 2026',
      // '7th February 2026',
      // '7th March 2026',
      // '4th April 2026',
      // '2nd May 2026',
      // '6th June 2026',
      '4th July 2026',
      '1st August 2026',
      '5th September 2026',
      '3rd October 2026',
      '7th November 2026',
      '5th December 2026',
    ],
    mostPopular: false,
    rating: 5,
    colorCode: '#DDAB58',
    timing: '9:30 am – 5:30 pm (IST)',
    fees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    newFees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    clevertapData: {
      name: 'Weight Loss Yoga Workshop - Online & On campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    category: 'camps',
    metaDescription: 'Lose weight naturally with yoga techniques that energize & restore.',
    image: `${baseDomain}${courseAssets.courseAsset15}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/weight-management-the-yoga-institute_+246+X+135.jpg`,
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Weight Loss Yoga Workshop',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga workshop for?',
          text: [
            'Obesity is increasing at an alarming rate all over the world and particularly in India. There are several contributing factors towards this problem. Despite following different types of diet and weight loss programs, the results are often not satisfactory. The basic reason for this ‘yo-yo effect’ is that obesity is not the cause of the problem. It’s only the effect of some deep-rooted problem within one’s total personality complex. Yoga deals with obesity at all levels - physical, mental and spiritual and with a focus on diet. Keeping these factors in mind, The Yoga Institute has designed a special 1-day yoga camp on Weight Management. This camp will provide you with a holistic approach on wellness and train you in effective Yoga poses for weight loss. ',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            '“First, learn to accept yourself as you are” - Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Yoga for weight loss',
              subItems: [],
            },
            {
              listItem:
                'Specific pranayama, and relaxation techniques to enhance your health',
              subItems: [],
            },
            {
              listItem: 'Low-calorie diet recipe',
              subItems: [],
            },
            {
              listItem: 'Health counseling',
              subItems: [],
            },
            {
              listItem:
                'Tips to maintain health by our spiritual guru and Institute’s Director, Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 1000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
  },

  15: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Women’s Yoga Camp',
    key: 'womens-camp',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    dates: [],
    mostPopular: false,
    rating: 5,
    colorCode: '#CE9B51',
    timing: '9:30 am – 5:30 pm (IST)',
    fees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    category: 'camps',
    metaDescription:
      'Specific yoga asana, pranayama, and relaxation techniques to enhance your health',
    image: `${baseDomain}${courseAssets.courseAsset84}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/bc95ab72-0a1e-4a68-be50-4e395227358e_+270+x+148.jpg`,
    online: false,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '1 Day',
    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Womens Yoga Camp',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 Day",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga workshop for?',
          text: [
            'As a woman, to say that you face a multitude of challenges would be an understatement. So, you need the power of yoga in your life to help you cope and thrive with these challenges. Additionally, there a lot of biological changes that come at different stages of life – menopause, pregnancy, and menstruation can cause a variety of symptoms like premenstrual syndrome, menstrual cramps, headaches, and a lot of other things. We, at The Yoga Institute, have devised this women’s yoga camp to help you be strong, focused, energetic, and balanced, so that you can take on everything that comes your way and continue being the superwoman that you are! With a strong emphasis on powerful yogic routines like ritucharya and dinacharya, the yoga for women’s health camp will give you the toolbox to help you create your desired life.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'Women tend to take their health for granted because they are so focused on their responsibilities. What is needed is active effort to make well-being a priority. -Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem:
                'Wholesome tools and yoga techniques to help you manage your health',
              subItems: [],
            },
            {
              listItem:
                'Specific asana, pranayama, and relaxation techniques to enhance your health',
              subItems: [],
            },
            {
              listItem: 'Yogic Diet guidelines to manage your health',
              subItems: [],
            },
            {
              listItem: 'Insightful yoga session with medical specialist',
              subItems: [],
            },
            {
              listItem:
                'Tips to maintain health by our spiritual guru Institute Director, Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 1000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
  },

  16: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Back & Joint Disorder Yoga Workshop Online & On Campus',
    key: 'back-joint-disorder-workshop',
    tenure: '1 day',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    dates: [
      // '23rd Feb 2025',
      // '23rd Mar 2025', 
      // '27th Apr 2025', 
      // '25th May 2025',
      // '22nd Jun 2025', 
      // '27th Jul 2025', 
      // '24th Aug 2025', 
      // '28th Sep 2025', 
      // '26th Oct 2025', 
      // '23rd Nov 2025', 
      // '28th Dec 2025',
      // '25th January 2026',
      // '22nd February 2026',
      // '22nd March 2026',
      // '26th April 2026',
      // '24th May 2026',
      '28th June 2026',
      '26th July 2026',
      '23rd August 2026',
      '27th September 2026',
      '25th October 2026',
      '22nd November 2026',
      '27th December 2026',
    ],
    clevertapData: {
      name: 'Back & Joint Disorder Yoga Workshop Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 5:30 pm (IST)',
    fees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    newFees: {
      onlineFee: 1000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1000 },
    },
    category: 'camps',
    metaDescription: 'Ease back & joint pain with targeted yoga therapy & mobility practices.',
    image: `${baseDomain}${courseAssets.courseAsset10}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/orthopaedic-yoga-camp-for-back-and-joint-disorders+_+246+X+135.jpg`,
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    courseType: 'Camps & Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: 'Back & Joint Disorder Yoga Workshop',
    days: [''],
    time: [
      '9:30 am – 5:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 Day",
      timings: [
        {
          day: "Time",
          time: "9:30 am – 5:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this yoga workshop for?',
          text: [
            'Chances are that you have accepted your back and joint pain as part of your life. But it need not be so. There is potential for healing to take place within us if we cooperate with our innate healing powers. At The Yoga Institute, we have been conducting specialized orthopedic camps for over 60 years and more so, our research shows the effectiveness of our methods. We give you potent yogic methods that will have a life-changing effect. Come attend our 1-day yoga camp for back and joint disorders and experience the potential for well-being in your life.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'You don’t need a teacher, mentor, or guide to heal yourself if you have an attitude to learn from your mistakes and your pain.. -Dr. Hansaji Yogendra',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Program Offerings',
          points: [
            {
              listItem: 'Yogic Diet guidelines to manage your condition and health',
              subItems: [],
            },
            {
              listItem: 'Insightful yoga session with an ortho-specialist',
              subItems: [],
            },
            {
              listItem:
                'Specific pranayama, and relaxation techniques to enhance your health',
              subItems: [],
            },
            {
              listItem:
                'Lifestyle tips by spiritual guru Dr. Hansaji who has decades of experience in the field',
              subItems: [],
            },
            {
              listItem: 'Fitness tips',
              subItems: [],
            },
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Offered with the program',
      //     points: [
      //       {
      //         listItem: 'Booklet with guidelines  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Wholesome Sattvik lunch',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Healthy snacks  ',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['9:30 am – 5:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['INR 1000 (Inclusive Lunch and Snacks)'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Guidelines',
          points: [
            {
              listItem:
                'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute dress code.',
              subItems: [],
            },
            // {
            //   listItem:
            //     'Campers are requested to have their breakfast and medication (as prescribed by their doctor). ',
            //   subItems: [],
            // },
          ],
        },
      },
    ],
  },

  17: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '7 Days Health Camp - On Campus - Yoga Camp - Hindi',
    key: '7-days-camp',
    weekDays: true,
    join: true,
    batch: 1,
    // templateId: 'CAMP_FOR_7_DAYS_HEALTH',
    templateId: {
      templateOnline: 'CAMP_FOR_7_DAYS_HEALTH_HINDI',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    dates: [
      // '13rd Jul to 19th Jul 2024', 
      // '14th Sep to 20th Sep 2024',
      // '9th Nov to 15th Nov 2024',
      // '11th Jan to 17th Jan 2025',
      // '8th Mar to 14th Mar 2025',
      // '10th May to 16th May 2025',
      // '12th Jul to 18th Jul 2025',
      // '13th Sep to 19th Sep 2025',
      // '8th Nov to 14th Nov 2025',
      // '10th  Jan to 16th Jan 2026',
      // '14th Mar to 20th Mar 2026',
      // '9th May to 15th May 2026',
      '11th July to 17th July 2026',
      '12th Sep to 18th Sept 2026',
      '14th Nov to 20th Nov 2026',

    ],
    clevertapData: {
      name: '7 Days Health Camp - On Campus - Yoga Camp - Hindi',
      courseType: '7 Day',
      courseSubType: '7 Days Health Camp',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: '7 DAYS HEALTH CAMP',
      coursePreRequisite: ''
    },
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: true,
    certficate: false,

    tenure: '7 days',
    courseType: '7 DAYS HEALTH CAMP',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: '7 Days Health Camp',
    newName: '7 Days Health Camp',
    days: [
      'Saturday to Friday'
    ],
    time: [
      '7:00 am - 7:00 pm (IST)'
    ],
    enrollInfo: {
      duration: "7 days",
      timings: [
        {
          day: "Saturday to Friday",
          time: "7:00 am - 7:00 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: true,
      residentialMode: true
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: true,
    rating: 5,
    colorCode: '#EDBE66',
    timing: 'Saturday to Friday : 7:00 am - 7:00 pm (IST)',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 17500, nonResidentialFee: 10000 },
    },
    newFees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 17500, nonResidentialFee: 10000 },
    },
    category: 'camps',
    metaDescription:
      'Experience TYI’s signature 7-day health camp for total mind-body wellness.',
    image: `${baseDomain}${courseAssets.courseAsset35}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/0A8A2720+1_+246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'Are you feeling burned out and looking for ways to develop mental strength, improve focus & emotional quotient and reduce stress? Join our 7-Days Health Camp reshape your life and health.',
            'The 7 Days Health Camp is an experiential, introductory course to Yoga theory and practice where one can get a glimpse of a yogic lifestyle within the premises of The Yoga Institute. In this yoga program you will learn how to achieve a balance between your mind, body, and soul. Through its powerful processes, this 7 days yoga program presents to you the possibility to access and re-configure your life and health in a way that improves productivity and imparts better control on your emotions. In this fast-paced and unwavering world, this 7 Days’ Health Camp offers you the much-needed respite to connect with yourself and experience the abundant joy and beauty in life.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' The programme covers',
          points: [
            {
              listItem: 'Yoga Asanas',
              subItems: [],
            },
            {
              listItem: 'Pranayama',
              subItems: [],
            },
            {
              listItem: 'Kriyas',
              subItems: [],
            },
            {
              listItem: 'Yogic concepts',
              subItems: [],
            },
            {
              listItem: 'Diet',
              subItems: [],
            },
            {
              listItem: 'Games and recreation,',
              subItems: [],
            },
            {
              listItem: 'Attitude training',
              subItems: [],
            },
            {
              listItem: 'Relaxation and meditation.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It is ideal for anyone who wants to live a yoga way of life and experience peace within. It helps you to incorporate Yogic ideals in every field of your daily life.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Benefits of this yoga camp',
          text: [],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Mind & Soul',
          points: [
            {
              listItem:
                'Helps build upon mental strength to improve focus, clarity, and emotional quotient',
              subItems: [],
            },
            {
              listItem: 'Helps build better mind-body connection',
              subItems: [],
            },
            {
              listItem: 'Helps you reduce stress and anxiety',
              subItems: [],
            },
            {
              listItem: 'Helps you get more in control of your feelings',
              subItems: [],
            },
            {
              listItem:
                'Helps you in developing and maintaining the right routine for your overall health',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Physical',
          points: [
            {
              listItem:
                'Helps you in detoxifying your body of the accumulated toxins',
              subItems: [],
            },
            {
              listItem:
                'Helps you in strengthening immunity and digestive system',
              subItems: [],
            },
            {
              listItem: 'Helps in overall development of your personality',
              subItems: [],
            },
            {
              listItem:
                'Helps you become self-reliant in maintaining to your physical health',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Trained teachers at The Yoga Institute will be conducting this 7 days course.Come and experience, amidst nature and beauty, our rejuvenating 7 Days Health Camp, which has transformed millions of people.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PROGRAM DETAILS',
          text: [],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'UPCOMING DATES FOR 2022',
      //     text: ['13th Aug 2022to 19th Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: [
            'Saturday to Friday : 7:00 am - 7:00 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'REGISTRATION',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'For registration in the 7-Days Yoga Camp, please click on the link below and fill in all the details. Within 24 hours after registering, you will receive an email containing the link to the payment portal. You can use the link to make the payment.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FEES',
          text: [

            'Non-Residential: 10,000/- (inclusive of course fees and 4 Meals)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Residential',
      //     text: [

      //       '',
      //       'Rs. 16,500/- Triple Sharing per person (Inclusive of course fee and 4 meals a day)',
      //       // 'Rs. 23,000/- Dual Sharing per person (Inclusive of course fee and 4 meals a day)',
      //       // 'Rs. 38,000/- Single Occupancy (Inclusive of course fee and 4 meals a day)',
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Residential',
          text: [

            '',
            'Rs. 17,500/- Triple Sharing per person (Inclusive of course fee and 4 meals a day)',
            // 'Rs. 23,000/- Dual Sharing per person (Inclusive of course fee and 4 meals a day)',
            // 'Rs. 38,000/- Single Occupancy (Inclusive of course fee and 4 meals a day)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '*Please note fees once paid will be non-refundable. We support all credit cards. For making payments using MasterCard. Alternatively, you can also make payments using net banking or opt for wire transfer by writing to us.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FAQs  ',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '1. What is the time to reach the Institute during the course duration?',
          text: [
            'For residential campers, students should arrive at The Yoga Institute between 7.00 a.m. to 7.00 p.m. IST (Indian Standard Time). Please read on Hostel Facility for more details.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '2. Can a person who has problem with sitting on the floor for a long time enroll for the course?',
          text: [
            'Backrest and chairs are available on request in special and exceptional cases. – Rest and recreation are also a part of the course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '3. How many seats are available in one course?',
          text: [
            'Only 35 seats are available. Registrations on a first come, first-serve basis only.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'UNIQUE OFFERINGS ',
          text: [''],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Our Amenities / Our Facilities',
          points: [
            {
              listItem:
                'Yoga Library: Explore one of largest collections of spiritual and philosophical books to expand your knowledge',
              subItems: [],
            },
            {
              listItem:
                'Internet Room: Access the internet in a comfortable setting when you need Meditation Pods: Meditate on the five fundamental natural elements, the Panchamahabhutas,',
              subItems: [],
            },
            {
              listItem:
                'Acupressure Path: Give your feet a natural massage and activate your vital energies',
              subItems: [],
            },
            {
              listItem:
                'Yogic Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area',
              subItems: [],
            },
            {
              listItem:
                'Dining Area: Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem:
                'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },
  18: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '7 Days Health Camp - On Campus - Yoga Camp - English',
    key: '7-days-camp-english',
    join: true,
    batch: 1,
    // templateId: 'CAMP_FOR_7_DAYS_HEALTH',
    templateId: {
      templateOnline: 'CAMP_FOR_7_DAYS_HEALTH',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    dates: [

      // '23rd Mar to 29th Mar 2024',
      // '27th Apr to 3rd May 2024',
      // '25th May to 31st May 2024',
      // '22nd Jun to 28th Jun 2024',
      // '27th Jul to 2nd Aug 2024',
      // '24th Aug to 30th Aug 2024',
      // '28th Sep to 4th Oct 2024',
      // '26th Oct to 1st Nov 2024',
      // '23rd Nov to 29th Nov 2024',
      // '28th Dec to 3rd Jan 2025',
      // '25th Jan to 31st Jan 2025',
      // '22nd Feb to 28th Feb 2025',
      // '22nd Mar to 28th Mar 2025',
      // '26th Apr to 2nd May 2025',
      // '24th May to 30th May 2025',
      // '28th Jun to 4th Jul 2025',
      // '26th Jul to 1st Aug 2025',
      // '23rd Aug to 29th Aug 2025',
      // '27th Sep to 3rd Oct 2025',
      // '25th Oct to 31st Oct 2025',
      // '22nd Nov to 28th Nov 2025',
      // '27th Dec to 2nd Jan 2026',
      // '24th Jan to 30th Jan 2026',
      // '28th Feb  to 6th March 2026',
      // '28th March to 3rd April 2026',
      // '25th April to 1st May 2026',
      // '23rd May to 29th May 2026',
      // '27th June to 3rd July 2026',
      '25th July to 31st July 2026',
      '22nd Aug to 28th Aug 2026',
      '26th Sep to 2nd Oct 2026',
      '24th Oct to 30th Oct 2026',
      '28th Nov to 4th Dec 2026',
      '26th Dec to 1st  Jan 2027',
    ],
    clevertapData: {
      name: '7 Days Health Camp - On Campus - Yoga Camp - English',
      courseType: '7 Day',
      courseSubType: '7 Days Health Camp',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: '7 DAYS HEALTH CAMP',
      coursePreRequisite: ''
    },
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: true,
    certficate: false,

    tenure: '7 days',
    courseType: '7 DAYS HEALTH CAMP',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: '7 Days Health Camp',
    newName: '7 Days Health Camp',
    days: [
      'Saturday to Friday'
    ],
    time: [
      '7:00 am - 7:00 pm (IST)'
    ],
    enrollInfo: {
      duration: "7 days",
      timings: [
        {
          day: "Saturday to Friday",
          time: "7:00 am - 7:00 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: true,
      residentialMode: true
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },


    mostPopular: true,
    rating: 5,
    colorCode: '#EDBE66',
    timing: 'Saturday to Friday : 7:00 am - 7:00 pm (IST)',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 17500, nonResidentialFee: 10000 },
    },
    newFees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 17500, nonResidentialFee: 10000 },
    },
    category: 'camps',
    metaDescription:
      'Experience TYI’s signature 7-day health camp for total mind-body wellness.',
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/0A8A2720+1_+246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'Are you feeling burned out and looking for ways to develop mental strength, improve focus emotional quotient and reduce stress? Join our 7-Days Health Camp reshape your life and health.',
            'The 7 Days Health Camp is an experiential, introductory course to Yoga theory and practice where one can get a glimpse of a yogic lifestyle within the premises of The Yoga Institute. In this yoga health-camp you will learn how to achieve a balance between your mind, body, and soul. Through its powerful processes, this yoga program presents to you the possibility to access and re-configure your life and health in a way that improves productivity and imparts better control on your emotions. In this fast-paced and unwavering world, this 7 Days’ Yoga Health Camp offers you the much-needed respite to connect with yourself and experience the abundant joy and beauty in life.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' The programme covers',
          points: [
            {
              listItem: 'Yoga Asanas',
              subItems: [],
            },
            {
              listItem: 'Pranayama',
              subItems: [],
            },
            {
              listItem: 'Kriya Yoga',
              subItems: [],
            },
            {
              listItem: 'Yogic concepts',
              subItems: [],
            },
            {
              listItem: 'Diet',
              subItems: [],
            },
            {
              listItem: 'Games and recreation',
              subItems: [],
            },
            {
              listItem: 'Attitude training',
              subItems: [],
            },
            {
              listItem: 'Relaxation and meditation.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It is ideal for anyone who wants to live a yoga way of life and experience peace within. It helps you to incorporate Yogic ideals in every field of your daily life.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Benefits of this yoga camp',
          text: [],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Mind & Soul',
          points: [
            {
              listItem:
                'Helps build upon mental strength to improve focus, clarity, and emotional quotient',
              subItems: [],
            },
            {
              listItem: 'Helps build better mind-body connection',
              subItems: [],
            },
            {
              listItem: 'Helps you reduce stress and anxiety',
              subItems: [],
            },
            {
              listItem: 'Helps you get more in control of your feelings',
              subItems: [],
            },
            {
              listItem:
                'Helps you in developing and maintaining the right routine for your overall health',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Physical',
          points: [
            {
              listItem:
                'Helps you in detoxifying your body of the accumulated toxins',
              subItems: [],
            },
            {
              listItem:
                'Helps you in strengthening immunity and digestive system',
              subItems: [],
            },
            {
              listItem: 'Helps in overall development of your personality',
              subItems: [],
            },
            {
              listItem:
                'Helps you become self-reliant in maintaining to your physical health',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Trained yoga teachers at The Yoga Institute will be conducting this yoga course.Come and experience, amidst nature and beauty, our rejuvenating 7 Days Health Camp, which has transformed millions of people.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PROGRAM DETAILS',
          text: [],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'UPCOMING DATES FOR 2022',
      //     text: ['13th Aug 2022to 19th Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: [
            'Saturday to Friday : 7:00 am - 7:00 pm (IST)'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'REGISTRATION',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'For registration in the 7-Days Yoga Camp, Within 24 hours after registering, you will receive an email containing the link to the payment portal. You can use the link to make the payment.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FEES',
          text: [
            'Non-Residential: 10,000/- (inclusive of course fees and 4 Meals)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Residential',
      //     text: [

      //       '',
      //       'Rs. 16,500/- Triple Sharing per person (Inclusive of course fee and 4 meals a day)',
      //       // 'Rs. 23,000/- Dual Sharing per person (Inclusive of course fee and 4 meals a day)',
      //       // 'Rs. 38,000/- Single Occupancy (Inclusive of course fee and 4 meals a day)',
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Residential',
          text: [

            '',
            'Rs. 17,500/- Triple Sharing per person (Inclusive of course fee and 4 meals a day)',
            // 'Rs. 23,000/- Dual Sharing per person (Inclusive of course fee and 4 meals a day)',
            // 'Rs. 38,000/- Single Occupancy (Inclusive of course fee and 4 meals a day)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '*Please note fees once paid will be non-refundable. We support all credit cards. For making payments using MasterCard. Alternatively, you can also make payments using net banking or opt for wire transfer by writing to us.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FAQs  ',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '1. What is the time to reach the Institute during the course duration?',
          text: [
            'For residential campers, students should arrive at The Yoga Institute between 7.00 a.m. to 7.00 p.m. IST (Indian Standard Time). Please read on Hostel Facility for more details.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '2. Can a person who has problem with sitting on the floor for a long time enroll for the course?',
          text: [
            'Backrest and chairs are available on request in special and exceptional cases. – Rest and recreation are also a part of the course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '3. How many seats are available in one course?',
          text: [
            'Only 35 seats are available. Registrations on a first come, first-serve basis only.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'UNIQUE OFFERINGS ',
          text: [''],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Our Amenities / Our Facilities',
          points: [
            {
              listItem:
                'Yoga Library: Explore one of largest collections of spiritual and philosophical books to expand your knowledge',
              subItems: [],
            },
            {
              listItem:
                'Internet Room: Access the internet in a comfortable setting when you need Meditation Pods: Meditate on the five fundamental natural elements, the Panchamahabhutas,',
              subItems: [],
            },
            {
              listItem:
                'Acupressure Path: Give your feet a natural massage and activate your vital energies',
              subItems: [],
            },
            {
              listItem:
                'Yogic Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area',
              subItems: [],
            },
            {
              listItem:
                'Dining Area: Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem:
                'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },
  19: {
    id: '',
    textdescription6: 'Please Note: Both morning and evening batches are required to participate in Satsang, followed by their classes, on all Sundays during their 21-day course duration. Class timings are from 8:30 am to 9:30 am, followed by Satsang from 9:30 am to 10:30 am.',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    textdescription10: '',
    weekDays: true,
    title: '21-Days Better Living Yoga Course - Morning Online and On Campus – English - Batch 1',
    key: '21-days-better-living-course',
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'CAMP_FOR_21_DAYS_BATCH_1',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    batch: 1,
    dates: [

      // '3rd Mar to 23rd Mar 2024',
      // '7th Apr to 27th Apr 2024',
      // '5th May to 25th May 2024',
      // '2nd Jun to 22nd Jun 2024',
      // '7th Jul to 27th Jul 2024',
      // '4th Aug to 24th Aug 2024',
      // '1st Sep to 21st Sep 2024',
      // '6th Oct to 26th Oct 2024',
      // '3rd Nov to 23rd Nov 2024',
      // '1st Dec to 21st Dec 2024',
      // '5th Jan to 25th Jan 2025',
      // '2nd Feb to 22nd Feb 2025',
      // '2nd Mar to 22nd Mar 2025',
      // '6th Apr to 26th Apr 2025',
      // '4th May to 24th May 2025',
      // '1st Jun to 21st Jun 2025',
      // '6th Jul to 26th Jul 2025',
      // '3rd Aug to 23rd Aug 2025',
      // '7th Sep to 27th Sep 2025',
      // '5th Oct to 25th Oct 2025',
      // '2nd Nov to 22nd Nov 2025',
      // '7th Dec to 27th Dec 2025',
      // '4th Jan to 24th Jan 2026',
      // '1st Feb to 21st  Feb 2026',
      // '1st Mar to 21st Mar 2026',
      // '5th April to 25th April 2026',
      // '3th May to 23rd May 2026',
      // '7th June to 27th June 2026',
      '5th July to 25th July 2026',
      '2nd Aug to 22nd Aug 2026',
      '6th Sept to 26th Sept 2026',
      '4th Oct to 24th Oct 2026',
      '1st Nov to 21st Nov 2026',
      '6th Dec to 26th Dec 2026',
    ],
    clevertapData: {
      name: '21 Days Better Living Course ( Morning Batch )',
      courseType: '21 Day',
      courseSubType: '21 Days Better Living',
      courseCategory: 'Self Help',
      courseCertificate: 'certificate Of Participation',
      courseTopCategory: '21-Days Better living Course',
      coursePreRequisite: ''
    },
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '21 days',
    courseType: '21-Days Better living Course',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: '21 Days Better Living',
    newName: '21 Days Better Living Course Batch 1',
    days: [],
    time: [
      'Morning: 7:00 am – 8:30 am (IST)'
    ],
    enrollInfo: {
      duration: "21 days",
      timings: [
        {
          day: "Sunday to Saturday",
          time: "Morning: 7:00 am – 8:30 am (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },


    // tenure: '',
    // courseType: '21-Days Better living Course',
    // language: 'English',
    // preRequisite: 'None',
    // courseCategory: 'Self Help', 
    // courseSubType: 'Yoga Course',

    // courseCertificate: 'certificate Of Participation',
    // onlineInfo: {
    //   courseMode: false,
    // },
    // residentialInfo: {
    //   courseMode: false,
    //   residentialMode: false
    // },
    // nonResidentialInfo: {
    //   courseMode: true,
    //   nonResidentialMode: true
    // },

    mostPopular: true,
    rating: 5,
    colorCode: '#EDBE66',
    timing: 'Morning: 7:00 am – 8:30 am (IST)',
    fees: {
      onlineFee: 2750,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2750 },
    },
    newFees: {
      onlineFee: 2750,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2750 },
    },
    category: 'camps',
    metaDescription: 'Embrace a healthier lifestyle in 21 days with our signature program. ',
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/21-days+-better-living-course_+246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'Become successful, healthy, stress-free, and more mindful in your relationships by learning the yogic way of living. Join The Yoga Institute’s 21-Days Better Living Yoga Course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It takes 21 days to build a habit into your daily routine. The Yoga Institute’s 21 Days Better Living Course is a course specifically designed to introduce you to the yogic way of living. begin your journey into the discovery of Yoga. Working professionals and house makers can take just one hour from their day to practice and learn yoga and begin their transformational journey.',
            'This is a yoga certificate course and has been successfully conducted for 50 years by the Institute. The program trains you holistically and enables you to achieve equilibrium between your mind and body and thus achieve a state of peace and happiness in life. The course is conducted by trained teachers at the Institute.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' The programme covers an introduction to: ',
          points: [
            {
              listItem: 'Astanga Yoga',
              subItems: [],
            },
            {
              listItem: 'Yoga Asanas',
              subItems: [],
            },
            {
              listItem: 'Pranayama',
              subItems: [],
            },
            {
              listItem: 'Kriyas',
              subItems: [],
            },
            {
              listItem: 'Attitude training  ',
              subItems: [],
            },
            {
              listItem: 'Parisamvad (sessions with Dr. Hansaji)',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It is ideal for anyone who wants to live a yoga way of life and experience peace within. It helps you to incorporate Yogic ideals in every field of your daily life.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Benefits of this camp: ',
          points: [
            {
              listItem:
                'Helps you in developing and maintaining the right routine for your overall health',
              subItems: [],
            },

            {
              listItem: 'Helps you reduce stress and anxiety',
              subItems: [],
            },
            {
              listItem: 'Helps you feel energetic throughout the day',
              subItems: [],
            },
            {
              listItem: 'Helps you become mindful in your relationships',
              subItems: [],
            },
            {
              listItem: 'Helps you get more in control of your feelings',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Come and experience, amidst nature and beauty, our enriching 21 Days Better Living yoga Course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PROGRAM DETAILS',
          text: [
            'The yoga certificate course is held once a month, starting on the first Sunday (7:00 a.m.) of every month. The classes are of 1 hr. 30 mins each day for 21 consecutive days. Participants can opt for the morning or evening batches.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'UPCOMING DATES FOR 2022',
      //     text: [],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Morning 7:00 am – 8:30 am (IST)', 'Please Note: Both morning and evening batches are required to participate in Satsang, followed by their classes, on all Sundays during their 21-day course duration. Class timings are from 8:30 am to 9:30 am, followed by Satsang from 9:30 am to 10:30 am.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'REGISTRATION',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'For registration in the 21 Days Better Living Yoga Course, please click on the link below and fill in all the details. Within 24 hours after registering, you will receive an email containing the link to the payment portal. You can use the link to make the payment.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'FEES',
      //     text: [

      //       'Rs. 2500/-'
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'FEES',
          text: [

            'Rs. 2750/-'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          // title: '',
          text: [
            '*Please note fees once paid will be non-refundable. Also, after making the payment, please provide us with a screenshot of the transaction.',
            'We support all credit cards. For making payments using MasterCard. Alternatively, you can also make payments using net banking or opt for wire transfer by writing to us.',
          ],
        },
      },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'PRE-REQUISITES',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: ' A MANDATORY PREREQUISITE FOR THIS COURSE IS:',
      //     points: [
      //       {
      //         listItem:
      //           'Covid test RT-PCR results dated 20th Jan 2022to 28th Jan 2022and later for entry into the premises post prior registration. ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Students must use personal vehicles for commuting, throughout the course duration. We would discourage the use of public transport. (For non-residential students)',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'This course is for healthy individuals. Kindly note if you suffer from any health issues like diabetes, hypertension, or orthopaedic problems, kindly take prior approval.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For international Students, it is mandatory to do 14 Day Quarantine as per the laws of Government of India along with RT-PCR test reports. ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Last but not the least, do not forget your masks and Yoga Mats',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'COURSE CERTIFICATION',
          text: [
            'To be eligible for a certificate, a minimum of 18 days attendance is compulsory.  If, for any reason, you were unable to attend 2 or 3 sessions and would like to make up for these in the upcoming batch, you will be required to re-enroll for the course and complete the payment process again.',
            'Online students must activate their video cameras for attendance to be recorded.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FAQs  ',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '1. What is the time to reach the Institute during the course duration?',
          text: [
            'For residential campers, students should arrive at The Yoga Institute between 7.00 a.m. to 7.00 p.m. IST (Indian Standard Time). Please read on Hostel Facility for more details.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '2. Can a person who has problem with sitting on the floor for a long time enroll for the yoga course?',
          text: [
            'Backrest and chairs are available on request in special and exceptional cases. – Rest and recreation are also a part of the course.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '3. How many seats are available in one course?',
      //     text: [
      //       'Only 35 seats are available. Registrations on a first come, first-serve basis only',
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Please Note',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'The payment validity and session attendance for 21-Days Better Living Course is only applicable for one month.',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'UNIQUE OFFERINGS ',
          text: [''],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Our Amenities / Our Facilities',
          points: [
            {
              listItem:
                'Yoga Library: Explore one of largest collections of spiritual and philosophical books to expand your knowledge',
              subItems: [],
            },
            {
              listItem:
                'Internet Room: Access the internet in a comfortable setting when you need Meditation Pods: Meditate on the five fundamental natural elements, the Panchamahabhutas,',
              subItems: [],
            },
            {
              listItem:
                'Acupressure Path: Give your feet a natural massage and activate your vital energies',
              subItems: [],
            },
            {
              listItem:
                'Yogic Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area',
              subItems: [],
            },
            {
              listItem:
                'Dining Area: Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem:
                'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },
  20: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekDays: true,
    title: '21-Days Better Living Yoga Course - Evening - Online & On Campus – English - Batch 2',
    key: '21-days-better-living-course-batch-2',
    batch: 2,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'CAMP_FOR_21_DAYS_BATCH_2',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    clevertapData: {
      name: '21 Days Better Living Course ( Evening Batch )',
      courseType: '21 Day',
      courseSubType: '21 Days Better Living',
      courseCategory: 'Self Help',
      courseCertificate: 'certificate Of Participation',
      courseTopCategory: '21-Days Better living Course',
      coursePreRequisite: ''
    },
    dates: [
      // '3rd Mar to 23rd Mar 2024',
      // '7th Apr to 27th Apr 2024',
      // '5th May to 25th May 2024',
      // '2nd Jun to 22nd Jun 2024',
      // '7th Jul to 27th Jul 2024',
      // '4th Aug to 24th Aug 2024',
      // '1st Sep to 21st Sep 2024',
      // '6th Oct to 26th Oct 2024',
      // '3rd Nov to 23rd Nov 2024',
      // '1st Dec to 21st Dec 2024',
      // '5th Jan to 25th Jan 2025',
      // '2nd Feb to 22nd Feb 2025',
      // '2nd Mar to 22nd Mar 2025',
      // '6th Apr to 26th Apr 2025',
      // '4th May to 24th May 2025',
      // '1st Jun to 21st Jun 2025',
      // '6th Jul to 26th Jul 2025',
      // '3rd Aug to 23rd Aug 2025',
      // '7th Sep to 27th Sep 2025',
      // '5th Oct to 25th Oct 2025',
      // '2nd Nov to 22nd Nov 2025',
      // '7th Dec to 27th Dec 2025',
      // '4th Jan to 24th Jan 2026',
      // '1st Feb to 21st  Feb 2026',
      // '1st Mar to 21st Mar 2026',
      // '5th April to 25th April 2026',
      // '3th May to 23rd May 2026',
      // '7th June to 27th June 2026',
      '5th July to 25th July 2026',
      '2nd Aug to 22nd Aug 2026',
      '6th Sept to 26th Sept 2026',
      '4th Oct to 24th Oct 2026',
      '1st Nov to 21st Nov 2026',
      '6th Dec to 26th Dec 2026'
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '21 Days',
    courseType: '21-Days Better living Course',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: '21 Days Better Living',
    newName: '21 Days Better Living Course Batch 2',
    days: [''],
    time: ['Evening 6:30 pm – 8:00 pm (IST)'],
    enrollInfo: {
      duration: "21 Days",
      timings: [
        {
          day: "Sunday to Saturday",
          time: "Evening 6:30 pm – 8:00 pm (IST)"
        }
      ]
    },

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: true,

    rating: 5,
    colorCode: '#EDBE66',
    timing: 'Evening 6:30 pm – 8:00 pm (IST)',
    fees: {
      onlineFee: 2750,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2750 },
    },
    newFees: {
      onlineFee: 2750,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2750 },
    },
    category: 'camps',
    metaDescription:
      `Embrace a healthier lifestyle in 21 days with our signature program.`,
    image: `${baseDomain}${courseAssets.courseAsset35}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/21-days+-better-living-course_+246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'Become successful, healthy, stress-free, and more mindful in your relationships by learning the yogic way of living. Join The Yoga Institute’s 21-Days Better Living Yoga Course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It takes 21 days to build a habit into your daily routine. The Yoga Institute’s 21 Days Better Living Course is a course specifically designed to introduce you to the yogic way of living. begin your journey into the discovery of Yoga. Working professionals and house makers can take just one hour from their day to practice and learn yoga and begin their transformational journey.',
            'This is a yoga certificate course and has been successfully conducted for 50 years by the Institute. The program trains you holistically and enables you to achieve equilibrium between your mind and body and thus achieve a state of peace and happiness in life. The course is conducted by trained teachers at the Institute.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'The programme covers an introduction to:',
          points: [
            {
              listItem: 'Astanga Yoga',
              subItems: [],
            },
            {
              listItem: 'Yoga Asanas',
              subItems: [],
            },
            {
              listItem: 'Pranayama',
              subItems: [],
            },
            {
              listItem: 'Kriyas',
              subItems: [],
            },
            {
              listItem: 'Attitude training  ',
              subItems: [],
            },
            {
              listItem: 'Parisamvad (sessions with Dr. Hansaji)',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It is ideal for anyone who wants to live a yoga way of life and experience peace within. It helps you to incorporate Yogic ideals in every field of your daily life.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Benefits of this camp: ',
          points: [
            {
              listItem:
                'Helps you in developing and maintaining the right routine for your overall health',
              subItems: [],
            },

            {
              listItem: 'Helps you reduce stress and anxiety',
              subItems: [],
            },
            {
              listItem: 'Helps you feel energetic throughout the day',
              subItems: [],
            },
            {
              listItem: 'Helps you become mindful in your relationships',
              subItems: [],
            },
            {
              listItem: 'Helps you get more in control of your feelings',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Come and experience, amidst nature and beauty, our enriching 21 Days Better Living yoga Course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PROGRAM DETAILS',
          text: [
            'The yoga certificate course is held once a month, starting on the first Sunday (7:00 a.m.) of every month. The classes are of 1 hr. 30 mins each day for 21 consecutive days. Participants can opt for the morning or evening batches.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'UPCOMING DATES FOR 2022',
      //     text: ['7th Aug 2022to 27th Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Evening 6:30 pm – 8:00 pm (IST)', 'Please Note: Both morning and evening batches are required to participate in Satsang, followed by their classes, on all Sundays during their 21-day course duration. Class timings are from 8:30 am to 9:30 am, followed by Satsang from 9:30 am to 10:30 am.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'REGISTRATION',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'For registration in the 21 Days Better Living Yoga Course, please click on the link below and fill in all the details. Within 24 hours after registering, you will receive an email containing the link to the payment portal. You can use the link to make the payment.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'FEES',
      //     text: [

      //       'Rs. 2500/-'
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'FEES',
          text: [

            'Rs. 2750/-'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          // title: 'Rs. 2500/-',
          text: [
            '*Please note fees once paid will be non-refundable. Also, after making the payment, please provide us with a screenshot of the transaction.',
            'We support all credit cards. For making payments using MasterCard. Alternatively, you can also make payments using net banking or opt for wire transfer by writing to us.',
          ],
        },
      },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'PRE-REQUISITES',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: ' A MANDATORY PREREQUISITE FOR THIS COURSE IS:',
      //     points: [
      //       {
      //         listItem:
      //           'Covid test RT-PCR results dated 20th Jan 2022to 28th Jan 2022and later for entry into the premises post prior registration. ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Students must use personal vehicles for commuting, throughout the course duration. We would discourage the use of public transport. (For non-residential students)',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'This course is for healthy individuals. Kindly note if you suffer from any health issues like diabetes, hypertension, or orthopaedic problems, kindly take prior approval.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For international Students, it is mandatory to do 14 Day Quarantine as per the laws of Government of India along with RT-PCR test reports. ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Last but not the least, do not forget your masks and Yoga Mats',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'COURSE CERTIFICATION',
          text: [
            'To be eligible for a certificate, a minimum of 18 days attendance is compulsory.  If, for any reason, you were unable to attend 2 or 3 sessions and would like to make up for these in the upcoming batch, you will be required to re-enroll for the course and complete the payment process again.',
            'Online students must activate their video cameras for attendance to be recorded.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FAQs  ',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '1. What is the time to reach the Institute during the course duration?',
          text: [
            'For residential campers, students should arrive at The Yoga Institute between 7.00 a.m. to 7.00 p.m. IST (Indian Standard Time). Please read on Hostel Facility for more details.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '2. Can a person who has problem with sitting on the floor for a long time enroll for the course?',
          text: [
            'Backrest and chairs are available on request in special and exceptional cases. – Rest and recreation are also a part of the course.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '3. How many seats are available in one course?',
      //     text: [
      //       'Only 35 seats are available. Registrations on a first come, first-serve basis only.',
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Please Note',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'The payment validity and session attendance for 21-Days Better Living Course is only applicable for one month. However, in emergency circumstances, the participant can attend the 21-Days BLC sessions for the next month but only on approval of the management. Without authorisation, the participant will not be allowed to attend the sessions post the actual sessions of the course.',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'UNIQUE OFFERINGS ',
          text: [''],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Our Amenities / Our Facilities',
          points: [
            {
              listItem:
                'Yoga Library: Explore one of largest collections of spiritual and philosophical books to expand your knowledge',
              subItems: [],
            },
            {
              listItem:
                'Internet Room: Access the internet in a comfortable setting when you need Meditation Pods: Meditate on the five fundamental natural elements, the Panchamahabhutas,',
              subItems: [],
            },
            {
              listItem:
                'Acupressure Path: Give your feet a natural massage and activate your vital energies',
              subItems: [],
            },
            {
              listItem:
                'Yogic Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area',
              subItems: [],
            },
            {
              listItem:
                'Dining Area: Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem:
                'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },
  21: {
    id: '',
    textdescription6: 'Please Note: Both morning and evening batches are required to participate in Satsang, followed by their classes, on all Sundays during their 21-day course duration. Class timings are from 8:30 am to 9:30 am, followed by Satsang from 9:30 am to 10:30 am.',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '21-Days Better Living Yoga Course - Evening - Online & On Campus – Hindi - Batch 3',
    key: '21-days-better-living-course-batch-3',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'CAMP_FOR_21_DAYS_BATCH_3',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    clevertapData: {
      name: '21 Days Hindi Course',
      courseType: '21 Day',
      courseSubType: '21 Days Better Living',
      courseCategory: 'Self Help',
      courseCertificate: 'certificate Of Participation',
      courseTopCategory: '21-Days Better living Course',
      coursePreRequisite: ''
    },
    dates: [

      // '10th Mar to 30th Mar 2024',
      // '14th Jul to 3rd Aug 2024',
      // '11th Aug to 31st Aug 2024',
      // '8th Sep to 28th Sep 2024',
      // '13th Oct to 2nd Nov 2024',
      // '10th Nov to 30th Nov 2024',
      // '8th Dec to 28th Dec 2024',
      // '9th Feb to 1st Mar 2025',
      // '13th Apr to 3rd May 2025',
      // '8th Jun to 28th Jun 2025',
      // '10th Aug to 30th Aug 2025',
      // '12th Oct to 1st Nov 2025',
      // '14th Dec to 3rd Jan 2026',
      // '8th Feb to 28th Feb 2026',
      // '12th April to 2nd May 2026',
      // '14th June to 4th July 2026',
      '9th Aug to 29th Aug 2026',
      '11th Oct to 31st Oct 2026',
      '13th Dec to 2nd Jan 2027',

    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '21 days',
    courseType: '21-Days Better living Course',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: '21 Days Better Living',
    newName: '21 Days Better Living Course Batch 3',
    days: [''],
    time: [
      'Evening 6:30 pm – 8:00 pm (IST)'
    ],
    enrollInfo: {
      duration: "21 days",
      timings: [
        {
          day: "Sunday to Saturday",
          time: "Evening 6:30 pm – 8:00 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: true,
    rating: 5,
    colorCode: '#EDBE66',
    timing: 'Evening 6:30 pm – 8:00 pm (IST)',
    fees: {
      onlineFee: 2750,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2750 },
    },
    newFees: {
      onlineFee: 2750,
      offlineFee: { residentialFee: 0, nonResidentialFee: 2750 },
    },
    category: 'camps',
    metaDescription: 'Embrace a healthier lifestyle in 21 days with our signature program. ',
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/21-days+-better-living-course_+246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'Become successful, healthy, stress-free, and more mindful in your relationships by learning the yogic way of living. Join The Yoga Institute’s 21-Days Better Living Yoga Course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It takes 21 days to build a habit into your daily routine. The Yoga Institute’s 21 Days Better Living Course is a course specifically designed to introduce you to the yogic way of living. begin your journey into the discovery of Yoga. Working professionals and house makers can take just one hour from their day to practice and learn yoga and begin their transformational journey.',
            'This is a yoga certificate course and has been successfully conducted for 50 years by the Institute. The program trains you holistically and enables you to achieve equilibrium between your mind and body and thus achieve a state of peace and happiness in life. The course is conducted by trained teachers at the Institute.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' The programme covers an introduction to: ',
          points: [
            {
              listItem: 'Astanga Yoga',
              subItems: [],
            },
            {
              listItem: 'Yoga Asanas',
              subItems: [],
            },
            {
              listItem: 'Pranayama',
              subItems: [],
            },
            {
              listItem: 'Kriyas',
              subItems: [],
            },
            {
              listItem: 'Attitude training  ',
              subItems: [],
            },
            {
              listItem: 'Parisamvad (sessions with Dr. Hansaji)',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'It is ideal for anyone who wants to live a yoga way of life and experience peace within. It helps you to incorporate Yogic ideals in every field of your daily life.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Benefits of this camp: ',
          points: [
            {
              listItem:
                'Helps you in developing and maintaining the right routine for your overall health',
              subItems: [],
            },

            {
              listItem: 'Helps you reduce stress and anxiety',
              subItems: [],
            },
            {
              listItem: 'Helps you feel energetic throughout the day',
              subItems: [],
            },
            {
              listItem: 'Helps you become mindful in your relationships',
              subItems: [],
            },
            {
              listItem: 'Helps you get more in control of your feelings',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Come and experience, amidst nature and beauty, our enriching 21 Days Better Living yoga Course.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PROGRAM DETAILS',
          text: [
            'The yoga course is held once a month, starting on the first Sunday (7:00 a.m.) of every month. The classes are of 1 hr. 30 mins each day for 21 consecutive days. Participants can opt for the morning or evening batches.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'UPCOMING DATES FOR 2022',
      //     text: [],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Evening 6:30 pm – 8:00 pm (IST) ( Yoga in Hindi)', 'Please Note: Both morning and evening batches are required to participate in Satsang, followed by their classes, on all Sundays during their 21-day course duration. Class timings are from 8:30 am to 9:30 am, followed by Satsang from 9:30 am to 10:30 am.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'REGISTRATION',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'For registration in the 21 Days Better Living Course, please click on the link below and fill in all the details. Within 24 hours after registering, you will receive an email containing the link to the payment portal. You can use the link to make the payment.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'FEES',
      //     text: [

      //       'Rs. 2500/-'
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'FEES',
          text: [

            'Rs. 2750/-'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          // title: 'Rs. 2500/-',
          text: [
            '*Please note fees once paid will be non-refundable. Also, after making the payment, please provide us with a screenshot of the transaction.',
            'We support all credit cards. For making payments using MasterCard. Alternatively, you can also make payments using net banking or opt for wire transfer by writing to us.',
          ],
        },
      },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'PRE-REQUISITES',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: ' A MANDATORY PREREQUISITE FOR THIS COURSE IS:',
      //     points: [
      //       {
      //         listItem:
      //           'Covid test RT-PCR results dated 20th Jan 2022to 28th Jan 2022and later for entry into the premises post prior registration. ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Students must use personal vehicles for commuting, throughout the course duration. We would discourage the use of public transport. (For non-residential students)',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'This course is for healthy individuals. Kindly note if you suffer from any health issues like diabetes, hypertension, or orthopaedic problems, kindly take prior approval.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For international Students, it is mandatory to do 14 Day Quarantine as per the laws of Government of India along with RT-PCR test reports. ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Last but not the least, do not forget your masks and Yoga Mats',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'COURSE CERTIFICATION',
          text: [
            'To be eligible for a certificate, a minimum of 18 days attendance is compulsory.  If, for any reason, you were unable to attend 2 or 3 sessions and would like to make up for these in the upcoming batch, you will be required to re-enroll for the course and complete the payment process again.',
            'Online students must activate their video cameras for attendance to be recorded.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FAQs  ',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '1. What is the time to reach the Institute during the course duration?',
          text: [
            'For residential campers, students should arrive at The Yoga Institute between 7.00 a.m. to 7.00 p.m. IST (Indian Standard Time). Please read on Hostel Facility for more details.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title:
            '2. Can a person who has problem with sitting on the floor for a long time enroll for the course?',
          text: [
            'Backrest and chairs are available on request in special and exceptional cases. – Rest and recreation are also a part of the course.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '3. How many seats are available in one course?',
      //     text: [
      //       'Only 35 seats are available. Registrations on a first come, first-serve basis only.',
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Please Note',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'The payment validity and session attendance for 21-Days Better Living Course is only applicable for one month. However, in emergency circumstances, the participant can attend the 21-Days BLC sessions for the next month but only on approval of the management. Without authorisation, the participant will not be allowed to attend the sessions post the actual sessions of the course.',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'UNIQUE OFFERINGS ',
          text: [''],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Our Amenities / Our Facilities',
          points: [
            {
              listItem:
                'Yoga Library: Explore one of largest collections of spiritual and philosophical books to expand your knowledge',
              subItems: [],
            },
            {
              listItem:
                'Internet Room: Access the internet in a comfortable setting when you need Meditation Pods: Meditate on the five fundamental natural elements, the Panchamahabhutas,',
              subItems: [],
            },
            {
              listItem:
                'Acupressure Path: Give your feet a natural massage and activate your vital energies',
              subItems: [],
            },
            {
              listItem:
                'Yogic Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area',
              subItems: [],
            },
            {
              listItem:
                'Dining Area: Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
              subItems: [],
            },
            {
              listItem:
                'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },

  // new courses 
  22: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Deep Sleep Workshop - Online & On Campus',
    key: 'deep-sleep-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    dates: [
      // '10th May 2025', 
      // '12th Jul 2025', 
      // '13th Sep 2025',
      // '8th Nov 2025',
      // '10th January 2026',
      // '14th March 2026',
      // '9th May 2026',
      '11th July 2026',
      '12th September 2026',
      '14th November 2026',

    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'Deep Sleep Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },

    tenure: '1 day',
    courseType: 'Deep Sleep Workshop',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Deep Sleep Workshop',
    newName: 'Deep Sleep Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: 'Unlock deep, restful sleep with yoga, breathwork & guided meditation.',
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/life-management-yoga-camp_++246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Workshop For?',
          text: [
            'This workshop is ideal for anyone struggling with restless nights, stress, or fatigue. Whether you’re a busy professional, a parent, or simply looking to enhance your sleep quality, this session offers practical yoga-based techniques to help you relax, rejuvenate, and enjoy truly restorative sleep.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'Experience deep relaxation as you learn simple yet effective techniques to enhance your sleep quality. This workshop will equip you with tools to unwind, reduce stress, and establish a restful sleep routine, leaving you feeling rejuvenated and energized',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Gentle yoga stretches to relax the body and calm the mind',
              subItems: [],
            },
            {
              listItem: 'Breathing techniques to reduce stress and promote relaxation',
              subItems: [],
            },
            {
              listItem: 'Guided meditations for deep mental and emotional rejuvenation',
              subItems: [],
            },
            {
              listItem: 'Tips and practices for improving sleep quality naturally',
              subItems: [],
            },
            {
              listItem: 'Expert guidance on creating a bedtime routine for restorative sleep',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  23: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Emotional Wellness Workshop - Online & On Campus ',
    key: 'emotional-wellness-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    dates: [
      // '16th Feb 2025', 
      // '29th Jun 2025', 
      // '19th Oct 2025',
      // '15th February 2026',
      // '21st June 2026',
      '18th October 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'Emotional Wellness Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },

    tenure: '1 day',
    courseType: 'Emotional Wellness Workshop',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Emotional Wellness Workshop',
    newName: 'Emotional Wellness Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: "Balance your mind & emotions with proven yogic tools & practices.  ",
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/21-days%2B-better-living-course+_+270+x+148.webp`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Workshop For?',
          text: [
            "This workshop is for anyone looking to improve their emotional health and well-being. Whether you're experiencing stress, anxiety, or simply want to build emotional resilience, this session is perfect for individuals seeking practical tools to enhance their mental and emotional state.",
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'In this workshop, you will explore a variety of mindfulness and emotional regulation techniques, including yoga, breathing exercises, and guided meditations. Expect to leave feeling more grounded, with a toolkit of practices to help you manage emotions, reduce stress, and create a deeper connection to yourself.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Yoga sequences designed to release emotional tension and promote relaxation  ',
              subItems: [],
            },
            {
              listItem: 'Breathing techniques to calm the nervous system and enhance emotional balance',
              subItems: [],
            },
            {
              listItem: 'Mindfulness practices to increase self-awareness and emotional clarity  ',
              subItems: [],
            },
            {
              listItem: 'Guided meditations to foster inner peace and reduce anxiety  ',
              subItems: [],
            },
            {
              listItem: 'Tools for building emotional resilience and coping with life’s challenges  ',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  24: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Gut Health Workshop - Online & On Campus',
    key: 'gut-health-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    dates: [
      // '22nd Feb 2025', 
      // '26th Apr 2025', 
      // '15th Jun 2025', 
      // '17th Aug 2025', 
      // '19th Oct 2025', 
      // '21st Dec 2025',
      // '28th February 2026',
      // '25th April 2026',
      '27th June 2026',
      '22nd August 2026',
      '24th October 2026',
      '26th December 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'Gut Health Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },

    tenure: '1 day',
    courseType: 'Gut Health Workshop',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Gut Health Workshop',
    newName: 'Gut Health Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: "Improve digestion, reduce bloating & boost gut health with yoga.",
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/0A8A2575_++246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Workshop For?',
          text: [
            "This workshop is for anyone experiencing digestive discomfort, bloating, or seeking to improve their gut health. Whether you're dealing with chronic gut issues or simply looking to maintain a healthy digestive system, this session provides the tools you need for optimal gut health.",
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'You will gain insight into the importance of gut health, learn techniques to improve digestion, and explore the impact of diet and lifestyle on your gut. Expect to leave with practical tips, easy-to-follow nutrition advice, and a renewed understanding of how to nurture your digestive system for better health.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Nutrition tips for a gut-friendly, anti-inflammatory diet',
              subItems: [],
            },
            {
              listItem: 'Breathing exercises to aid digestion and reduce stress',
              subItems: [],
            },
            {
              listItem: 'Yoga sequences to improve gut function and alleviate discomfort',
              subItems: [],
            },
            {
              listItem: 'Insights into the role of probiotics and gut microbiota in overall health',
              subItems: [],
            },
            {
              listItem: 'Mindfulness practices to enhance digestion and support emotional well-being',
              subItems: [],
            },
            {
              listItem: 'Expert guidance on creating a personalized self-care routine for long-term health',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  25: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Healthy & Sattvik Cooking Workshop - Online & On Campus',
    key: 'healthy-sattvik-cooking-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    dates: [
      // '22nd Mar 2025', 
      // '24th May 2025',
      // '26th Jul 2025', 
      // '27th Sep 2025', 
      // '22nd Nov 2025',
      // '24th January 2026',
      // '28th March 2026',
      // '23rd May 2026',
      '25th July 2026',
      '26th September 2026',
      '28th November 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'Healthy & Sattvik Cooking Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },

    tenure: '1 day',
    courseType: 'Healthy & Sattvik Cooking Workshop',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Healthy & Sattvik Cooking Workshop',
    newName: 'Healthy & Sattvik Cooking Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: "Learn to cook nourishing sattvik meals for health, balance & vitality.",
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/21-days%2B-better-living-course+_+270+x+148.webp`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Workshop For?',
          text: [
            "This workshop is for anyone looking to improve their eating habits, increase energy levels, and adopt a more mindful approach to cooking and eating. Whether you’re new to sattvik cooking or seeking to deepen your understanding, this workshop will provide valuable tools for a healthier, more balanced lifestyle.",
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'You can expect to learn practical cooking techniques for preparing delicious, easy-to-make sattvik meals that support overall health. Gain insight into the importance of food choices, ingredients, and mindful eating practices. Leave with a collection of recipes to incorporate into your daily routine, fostering nourishment and wellness from within.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Introduction to sattvik cooking principles and their benefits',
              subItems: [],
            },
            {
              listItem: 'Simple, plant-based recipes for every meal',
              subItems: [],
            },
            {
              listItem: 'Techniques for cooking with fresh, wholesome ingredients',
              subItems: [],
            },
            {
              listItem: 'Mindful eating practices to enhance digestion and well-being',
              subItems: [],
            },
            {
              listItem: 'Tips for creating balanced meals that nourish the body and mind',
              subItems: [],
            },
            {
              listItem: 'Expert guidance on creating a personalized self-care routine for long-term health',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  26: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Menopause Wellness Workshop - Online & On Campus',
    key: 'menopause-wellness-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    clevertapData: {
      name: 'Menopause Wellness Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    dates: [
      // '15th Feb 2025', 
      // '31st May 2025', 
      // '31st Aug 2025',
      // '30th Nov 2025',
      // '22nd February 2026',
      // '31st May 2026',
      '30th August 2026',
      '29th November 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,

    tenure: '1 day',
    courseType: 'Menopause Wellness Workshop',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Menopause Wellness Workshop',
    newName: 'Menopause Wellness Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: "Relieve hot flashes, stress & fatigue with yoga for menopause care. ",
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/21-days%2B-better-living-course+_+270+x+148.webp`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Workshop For?',
          text: [
            "This workshop is designed for women who are experiencing peri-menopause, menopause, or post-menopause. Whether you’re seeking to manage symptoms like hot flashes, mood swings, or sleep disturbances, or simply want to feel more balanced and energized, this workshop offers valuable tools for enhancing wellness during this life transition.",
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'You will explore yoga sequences, breathing techniques, and lifestyle tips tailored to ease menopause symptoms and improve overall well-being. Expect to gain a deeper understanding of how to support your body during menopause, with practical strategies for physical, emotional, and mental balance.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Yoga practices designed to ease symptoms like hot flashes and fatigue',
              subItems: [],
            },
            {
              listItem: 'Breathing exercises to reduce stress and improve sleep quality',
              subItems: [],
            },
            {
              listItem: 'Nutrition advice for managing hormone levels and boosting energy',
              subItems: [],
            },
            {
              listItem: 'Mindfulness practices for emotional balance and mental clarity',
              subItems: [],
            },
            {
              listItem: 'Tools for enhancing bone health, circulation, and overall vitality during menopause',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  27: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'PCOD & PCOS Wellness Workshop - Online & On Campus',
    key: 'pcod-pcos-wellness-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    dates: [
      // '18th May 2025',
      //  '20th Jul 2025',
      // '21st Sep 2025', 
      // '16th Nov 2025',
      // '18th January 2026',
      // '15th March 2026',
      // '17th May 2026',
      '19th July 2026',
      '20th September 2026',
      '15th November 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'PCOD & PCOS Wellness Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },
    tenure: '1 day',
    courseType: 'PCOD & PCOS Wellness Workshop',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'PCOD & PCOS Wellness Workshop',
    newName: 'PCOD & PCOS Wellness Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: "Improve hormonal health & well-being with yoga for PCOD/PCOS.",
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/DSC05426_+246+X+135.jpg`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Workshop For?',
          text: [
            "This workshop is ideal for individuals dealing with PCOD and PCOS or those looking to prevent or manage related symptoms. Whether you’re new to yoga or have been practicing for years, this session is designed for anyone seeking holistic support for hormonal balance, stress management, and overall wellness",
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'In this workshop, you will experience a combination of yoga poses, breathing exercises, and mindfulness practices specifically tailored to address the needs of those with PCOD and PCOS. Expect to leave feeling more relaxed, empowered, and equipped with tools to support your hormonal health and overall vitality.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Yoga sequences to support hormonal balance and menstrual health',
              subItems: [],
            },
            {
              listItem: 'Breathing techniques to reduce stress and improve circulation',
              subItems: [],
            },
            {
              listItem: 'Targeted exercises for improving ovarian health and reducing inflammation',
              subItems: [],
            },
            {
              listItem: 'Nutrition tips to manage weight and enhance overall wellness',
              subItems: [],
            },
            {
              listItem: 'Mindfulness practices for emotional balance and mental clarity',
              subItems: [],
            },
            {
              listItem: 'Expert guidance on creating a personalized self-care routine for long-term health',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  28: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Total Body Detox Workshop - Online & On Campus',
    key: 'total-body-detox-workshop',
    batch: 3,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    dates: [
      // '12th Apr 2025', 
      // '14th Jun 2025',
      //  '10th Aug 2025', 
      //  '11th Oct 2025', 
      //  '13th Dec 2025',
      // '14th February 2026',
      // '11th April 2026',
      // '13th June 2026',
      '8th August 2026',
      '10th October 2026',
      '12th December 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'Total Body Detox Workshop - Online & On Campus',
      courseType: 'Camps & Workshops',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Camps & Workshop',
      coursePreRequisite: ''
    },

    tenure: '1 day',
    courseType: 'Total Body Detox Workshop',
    language: 'Hindi',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Total Body Detox Workshop',
    newName: 'Total Body Detox Workshop',
    days: [''],
    time: [
      '9:30 am – 1:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "1 day",
      timings: [
        {
          day: "",
          time: "9:30 am – 1:30 pm (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'certificate Of Participation',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    mostPopular: false,
    rating: 5,
    colorCode: '#EDBE66',
    timing: '9:30 am – 1:30 pm (IST)',
    fees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    newFees: {
      onlineFee: 500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 500 },
    },
    category: 'camps',
    metaDescription: "Detox naturally with powerful yogic techniques for total well-being. ",
    image: `${baseDomain}${courseAssets.courseAsset34}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/21-days%2B-better-living-course+_+270+x+148.webp`,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Who is this Yoga Workshop For?',
          text: [
            "This workshop is designed for anyone looking to rejuvenate their body and mind through natural, holistic practices. Whether you’re feeling sluggish, dealing with stress, or simply want to reset your system, this session is perfect for individuals seeking to improve their health, vitality, and overall well-being.",
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'What can you expect?',
          text: [
            'In this workshop, you will learn a variety of cleansing techniques, yoga practices, and mindfulness exercises to detoxify your body and energize your mind. Expect to feel lighter, more focused, and recharged as you explore ways to restore balance and harmony from within.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Offerings',
          points: [
            {
              listItem: 'Detoxifying yoga sequences to cleanse and revitalize the body',
              subItems: [],
            },
            {
              listItem: 'Breathing exercises to boost energy and enhance mental clarity',
              subItems: [],
            },
            {
              listItem: 'Mindful practices for stress relief and emotional balance',
              subItems: [],
            },
            {
              listItem: 'Holistic tips for improving digestion and boosting metabolism',
              subItems: [],
            },
            {
              listItem: 'Guided meditations for mental rejuvenation and focus',
              subItems: [],
            },
            {
              listItem: 'Personalized guidance to help you integrate detox practices into daily life',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: [
            '9:30 am – 1:30 pm (IST)',
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 500 (Inclusive Lunch)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Guidelines',
          text: [
            'Campers are requested to come attired to comfortable loose fitting clothes. Shorts, capris, tank tops, low cut shirts, short and sleeveless T-shirts are not permitted as per the Institute’s dress code.',
          ],
        },
      }
    ],
  },
  // 22: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  // textdescription1:'',
  // textdescription2:'',
  // textdescription3:'',
  // textdescription4:'',
  // textdescription5:'',
  //   title: '21 Days BLC - Morning - Online – English - Batch 4',
  //   key: '21-days-better-living-course-batch-4',
  //   batch: 4,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   dates: [
  //     '8th Jan to 28th ',
  //   ],
  //   online: true,
  //   onCampus: false,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   mostPopular: true,
  //   rating: 5,
  //   colorCode: '#EDBE66',
  //   timing: 'Morning 7:00 am – 8:30 am (IST)',
  //   fees: {
  //     onlineFee: 2100,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'camps',
  //   metaDescription:
  //     'Become successful, healthy, stress-free, and more mindful in your relationships by learning the yogic way of living. Join The Yoga Institute’s 21-Days Better Living Course. ',
  //   image: `${baseDomain}${courseAssets.courseAsset34}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset34}`,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Overview',
  //         text: [
  //           'Become successful, healthy, stress-free, and more mindful in your relationships by learning the yogic way of living. Join The Yoga Institute’s 21-Days Better Living Course. ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'It takes 21 days to build a habit into your daily routine. The Yoga Institute’s 21 Days Better Living Course is a course specifically designed to introduce you to the yogic way of living. begin your journey into the discovery of Yoga. Working professionals and house makers can take just one hour from their day to practice and learn yoga and begin their transformational journey. ',
  //           'This is a certificate course and has been successfully conducted for 50 years by the Institute. The program trains you holistically and enables you to achieve equilibrium between your mind and body and thus achieve a state of peace and happiness in life. The course is conducted by trained teachers at the Institute.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' The programme covers an introduction to: ',
  //         points: [
  //           {
  //             listItem: 'Astanga Yoga',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Asanas',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Pranayama',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Kriyas',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Attitude training  ',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Parisamvad (sessions with Dr. Hansaji)',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'It is ideal for anyone who wants to live a yoga way of life and experience peace within. It helps you to incorporate Yogic ideals in every field of your daily life. ',
  //         ],
  //       },
  //     },

  //     {
  //       type: 'u-list',
  //       content: {
  //         title: ' Benefits of this camp: ',
  //         points: [
  //           {
  //             listItem:
  //               'Helps you in developing and maintaining the right routine for your overall health ',
  //             subItems: [],
  //           },

  //           {
  //             listItem: 'Helps you reduce stress and anxiety',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Helps you feel energetic throughout the day',
  //             subItems: [],
  //           },
  //           {
  //             listItem: 'Helps you become mindful in your relationships',
  //             subItems: [],
  //           },
  //           {
  //             listItem: ' Helps you get more in control of your feelings',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },

  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'Come and experience, amidst nature and beauty, our enriching 21 Days Better Living Course.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'PROGRAM DETAILS',
  //         text: [
  //           'The course is held once a month, starting on the first Sunday (7:00 a.m.) of every month. The classes are of 1 hr. 30 mins each day for 21 consecutive days. Participants can opt for the morning or evening batches.',
  //         ],
  //       },
  //     },
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'UPCOMING DATES FOR 2022',
  //     //     text: [],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Timings',
  //         text: ['Morning 7:00 am – 8:30 am (IST)'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'REGISTRATION',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'For registration in the 21 Days Better Living Course, please click on the link below and fill in all the details. Within 24 hours after registering, you will receive an email containing the link to the payment portal. You can use the link to make the payment.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'FEES',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Rs. 2100/-',
  //         text: [
  //           '*Please note fees once paid will be non-refundable.',
  //           ' We support all credit cards. For making payments using MasterCard. Alternatively, you can also make payments using net banking or opt for wire transfer by writing to us.',
  //         ],
  //       },
  //     },

  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'PRE-REQUISITES',
  //     //     text: [],
  //     //   },
  //     // },
  //     // {
  //     //   type: 'u-list',
  //     //   content: {
  //     //     title: ' A MANDATORY PREREQUISITE FOR THIS COURSE IS:',
  //     //     points: [
  //     //       {
  //     //         listItem:
  //     //           'Covid test RT-PCR results dated 20th Jan 2022to 28th Jan 2022and later for entry into the premises post prior registration. ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem:
  //     //           'Students must use personal vehicles for commuting, throughout the course duration. We would discourage the use of public transport. (For non-residential students)',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem:
  //     //           'This course is for healthy individuals. Kindly note if you suffer from any health issues like diabetes, hypertension, or orthopaedic problems, kindly take prior approval.',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem:
  //     //           'For international Students, it is mandatory to do 14 Day Quarantine as per the laws of Government of India along with RT-PCR test reports. ',
  //     //         subItems: [],
  //     //       },
  //     //       {
  //     //         listItem:
  //     //           'Last but not the least, do not forget your masks and Yoga Mats',
  //     //         subItems: [],
  //     //       },
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'FAQs  ',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title:
  //           '  1. What is the time to reach the Institute during the course duration?  ',
  //         text: [
  //           'For residential campers, students should arrive at The Yoga Institute between 7.00 a.m. to 7.00 p.m. IST (Indian Standard Time). Please read on Hostel Facility for more details. ',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title:
  //           ' 2. Can a person who has problem with sitting on the floor for a long time enroll for the course?',
  //         text: [
  //           'Backrest and chairs are available on request in special and exceptional cases. – Rest and recreation are also a part of the course.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '3. How many seats are available in one course?',
  //         text: [
  //           'Only 35 seats are available. Registrations on a first come, first-serve basis only.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Please Note',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'The payment validity and session attendance for 21-Days Better Living Course is only applicable for one month. However, in emergency circumstances, the participant can attend the 21-Days BLC sessions for the next month but only on approval of the management. Without authorisation, the participant will not be allowed to attend the sessions post the actual sessions of the course.',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'UNIQUE OFFERINGS ',
  //         text: [''],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'Our Amenities / Our Facilities',
  //         points: [
  //           {
  //             listItem:
  //               'Library: Explore one of largest collections of spiritual and philosophical books to expand your knowledge ',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Internet Room: Access the internet in a comfortable setting when you need Meditation Pods: Meditate on the five fundamental natural elements, the Panchamahabhutas,',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Acupressure Path: Give your feet a natural massage and activate your vital energies',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Yogic Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Dining Area: Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //   ],
  // },

}

const classes = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekDays: true,
    title: 'Advanced Yoga Asana Regular Class - Online',
    isRegular: true,
    key: 'advanced-regular-yoga-classes',
    batch: 1,
    newName: 'Advanced Asana Regular Class Online',
    days: [
      'Monday, Wednesday, Thursday and Friday',
      ' Tuesday, Thursday & Saturday'
    ],
    time: [
      'Morning: 6:30 am - 8:00 am (IST)',
      '5:30 pm - 7:00 pm (IST)'

    ],
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'ADVANCED_REGULAR_YOGA_CLASS_1',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    mostPopular: false,
    rating: 5,
    colorCode: '#D3A29D',
    join: true,
    timing:
      'Weekdays: Monday, Wednesday, Thursday and Friday: 07:00 AM- 08:00 AM OR 05:30 PM- 06:30 PM, Weekend: Saturday and Sunday: 07:00 AM- 08:30 AM   ',
    fees: {
      onlineFee: 1600,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1600,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Advanced Yoga Asana Regular Class - Online (Only for TYI Teachers)',
      courseType: 'Regular Asana Classes for Teachers ',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Asana Classes for Teachers ',
      coursePreRequisite: ''
    },
    metaDescription: 'Advanced Asana regular classes for students who wish to advance their practice – Online sessions  ',
    image: `${baseDomain}${courseAssets.courseAsset67}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/advance-yoga-asana-regular-class-online-(only-for-tYI-teachers)_+246+X+135.jpg`,
    dates: ['07:00 AM - 08:00 AM Weekdays', '05:30 PM - 06:30 PM Weekdays', '07:00 AM - 08:30 AM Weekends'],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: true,

    tenure: '6 Days',
    courseType: '',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    enrollInfo: {
      duration: "",
      timings: [
        {
          day: "Monday, Wednesday, Thursday and Friday",
          time: "07:00 AM- 08:00 AM"
        },
        {
          day: "",
          time: "OR"
        },

        {
          day: "",
          time: "05:30 PM- 06:30 PM"
        },
        {
          day: "",
          time: "OR"
        },
        {
          day: "Saturday and Sunday ",
          time: "07:00 AM- 08:30 AM"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'This Advanced Asana Regular Class by The Yoga Institute is open to all who wish to explore deeper asanas, dynamic flows, and refined techniques. The sessions include advanced Yoga Asanas, Pranayamas, Kriyas, and diet and Yogic lifestyle guidance, along with personal attention.',
            'Join us to stay connected with your practice. ',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [
            'Advanced Asana Regular Class is of 1-hour duration held every Monday, Tuesday, Wednesday, and Friday and 1.5 hours every Saturday and Sunday',
            'A minimum attendance of 3 months is recommended, to experience the difference in your life. Can join on any day of the month. ',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing options',
          text: [
            'Weekdays : Monday, Wednesday, Thursday, Friday ',


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '07:00 am to 08:00 am',
              subItems: [],
            },
            {
              listItem:
                '05:30 pm to 06:30 pm',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Weekend: Saturday and Sunday ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '07:00 am to 08:30 am',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Monthly Fees (Join on any date) ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Rs. 1600/-',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Half Yearly Fees (Join on any date) ',


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Rs. 8000/-',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: [
            'Kindly note the fees once paid will not be refundable. ',


          ],
        },
      },

    ],
  },
  61: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekDays: true,
    title: 'Advanced Yoga Asana Regular Class - On Campus',
    isRegular: true,
    key: 'advanced-regular-yoga-classes-oncampus',
    batch: 1,
    newName: 'Advanced Asana Regular Class On Campus',
    days: [
      'Monday, Wednesday, Thursday and Friday',
      ' Tuesday, Thursday & Saturday'
    ],
    time: [
      'Morning: 6:30 am - 8:00 am (IST)',
      '5:30 pm - 7:00 pm (IST)'

    ],
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'ADVANCED_REGULAR_YOGA_CLASS_1',
      templateOffline: {
        templateResidential: 'ADVANCED_REGULAR_YOGA_CLASS_1',
        templateNonResidential: 'ADVANCED_REGULAR_YOGA_CLASS_1',
      },
    },
    mostPopular: false,
    rating: 5,
    colorCode: '#D3A29D',
    join: true,
    timing:
      'Weekdays: Monday, Wednesday, Thursday and Friday: 07:00 AM- 08:00 AM, Weekend: Saturday and Sunday: 07:00 AM- 08:30 AM   ',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1600 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Advanced Yoga Asana Regular Class - On Campus',
      courseType: 'Regular Asana Classes for Teachers ',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Asana Classes for Teachers ',
      coursePreRequisite: ''
    },
    metaDescription: 'Advanced Asana regular classes for students who wish to advance their practice – On campus sessions ',
    image: `${baseDomain}${courseAssets.courseAsset67}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/advance-yoga-asana-regular-class-online-(only-for-tYI-teachers)_+246+X+135.jpg`,
    dates: ['07:00 AM- 08:00 AM Weekdays', '07:00 AM- 08:30 AM Weekends'],
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: true,

    tenure: '6 Days',
    courseType: '',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    enrollInfo: {
      duration: " ",
      timings: [
        {
          day: "Monday, Wednesday, Thursday and Friday",
          time: "07:00 AM- 08:00 AM"
        },
        {
          day: "",
          time: "OR"
        },
        {
          day: "Saturday and Sunday",
          time: " 07:00 AM- 08:30 AM"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'This Advanced Asana Regular Class by The Yoga Institute is open to all who wish to explore deeper asanas, dynamic flows, and refined techniques. The sessions include advanced Yoga Asanas, Pranayamas, Kriyas, and diet and Yogic lifestyle guidance, along with personal attention.',
            'Join us to stay connected with your practice. ',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [
            'Advanced Asana Regular Class is of 1-hour duration held every Monday, Wednesday, Thursday and Friday and 1.5 hours every Saturday and Sunday',
            'A minimum attendance of 3 months is recommended, to experience the difference in your life. Can join on any day of the month. ',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing options',
          text: [
            'Weekdays : Monday, Wednesday, Thursday, Friday ',


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '07:00 am to 08:00 am',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Weekend: Saturday and Sunday ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '07:00 am to 08:30 am',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Monthly Fees (Join on any date) ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Rs. 1600/-',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Half Yearly Fees (Join on any date) ',


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Rs. 8000/-',
              subItems: [],
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: [
            'Kindly note the fees once paid will not be refundable. ',


          ],
        },
      },

    ],
  },
  // 2: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   weekDays: true,
  //   title: 'Healing Yoga Movement & Rhythm - Online',
  //   key: 'healing-movement-and-rhythm',
  //   isRegular: true,
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   image: `${baseDomain}${courseAssets.courseAsset68}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset109}`,
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#C48E8C',
  //   metaDescription:
  //     'A movement-based therapy programme for stress management, emotional well-being',
  //   join: true,
  //   timing:
  //     'Tuesday & Thursday - 8pm - 9pm (IST) (Online)',
  //   fees: {
  //     onlineFee: 1500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'classes',
  //   dates: ['8pm - 9pm'],
  //   online: true,
  //   onCampus: true,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,

  //   tenure: '',
  //   courseType: "HEALING YOGA MOVEMENT",
  //   language: 'English',
  //   preRequisite: 'None',
  //   courseCategory: 'Self Help',
  //   courseSubType: 'Regular Asana Classes',
  //   newName: 'Healing Movement and Rhythm Classes',
  //   days: [
  //     'Tuesday',
  //     'Thursday'
  //   ],
  //   time: [
  //     '8pm - 9pm (IST)'
  //   ],
  //   enrollInfo: {
  //     duration: "Upto 12 months",
  //     timings: [
  //       {
  //         day: "Tuesday & Thursday",
  //         time: "8pm - 9pm (IST) (Online)"
  //       }
  //     ]
  //   }
  //   ,

  //   courseCertificate: 'NO',
  //   onlineInfo: {
  //     courseMode: true,
  //   },
  //   residentialInfo: {
  //     courseMode: false,
  //     residentialMode: false
  //   },
  //   nonResidentialInfo: {
  //     courseMode: false,
  //     nonResidentialMode: false
  //   },


  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'Harness the power of movement to unleash the power of positivity and joy in your life. Healing Yoga Movement & Rhythm is The Yoga Institute’s movement based therapy programme for stress management, emotional well-being and trauma healing.',
  //           'Join now if you’re looking for an immunity and vitality boost, emotional release, anxiety and anger management, glowing skin, inner radiance and enhanced creativity.',
  //           '#hackyourhappyhormones',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Duration',
  //         text: ['60 Minutes'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: ['1500'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Classes',
  //         text: [
  //           'Tuesday & Thursday - 8 pm - 9 pm (IST) (Online)',
  //           '(Join on any date)',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Mode',
  //         text: ['Online'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'To Register write to us at info@theyogainstitute.org or call us at +91-22-26110506 or at +91-22-26203568',
  //         ],
  //       },
  //     },
  //   ],
  // },
  3: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: ' Monday ,  Tuesday , Thursday and Friday',
    textdescription2: 'Morning Batch (IST): 6:30 am to 7:30 am, 7:30 am to 8:30 am, 8:30 am to 9:30 am',
    textdescription3: 'Evening Batch (IST): 4pm to 5pm, 5pm to 6pm, 6pm to 7pm, 7pm to 8pm',
    textdescription4: 'We also have Weekend batches and the details are:',
    textdescription5: 'Weekend Schedule(Sat-Sun): 7:30 am to 9 am',
    weekDays: true,
    title: 'Yoga Asana Regular Classes - (Men & Women) - Online Yoga Classes',
    key: 'asana-regular-classes-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'YOGA_ASANA_REGULAR_CLASSES_M_AND_F_ONLINE',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset81}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/weekend-yoga-Asana-Classes_-Men-Women+(1).webp`,
    mostPopular: true,
    metaDescription:
      'Daily online yoga classes to enhance flexibility, strength & well-being.',
    rating: 5,
    colorCode: '#B77E7E',
    join: true,
    timing:
      'Regular Asana Classes is conducted 4 days in a week. ',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Yoga Asana Regular Classes - (Men & Women) - Online Yoga Classes',
      courseType: 'Regular Asana Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Asana Men &  Women online',
      coursePreRequisite: ''
    },
    dates: [
      '6:30 a.m. to 7:30 a.m.',
      '7:30 a.m. to 8:30 a.m.',
      '8:30 a.m. to 9:30 a.m.',
      '4:00 p.m. to 5:00 p.m.',
      '5:00 p.m. to 6:00 p.m.',
      '6:00 p.m. to 7:00 p.m.',
      '7:00 p.m. to 8:00 p.m.',
      'Sat/Sun:7:30-9:00 a.m'],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: 'Weekly 4 Days',
    courseType: 'Regular Asana Classes 1/ Online',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Asana Regular Classes (Men & Women)',
    days: [
      'Monday',
      'Tuesday',
      'Thursday',
      'Friday',
      'Weekend batches'
    ],
    time: [
      'Morning Batch (IST): 6:30 am to 7:30 am, 7:30 am to 8:30 am, 8:30 am to 9:30 am',
      'Evening Batch (IST): 4pm to 5pm, 5pm to 6pm, 6pm to 7pm, 7pm to 8pm',
      'Weekend Schedule(Sat-Sun): 7:30 am to 9 am'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Monday , Tuesday , Thursday and Friday",
          time: "Morning Batch (IST): 6:30 am to 7:30 am, 7:30 am to 8:30 am, 8:30 am to 9:30 am"
        },
        {
          day: "Monday , Tuesday , Thursday and Friday",
          time: "Evening Batch (IST): 4pm to 5pm, 5pm to 6pm, 6pm to 7pm, 7pm to 8pm"
        },
        {
          day: "Weekend batches",
          time: "(Sat-Sun): 7:30 am to 9 am"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Step into the world of authentic yoga practice from the comfort of your home with our Online Yoga Asana Regular Classes for men and women. Whether you’re a beginner taking your first step or an experienced practitioner working towards advanced postures, our expert-led sessions will support your journey every step of the way. These classes are not just about fitness — they’re about holistic transformation. Whether your goal is to improve flexibility, manage stress, lose weight, or develop emotional balance, our integrated approach with asanas, pranayamas, and yogic lifestyle techniques will guide you there.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Join on any date – start your practice when you’re ready',
              subItems: [],
            },
            {
              listItem:
                'Validity: 1 month from the date of payment',
              subItems: [],
            },
            {
              listItem:
                'Live interactive sessions via Zoom',
              subItems: [],
            },
            {
              listItem: 'Class links will be shared via Email and WhatsApp',
              subItems: [],
            },
            // {
            //   listItem: 'Class links will be sent via email and WhatsApp',
            //   subItems: [],
            // },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Important Guidelines',
          points: [
            {
              listItem:
                'Missed classes cannot be adjusted in other batches',
              subItems: [],
            },
            {
              listItem: 'Batch transfers are not permitted',
              subItems: [],
            },
            {
              listItem:
                'Recording the sessions is strictly prohibited',
              subItems: [],
            },
            {
              listItem: 'Fees are non-refundable',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Weekday Schedule for Regular Asana Class (Four Days in a week)',
          text: ['Mon-Tues-Thur-Fri'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: ' Morning Batch',
          points: [
            {
              listItem: '6:30 am to 7:30 am ',
              subItems: [],
            },
            {
              listItem: '7:30 am to 8:30 am ',
              subItems: [],
            },
            {
              listItem: '8:30 am to 9:30 am ',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Evening Batch',
          points: [
            {
              listItem: '4pm to 5pm',
              subItems: [],
            },
            {
              listItem: '5pm to 6pm',
              subItems: [],
            },
            {
              listItem: '6pm to 7pm ',
              subItems: [],
            },
            {
              listItem: '7pm to 8pm',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Weekend Schedule for Regular Asana Class (Weekend batch)',
          text: ['Sat & Sun', '7:30 am to 9 am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Monthly Fees',
      //     text: ['Rs. 1100/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Monthly Fees - 2026',
          text: ['Rs. 1200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Six Months Fees',
      //     text: ['Rs. 6600/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Six Months Fees - 2026',
          text: ['Rs. 7200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Annual Fees',
      //     text: ['Rs. 11000/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Annual Fees - 2026',
          text: ['Rs. 12000/-'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note:-',
          text: ['We kindly urge you to regularly check your email inboxes, including your spam/junk folders, for important updates from the (email id - asanaclasses@theyogainstitute.in) from the institute regarding regular yoga asanas. Additionally, kindly note that new members will be added to the WhatsApp group on Wednesdays and Saturdays only.'],
        },
      },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Monthly',
      //     text: ['Rs.1000 '],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Half yearly',
      //     text: ['Rs. 6000'],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Annual ',
      //     text: ['Rs. 10,000'],
      //   },
      // },
    ],
  },
  4: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Yoga Classes for Men (Regular Asana) - On Campus',
    key: 'asana-regular-classes-on-campus',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset70}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/yoga-asana-regular-classes-for-men_+246+X+135+(1).jpg`,
    mostPopular: true,
    metaDescription:
      'Regular yoga sessions for men with asanas, kriyas, breathwork & health tips.',
    rating: 5,
    colorCode: '#D3A29D',
    join: true,
    timing:
      'Monday,Tuesday,Thursday,Friday * :6:30 am to 7:30 am, 7:30 am to 8:30 am, 1:00 pm to 2:00 pm, 6:00 pm to 7:00 pm, 7:00 pm to 8:00 pm',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Yoga Classes for Men (Regular Asana) - On Campus',
      courseType: 'Regular Asana Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Asana Classes Men',
      coursePreRequisite: ''
    },
    dates: [
      '6:30 a.m to 7:30 a.m.',
      '7:30 a.m. to 8:30 a.m.',
      '1:00 p.m to 2:00 p.m.',
      '6:00 p.m. to 7:00 p.m',
      '7:00 p.m. to 8:00 p.m.',
    ],
    online: false,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: 'Weekly 4 Days',
    courseType: 'Regular Asana Classes 1/ on campus',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Asana Regular Classes for Men',
    days: [
      'Monday',
      'Tuesday',
      'Thursday',
      'Friday'
    ],
    time: [
      '6:30 am to 7:30 am',
      '7:30 am to 8:30 am',
      '1:00 pm to 2:00 pm',
      '6:00 pm to 7:00 pm',
      '7:00 pm to 8:00 pm'
    ],

    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Monday,Tuesday,Thursday,Friday*",
          time: "6:30 am to 7:30 am, 7:30 am to 8:30 am, 1:00 pm to 2:00 pm, 6:00 pm to 7:00 pm, 7:00 pm to 8:00 pm"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'This is a special men-only regular yoga asana class conducted by The Yoga Institute. The yoga classes for men cover Asanas, Pranayamas, Kriyas, diet and Yogic lifestyle recommendations, personal attention on health, and counseling on other aspects of life.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [
            'Yoga Classes for Men are of 1-hour duration held every Monday, Tuesday, Thursday, Friday',
            'A minimum attendance of 3 months is recommended, to experience the difference in your life. Can join on any day of the month.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing options ',
          text: [
            '6:30 am to 7:30 am',
            '7:30 am to 8:30 am',
            '1:00 pm to 2:00 pm',
            '6:00 pm to 7:00 pm',
            '7:00 pm to 8:00 pm',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Fees'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Monthly Fees',
      //     text: ['Rs. 1100/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Monthly Fees - 2026',
          text: ['Rs. 1200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Six Months Fees',
      //     text: ['Rs. 6600/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Six Months Fees - 2026',
          text: ['Rs. 7200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Annual Fees',
      //     text: ['Rs. 11000/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Annual Fees - 2026',
          text: ['Rs. 12000/-'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: ['Kindly note the fees once paid will not be refundable.'],
        },
      },
    ],
  },
  5: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Yoga Classes for Women (Regular Asana) - On Campus',
    key: 'asana-regular-classes-on-campus-women',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset71}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/asana-regular-classes_for-women_+270+x+148.jpg`,
    mostPopular: true,
    metaDescription:
      'Regular yoga sessions for women with asanas, kriyas, breathwork & health tips.',
    rating: 5,
    colorCode: '#C48E8C',
    join: true,
    timing:
      'Monday,Tuesday,Thursday,Friday * :6:30 am to 7:30 am, 7:30 am to 8:30 am,8:30 am to 9:30 am, 9:30 am to 10:30 am, 10:30 am to 11:30 am, 11:30 am to 12:30 pm, 1:00 pm to 2:00 pm, 2:00 pm to 3:00 pm, 3:00 pm to 4:00 pm, 4:00 pm to 5:00 pm, 5:00 pm to 6:00 pm, 6:00 pm to 7:00 pm, 7:00 pm to 8:00 pm',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Yoga Classes for Women (Regular Asana) - On Campus',
      courseType: 'Regular Asana Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Asana Classes Women',
      coursePreRequisite: ''
    },
    dates: [
      '6:30 a.m to 7:30 a.m.',
      '7:30 a.m. to 8:30 a.m.',
      '8:30 a.m to 9:30 a.m',
      '9:30 a.m. to 10:30 a.m.',
      '10:30 a.m. to 11:30 a.m',
      '11:30 a.m. to 12:30 p.m',
      '1:00 p.m. to 2:00 p.m.',
      '2:00 p.m to 3:00 p.m',
      '3:00 p.m. to 4:00 p.m.',
      '4:00 p.m to 5:00 p.m.',
      '5:00 p.m. to 6:00 p.m',
      '6:00 p.m. to 7:00 p.m.',
      '7:00 p.m to 8:00 p.m',
    ],
    online: false,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: 'Weekly 4 Days',
    courseType: 'Regular Asana Classes 1/ on campus',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Asana Regular Classes for Women',
    timings: [
      {
        day: 'Monday, Tuesday, Thursday, Friday',
      }
    ],
    days: [
      'Monday',
      'Tuesday',
      'Thursday',
      'Friday'
    ],
    time: [
      '6:30 am to 7:30 am',
      '7:30 am to 8:30 am',
      '8:30 am to 9:30 am',
      '9:30 am to 10:30 am',
      '10:30 am to 11:30 am',
      '11:30 am to 12:30 pm',
      '1:00 pm to 2:00 pm',
      '2:00 pm to 3:00 pm',
      '3:00 pm to 4:00 pm',
      '4:00 pm to 5:00 pm',
      '5:00 pm to 6:00 pm',
      '6:00 pm to 7:00 pm',
      '7:00 pm to 8:00 pm'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Monday,Tuesday,Thursday,Friday *",
          time: "6:30 am to 7:30 am, 7:30 am to 8:30 am,8:30 am to 9:30 am, 9:30 am to 10:30 am, 10:30 am to 11:30 am, 11:30 am to 12:30 pm, 1:00 pm to 2:00 pm, 2:00 pm to 3:00 pm, 3:00 pm to 4:00 pm, 4:00 pm to 5:00 pm, 5:00 pm to 6:00 pm, 6:00 pm to 7:00 pm, 7:00 pm to 8:00 pm"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'This is a special women-only regular yoga asana class conducted by The Yoga Institute. The yoga classes for women cover Yoga Asanas, Pranayamas, Kriyas, diet and Yogic lifestyle recommendations, personal attention on health and counselling on other aspects of life.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [
            'Yoga Classes for Women are of 1-hour duration held every Monday, Tuesday, Thursday, Friday.',
            'A minimum attendance of 3 months is recommended, to experience the difference in your life. Can join on any day of the month.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing options ',
          text: [
            'Monday, Tuesday, Thursday & Friday',
            '6:30 am to 7:30 am',
            '7:30 am to 8:30 am',
            '8:30 am to 9:30 am',
            '9:30 am to 10:30 am',
            '10:30 am to 11:30 am',
            '11:30 am to 12:30 pm',
            '1:00 pm to 2:00 pm',
            '2:00 pm to 3:00 pm',
            ' 3:00 pm to 4:00 pm',
            '4:00 pm to 5:00 pm',
            '5:00 pm to 6:00 pm',
            '6:00 pm to 7:00 pm',
            '7:00 pm to 8:00 pm',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Fees'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Monthly Fees',
      //     text: ['Rs. 1100/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Monthly Fees - 2026',
          text: ['Rs. 1200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Six Months Fees',
      //     text: ['Rs. 6600/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Six Months Fees - 2026',
          text: ['Rs. 7200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Annual Fees',
      //     text: ['Rs. 11000/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Annual Fees - 2026',
          text: ['Rs. 12000/-'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: ['Kindly note the fees once paid will not be refundable.'],
        },
      },
    ],
  },
  11: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Children\'s Yoga Classes (Regular) - On Campus',
    key: 'childrens-regular-classes',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'COURSE_ADVANCED_CHILDREN',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset76}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/children-camp-the-yoga-institute_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'Yoga for kids to enhance mindfulness, focus, discipline & well-being.',
    rating: 5,
    colorCode: '#C48E8C',
    timing: '4:00 pm -5:00 pm (Mon, Tues, Thurs, Fri)',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Children\'s Yoga Classes (Regular) - On Campus',
      courseType: 'Children Regular Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Children Regular Classes',
      coursePreRequisite: ''
    },
    dates: ['4:00 p.m to 5:00 p.m.'],
    online: false,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: false,
    tenure: 'Weekly 4 Days',
    language: 'English ',
    newName: 'Childrens Regular Classes',
    days: [
      'Mon',
      'Tues',
      'Thurs',
      'Fri'
    ],
    time: [
      '4:00 pm -5:00 pm'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Mon, Tues, Thurs, Fri",
          time: "4:00 pm -5:00 pm"
        }
      ]
    }
    ,

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Introduce your child to mindfulness with our special program for children. Use the power of Yoga to improve your child’s focus, memory, discipline, determination and value system. The children`s yoga classes cover simple yoga asanas and a simple introduction to yogic philosophy through games, arts and other child-friendly activities. Ideal for children between the ages of 5-13 years and will not place any extra academic burden on the child. Children`s yoga classes are conducted in Hindi and English. Parents are encouraged to be actively involved in this yoga for children classes.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Evening Batch Time',
          text: ['4:00 pm -5:00 pm (Mon, Tues, Thurs, Fri) '],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: [' Rs 1100 per month'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees - 2026',
          text: [' Rs 1200 per month'],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Rules',
          text: ['Fees once paid is non-refundable.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Please take a screenshot of your order receipt and share it with us at info@theyogainstitute.org',
          ],
        },
      },
    ],
  },
  12: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekends: true,
    title: 'Children\'s Weekend Yoga Class - On Campus',
    key: 'childrens-weekend-classes-on-campus',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'COURSE_ADVANCED_CHILDREN_WEEKEND',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    newName: 'Childrens Weekend Classes',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      '8:00 am - 9:30 am (IST)'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Saturday & Sunday",
          time: "8:00 am - 9:30 am (IST) *"
        }
      ]
    }
    ,
    image: `${baseDomain}${courseAssets.courseAsset76}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/children-camp-the-yoga-institute_+246+X+135.jpg`,
    mostPopular: false,
    tenure: '2 Days',
    language: 'English',
    metaDescription:
      'Weekend yoga for kids to build focus, discipline & mindfulness.',
    rating: 5,
    colorCode: '#B77E7E',
    join: true,
    timing: 'Saturday & Sunday: 8:00 am - 9:30 am (IST) *',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Children\'s Weekend Yoga Class - On Campus',
      courseType: 'Children Weekend Regular Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Children Weekend Regular Classes',
      coursePreRequisite: ''
    },
    dates: ['8:00 a.m. to 9:30 a.m.'],
    online: false,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Don’t let your child waste the weekend. Make the end of the week super-fun and super-special with our Weekend Yoga Class for children. Let your child explore the world of Yoga to become more grounded, friendly, less bored and more happy. The Weekend kids yoga classes cover simple asanas, games, arts and other child-friendly activities that introduce your child to profound Yogic ideas and a yogic lifestyle. Ideal for children between the ages of 5-13 years.',
            'This kids yoga classes are conducted in Hindi and English.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: ' Batch Time',
          text: [
            'Saturday & Sunday: 8:00 am - 9:30 am (IST) (Join on any date)',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: [' Rs 1100 per month'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees - 2026',
          text: [' Rs 1200 per month'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Rules',
          text: ['  Fees once paid is non-refundable'],
        },
      },
    ],
  },
  13: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Online Meditation Course  (Foundation Course)',
    key: 'meditation-foundation-course-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset28}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/0A8A2637_+246+X+135.jpg`,
    mostPopular: true,
    metaDescription: '12-session course to build a strong foundation in meditation practice.',
    rating: 5,
    colorCode: '#D3A29D',
    timing: 'Monday, Wednesday & Friday: 7:00 am - 8:00 am (IST)',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Online Meditation Course (Foundation Course)',
      courseType: 'Meditation course',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Meditation Foundation Course',
      coursePreRequisite: ''
    },
    dates: [
      // '4th Mar to 29th Mar 2024',
      // '8th Apr to 3rd May 2024',
      // '6th May to 31st May 2024',
      // '3rd Jun to 28th Jun 2024',
      // '1st Jul to 26th Jul 2024',
      // '5th Aug to 30th Aug 2024',
      // '2nd Sep to 27th Sep 2024',
      // '7th Oct to 1st Nov 2024',
      // '4th Nov to 29th Nov 2024',
      // '2nd Dec to 27th Dec 2024',
      // '6th Jan to 31st Jan 2025',
      // '3rd Feb to 28th Feb 2025',
      // '3rd Mar to 28th Mar 2025',
      // '7th Apr to 2nd May 2025',
      // '5th May to 30th May 2025',
      // '2nd Jun to 27th Jun 2025',
      // '7th Jul to 1st Aug 2025',
      // '4th Aug to 29th Aug 2025',
      // '1st Sep to 26th Sep 2025',
      // '6th Oct to 31st Oct 2025',
      // '3rd Nov to 28th Nov 2025',
      // '1st Dec to 26th Dec 2025',
      // '5th Jan to 30th Jan 2026',
      // '2nd Feb to 27th Feb 2026',	
      // '2nd Mar to 27th Mar 2026',	
      // '6th Apr to 1st May 2026', 
      // '4th May to 29th May 2026',
      // '1st Jun to 26th Jun 2026',	
      '6th July to 31st July 2026', '3rd Aug to 28th Aug 2026', '7th Sep to 1st Oct 2026', '5th Oct to 30th Oct 2026', '2nd Nov to 27th Nov 2026', '7th Dec to 1st Jan 2027'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '3 Days',
    courseType: 'Regular Meditation Foundation Course',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Online Meditation Course (Foundation)',
    days: [
      'Monday',
      'Wednesday',
      'Friday'
    ],
    time: ['7:00 am - 8:00 am (IST)'],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Monday, Wednesday & Friday",
          time: "7:00 am - 8:00 am (IST)"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Simple recommendations are provided in these meditation workshops to demonstrate how meditation can lead to a meditative state throughout the day, assisting in job and life efficiency. Recent research has demonstrated that frequent meditation improves brain waves.',
            'This is a 12-session online meditation course starting on the 1st of every month',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course content',
          points: [
            {
              listItem: 'The science behind meditation',
              subItems: [],
            },
            {
              listItem: 'Intense guided meditation practices',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Course Timings and fees'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Monday, Wednesday & Friday',
          text: [' 7:00 am - 8:00 am  (IST) '],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: [

      //       'Rs. 1100/-'
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [

            'Rs. 1200/-'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Kindly make the payments at least one day prior to the camp.',
          ],
        },
      },
    ],
  },
  14: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Regular Online Meditation Classes',
    key: 'regular-meditation-classes-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset28}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/270x148.jpg`,
    mostPopular: true,
    metaDescription:
      'Join expert-led live meditation classes for daily practice & growth.',
    rating: 5,
    colorCode: '#C48E8C',
    join: true,
    timing:
      'Tuesday, Thursday & Saturday: 7:00 am - 7:45 am (IST) *',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Regular Online Meditation Classes',
      courseType: 'Regular Online Meditation Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Online Meditation Classes',
      coursePreRequisite: ''
    },
    dates: ['7:00 a.m. to 7:45 a.m.'],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '3 Days',
    courseType: 'Regular Class - 2 Regular Meditation Class',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Regular Online Meditation Classes',
    days: [
      'Tuesday',
      'Thursday',
      'Saturday'
    ],
    time: [
      '7:00 am - 7:45 am (IST)'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Tuesday, Thursday & Saturday",
          time: "7:00 am - 7:45 am (IST) *"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Developing your meditation practice is easier than ever before with our regular online meditation classes. Whether you are new to meditation or an experienced meditator, our program is designed to guide you through every step. Connect with our renowned community of meditators and gurus to explore your personal meditation journey. These online meditation courses help you develop a daily habit of mindfulness, ensuring that you never miss your meditation goals again. You can conveniently join any day of the week, allowing you to learn meditation online with flexibility.',

            "Join our online yoga and meditation classes to start your journey towards inner peace and balance. If you're looking for structured classes for meditation, this program offers the perfect opportunity to integrate meditation into your routine.",
            // 'Click now to meditate daily!',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Click now to meditate daily!',
          text: [
            // 'Join on any date. Payments stay valid for a month from the date of joining.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Begins',
          text: [
            'Join on any date. Payments stay valid for a month from the date of joining.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Sessions conducted',
          text: [' Tuesday, Thursday and Saturday'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['7:00 am - 7:45 am (IST)'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: [' Rs 1100/- '],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees - 2026',
          text: [' Rs 1200/- '],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Please make your payments one day before the date you wish to start the class.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Please share a screenshot of your order receipt with us at info@theyogainstitute.org',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Rules and Regulations',
          points: [
            {
              listItem:
                'Missed classes cannot be covered in other sessions.',
              subItems: [],
            },
            {
              listItem:
                'Any form of recording of classes is strictly prohibited.',
              subItems: [],
            },
            {
              listItem: 'Change of batches is not permitted.',
              subItems: [],
            },
            {
              listItem: 'Fees once paid are non-refundable.',
              subItems: [],
            },
          ],
        },
      },
    ],
  },
  15: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: ' Satsang ',
    key: 'satsang',
    isRegular: true,
    tenure: '1 day',
    weekends: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'SATSANG_FORM_CONFIRMATION_MAIL',
      templateOffline: {
        templateResidential: 'SATSANG_FORM_CONFIRMATION_MAIL',
        templateNonResidential: 'SATSANG_FORM_CONFIRMATION_MAIL',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset80}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/Satsang_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'Experience life lessons through skits, discourse & wisdom by Dr. Hansaji.',
    rating: 5,
    colorCode: '#DDAB58',
    timing: 'Every Sunday between 9.30 am and 10.30am',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: [
      // '9th Feb 2025', '16th Feb 2025', 
      // '23rd Feb 2025',
      // '16th Mar 2025', 
      // '23rd Mar 2025', 
      // '30th Mar 2025', 
      // '6th Apr 2025', 
      // '13th Apr 2025', 
      // '20th Apr 2025', 
      // '27th Apr 2025',
      // '4th May 2025', 
      // '11th May 2025', 
      // '18th May 2025', 
      // '25th May 2025', 
      // '1st Jun 2025', 
      // '8th Jun 2025', 
      // '15th Jun 2025', 
      // '22nd Jun 2025', 
      // '29th Jun 2025',
      // '6th Jul 2025', 
      // '13th Jul 2025', 
      // '20th Jul 2025', 
      // '27th Jul 2025',
      // '3rd Aug 2025', 
      // '10th Aug 2025', 
      // '17th Aug 2025', 
      // '24th Aug 2025', 
      // '31st Aug 2025', 
      // '7th Sep 2025', 
      // '14th Sep 2025', 
      // '21st Sep 2025', 
      // '28th Sep 2025', 
      // '5th Oct 2025', 
      // '12th Oct 2025', 
      // '19th Oct 2025', 
      // '26th Oct 2025', 
      // '2nd Nov 2025', 
      // '9th Nov 2025', 
      // '16th Nov 2025', 
      // '23rd Nov 2025', 
      // '30th Nov 2025', 
      // '7th Dec 2025', 
      // '14th Dec 2025', 
      // '21st Dec 2025', 
      // '28th Dec 2025', 
      // '4th Jan 2026', 
      // '11th Jan 2026',
      //  '18th Jan 2026', 
      //  '25th Jan 2026',
      //  '1st Feb 2026', 
      //  '8th Feb 2026', 
      //  '15th Feb 2026', 
      //  '22nd Feb 2026', 
      //  '1st March 2026', 
      //  '8th March 2026', '15th March 2026', 
      //  '22nd March 2026', '29th March 2026',
      //  '5th April 2026',
      //  '12th April 2026',
      //  '26th April 2026',
      //  '3rd May 2026',
      //  '10th May 2026',
      //  '17th May 2026',
      //  '24th May 2026',
      //  '31st May 2026',
      //  '7th June 2026',
      //  '14th June 2026',
      // '21st June 2026',
      // '28th June 2026',
      '5th July 2026',
      '12th July 2026',
      '19th July 2026',
      '26th July 2026',
      '2nd August 2026',
      '9th August 2026',
      '16th August 2026',
      '23rd August 2026',
      '30th August 2026',
      '6th September 2026',
      '13th September 2026',
      '20th September 2026',
      '27th September 2026',
      '4th October 2026',
      '11th October 2026',
      '18th October 2026',
      '25th October 2026',
      '1st November 2026',
      '8th November 2026',
      '15th November 2026',
      '22nd November 2026',
      '29th November 2026',
      '6th December 2026',
      '13th December 2026',
      '20th December 2026',
      '27th December 2026'
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "Every Sunday",
      timings: [
        {
          day: "Every Sunday",
          time: "9.30 am and 10.30am"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  16: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekends: true,
    title: 'Weekend Yoga Asana Classes - (Men & Women) - On Campus',
    key: 'weekend-classes',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    newName: 'Weekend Asana Classes (Men & Women)',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      'Saturday: 8:00 am - 9:30 am (IST)',
      'Sunday: 8:00 am - 9:30 am (IST) or 10:30 am - 12:00 pm (IST)'
    ],
    image: `${baseDomain}${courseAssets.courseAsset77}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/weekend-yoga-Asana-Classes_-Men-Women)_+246+X+135.jpg`,
    mostPopular: true,
    metaDescription:
      'Weekend yoga to boost strength, flexibility & inner balance.',
    rating: 5,
    colorCode: '#D3A29D',
    timing:
      'Saturday & Sunday: Saturday: 8:00 am - 9:30 am (IST) and Sunday: 8:00 am - 9:30 am (IST) or 10:30 am - 12:00 pm (IST)',
    fees: {
      onlineFee: 1200,
      // onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1200 },
    },
    newFees: {
      onlineFee: 1200,
      // onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1200 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Weekend Yoga Asana Classes - (Men & Women) - On Campus',
      courseType: 'Weekend Regular Asana Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Weekend Regular Asana',
      coursePreRequisite: ''
    },
    dates: ['Saturday', 'Sunday'],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Saturday & Sunday",
          time: "Saturday: 8:00 am - 9:30 am (IST)"
        },
        {
          day: "Saturday & Sunday",
          time: "Sunday: 8:00 am - 9:30 am (IST) or 10:30 am - 12:00 pm (IST)"
        },
      ]
    }
    ,
    online: false,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: false,
    tenure: 'Weekly 2 Days',
    language: 'English ',
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Struggling to meet your yoga goals during the week? No worries, we got you! You have the option to register for regular weekend yoga class with The Yoga Institute. These are regular weekend yoga classes for those who are unable to attend on weekdays owing to other obligations. Weekend Yoga Asana Regular Class is an excellent course for daily yoga practise. Yoga Asanas, Pranayamas, Kriyas, and food and Yogic lifestyle suggestions are all covered in these weekend yoga classes. Participants are divided into groups based on their health status, and each group receives distinct training. In addition, as needed, all students receive individual attention.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Duration',
          points: [
            {
              listItem:
                'Weekend Yoga Classes are of 1 and half hour duration held every Saturday and Sunday',
              subItems: [],
            },
            {
              listItem:
                'A minimum attendance of 3 months is recommended, to experience the difference in your life. Can join on any day of the month.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing ',
          text: [''],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Saturday & Sunday',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Saturday',
          text: ['8:00 am - 9:30 am - 5:00 pm to 6:30 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Sunday',
          text: ['8:00 am - 9:30 am (IST) or 10:30 am - 12:00 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees ',
          text: [''],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Monthly Fees',
      //     text: ['Rs. 1100/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Monthly Fees - 2026',
          text: ['Rs. 1200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Six Months Fees',
      //     text: ['Rs. 6600/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Six Months Fees - 2026',
          text: ['Rs. 7200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Annual Fees',
      //     text: ['Rs. 11000/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Annual Fees - 2026',
          text: ['Rs. 12000/-'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: [' Kindly note the fees once paid will not be refundable. '],
        },
      },
    ],
  },
  // 17: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Yog Prayas - Online',
  //   key: 'yog-prayas-online',
  //   isRegular: true,
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   newName: 'Yog Prayas',
  //   days: ['Monday', 'Wednesday', 'Friday'],
  //   time: [
  //     'Morning: 5:30 am - 6:30 am (IST) ',
  //     'Evening: 6:00 pm - 7:00 pm (IST)'
  //   ],
  //   image: `${baseDomain}${courseAssets.courseAsset82}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset82}`,
  //   mostPopular: false,
  //   metaDescription:
  //     'This is for people who are looking forward to yogic progress after being familiar with basic Yogasanas.',
  //   rating: 5,
  //   colorCode: '#C48E8C',
  //   join: true,
  //   timing:
  //     'Monday, Wednesday & Friday : Morning: 5:30 am - 6:30 am (IST) or Evening: 6:00 pm - 7:00 pm (IST) *',
  //   fees: {
  //     onlineFee: 1500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'classes',
  //   dates: ['5:30 am to 6:30 am ', '6:00 pm to 7:00 pm '],
  //   online: true,
  //   onCampus: false,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   tenure: '',
  //   courseType: 'Regular Class - 2',
  //   language: 'English',
  //   preRequisite: 'None',
  //   courseCategory: 'Self Help',
  //   courseSubType: 'Regular Asana Classes',
  //   enrollInfo: {
  //     duration: "Upto 12 months",
  //     timings: [
  //       {
  //         day: "Monday, Wednesday & Friday",
  //         time: "Morning: 5:30 am - 6:30 am (IST)"
  //       },
  //       {
  //         day: "Monday, Wednesday & Friday",
  //         time: "Evening: 6:00 pm - 7:00 pm (IST) *"
  //       }
  //     ]
  //   }
  //   ,

  //   courseCertificate: 'NO',
  //   onlineInfo: {
  //     courseMode: true,
  //   },
  //   residentialInfo: {
  //     courseMode: false,
  //     residentialMode: false
  //   },
  //   nonResidentialInfo: {
  //     courseMode: false,
  //     nonResidentialMode: false
  //   },
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'This is for people who are looking forward to yogic progress after being familiar with basic Yogasanas. The focused Sadhaka’s, who just doesn’t want to become Yoga Professional, but aims for an even bigger goal, SELF DEVELOPMENT.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title:
  //           'Few of the basic qualities we look forward to in a Sadhaka for this yoga program are',
  //         text: [
  //           'Focus for yoga practice',
  //           'Curiosity for yogic knowledge',
  //           'Application of Yogic Principals in Practical life',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'PROGRAMME DETAILS',
  //         points: [
  //           {
  //             listItem:
  //               'The yoga program offers the best time for YOGASANA PRACTICE (early morning) in relation to Sattvik energy of the rising sun.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Every day consultation time for 15 mins prior and 15 mins after the 1-hours YOG ABHYAS (Yogasana, Pranayama and basic Meditation)',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Personal attention- as seats are limited – 30 seats only each batch',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'A balance of Yoga Asanas, Pranayamas, Relaxation techniques and much more.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'The yoga practice class shall be a live session via the Zoom App.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Once registered and payment is made, we shall be sending you links on your email id or WhatsApp.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'This online yoga program is open to both males and females.',
  //             subItems: [],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: [],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: ['Rs. 1500/-'],
  //       },
  //     },
  //     {
  //       type: 'u-list',
  //       content: {
  //         title: 'RULES AND REGULATIONS',
  //         points: [
  //           {
  //             listItem:
  //               'Carry forwarding of missed sessions, recording of the session, and shifting of the batch is not permitted.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Please note fees once paid will be non-refundable.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Join on any date. Your payment is valid for one month from the date of joining.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               '3 Days a week – Morning Batch – Monday, Wednesday, Friday. – 1 Hour sessions will continue as it is.',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               '3 Days a week – Evening Batch – Monday, Wednesday, Friday. – 1 Hour sessions',
  //             subItems: [],
  //           },
  //           {
  //             listItem:
  //               'Rest is the same as the morning batch, a mix of philosophy and regular online yogaasanas session.',
  //             subItems: [],

  //           },
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'WEEKDAYS SCHEDULE',
  //         text: [
  //           'Monday, Wednesday & Friday : Morning: 5:30 am - 6:30 am (IST) or Evening: 6:00 pm - 7:00 pm (IST) (Join on any date)',
  //         ],
  //       },
  //     },
  //   ],
  // },
  18: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Samattvam – Free Health Consultation (On Campus)',
    key: 'samattvam',
    isRegular: true,
    tenure: '1 day',
    weekends: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    // templateId: {
    //   templateOnline: 'SAMATTVAM_FORM_CONFIRMATION_MAIL',
    //   templateOffline: {
    //     templateResidential: 'SAMATTVAM_FORM_CONFIRMATION_MAIL',
    //     templateNonResidential: 'SAMATTVAM_FORM_CONFIRMATION_MAIL',
    //   },
    // },
    templateId: {
      templateOnline: 'SAMATTVAM_CLASSES',
      templateOffline: {
        templateResidential: 'SAMATTVAM_CLASSES',
        templateNonResidential: 'SAMATTVAM_CLASSES',
      },
    },
    image: `${baseDomain}${homeAssets.homeAsset16}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/satvam_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      '',
    rating: 5,
    colorCode: '#DDAB58',
    timing: 'Every Saturday - 2.00 p.m. - 5.00 p.m. (IST)',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    dates: [
      // '8th Feb 2025', '15th Feb 2025', 
      // '22nd Feb 2025', 
      // '15th Mar 2025', 
      // '22nd Mar 2025', 
      // '29th Mar 2025',
      // '5th Apr 2025',
      // '12th Apr 2025', 
      // '19th Apr 2025', 
      // '26th Apr 2025', 
      // '3rd May 2025', 
      // '10th May 2025', 
      // '17th May 2025', 
      // '24th May 2025', 
      // '31st May 2025', 
      // '7th June 2025', 
      // '14th Jun 2025', 
      // '21st Jun 2025', 
      // '28th Jun 2025',
      // '5th Jul 2025', 
      // '12th Jul 2025', 
      // '19th Jul 2025', 
      // '26th Jul 2025',
      // '2nd Aug 2025', 
      // '9th Aug 2025', 
      // '16th Aug 2025', 
      // '23rd Aug 2025', 
      // '30th Aug 2025', 
      // '6th Sep 2025', 
      // '13th Sep 2025', 
      // '20th Sep 2025', 
      // '27th Sep 2025', 
      // '4th Oct 2025', 
      // '11th Oct 2025', 
      // '18th Oct 2025', 
      // '25th Oct 2025', 
      // '1st Nov 2025', 
      // '8th Nov 2025', 
      // '15th Nov 2025', 
      // '22nd Nov 2025', 
      // '29th Nov 2025', 
      // '6th Dec 2025', 
      // '13th Dec 2025', 
      // '20th Dec 2025', 
      // '27th Dec 2025', 
      // '3rd Jan 2026',
      //  '10th Jan 2026',
      // '17th Jan 2026', 
      // '24th Jan 2026', 
      // '31st Jan 2026',
      // '7th Feb 2026', 
      // '14th Feb 2026', 
      // '21st Feb 2026', 
      // '28th Feb 2026', 
      // '7th March 2026', 
      // '14th March 2026',
      //  '21st March 2026',
      //   '28th March 2026',
      // '4th April 2026',
      // '11th April 2026',
      // '25th April 2026',
      // '2nd May 2026',
      // '9th May 2026',
      // '16th May 2026',
      // '23rd May 2026',
      // '30th May 2026',
      // '6th June 2026',
      // '13th June 2026',
      // '20th June 2026',
      // '27th June 2026',
      '4th July 2026',
      '11th July 2026',
      '18th July 2026',
      '25th July 2026',
      '1st August 2026',
      '8th August 2026',
      '15th August 2026',
      '22nd August 2026',
      '29th August 2026',
      '5th September 2026',
      '12th September 2026',
      '19th September 2026',
      '26th September 2026',
      '3rd October 2026',
      '10th October 2026',
      '17th October 2026',
      '24th October 2026',
      '31st October 2026',
      '7th November 2026',
      '14th November 2026',
      '21st November 2026',
      '28th November 2026',
      '5th December 2026',
      '12th December 2026',
      '19th December 2026',
      '26th December 2026'
    ],
    category: 'classes',
    clevertapData: {
      name: 'Samattvam (Health Checkup) - On Campus',
      courseType: 'Health Check Up ',
      courseSubType: 'Camps & Workshops',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Health Check Up ',
      coursePreRequisite: ''
    },
    online: false,
    onCampus: true,//true
    nonResidential: false,//true
    residential: false,
    certficate: false,

    courseType: "samatwam health checkup",
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Camps & Workshops',
    newName: '',
    enrollInfo: {
      duration: "Only on Saturday’s",
      timings: [
        {
          day: "Every Saturday",
          time: "2.00 p.m. - 5.00 p.m. (IST)"
        }
      ]
    },

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: false,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            ' Samattvam is a free health consultation initiative offering personalised guidance for health concerns such as Cardiac care, diabetes, Weight and hormonal management, nutrition, respiratory health,  Emotional Wellness, Gut health, stress management, bone health and many more. Led by specialised medical doctors and yoga experts, recommendations are made based on each individual’s health condition. Where based on individual requirement, simple yogic practices-including asanas, relaxation, and breathing techniques-are taught to support health management, with clear guidance for self-practice.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Guided by Dr. Hansaji Yogendra, Samattvam brings together experienced Medical doctors, physiotherapists, counsellors, nutritionists, and yoga experts-offering integrated, compassionate care under one roof.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'What You Gain',
          points: [
            {
              listItem:
                'Personalised guidance on health, lifestyle, and well-being',
              subItems: [],
            },
            {
              listItem:
                'Yogic insights for preventive and supportive care',
              subItems: [],
            },
            {
              listItem:
                'Individualised recommendations based on physical and mental - emotional needs',
              subItems: [],
            },
            {
              listItem:
                'Direction towards suitable yoga classes, camps, or further care, if required',
              subItems: [],
            },
            {
              listItem:
                'An opportunity to receive wisdom from Pujya Maa Hansaji',
              subItems: [],
            },
            {
              listItem:
                'Need based guidance from experienced Medical doctors, physiotherapists, counsellors, nutritionists, yoga therapists',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Flow',
          points: [
            {
              listItem:
                '1.30 - 2.00 p.m.: Walk-in registration',
              subItems: [],
            },
            {
              listItem:
                '2.00 - 2.30 p.m.: Physical parameter assessments',
              subItems: [],
            },
            {
              listItem:
                '2.30 - 3.00 p.m.: Institute overview & asana introduction',
              subItems: [],
            },
            {
              listItem:
                '3.00 - 3.30 p.m.: Lifestyle management video by Dr. Hansaji Yogendra',
              subItems: [],
            },
            {
              listItem:
                '3.30 - 3.45 p.m.: Sattvik snack and herbal tea',
              subItems: [],
            },
            {
              listItem:
                '3.45 - 4.10 p.m.: Special talk by doctor / counsellor',
              subItems: [],
            },
            {
              listItem:
                'From 4.10 p.m. onwards: One-on-one consultations based on individual health needs with specialised doctors, yoga counsellors, asana teachers (if required), physiotherapists, and yoga therapists.',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Why Samattvam',
          points: [
            {
              listItem:
                'Free of charge seva',
              subItems: [],
            },
            {
              listItem:
                'Access to multi-disciplinary expertise',
              subItems: [],
            },
            {
              listItem:
                'A compassionate, holistic approach to health',
              subItems: [],
            },
            {
              listItem:
                'An ideal first step towards balanced living through yoga',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'What to Bring',
          text: ['Relevant medical reports (if any), along with a pen and notepad.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['Every Saturday - 2.00 p.m. - 5.00 p.m. (IST)'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: ['Rs. 200/- per person (inclusive of snacks).'],
      //   },
      // },
    ],
  },
  19: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Couples’ Yoga Classes  - Online',
    key: 'couples-classes',
    isRegular: true,
    tenure: '1 day',
    weekends: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset77}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/270x148-2.jpg`,
    mostPopular: false,
    metaDescription:
      'Yoga for couples—grow together in love, balance & mindful partnership.',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Third Sunday of every month from 5.00 p.m. to 7.00 p.m.',
    fees: {
      onlineFee: 3500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 3500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },

    category: 'classes',
    clevertapData: {
      name: 'Couples’ Yoga Classes - Online',
      courseType: 'Couple Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Couple Classes',
      coursePreRequisite: ''
    },
    dates: [
      // '21st Jan 2024',
      '18th Jan 2026',

    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    courseType: "Couple's Classes Online",
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Couples Classes',
    days: [
      'Third Sunday of every month'
    ],
    time: [
      '5.00 p.m. to 7.00 p.m.'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Third Sunday of every month",
          time: "5.00 p.m. to 7.00 p.m."
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'About Couples Yoga Class',
          text: [
            'Since 1973, The Yoga Institute has been conducting Couples Yoga Class to strengthen the bond, nurture the relationship, and build intimacy and trust among couples. Relationships need constant efforts from both partners and an immense amount of understanding and compatibility.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Why Choose Couples Class?',
          text: [
            'Yoga when performed with your partner brings multiple benefits as it creates more awareness of the self and others, enhances communication and fortifies the connection. Through regular yoga practice, couples will learn to share, grow, build, trust, bond and have fun with each other.',
            'Most importantly, couples learn to give each other space when required and resolve conflicts constructively and respectfully. The Yoga Institute’s Couples Class will train you to work as one unit, work towards making your relationship better and stronger and lead a healthy and stress-free life.',
            'The Yoga Institute’s Couples Class will cover the following topics that will help couples to make their relationship healthy and successful '
          ],
        },
      },
      {
        type: 'o-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Understanding the Importance of Marriage',
              subItems: [],
            },
            {
              listItem: 'Role of Honesty and Faithfulness',
              subItems: [],
            },
            {
              listItem: 'Being a Supportive Partner',
              subItems: [],
            },
            {
              listItem: 'Enhancing your Communication Skills',
              subItems: [],
            },
            {
              listItem: 'Coping with Difficulties',
              subItems: [],
            },
            {
              listItem: 'Building Spiritual Connection',
              subItems: [],
            },
            {
              listItem: 'Performing Marital Duties Selflessly',
              subItems: [],
            },
            {
              listItem: 'Acceptance, Patience & Understanding',
              subItems: [],
            },
            {
              listItem: 'Open to Adjustment',
              subItems: [],
            },
            {
              listItem: 'Financial Transparency & Management',
              subItems: [],
            },
            {
              listItem: 'Balancing Interpersonal relationships',
              subItems: [],
            },
            {
              listItem: 'Positive Role Models to Children',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'USP of Couples Class',
          text: [
            'Smt. Hansaji addresses the Couples Yoga Classes once a month where various topics are discussed to help the householders in their daily commitments. Lectures by eminent personalities work as guidance to the couples. Further, group discussions and personal sharing on specific topics are regular features, which have been well-appreciated by members.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [
            'Enrollment is for a calendar year. Meetings are held on the third Sunday of every month from 5.00 p.m. to 7.00 p.m.in the Institute. Additionally, co-ordinated couples meet once during the same month in their respective groups.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: [
            'Couples should be connected with some activity with The Yoga Institute.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: ['Starts 18th January 2026'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'Annual fees - Rs. 3,500/- (per year for a couple)',
            '*Please note: Fees once paid will be non-refundable.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note:',
          text: [
            'Please take screenshot of your order receipt immediately after the payment is made to info@theyogainstitute.org',
          ],
        },
      },
    ],
  },
  20: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekends: true,
    title: 'Weekend Yoga Asana Classes - (Men & Women) - Online',
    key: 'weekend-classes-online',
    isRegular: true,
    batch: 1,
    newName: 'Weekend Asana Classes (Men & Women)',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      '7:30 am - 9:00 am (IST)'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Saturday & Sunday",
          time: "7:30 am - 9:00 am (IST)"
        }
      ]
    }
    ,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${homeAssets.homeAsset13}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/270+x+148.jpg`,
    mostPopular: true,
    metaDescription:
      'Weekend online yoga to enhance flexibility, strength & inner calm.',
    rating: 5,
    tenure: 'Weekly 2 Days',
    language: 'English ',
    colorCode: '#C48E8C',
    timing: 'Saturday & Sunday: 7:30 am - 9:00 am  (IST)',
    fees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 1200,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Weekend Yoga Asana Classes - (Men & Women) - Online',
      courseType: 'Weekend Regular Asana Classes',
      courseSubType: 'Regular Asana Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Weekend Regular Asana',
      coursePreRequisite: ''
    },
    dates: ['7:30 am to 9:00 am', ''],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Busy weekdays making it hard to stick to your yoga routine? We’ve got the perfect solution. We offer Weekend Online Yoga Asana Classes designed especially for those who can’t attend during the week due to work or personal commitments.',
            'These classes provide a complete and consistent yoga practice, covering asanas, pranayamas, kriyas, and practical guidance on yogic diet and lifestyle. Participants are thoughtfully grouped based on their health conditions, ensuring safe and personalized instruction. Every individual receives the attention they need to progress mindfully.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Duration',
          points: [
            {
              listItem:
                'Weekend Yoga Classes are of 1 and half hour duration held every Saturday and sunday',
              subItems: [],
            },
            {
              listItem:
                'A minimum attendance of 3 months is recommended, to experience the difference in your life. Can join on any day of the month.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing',
          text: ['Saturday & Sunday: 7:30 am - 9:00 am  (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Monthly Fees',
      //     text: ['Rs. 1100/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Monthly Fees - 2026',
          text: ['Rs. 1200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Six Months Fees',
      //     text: ['Rs. 6600/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Six Months Fees - 2026',
          text: ['Rs. 7200/-'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Annual Fees',
      //     text: ['Rs. 11000/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Annual Fees - 2026',
          text: ['Rs. 12000/-'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Please note : Yoga Classes will be conducted on Zoom'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '*Note: Kindly note the fees once paid will not be refundable',
          ],
        },
      },
    ],
  },
  21: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Regular Pregnancy Yoga Classes - Online & On Campus',
    key: 'regular-pregnacy-classes',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAssets115}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/pregnancy-yoga-camp_270+x+148.jpg`,
    mostPopular: false,
    metaDescription:
      'Holistic prenatal yoga for a smooth & joyful pregnancy journey.',
    rating: 5,
    colorCode: '#C48E8C',
    timing: '8:30 am to 9:30 am (Monday, Wednesday, Friday)',
    fees: {
      onlineFee: 1500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1600 },
    },
    newFees: {
      onlineFee: 1500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 1600 },
    },
    category: 'classes',
    dates: ['8:30 am to 9:30 am'],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    clevertapData: {
      name: 'Regular Pregnancy Yoga Classes - Online & On Campus',
      courseType: 'Regular Pregnancy Classes',
      courseSubType: 'Regular Pregnancy Classes',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Regular Pregnancy Classes',
      coursePreRequisite: ''
    },

    tenure: '3 Days',
    courseType: 'Regular Meditation Foundation Course',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Self Help',
    courseSubType: 'Regular Asana Classes',
    newName: 'Regular Pregnancy Yoga Class',
    days: [
      'Monday',
      'Wednesday',
      'Friday'
    ],
    time: [
      '8:30 am to 9:30 am'
    ],
    enrollInfo: {
      duration: "Upto 12 months",
      timings: [
        {
          day: "Monday, Wednesday, Friday",
          time: "8:30 am to 9:30 am"
        }
      ]
    }
    ,

    courseCertificate: 'NO',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'About The Class:',
          text: [
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Pregnancy and parenthood are the two most beautiful and crucial phases of a woman’s life.',
            'During pregnancy, a woman’s body goes through multiple changes. The techniques offered at The Yoga Institute are tailored to assist the would-be-mother to adapt to these changes, cope with her emotions, be mindful, build strength, enjoy the process, connect with the baby and be prepared to welcome the child both on mental and physical level.',
            'So, come and join the Pregnancy Yoga classes for a healthy and happy pregnancy and easy delivery.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Class Offerings:',
          points: [
            {
              listItem: 'Yoga Asana',
              subItems: [],
            },
            {
              listItem: 'Guided Meditation',
              subItems: [],
            },
            {
              listItem: 'Breathing Technique',
              subItems: [],
            },
            {
              listItem: 'Yoga for Easy Delivery',
              subItems: [],
            },
            {
              listItem: 'Garbhsanskar',
              subItems: [],
            },
            {
              listItem: 'Prayer & Mantra Chanting',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Days:',
          text: ['Monday, Wednesday, Friday'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time:',
          text: ['8:30 am to 9:30 am'],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Fees:',
          text: ['Rs. 1,500/- per month'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '*Please Note:',
          text: [
            'Women can join only after completing the first trimester of their pregnancy',
          ],
        },
      },
    ],
  },
  33: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: 'fellowship-in-yoga-therapy',
    // templateId: 'COURSE200_2M_TTC2',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: 'GENERAL_AUTO_EMAIL',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    batch: 3,
    metaDescription:
      'In association with Maharashtra University of Health Sciences.',
    textDescription: 'You will see a marked improvement in your life, relationships and work.',
    image: `https://nispand.s3.ap-south-1.amazonaws.com/WhatsApp+Image+2025-10-16+at+15.39.17+(1).webp`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/200-hour-yoga-teacher-training-course_246+X+135.jpg`,
    mostPopular: false,
    rating: 5,
    colorCode: '#E38F73',
    timing:
      'Saturday Offline – 11am to 2pm and Sunday Online– 11am to 2pm',
    fees: {
      onlineFee: 100000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Fellowship+in+Yoga+Therapy++Syllabus.pdf",
    faqurl: "",
    category: 'ttc',
    title: 'Fellowship in Yoga Therapy',
    clevertapData: {
      name: 'Fellowship in Yoga Therapy',
      courseType: 'TTC',
      courseSubType: '200 Hour Yoga Teacher Training',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    dates: [
      // '8th Jan – 2nd Mar 2024',
      // '11th Mar – 4th May 2024',
      // '13th May – 6th Jul 2024',
      // '15th Jul – 7th Sep 2024',
      // '16th Sep – 9th Nov 2024',
      // '18th Nov – 11th Jan 2025',
      // '19th Feb - 8th Jun 2024',
      // '17th Jun - 5th Oct 2024',
      // '14th Oct - 1st Feb 2025',
      // '20th Jan - 15th Mar 2025',
      // '24th Mar - 17th May 2025',
      // '26th May - 19th Jul 2025',
      // '28th Jul - 20th Sep 2025',
      // '29th Sep - 22nd Nov 2025',
      // '25th Nov - 18th Jan 2026',
      // '6th Oct - 29th Nov 2025',
      //  '24th Nov 2025'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: '1 year',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: 'Fellowship in Yoga Therapy',
    newName: 'Fellowship in Yoga Therapy',
    days: [
      'Saturday',
      'Sunday'
    ],
    time:
      [
        'Saturday Offline – 11am to 2pm',
        'Evening : 6:30 pm - 8:30 pm (IST)'
      ],

    enrollInfo: {
      duration: "1 year",
      timings: [
        {
          day: "Saturday",
          time: " 11am to 2pm"
        },
        {
          day: "Sunday",
          time: "11am to 2pm "
        }
      ],
      message: "(Both the time slots are mandatory)",
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute is the world’s first established yoga centre founded in 1918 by the revered Yogi Shri Yogendra ji. The enduring spirit of The Yoga Institute lies in its 100-year legacy, deeply rooted in the ideals, wisdom, and practices of Yoga. The Yoga Institute offers courses specifically designed for various age groups, addressing diverse challenges. The Yoga Institute Mumbai offers a new course, ‘Fellowship in Yoga Therapy’, in association with Maharashtra University of Health Sciences, Nashik to provide professional yogic education and skill. The goal of this ‘Fellowship in Yoga Therapy’ course is to provide value added qualifications in Yoga Therapy to yoga and clinical practitioners.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'fees',
          text: [
            'INR 1,00,000/- '
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Key Features',
          points: [
            {
              listItem:
                'Imparting knowledge about therapeutic aspect of Yoga.',
              subItems: [],
            },
            {
              listItem:
                'Empowering students with Yoga Therapy for professional advances',
              subItems: [],
            },
            {
              listItem:
                'Exploring benefits of Yoga Therapy for different diseases.',
              subItems: [],
            },
            {
              listItem:
                'Learn through online course and interactive sessions on campus.',
              subItems: [],
            },
            {
              listItem:
                'The syllabus includes academic activities, yoga practices, clinical activities and research project.',
              subItems: [],
            },
            {
              listItem:
                'This course is in association with Maharashtra University of Health Sciences, Nashik.',
              subItems: [],
            },
            {
              listItem:
                'Curriculum is designed and approved by UGC.',
              subItems: [],
            },
            {
              listItem:
                'On successful completion of the course and qualifying the examination, the candidate will be awarded a Fellowship in Yoga Therapy.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'This course is designed for',
          points: [
            {
              listItem:
                'Professionals / Students with Bachelor degree from Health Sciences/ Medical Science (MBBS, BAMS, BHMS)',
              subItems: [],
            },
            {
              listItem:
                'Degree having Registration with MCIM / CCIM /Council of Ayurvedic / Unani Board of respective state shall be compulsory ',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Medium of Instruction',
          text: [
            'English ',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Intake capacity',
          text: [
            '30 students per batch ',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Nature of Course',
          text: [
            'Transferable Credit Based System (200 credits) ',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [
            '1 year ',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timing',
          text: [
            '(Saturday Offline – 11am to 2pm and Sunday Online– 11am to 2pm) ',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Course',
      //     text: [
      //       '200 hrs Batch 3 - Two Month Yoga TTC (Online – English)',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Timings',
      //     text: ['Monday to Saturday: Morning- 7:00 am to 8:30 am & Evening- 6:30 pm - 8:00 pm (IST) (Mandatory to attend both the slots)'],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500.',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Prerequisites',
      //     text: ['Minimum age requirement: 18 years.'],
      //   },
      // },
      //   {
      //   type: 'u-list',
      //   content: {
      //     title: 'Post Qualification Opportunities',
      //      points: [
      //       {
      //         listItem:
      //           'Best suited for seekers to learn foundational yoga practices & start a career in Yoga',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Universal & holistic syllabus with streamlined training helping to start teaching with clarity and confidence immediately post course completion.',
      //         subItems: [],
      //       },
      //        {
      //         listItem:
      //           'Offers opportunities to teach in community centres, home studios, online platforms, and group settings, while also enabling you to conduct group classes for healthy individuals, one-on-one sessions, workshops, and local outreach programs.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Lays a strong foundation of core concepts, fostering spiritual growth and self-awareness through insights into the subject of yoga.',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Documents Required',
          text: ['Participants in fellowship courses approved by MUHS will not be able to take part without original documents. Participants must present a set of self-attested Xerox copies of the following documents at the time of admission, along with the originals, for eligibility clearance. In case any additional documents are required by the regulatory body, then participants will have to comply with the same.'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Document list:',
          points: [
            {
              listItem: 'Application form ',
              subItems: [],
            },
            {
              listItem: 'Nationality / Domicile Certificate issued by Magistrate ',
              subItems: [],
            },
            {
              listItem: 'Degree Certificate UG & PG Both (in case PG is completed) ',
              subItems: [],
            },
            {
              listItem: 'Central / State Council Registration Certificate (UG & PG) with Additional Qualification Registrations ',
              subItems: [],
            },
            {
              listItem: 'Experience Certificate (If applicable, in case of an ongoing academician or working with a government institute)',
              subItems: [],
            },
            {
              listItem: 'Leaving & Transfer Certificates',
              subItems: [],
            },
            {
              listItem: 'Caste Certificate (If applicable) ',
              subItems: [],
            },
            {
              listItem: 'Caste Validity Certificate (Mandatory for participants with caste certificate) ',
              subItems: [],
            },
            {
              listItem: 'Valid Non-Creamy Layer Certificate (wherever applicable)',
              subItems: [],
            },
            {
              listItem: 'Migration Certificate (If the last degree obtained other than MUHS)',
              subItems: [],
            },
            {
              listItem: 'Gazette copy / Marriage certificate (In case of change in name)',
              subItems: [],
            },
            {
              listItem: 'Educational Gap Certificate (If applicable) ',
              subItems: [],
            },


          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Examination & Certification',
      //     points: [
      //       {
      //         listItem:
      //           'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Students who pass the final exam successfully, will be:',
      //         subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
      //           'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
      //           'Qualified to register with Yoga Alliance (RYT 200)'
      //         ],
      //       },
      //       {
      //         listItem:
      //           'Exam Details',
      //         subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
      //           {
      //             subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
      //             leafItems: [
      //               'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
      //               'They will have to appear for both in case of a 3rd attempt.'
      //             ]
      //           },
      //           {
      //             subItem: 'Students can register for either Online or On-Campus exams.',
      //             leafItems: [
      //               'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
      //             ]
      //           },
      //           'Examiners will evaluate students only as per the final approved list.'

      //         ],
      //       },
      //       {
      //         listItem:
      //           'Exam Schedule',
      //         subItems: ['On Campus/ Online Final exams will be conducted on the 1st Sat and the 3rd Saturday of each month or as announced (in case of exigencies), subject to a minimum quorum of 8 students.',
      //           'A mock test will be conducted 7–14 days before the final exam, typically on a Saturday, to familiarize students with the examination process.',
      //           'The examination timings will be announced in advance by the course coordinator.'
      //         ],
      //       },
      //     ],
      //   },
      // },




    ],
    teaching: [],
    offerings: [
      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
      //         subItems: []
      //       },
      //       {
      //         listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
      //         subItems: []
      //       },
      //       {
      //         listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
      //         subItems: []
      //       },
      //       {
      //         listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
      //         subItems: []
      //       }
      //     ]
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
      //   },
      // },
    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "02 Months",
      mode: "Online",
      language: "English",
      timing: "Morning: 7:00am - 8:30am and Evening : 6:30pm - 8:30pm (IST)",
      days: "Monday - Saturday",
      navigate: "/200-hrs-part-time-ttc-online-english",
    },
  },
  22: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'MA Yogashastra',
    key: 'ma-yoga-shastra',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'MA_YOGA_SHASTRA',
      templateOffline: {
        templateResidential: 'MA_YOGA_SHASTRA',
        templateNonResidential: 'MA_YOGA_SHASTRA',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${extraImage.mayogaImg}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/MA+Yogashastra+2025+_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'For full online learning please contact us at\nma.yogashastra.iby@gmail.com\n\nPursue higher learning in yoga’s wisdom with an M.A. in Yogashastra.',
    rating: 5,
    colorCode: '#759F80',
    timing: 'Lectures will be conducted On Campus - Monday, Wednesday, Friday - 3pm to 8pm And Online only on Saturday - 10am - 2pm',
    fees: {
      // onlineFee: 1500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 40000 },
      internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    language: 'English ',
    tenure: '2 Years',
    dates: [
      '15th June 2026'
      // '30th May 2026'

    ],
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'About The Class:',
      //     text: [
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'The Master of Arts (MA) in Yogashastra at The Yoga Institute, Santacruz East, is a comprehensive two-year program designed to deepen your understanding and practice of yoga. Established in 1918 by Shri Yogendraji, The Yoga Institute is the worlds oldest organized yoga centre. Our institute has a rich legacy of over 100 years, promoting the ideals, wisdom, and practice of yoga and the yogic way of life. This course integrates ancient yogic wisdom with modern scientific knowledge, preparing students for advanced studies and professional practice in yoga.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Full online learning experience will be offered for students.',
            'For details contact us at', 'ma.yogashastra.iby@gmail.com'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'The MA Yogashastra program includes a blend of theoretical and practical components, covering a wide range of topics such as:',
          points: [
            {
              listItem: 'Semester - I',
              subItems: [
                'Fundamentals Of Indian Philosophy - 1',
                'Yoga Tradition',
                'Research Methodology',
                'Yoga Practical I',
                'Hathayoga Texts'
              ],
            },
            {
              listItem: 'Semester - II',
              subItems: [
                'Indian Philosophy & Yogasutra',
                'Yoga-Upanishad and Modern Yoga',
                'Internship',
                'Yoga Practical II',
                'Dietetics, Nutrition and Yogic Diet'
              ],
            },
            {
              listItem: 'Semester - III',
              subItems: [
                'Classical Yoga Texts',
                'Yoga & Allied Sciences',
                'Research Project',
                'Yoga Practical III',
                'Yoga Application'
              ],
            },
            {
              listItem: 'Semester - IV',
              subItems: [
                'Traditional Yoga Texts',
                'Western Psychology',
                'Dissertation',
                'Yoga Practical IV',
                'Yoga Therapy and Other Therapies'
              ],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Eligibility',
          text: ['Educational Qualification: Any Bachelors degree from a recognized university'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Admission Process',
          text: ['Application Deadline: 15th June 2026',
            //  'Course Commencement Date: 16th June 2025', 
            'Selection Criteria: Based on merit and timely registration'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Pricing',
          text: ['For National Students : ₹40,000 per year', 'For International Students : $3950 per year'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Documents Required:',
          points: [
            {
              listItem: 'Graduation Marksheet (Last Semester)',
              subItems: [],
            },
            {
              listItem: 'Leaving Certificate (From the last college attended)',
              subItems: [],
            },
            {
              listItem: 'Migration Certificate (From the last university attended)',
              subItems: [],
            },
            {
              listItem: 'Marriage Certificate/ Proof of Name Change (in case of name change)',
              subItems: [],
            },
            {
              listItem: 'Aadhaar Card',
              subItems: [],
            },
            {
              listItem: 'ABC ID (Students can create their ABC ID using the link: https://www.abc.gov.in/)',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Career Opportunities',
          points: [
            {
              listItem: 'Graduates of the MA Yogashastra program can pursue careers as:',
              subItems: ['Yoga Instructors', 'Yoga Advisors', 'Academic Professors in Yoga Studies', 'Yoga Researchers',],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'How to Apply',
          text: [
            'Interested candidates can apply by clicking in the apply now button above or contact our admissions office at Shri Yogendra Marg, Prabhat Colony, Santacruz East, Mumbai - 400055 India.',
            'For more information, reach out to us at info@theyogainstitute.org or +91-22-26110506 / +91-22-26103568 '
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Why Study MA Yoga Shastra at The Yoga Institute?',
      //     points: [
      //       {
      //         listItem: 'Rich Legacy: The Yoga Institute, established in 1918, is the world`s oldest organized yoga center',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Experienced Faculty: Learn from highly qualified and experienced yoga practitioners and scholars',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Holistic Approach: Our program emphasizes a holistic approach to yoga, integrating physical, mental, emotional, and spiritual aspects',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Personalized Attention: We maintain a low student-to-teacher ratio, ensuring personalized attention and guidance',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'State-of-the-Art Facilities: Enjoy access to advanced yoga studios, libraries, and research centers',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Innovative Teaching Methods: Our faculty uses innovative teaching methods that blend traditional knowledge with modern pedagogical techniques',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Research Opportunities: Engage in research in yoga and its applications, contributing to the growing body of scientific literature',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Global Recognition: Our graduates are recognized globally and are in demand for their expertise and knowledge',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Lifelong Learning: We offer lifelong learning opportunities through workshops, seminars, and advanced courses',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Join us to embark on a transformative journey in the world of Yoga Shastra!',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Why Study MA Yogashastra at The Yoga Institute?',
          text: [
            '●	Rich Legacy: The Yoga Institute, established in 1918, is the world`s oldest organized yoga center',
            '●	Experienced Faculty: Learn from highly qualified and experienced yoga practitioners and scholars',
            '●	Holistic Approach: Our program emphasizes a holistic approach to yoga, integrating physical, mental, emotional, and spiritual aspects',
            '●	Personalized Attention: We maintain a low student-to-teacher ratio, ensuring personalized attention and guidance',
            '●	State-of-the-Art Facilities: Enjoy access to advanced yoga studios, libraries, and research centers',
            '●	Innovative Teaching Methods: Our faculty uses innovative teaching methods that blend traditional knowledge with modern pedagogical techniques',
            '●	Research Opportunities: Engage in research in yoga and its applications, contributing to the growing body of scientific literature',
            '●	Global Recognition: Our graduates are recognized globally and are in demand for their expertise and knowledge',
            '●	Lifelong Learning: We offer lifelong learning opportunities through workshops, seminars, and advanced courses',
            'Join us to embark on a transformative journey in the world of Yogashastra!'
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Why Study MA Yoga Shastra at The Yoga Institute?',
      //     text: [
      //       'Rich Legacy: The Yoga Institute, established in 1918, is the world`s oldest organized yoga center.',
      //       'Experienced Faculty: Learn from highly qualified and experienced yoga practitioners and scholars.',
      //       'Holistic Approach: Our program emphasizes a holistic approach to yoga, integrating physical, mental, emotional, and spiritual aspects.',
      //       'Personalized Attention: We maintain a low student-to-teacher ratio, ensuring personalized attention and guidance',
      //       'State-of-the-Art Facilities: Enjoy access to advanced yoga studios, libraries, and research centers.',
      //       'Innovative Teaching Methods: Our faculty uses innovative teaching methods that blend traditional knowledge with modern pedagogical techniques.',
      //       'Research Opportunities: Engage in research in yoga and its applications, contributing to the growing body of scientific literature.',
      //       'Global Recognition: Our graduates are recognized globally and are in demand for their expertise and knowledge.',
      //       'Lifelong Learning: We offer lifelong learning opportunities through workshops, seminars, and advanced courses.',
      //       'Join us to embark on a transformative journey in the world of Yoga Shastra!'
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Contact Us',
          text: [
            'The Yoga Institute',
            'Santacruz East',
            'Mumbai, Maharashtra 400055',
            'Email id - info@theyogainstitute.org',
            'Phone -  +91-22-26110506, +91-22-26103568.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Apply Now',
          text: [
            ' ',
            '',
            '* Affiliation: This course is affiliated with Kavikulaguru Kalidas Sanskrit University (KKSU) Ramtek, Nagpur, awarded with "A+" grade by the National Assessment and Accreditation Council (NAAC).'
          ],
        },
      },
    ],
  },
  23: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Department of Rehabilitation and Physiotherapy',
    key: 'department-of-rehabilitation-and-physiotherapy',
    isRegular: true,
    tenure: '1 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'PHYSIO_FORM_CONFIRMATION_MAIL',
      templateOffline: {
        templateResidential: 'PHYSIO_FORM_CONFIRMATION_MAIL',
        templateNonResidential: 'PHYSIO_FORM_CONFIRMATION_MAIL',
      },
    },
    image: courseAssets.courseAssetPhysio,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/Department+of+Rehabilitation+and+Physiotherapy+_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'Personalized physiotherapy & rehab solutions for better recovery. ',
    rating: 5,
    colorCode: '#DDAB58',
    timing: 'Starting 2nd January 2025. Monday to Saturday between 9:30 am and 1:30pm',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: ['9:30 am to 1:30 pm '
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Day",
      timings: [
        {
          day: "Monday to Saturday",
          time: "9.30 am and 1.30pm"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'What is Rehabilitation?',
          text: [
            'Rehabilitation is a comprehensive process that helps individuals recover, improve, and adapt after an injury, illness, surgery, or disability. Its goal is to restore your strength, abilities, and independence, enabling you to live your life to the fullest.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Why is Rehabilitation Important?',
          text: [
            'Rehabilitation is a critical part of the recovery journey. Here’s why it matters:'],
        },
      },
      {
        type: 'o-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Restores Independence: We help you regain vital skills, allowing you to handle daily tasks on your own.',
              subItems: [],
            },
            {
              listItem: 'Enhances Physical Health: Targeted therapies improve strength, mobility, and overall well-being.',
              subItems: [],
            },
            {
              listItem: 'Reduces Pain: Our treatments alleviate discomfort, improving your quality of life.',
              subItems: [],
            },
            {
              listItem: 'Prevents Complications: Early rehab helps avoid issues like muscle weakness and joint stiffness.',
              subItems: [],
            },
            {
              listItem: 'Boosts Confidence: As you recover, you’ll feel more confident and motivated to return to your normal routine.',
              subItems: [],
            },
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Treatments We Offer',
          text: [
            'We provide specialized treatments for a wide range of conditions, including:'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Spondylosis, Arthritis, Frozen Shoulder',
              subItems: [],
            },
            {
              listItem: 'Paralysis, Facial Palsy',
              subItems: [],
            },
            {
              listItem: 'Spine Problems',
              subItems: [],
            },
            {
              listItem: 'Post-Joint Replacement & Post-Surgery Rehabilitation',
              subItems: [],
            },
            {
              listItem: 'Women’s Health – Osteoporosis',
              subItems: [],
            },
            {
              listItem: 'Sports Injuries',
              subItems: [],
            },
            {
              listItem: 'Disc Problems',
              subItems: [],
            },
            {
              listItem: 'Nerve Injuries',
              subItems: [],
            },
            {
              listItem: 'Antenatal & Postnatal (Pregnancy) Exercises',
              subItems: [],
            },
            {
              listItem: 'Chest Physiotherapy and More',
              subItems: [],
            },
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Role of Physiotherapy in Rehabilitation',
          text: [
            'Physiotherapy is essential in the rehabilitation process. Our expert physiotherapists help you recover and regain function through:'],
        },
      },
      {
        type: 'o-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Restoring Mobility: Tailored exercises enhance flexibility, strength, and balance.',
              subItems: [],
            },
            {
              listItem: 'Pain Management: Techniques like manual therapy and electrotherapy reduce pain and inflammation.',
              subItems: [],
            },
            {
              listItem: 'Preventing Complications: Early physiotherapy prevents muscle atrophy, joint stiffness, and secondary injuries.',
              subItems: [],
            },
            {
              listItem: 'Enhancing Recovery: Physiotherapy speeds up healing and restores function.',
              subItems: [],
            },
            {
              listItem: 'Improving Quality of Life: Addressing physical limitations helps you regain independence and confidence. ',
              subItems: [],
            },
            {
              listItem: 'Empowering Health: Physiotherapy not only aids recovery but promotes a more active, healthier lifestyle.',
              subItems: [],
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Who Can Benefit from Physiotherapy?',
          text: [
            'Physiotherapy is a versatile field that benefits people of all ages and conditions. Here’s how it can help:'],
        },
      },

      {
        type: 'o-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Musculoskeletal Physiotherapy',
              subItems: ['Conditions: Back pain, arthritis, sports injuries, post-surgery recovery.', 'Focus: Restoring joint function, strength, and flexibility.'],
            },
            {
              listItem: 'Neurological Physiotherapy',
              subItems: ['Conditions: Stroke, Parkinson’s disease, multiple sclerosis, spinal cord injuries.', 'Focus: Improving motor function, balance, and coordination.'],
            },
            {
              listItem: 'Cardiopulmonary Physiotherapy',
              subItems: ['Conditions: COPD, asthma, post-cardiac surgery recovery.', 'Focus: Enhancing respiratory function and cardiovascular fitness.'],
            },
            {
              listItem: 'Geriatric Physiotherapy',
              subItems: ['Conditions: Osteoporosis, arthritis, balance disorders.', 'Focus: Improving mobility and reducing fall risk.'],
            },
            {
              listItem: 'Sports Physiotherapy',
              subItems: ['Focus: Preventing, diagnosing, and treating sports-related injuries, enhancing athletic performance, and facilitating a safe return to sport.'],
            },
            {
              listItem: 'Women’s Health Physiotherapy',
              subItems: ['Conditions: Pregnancy, postpartum recovery, pelvic floor dysfunction.', 'Focus: Improving pelvic health and managing pain.'],
            },
            {
              listItem: 'Orthopedic Physiotherapy',
              subItems: ['Conditions: Fractures, joint replacements, and other orthopedic issues.', 'Focus: Post-surgery rehabilitation and functional restoration.'],
            },
            {
              listItem: 'Community-Based Rehabilitation',
              subItems: ['Focus: Providing physiotherapy services in community settings to promote overall health, wellness, and preventive care.'],
            },
          ]
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'How Do Physiotherapists Help?',
          text: [
            'Our physiotherapists use a combination of techniques to help you recover, regain function, and prevent future injuries:'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Exercise Therapy: Targeted exercises to improve strength, flexibility, and endurance',
              subItems: [],
            },
            {
              listItem: 'Manual Therapy: Hands-on techniques to alleviate pain and improve movement.',
              subItems: [],
            },
            {
              listItem: 'Electrotherapy: Using advanced machines like ultrasound or TENS to relieve pain and promote healing.',
              subItems: [],
            },
            {
              listItem: 'Education: Providing guidance on posture, ergonomics, and lifestyle changes to help prevent injury and support long-term health.',
              subItems: [],
            },
          ]
        }
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'For booking your appointment and more information, Call on +91-7738155500, +91-22-26110506, +91-22-26103568'],
        },
      },

    ],
  },
  24: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'BA Yogashastra',
    key: 'ba-yoga-shastra',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: 'GENERAL_AUTO_EMAIL',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    newName: 'BA Yogashastra',
    // language: 'English',
    enrollInfo: {
      duration: "3 Months",
      timings: [
        {
          day: "(Monday to Friday) - On Campus",
          time: "10:00 am - 2:00 pm"
        }
      ],
      message: "(Both the time slots are mandatory)",
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${BA_yoga_1}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/BA+Yogashastra+2025+_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'Comprehensive 4-year B.A. in Yogashastra covering theory & practice.',
    rating: 5,
    colorCode: '#759F80',
    timing: '10:00 am - 2:00 pm (Monday to Friday) - On Campus',
    fees: {
      // onlineFee: 1500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 33000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    dates: [
      // '15th June 2026 - BA'
      '31st July 2026'
    ],
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    language: 'English ',
    tenure: '4 Years',
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'About The Class:',
      //     text: [
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'The BA in Yogashastra is a four-year, full-time course aimed at offering an in-depth study of Yoga philosophy, techniques, and its practical applications. The curriculum is structured to provide a balanced education in both the theoretical and practical aspects of Yoga.'
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'The MA Yoga Shastra program includes a blend of theoretical and practical components, covering a wide range of topics such as:',
      //     points: [
      //       {
      //         listItem: 'Semester - I',
      //         subItems: [
      //           'Fundamentals Of Indian Philosophy - 1', 
      //           'Yoga Tradition', 
      //           'Research Methodology', 
      //           'Yoga Practical I',
      //           'Hathayoga Texts'
      //         ],
      //       },
      //       {
      //         listItem: 'Semester - II',
      //         subItems: [
      //           'Indian Philosophy & Yogasutra', 
      //           'Yoga-Upanishad and Modern Yoga', 
      //           'Internship', 
      //           'Yoga Practical II', 
      //           'Dietetics, Nutrition and Yogic Diet'
      //         ],
      //       },
      //       {
      //         listItem: 'Semester - III',
      //         subItems: [
      //           'Classical Yoga Texts', 
      //           'Yoga & Allied Sciences', 
      //           'Research Project', 
      //           'Yoga Practical III', 
      //           'Yoga Application'
      //         ],
      //       },
      //       {
      //         listItem: 'Semester - IV',
      //         subItems: [
      //           'Traditional Yoga Texts', 
      //           'Western Psychology', 
      //           'Dissertation', 
      //           'Yoga Practical IV', 
      //           'Yoga Therapy and Other Therapies'
      //         ],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Syllabus',
          text: ['The syllabus covers various essential topics, including the history and evolution of Yoga, human anatomy and physiology, Indian philosophy, Patanjali’s Yogasutras, Hatha Yoga traditions, applied yoga therapy, and modern research methodologies. Students also gain hands-on experience through practical sessions, internships, and field projects, ensuring a well-rounded understanding of Yogic science and its contemporary applications.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Duration: 4 Years (8 Semesters)',
          text: [''],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Eligibility Criteria',
          text: ['Applicants must have completed their Higher Secondary Certificate (HSC) or 10+2 or an equivalent examination from a recognized education board.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Admission Process',
          text: ['Application Deadline: 31st July 2026',
            // 'Course Commencement Date: 16th June 2025', 
            'Selection Criteria: Based on merit and timely registration'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Documents Required:',
          points: [
            {
              listItem: '12th Pass Certificate',
              subItems: [],
            },
            {
              listItem: '12th Pass Marksheet',
              subItems: [],
            },
            {
              listItem: 'Transfer Certificate (TC)',
              subItems: [],
            },
            {
              listItem: 'Aadhaar Card',
              subItems: [],
            },
            {
              listItem: 'ABC ID (Students can create their ABC ID using the link: https://www.abc.gov.in/)',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Pricing',
          text: ['For Indian National Students: Rs. 33,000 per year',
            'For International Students : $2950 per year'
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Documents Required:',
      //     points: [
      //       {
      //         listItem: 'Graduation Marksheet (Last Semester)',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Leaving Certificate (From the last college attended)',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Migration Certificate (From the last university attended)',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Marriage Certificate/ Proof of Name Change (in case of name change)',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Aadhaar Card',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Career Opportunities',
      //     points: [
      //       {
      //         listItem: 'Graduates of the MA Yoga Shastra program can pursue careers as:',
      //         subItems: ['Yoga Instructors', 'Yoga Advisors', 'Academic Professors in Yoga Studies', 'Yoga Researchers',],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'How to Apply',
          text: [
            'Interested candidates can apply by clicking in the apply now button above or contact our admissions office at Shri Yogendra Marg, Prabhat Colony, Santacruz East, Mumbai - 400055 India.',
            'For more information, reach out to us at info@theyogainstitute.org or +91-22-26110506 / +91-22-26103568 '
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Why Study BA Yogashastra at The Yoga Institute?',
          text: [
            '●	Rich Legacy: The Yoga Institute, established in 1918, is the world`s oldest organized yoga center',
            '●	Experienced Faculty: Learn from highly qualified and experienced yoga practitioners and scholars',
            '●	Holistic Approach: Our program emphasizes a holistic approach to yoga, integrating physical, mental, emotional, and spiritual aspects',
            '●	Personalized Attention: We maintain a low student-to-teacher ratio, ensuring personalized attention and guidance',
            '●	State-of-the-Art Facilities: Enjoy access to advanced yoga studios, libraries, and research centers',
            '●	Innovative Teaching Methods: Our faculty uses innovative teaching methods that blend traditional knowledge with modern pedagogical techniques',
            '●	Research Opportunities: Engage in research in yoga and its applications, contributing to the growing body of scientific literature',
            '●	Global Recognition: Our graduates are recognized globally and are in demand for their expertise and knowledge',
            '●	Lifelong Learning: We offer lifelong learning opportunities through workshops, seminars, and advanced courses',
            'Join us to embark on a transformative journey in the world of Yogashastra!'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Contact Us',
          text: [
            'The Yoga Institute',
            'Santacruz East',
            'Mumbai, Maharashtra 400055',
            'Email id - info@theyogainstitute.org',
            'Phone - +91-22-26110506 / +91-22-26103568'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Apply Now',
          text: [
            ' ',
            '',
            // '* Affiliation: This course is affiliated with Kavikulaguru Kalidas Sanskrit University (KKSU) Ramtek, Nagpur, awarded with "A+" grade by the National Assessment and Accreditation Council (NAAC).'
          ],
        },
      },
    ],
  },

}

const extra = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    weekDays: true,
    key: 'nutri-diet',
    title: 'Nutri Diet Clinic',
    cardImage: `${baseDomain}${nutriDiet.nutriDietCard}`,
    mostPopular: true,
    colorCode: '#B77E7E',
    dates: [],
    metaDescription: 'Nutri Diet Clinic blends science & yogic wisdom to create customized diet plans for weight loss, PCOS, diabetes, gut health or any fitness goal of yours. Achieve balance & long-term wellness with expert-guided nutritional support.'
  }
}

const certificate = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: 'Morning batch : Mondays, Tuesdays & Thursdays: 11:30 am - 12:30 pm (IST)',
    textdescription2: 'Evening batch: Monday,Tuesday & Thursday: 06:00 pm - 07:00 pm (IST)',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Certificate Course on Advanced Pranayama Techniques ( Pranayama Online Course)',
    key: 'certificate-course-on-advanced-pranayama-techniques',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset72}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/yoga-certificate-course-advanced-pranayama-techniques-online+_+270+x148.jpg`,
    metaDescription: 'Deepen pranayama practice with advanced breathwork techniques for teachers.',
    mostPopular: true,
    rating: 5,
    colorCode: '#759F80',
    timing: ' ',
    fees: {
      onlineFee: 28000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 28000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    clevertapData: {
      name: 'Certificate Course on Advanced Pranayama Techniques',
      courseType: 'Certificate',
      courseSubType: 'Special Course - Pranayama',
      courseCategory: 'Educational',
      courseCertificate: 'Certificate',
      courseTopCategory: 'Certificate Yoga Therapy Course - Online',
      coursePreRequisite: ''
    },
    category: 'certificate-course',
    dates: [
      // '5th Aug to 26th Sep 2024· Morning', 
      // '7th Aug to 28th Sep 2024· Evening',
      // '6th November 2024 to 28th December 2024· Evening',
      // '11th Nov 2024 to 2nd Jan 2025· Morning',
      // '3rd February to 27th March 2025· Morning',
      // '5th May to 26th June 2025· Morning',
      // '7th May to 28th June 2025· Evening',
      // '4th August to 25th September 2025· Morning',
      // '3rd November to 25th December 2025· Morning',
      // '6th Apr to 28th May 2026 Morning',
      // '6th May to 27th Jun 2026 Evening',
      // '6th Jul to 27th Aug 2026 Morning',
      // '16th Nov to 7th Jan 2027 Morning'

      // '2nd Feb to 26th March 2026 Morning',
      // '4th May to 25th June 2026 Morning',
      // '11th May to 2nd July 2026 Evening',
      '20th July to 14th Sept 2026 Morning',
      '16th Nov to 7th Jan 2027 Morning',
    ],

    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: 'Weekly 3 Days',
    courseType: 'Certificate Yoga Therapy Course - Online',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: 'Special Course - Pranayama',
    newName: 'Certificate Course on Advanced Pranayama Techniques',
    days: [
      'Wednesday',
      'Friday',
      'Saturday',
      'Mondays',
      'Tuesdays',
      'Thursdays'
    ],

    time: [
      '6:00 pm - 7:00 pm (IST)',
      '11:30 am - 12:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "24 sessions",
      timings: [
        {
          day: "Morning batch : Mondays, Tuesdays & Thursdays",
          time: "11:30 am - 12:30 pm (IST)"
        },
        // {
        //   day: "Evening batch (Only May Month) : Wednesday, Friday & Saturday",
        //   time: "6:00 pm - 7:00 pm (IST)"
        // }
      ]
    }
    ,

    courseCertificate: 'Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Now that you have mastered the basics of pranayama practices, it is time to go one step ahead! The certificate course on advanced pranayama techniques by The Yoga Institute will help you get the hang of various advanced pranayama techniques along with the right teaching methodology to teach these breathing techniques efficiently.',
            'Pranayamas are powerful yogic breathing techniques that boost your body’s bioenergy as well as strengthen both body and mind. Maharishi Patanjali mentions in his text “Yoga Darshanam” which was written around 2500 years ago that pranayamas are powerful techniques to achieve the highest degree of breathe awareness and profound meditative state. It prepares you for deep meditation.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Advanced Pranayama Online Course content',
          points: [
            {
              listItem: 'Knowledge of nadi system and energy channels',
              subItems: [],
            },
            {
              listItem: 'Bandha yoga, yoga mudras and mantras in pranayama practice',
              subItems: [],
            },
            {
              listItem: 'Teaching techniques to become a capable teacher',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            // 'You will receive a printed manual with a detailed list of subjects.',
            // 'access the detailed syllabus here',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Course Timings and fees:'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Yoga Course',
          text: [
            'The morning sessions take place on Mondays, Tuesdays, and Thursdays from 11:30am to 12:30pm.',

            // 'We also have one evening batch which is held only once a year. In 2025 the evening batch will be in the month of May' ,

            // 'Evening batch timings : Wednesdays, Fridays, and Saturdays from 6:00pm to 7:00pm',

            // '24 sessions of one hour each',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [

            'Rs. 28,000/-'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'NOTE',
          text: [
            'THE PRINTED MANUAL IS COMPULSORY FOR ALL ASPIRING YOGA STUDENTS; HOWEVER, THE KIT IS MANDATORY BUT NOT NECESSARY TO BE BOUGHT FROM THE INSTITUTE. (THE COURIER CHARGES SHALL BE INCURRED BY THE STUDENTS.)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'NOTE',
          text: [
            'All study material available for the yoga students for any course in physical (hard copy) only. The same can be collected by the student directly from the Institute or can be delivered to them by courier, charges of which will have to be borne by the student.',
          ],
        },
      },
    ],
  },
  // 2: {
  //      id: '',
  // textdescription6: '',
  // textdescription7: '',
  // textdescription8: '',
  // textdescription9: '',
  // textdescription10: '',
  textdescription1: '',
  textdescription2: '',
  textdescription3: '',
  textdescription4: '',
  textdescription5: '',
  //   title: 'Certificate Course on Yoga Sutra - Online',
  //   key: 'certification-course-on-yoga-sutra-online',
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   image: `${baseDomain}${courseAssets.courseAsset73}`,
  //   cardImage: `${baseDomain}${courseAssets.courseAsset73}`,
  //   metaDescription:
  //     'The Yoga Sutras help you unravel the mystical, the seemingly miraculous possibilities and powers that lie dormant within you',
  //   mostPopular: false,
  //   rating: 5,
  //   colorCode: '#D3A29D',
  //   timing: '1st Sunday of every month: 10:00 am - 12:30 pm (IST)',
  //   fees: {
  //     onlineFee: 15000,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'certificate-course',
  //   dates: ['10:00 am - 12:30 pm'],
  //   online: true,
  //   onCampus: false,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'What is the course about?',
  //         text: [
  //           'Patanjali’s Yoga Sutras say that by learning to develop a certain introspective awareness, with a commitment to making objective observations of oneself, we can begin a journey away from the pressures and pains of daily life. We become able to see things as they are, with a greater sense of perspective. It is not escapism, but instead a kind of ‘waking up’.',
  //           'Think of everything that you have always wanted to do. And think of what comes in the way of that. Even if it is hard to admit, the answer is – yourself. With this dynamic and powerful course on the Yoga Sutra of Patanjali, you will unlock the key to all that you want from yourself, and your life.',
  //           'The Yoga Sutras help you unravel the mystical, the seemingly miraculous possibilities and powers that lie dormant within you. Come, experience the power that is waiting within you!',
  //           'access the detailed syllabus here',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Eligibility',
  //         text: ['Open to all.  Prior knowledge of Yoga or the earlier chapters though not a prerequisite, would be helpful.'],
  //       },
  //     },
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'Details (in tabular form)',
  //     //     text: [''],
  //     //   },
  //     // },
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'Schedule',
  //     //     text: [''],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Prerequisites',
  //         text: [
  //           'Open to all. Prior knowledge of yoga not required, though helpful.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Duration',
  //         text: ['1 year – 1st & 3rd 2022, Sunday of every month'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Fees',
  //         text: [
  //           'Rs. 15000/-',
  //           'Please note fees once paid will be non-refundable.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Timings',
  //         text: ['1st Sunday of every month: 10:00 am - 12:30 pm (IST)'],
  //       },
  //     },

  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'Guidelines',
  //     //     text: [''],
  //     //   },
  //     // },
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'Contact Details',
  //     //     text: [''],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Registration',
  //         text: ['REGISTRATIONS ARE CLOSED..STAY TUNED FOR OUR NEXT BATCH.'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Conducted By',
  //         text: ['Shri Kartik Vyas'],
  //       },
  //     },
  //   ],
  // },
  3: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Certificate Program on Yoga for Cancer - Online',
    key: 'certificate-program-on-yoga-for-cancer',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    clevertapData: {
      name: 'Certificate Program on Yoga for Cancer',
      courseType: 'Certificate',
      courseSubType: 'Special Course - Cancer',
      courseCategory: 'Educational',
      courseCertificate: 'Certificate',
      courseTopCategory: 'Certificate Yoga Therapy Course - Online',
      coursePreRequisite: '200 Hour Teacher Training Course'
    },
    image: `${baseDomain}${courseAssets.courseAsset74}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/certificate-program-on-yoga-for-cancer-online_+246+X+135.jpg`,
    metaDescription:
      'Equip yourself with yogic tools to support cancer patients effectively.',
    mostPopular: true,
    rating: 5,
    colorCode: '#759F80',
    timing: 'Fridays & Saturdays: 3:00 pm - 5:00 pm (IST)',
    fees: {
      onlineFee: 28000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 28000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'certificate-course',
    dates: [
      // '2nd Aug to 7th Sep 2024',
      // '15th Nov - 21st Dec 2024',
      // '7th Feb to 15th Mar 2025',
      // '2nd May to 7th Jun 2025',
      // '1st Aug to 6th Sep 2025',
      // '7th Nov to 13th Dec 2025',
      //       '3rd April to 9th May 2026',
      // '3rd July to 8th August 2026',
      // '13th Nov to 19th Dec 2026',
      // '6th Feb to 14th March 2026',
      // '3rd July to 8th Aug 2026',
      '13th Nov to 19th Dec 2026',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: true,

    tenure: 'Weekly 2 Days',
    courseType: 'Certificate Yoga Therapy Course - Online',
    language: 'English',
    preRequisite: '200 Hour Teacher Training Course',
    courseCategory: 'Educational',
    courseSubType: 'Special Course - Cancer',
    newName: 'Certificate Program on Yoga for Cancer',
    days: [
      'Fridays',
      'Saturdays'
    ],
    time: [
      '3:00 pm - 5:00 pm (IST)'
    ],

    enrollInfo: {
      duration: "12 session",
      timings: [
        {
          day: "Fridays & Saturdays",
          time: "3:00 pm - 5:00 pm (IST)"
        }
      ]
    },

    courseCertificate: 'Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Contact Details',
          text: [
            'Yoga offers a safe, effective and low cost modality that can add considerable value to any Cancer care continuum. This yoga for cancer patients program is designed to create a cadre of Yoga Professionals who are well-trained in Cancer care that is accessible and effective. The Yoga Certificate Program is a specialized Yoga module for the special needs of Cancer patients. This oncology based program trains Yoga teachers to safely and effectively work with Cancer survivors. Learn yoga practices and yoga techniques to address Cancer specific issues such as scar tissue, bone loss, lymphedema, weight gain, fatigue, sleeplessness and stress.',
            'We offer a supportive and compassionate support group to understand and discuss Cancer confidently and intelligently.',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'From',
      //     text: ['__________ to __________'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Days',
          text: ['Fridays & Saturdays: 3:00 pm - 5:00 pm (IST)'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: [
      //       'Rs. 24,000/-'
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'Rs. 28,000/-'
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Eligibility',
      //     text: [
      //       'Completion of 500 hrs or 900 hrs TTC programme is mandatory.',
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Write to us at info@theyogainstitute.org or call us at +91-22-26122185 or +91-22-26110506',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Eligibility',
          text: ['Eligible for those who have completed minimum 200 hours TTC from any Institution.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Rules',
          text: ['Recordings are strictly prohibited.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Note',
          text: [
            'All study materials are available in physical form only.',
            'Physical copies maybe collected from the Institute.',
            'For delivery, the courier charges will have to be borne by the participant.',
          ],
        },
      },
    ],
  },
  4: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Certificate Program on Yoga for Lung Cancer - Online',
    key: 'certification-program-on-yoga-for-lung-cancer-online',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset113}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/yoga-certificate-program-for-lung-Cancer-Online_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'Master therapeutic yoga tools to aid lung cancer care & well-being.',
    rating: 5,
    colorCode: '#759F80',
    timing: 'Tuesdays to Saturday: 5:00 p.m. - 7:00 p.m. (IST)',
    fees: {
      onlineFee: 12000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 12000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    clevertapData: {
      name: 'Certificate Program on Yoga for Lung Cancer',
      courseType: 'Certificate',
      courseSubType: 'Special Course - Cancer',
      courseCategory: 'Educational',
      courseCertificate: 'Certificate',
      courseTopCategory: 'Certificate Yoga Therapy Course - Online',
      coursePreRequisite: '500 Hour Teacher Training Course, 900 Hour Teacher Training Course '
    },
    category: 'certificate-course',
    dates: [
      // '2nd July to 6th July 2024',
      // '7th Oct to 11th Oct 2025',
      // '16th Dec to 20th Dec 2025',
      '22nd Dec to 26th Dec 2026',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: 'Weekly 2 Days',
    courseType: 'Certificate Yoga Therapy Course - Online',
    language: 'English',
    preRequisite: '500 Hour Teacher Training Course, 900 Hour Teacher Training Course ',
    courseCategory: 'Educational',
    courseSubType: 'Special Course - Cancer',
    newName: 'Certificate Program on Yoga for Lung Cancer',
    days: [
      'Tuesdays',
      'Saturday'
    ],
    time: [
      '5:00 p.m. - 7:00 p.m. (IST)'
    ],
    enrollInfo: {
      duration: "5 days",
      timings: [
        {
          day: "Tuesdays to Saturday",
          time: "5:00 p.m. - 7:00 p.m. (IST)"
        }
      ]
    },

    courseCertificate: 'Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Help boost your body’s efforts in its fight against Lung Cancer with the Yoga for Lung Cancer Programme. The programme includes specific yoga asanas, pranayamas, mudras, meditation and dietary practices that will aid you in your cancer care and management. The theory part of the course will help you understand the anatomy and physiology of the yoga for lungs, causes of lung cancer, its symptoms and type, stages of lung cancer, treatments and side effects of treatments. The Yoga based practical part of the programme will be a holistic approach to Cancer management and care usingc yoga asanas, pranayamas and dietary modifications.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Time',
          text: ['Tuesdays to Saturday: 5:00 p.m. - 7:00 p.m. (IST)'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees',
      //     text: ['10,000/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['12,000/-'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Eligibility:',
          text: [
            'Completion of the Basic Programme on Yoga for Cancer Rehabilitation and Recovery.',
          ],
        },
      },
    ],
  },
  5: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Certificate Yoga Therapy Course - Online & On Campus',
    key: 'certificate-yoga-therapy-course-online',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset75}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/certificate-yoga-therapy_course-online_+246+X+135.jpg`,
    mostPopular: true,
    duration: 'Weekly 3 Days',
    metaDescription:
      'Comprehensive yoga therapy training for 110+ diseases and conditions.',
    rating: 5,
    colorCode: '#759F80',
    timing: 'Monday, Wednesday & Friday: 5:30 pm - 7:30 pm (IST)',
    fees: {
      onlineFee: 41000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 41000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    clevertapData: {
      name: 'Yoga Therapy Course',
      courseType: 'Certificate',
      courseSubType: 'Special Course - Therapy',
      courseCategory: 'Educational',
      courseCertificate: 'Certificate',
      courseTopCategory: 'Certificate Yoga Therapy Course - Online & On Campus',
      coursePreRequisite: '500 Hour Teacher Training Course, 900 Hour Teacher Training Course '
    },
    category: 'certificate-course',
    dates: [
      // '28th Aug  to 20th Dec 2024'
      // '3rd Jan to 28th Apr 2025',
      // '14th May to 3rd Sep 2025',
      // '5th Sep to 29th Dec 2025',
      // '3rd Jan to 28th Apr 2025',
      // '14th May to 3rd Sep 2025',
      // '5th Sep to 29th Dec 2025',
      // '30th Apr to 20th Aug 2025', 
      // '29th Aug to 22nd Dec 2025'
      //  '5th Jan to 29th Apr 2026',
      '4th May to 26th Aug 2026',
      '31st Aug to 23rd Dec 2026',
      // '5th Jan 2026 to 29th April 2026',
      // '4th May 2026 to 26th Aug 2026',
      // '31st Aug 2026 to 23rd Dec 2026',

    ],
    online: true,
    onCampus: true,
    nonResidential: false,
    residential: false,
    certficate: true,

    tenure: 'Weekly 3 Days',
    courseType: 'Certificate Yoga Therapy Course - Online & On Campus',
    language: 'English',
    preRequisite: '500 Hour Teacher Training Course, 900 Hour Teacher Training Course ',
    courseCategory: 'Educational',
    courseSubType: 'Special Course - Therapy',
    newName: 'Certificate Yoga Therapy',
    days: [
      'Monday',
      'Wednesday',
      'Friday'
    ],
    time: [
      '5:30 pm - 7:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "4 months",
      timings: [
        {
          day: "Monday, Wednesday & Friday",
          time: "5:30 pm - 7:30 pm (IST)"
        }
      ]
    },

    courseCertificate: 'Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: 'YOGA THERAPY COURSE',
          text: [
            'Become a Certified Yoga Therapist with The Yoga Institute',
            'The Yoga Therapy Course at The Yoga Institute is a complete, one-stop program designed to help you build strong skills in the yogic management of diseases.',
            'This is a detailed and comprehensive 100-hour Yoga Therapy Certification Course, where yogic lifestyle principles and therapeutic applications are taught in a simple, practical, and easy-to-understand manner. The course prepares you to become a confident, capable, and well-rounded Yoga Therapist, able to handle a wide range of health conditions with clarity and confidence.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Course Highlights',
          points: [
            {
              listItem: 'In-depth understanding of 110+ diseases, with practical yogic management based on:',
              subItems: [
                'Yogic diet',
                'Condition-specific daily care',
                'Relevant Yoga Asanas, Pranayamas, and Kriyas',
                'Modification and demonstration of yoga therapy techniques according to age, body type, and limitations',
                'Developing the right mental attitude to cope with health challenges'
              ],
            },
            {
              listItem:
                'Expert lectures by Ayurvedic professionals and specialist doctors to help you understand diseases clearly and design effective yoga programs for clients.',
              subItems: [

              ],
            },
            {
              listItem:
                'Detailed sessions on Anatomy, Physiology, and Pathology of each condition, including causes and symptoms, conducted by experienced yoga experts and medical practitioners from their respective specialties.',
              subItems: [],
            },
            {
              listItem:
                'Introduction to basic Ayurveda, helping you understand the body and the role of doshas in different health conditions.',
              subItems: [],
            },
            {
              listItem:
                'Hands-on learning through case studies: Students are encouraged to apply yoga therapy techniques on family and friends and prepare case studies of combined diseases, ensuring real-life practical understanding.',
              subItems: [],
            },
            {
              listItem: 'General and specialized topics covered in depth.',
              subItems: [],
            },
            {
              listItem: 'Comprehensive course material provided.',
              subItems: [],
            },
            {
              listItem:
                'Special focus areas include:',
              subItems: [
                'Male and female infertility',
                'Couples counselling',
                'Cancer care',
                'Substance abuse and addiction'
              ],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Assessment and Internship:',
          points: [
            {
              listItem: 'Final examination conducted at the end of the course',
              subItems: [

              ],
            },
            {
              listItem:
                'Internship opportunity at Samattvam, The Yoga Institute’s signature therapy program. This is a 12-week certified internship (1 hour per week) where patients seek holistic guidance for chronic health issues. This internship is available only to Yoga Therapy course graduates.',
              subItems: [

              ],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Recording Policy',
          text: [
            'The Yoga Institute reserves the right to record live interactive yoga sessions for internal use and quality purposes. These recordings are securely stored and protected against misuse or unauthorized access. Students are strictly prohibited from recording live sessions.Recorded sessions will not be shared with students.'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Curriculum Covered',
          text: [
            '• General Disorders',
            'Anaemia, Insomnia, Vertigo'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Gastrointestinal Disorders',
            'Constipation, IBS, Flatulence and Bloating, Piles and Anal Fissures, Perianal Abscess, Anal Fistula, Pilonidal Sinus, Acidity and GERD, Migraine, Fatty Liver, IBD, Ulcerative Colitis, Crohn’s Disease, Diverticulitis'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Respiratory Disorders',
            'Common Cold, Respiratory Allergies, Pharyngitis, Tonsillitis, Laryngitis, Sinusitis, Sleep Apnoea, Bronchitis, Emphysema, COPD, Asthma, Tuberculosis'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Circulatory Disorders',
            'Low and High Blood Pressure, VSD, Valvular Defects, Pacemaker Care, Atherosclerosis, Angina, Ischemic Heart Disease, Varicose Veins, Deep Vein Thrombosis, Stroke, Facial Paralysis'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Endocrine Disorders',
            'Diabetes, Hypothyroidism, Hyperthyroidism, Parathyroid Disorders'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Weight Management and Eating Disorders',
            'Obesity, Anorexia Nervosa, Binge Eating Disorder, Bulimia Nervosa, Orthorexia Nervosa'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Urinary Tract Infection',
            ''
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Female Reproductive Health',
            'Dysmenorrhea, PMS/PMT, PCOS, Fibroids, Menopause, Uterine Prolapse, Pregnancy, Infertility'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Male and Female Infertility',
            'Couples Counselling'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Orthopaedic Conditions',
            'Sprains and Strains, Fascia and Myofascial Pain, Fibromyalgia, Hernia, Cervical Spondylitis, Low Back Pain, Slipped Disc, Lumbar Canal Stenosis, Lumbar Spondylosis, Sciatica, Piriformis Syndrome, Coccydenia, Osteoporosis, Osteoarthritis, Gout, Tennis Elbow, Frozen Shoulder, Kyphosis'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Autoimmune Joint Disorders',
            'Rheumatoid Arthritis, Ankylosing Spondylitis, Lupus'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Skin Disorders',
            'Acne, Lichen Planus, Eczema, Psoriasis, Peeling Skin Syndrome, Vitiligo'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Psychological and Psychiatric Disorders',
            'Hormones and Mood, Happy and Stress Hormones, Stress Management, Depression, Anxiety Disorders, Phobias, Panic Disorders, PTSD, Prolonged Grief Disorder, Substance Abuse'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Nervous System Disorders',
            'OCD, Bipolar Disorder, Schizophrenia, Dementia, Alzheimer’s Disease, Epilepsy, Parkinson’s Disease'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Geriatric Care',
            ''
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            '• Cancer Care',
            'Oral Cancer, Cervical Cancer, Ovarian Cancer, Breast Cancer, Prostate Enlargement'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Course Conducted By',
          text: [
            'A team of experienced yoga experts, senior counsellors, and medical doctors ',
            ''
          ],
        },
      },



      {
        type: 'u-list',
        content: {
          title: 'Eligibility Criteria',
          points: [
            {
              listItem: 'Students who have completed (500 or 900 hours TTC) from The Yoga Institute',
              subItems: [],
            },
            {
              listItem: 'Medical doctors who have completed any TTC (200/500/900 hours) from The Yoga Institute',
              subItems: [],
            },
            {
              listItem: 'Students who have completed YCB Level 2 or 3',
              subItems: [],
            },
            {
              listItem: 'Students with a minimum of 500 hours TTC from other institutions may apply by submitting certificates and course curriculum to info@theyogainstitute.org for review',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Course Details',
          text: [' '],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Duration:',
          text: [' 4 months '],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date:',
      //     text: [' 24th Aug - 16th Dec 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings:',
          text: ['Monday, Wednesday, Friday – 5:30 pm to 7:30 pm (IST)'],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Fees:',
      //     text: [' Rs. 38,500/-'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [' Rs. 41,000/-'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Important Notes',
          points: [
            {
              listItem: 'All sessions will be conducted in English',
              subItems: [],
            },
            {
              listItem: 'For Hindi-speaking students, an additional doubt-clearing session will be held every Saturday from 4:00 pm to 5:00 pm at no extra cost',
              subItems: [],
            },
            {
              listItem: 'Only 30% of the sessions will be conducted on-campus (for students opting for on-campus classes)',
              subItems: [],
            },
            {
              listItem: 'Fees once paid are non-refundable',
              subItems: [],
            },
            {
              listItem: 'All study material will be provided in physical (hard copy) format only',
              subItems: [],
            },
            {
              listItem: 'Study material can be collected from the Institute or delivered by courier at the student’s expense',
              subItems: [],
            },
          ],
        },
      },
    ],
  },
  6: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Restorative Yoga for Cancer Survivors - Online Program',
    key: 'restorative-yoga-for-cancer-survivors',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'RESTORATIVE_YOGA_FOR_CANCER_PROGRAM_COFIRMATION_MAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${courseAssets.courseAsset117}`,
    cardImage: `${baseDomain}${courseAssets.courseAsset117}`,
    metaDescription:
      'Holistic yoga training to enhance healing and recovery for survivors.',
    mostPopular: false,
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Wed, Fri, Sat 11.30 a.m. to 12.30 p.m.',
    fees: {
      onlineFee: 27000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'certificate-course',
    dates: [],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: true,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'About the Program',
          text: [
            'Restorative Yoga for Cancer is a specialized healing program that helps facilitate cancer recovery, support breast, ovaries and prostate health, reduce cancer related fatigue and manage lymphedema. This program takes into consideration the psychological effects as well as all the emotional upheavals associated with cancer.',
            'This is a new system of supported, gentle “flowing” Yoga that can be easily practiced at home. Sequencing the breath and Yoga pose is vital for overall physical and emotional recovery. These specialized Yoga poses are meant to strengthen and open every part of the body. Not only will these pose stretch, lengthen muscles and breast tissue - they will also improve the circulation of lymph fluid and blood flow. The use of Yoga props is recommended and encouraged with each pose in order to receive maximum healing benefits. These poses tone the internal organs, glands and nerves. The results are measured in increased vitality, energy and hope, sense of balance and mental peace.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Program Highlights',
          points: [
            {
              listItem: 'Specific Yoga asanas addressing side effects of cancer treatments.',
              subItems: [],
            },
            {
              listItem: 'Pranayama practices to improve breathing as well as bringing mental calm and poise.',
              subItems: [],
            },
            {
              listItem: 'Meditative practices and Kriyas for cleansing.',
              subItems: [],
            },
            {
              listItem: 'You will receive specialized training from highly experienced and certified yoga teachers who possess deep knowledge and empathy towards the physical, psychological, and emotional struggles faced by cancer survivors.',
              subItems: [],
            },
          ],
        },
      }, {
        type: 'u-list',
        content: {
          title: 'Program Benefits',
          points: [
            {
              listItem: 'The gentle and therapeutic movements will aid in restoring your body’s vitality and flexibility.',
              subItems: [],
            },
            {
              listItem: 'Improvements in your physical well-being and increased energy levels.',
              subItems: [],
            },
            {
              listItem: 'Pranayama practices can enhance your respiratory function, reduce anxiety, and bring a sense of calm and serenity to your mind.',
              subItems: [],
            },
            {
              listItem: 'Finding inner peace, releasing stress, and cultivating a positive mindset, empowering you to face the future with renewed optimism and resilience.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Program Duration',
          text: ['3-Months Online Program (Total of 36 sessions)',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Program Fees',
          text: ['1st 12 sessions: ₹12,000 (Learning major techniques)',
            'Next 12 sessions: ₹6,000 (Practicing)',
            'Next 12 sessions: ₹6,000 (Practicing)',
            'Cancer Kit: ₹3,000',
            'Total: ₹27,000'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Admission Criteria',
          text: ['Open to breast, ovarian, prostate, and uterine cancer survivors who have completed surgery, chemotherapy, radiation therapy and other treatments.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Get in Touch',
          text: ['To learn more about our Program or to enroll, please contact on WhatsApp: Dharmesh Sukhadia – 9892550595, Puja Heliwal – 9911543557 or email us at info@theyogainstitute.org.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Medical Disclaimer',
          text: ['The programme will only aid in providing the best Yoga support to cancer survivors. It should not be a substitute to professional medical advice, diagnosis or treatment. A qualified healthcare professional should be consulted for medical advice and answers to personal health questions. This program is not an attempt to practice medicine. It is assumed that the participant has sought permission from their respective consulting oncologist for the practice of Yoga.'],
        },
      },
    ],
  },

  7: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '150 Hour Ayurveda Certification Program',
    key: '150-hour-ayurveda-certification-program',
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: '',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `https://ecom-oss-bucket-prod.s3.ap-south-1.amazonaws.com/PG-image/gemini_generated_image_n31kukn31kukn31k7944ab13-534c-48be-a232-6e3d332ab180.png`,
    cardImage: `https://ecom-oss-bucket-prod.s3.ap-south-1.amazonaws.com/PG-image/gemini_generated_image_n31kukn31kukn31k7944ab13-534c-48be-a232-6e3d332ab180.png`,
    metaDescription:
      'Learn the Science of Holistic Health & Conscious Living',
    mostPopular: false,
    rating: 5,
    colorCode: '#C48E8C',
    timing: '150 Hours | Online | Recorded Access | Beginner Friendly | Certificate Upon Completion',
    fees: {
      onlineFee: 20000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'certificate-course',
    dates: [
      '21st July 2026'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: true,
    language: 'English',
    newName: '150 Hour Ayurveda Certification Program',
    enrollInfo: {
      duration: "3 Months",
      timings: [
        {
          day: "Tue, Wed and Thurs",
          time: "6:30 pm to 9 pm (IST)"
        }
      ],
      message: "(Both the time slots are mandatory)",
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'About the Program',
          text: [
            'Discover the timeless wisdom of Ayurveda and learn how to create balance through food, lifestyle, herbs, daily routines, and self-awareness. This comprehensive certification program provides a strong foundation in Ayurvedic philosophy, nutrition, lifestyle medicine, diagnostics, and wellness practices for personal growth and professional development.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'WHY AYURVEDA TODAY?',
          text: ['',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Ancient Wisdom for Modern Living',
          text: ['In today’s fast-paced world, many health challenges stem from stress, poor lifestyle habits, irregular routines, and disconnection from nature. Ayurveda offers a practical and holistic approach to understanding the body, mind, and environment, helping individuals create lasting wellbeing through simple yet powerful daily practices.',
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'What You\'ll Learn',
          points: [
            {
              listItem: 'Assess Doshas, Symptoms & Basic Pulse',
              subItems: [],
            },
            {
              listItem: 'Learn Ayurvedic Diet, Herbs & Home Apothecary',
              subItems: [],
            },
            {
              listItem: 'Understand Disease Progression and causes of Diseases',
              subItems: [],
            },
            {
              listItem: 'Explore Cleansing Therapies & Panchakarma overview',
              subItems: [],
            },
            {
              listItem: 'Study Healing Principles from Classical Ayurvedic scriptures.',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PROGRAM DETAILS',
          text: ['Course at a Glance',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Program Duration',
          text: ['150 Hours',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Level',
          text: ['Beginner to Intermediate',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Program Type',
          text: ['Self-Development & Practitioner Foundation Program',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Start Date',
          text: ['21st July 2026',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Duration',
          text: ['3 months'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Days',
          text: ['Tue, Wed and Thurs'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['6:30 pm to 9 pm (IST)'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: ['Rs. 20,000/-'],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Learning Format',
          points: [
            {
              listItem: 'Online Learning',
              subItems: [],
            },
            {
              listItem: 'Recorded Session Access',
              subItems: [],
            },
            {
              listItem: 'Interactive Learning',
              subItems: [],
            },
            {
              listItem: 'Practical Assignments',
              subItems: [],
            },
            {
              listItem: 'Lifestyle Integration Exercises',
              subItems: [],
            },
            {
              listItem: 'Theory + Practical Application',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Curriculum Highlights',
          points: [
            {
              listItem: 'Foundations of Ayurveda',
              subItems: [],
            },
            {
              listItem: 'Digestion & Elimination',
              subItems: [],
            },
            {
              listItem: 'Daily & Seasonal Living',
              subItems: [],
            },
            {
              listItem: 'Ayurvedic Nutrition',
              subItems: [],
            },
            {
              listItem: 'Herbs & Home Remedies',
              subItems: [],
            },
            {
              listItem: 'Diagnostics & Assessment',
              subItems: [],
            },
            {
              listItem: 'Women’s Health & Special Topics',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Course Objective',
          text: ['To provide a strong foundation in Ayurvedic philosophy, nutrition, lifestyle medicine, herbal remedies, diagnostics, and holistic wellness while empowering participants to apply these principles for personal wellbeing, family health, and professional growth.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'KEY FEATURES',
          text: [''],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Why Choose This Program?',
          points: [
            {
              listItem: '150-Hours of Structured Learning',
              subItems: [],
            },
            {
              listItem: '7 Comprehensive Modules',
              subItems: [],
            },
            {
              listItem: 'Traditional Ayurvedic Wisdom with Modern Application',
              subItems: [],
            },
            {
              listItem: 'Nutrition, Herbs, Lifestyle & Diagnostics',
              subItems: [],
            },
            {
              listItem: 'Women’s Health & Emotional Wellbeing',
              subItems: [],
            },
            {
              listItem: 'Constitution Analysis & Assessment Skills',
              subItems: [],
            },
            {
              listItem: 'Practical Tools for Everyday Wellness',
              subItems: [],
            },
            {
              listItem: 'Personalized Health Planning',
              subItems: [],
            },
            {
              listItem: 'Root-Cause Approach to Health',
              subItems: [],
            },
            {
              listItem: 'Certificate Upon Successful Completion',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'PREREQUISITES',
          text: [
            'No Prior Experience Required',
            'This program is suitable for beginners as well as wellness professionals. All concepts are taught in a clear, practical, and accessible manner, making Ayurveda easy to understand and apply in everyday life.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'CURRICULUM',
          text: [''
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 1: Foundations of Ayurveda (15 Hours)',
          points: [
            {
              listItem: 'Introduction to Ayurveda',
              subItems: [],
            },
            {
              listItem: 'History & Origins',
              subItems: [],
            },
            {
              listItem: 'Samkhya Philosophy',
              subItems: [],
            },
            {
              listItem: 'Panchamahabhutas',
              subItems: [],
            },
            {
              listItem: 'Twenty Gunas',
              subItems: [],
            },
            {
              listItem: 'Doshas & Subdoshas',
              subItems: [],
            },
            {
              listItem: 'Prakriti (Constitution)',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 2: Digestion & Elimination (15 Hours)',
          points: [
            {
              listItem: 'Agni (Digestive Fire)',
              subItems: [],
            },
            {
              listItem: 'Ama (Toxins)',
              subItems: [],
            },
            {
              listItem: 'Malas',
              subItems: [],
            },
            {
              listItem: 'Rasa, Virya & Vipaka',
              subItems: [],
            },
            {
              listItem: 'Six Tastes',
              subItems: [],
            },
            {
              listItem: 'Food Combining Principles',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 3: Daily & Seasonal Living (10 Hours)',
          points: [
            {
              listItem: 'Dinacharya',
              subItems: [],
            },
            {
              listItem: 'Ritucharya',
              subItems: [],
            },
            {
              listItem: 'Ayurvedic Cleansing Practices',
              subItems: [],
            },
            {
              listItem: 'Khichadi Cleanse',
              subItems: [],
            },
            {
              listItem: 'Self-Care Practices',
              subItems: [],
            },
            {
              listItem: 'Herbal Teas & Ghee Preparation',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 4: Ayurvedic Diet & Nutrition (15 Hours)',
          points: [
            {
              listItem: 'Dosha-Specific Diets',
              subItems: [],
            },
            {
              listItem: 'Seasonal Nutrition',
              subItems: [],
            },
            {
              listItem: 'Food as Medicine',
              subItems: [],
            },
            {
              listItem: 'Therapeutic Nutrition',
              subItems: [],
            },
            {
              listItem: 'Meal Planning',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 5: Herbs & Home Remedies (15 Hours)',
          points: [
            {
              listItem: 'Ayurvedic Herbal Medicine',
              subItems: [],
            },
            {
              listItem: 'Common Herbs',
              subItems: [],
            },
            {
              listItem: 'Kitchen Pharmacy',
              subItems: [],
            },
            {
              listItem: 'Home Remedies',
              subItems: [],
            },
            {
              listItem: 'Home Apothecary Basics',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 6: Diagnostics & Understanding Imbalance (20 Hours)',
          points: [
            {
              listItem: 'Causes of Disease',
              subItems: [],
            },
            {
              listItem: 'Stages of Disease (Shatkriyakala)',
              subItems: [],
            },
            {
              listItem: 'Constitution Assessment',
              subItems: [],
            },
            {
              listItem: 'Symptom Analysis',
              subItems: [],
            },
            {
              listItem: 'Tongue Diagnosis',
              subItems: [],
            },
            {
              listItem: 'Introduction to Pulse Assessment',
              subItems: [],
            },
            {
              listItem: 'Mind & Emotional Health',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Module 7: Special Topics (10 Hours)',
          points: [
            {
              listItem: 'Women’s Health',
              subItems: [],
            },
            {
              listItem: 'Menstrual Wellness',
              subItems: [],
            },
            {
              listItem: 'Fertility',
              subItems: [],
            },
            {
              listItem: 'Menopause',
              subItems: [],
            },
            {
              listItem: 'Emotional Wellbeing',
              subItems: [],
            },
            {
              listItem: 'Panchakarma Overview',
              subItems: [],
            },
            {
              listItem: 'Lifestyle Alignment',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'WHAT YOU WILL LEARN & GAIN?',
          text: [''
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Classical Ayurvedic Foundations',
          text: ['Study concepts inspired by:'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Charaka Samhita',
              subItems: [],
            },
            {
              listItem: 'Sushruta Samhita',
              subItems: [],
            },
            {
              listItem: 'Ashtanga Hridayam',
              subItems: [],
            },
            {
              listItem: 'Samkhya Philosophy',
              subItems: [],
            },
            {
              listItem: 'Panchamahabhuta Theory',
              subItems: [],
            },
            {
              listItem: 'Doshas & Prakriti',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Practical Assessment Skills',
          text: ['Develop foundational skills to identify patterns of balance and imbalance through:'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Constitution (Prakriti) Assessment',
              subItems: [],
            },
            {
              listItem: 'Symptom Observation & Analysis',
              subItems: [],
            },
            {
              listItem: 'Tongue Assessment Basics',
              subItems: [],
            },
            {
              listItem: 'Introduction to Pulse Assessment',
              subItems: [],
            },
            {
              listItem: 'Understanding Disease Progression',
              subItems: [],
            },
            {
              listItem: 'Mind-Body Pattern Recognition ',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Key Learning Outcomes',
          text: ['Upon successful completion of the program, participants will:'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Build a strong foundation in Ayurvedic principles',
              subItems: [],
            },
            {
              listItem: 'Understand their unique mind-body constitution',
              subItems: [],
            },
            {
              listItem: 'Apply Ayurvedic nutrition and lifestyle practices',
              subItems: [],
            },
            {
              listItem: 'Gain practical knowledge of herbs and home remedies',
              subItems: [],
            },
            {
              listItem: 'Develop observational and assessment skills',
              subItems: [],
            },
            {
              listItem: 'Support physical, emotional, and mental wellbeing',
              subItems: [],
            },
            {
              listItem: 'Create informed wellness recommendations',
              subItems: [],
            },
            {
              listItem: 'Integrate Ayurvedic wisdom into personal and professional practice with confidence',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'WHO IS THIS COURSE DESIGNED FOR?',
          text: ['This program is ideal for:'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Wellness Coaches & Health Coaches',
              subItems: ['Enhance your practice with Ayurvedic principles of nutrition, lifestyle medicine, and holistic health.'],
            },
            {
              listItem: 'Yoga Teachers & Practitioners',
              subItems: ['Deepen your understanding of Ayurveda and Yoga to better support your students.'],
            },
            {
              listItem: 'Holistic Health Practitioners',
              subItems: ['Expand your knowledge of natural healing and preventive healthcare.'],
            },
            {
              listItem: 'Nutritionists & Health Professionals',
              subItems: ['Gain insights into constitution-based nutrition and lifestyle interventions.'],
            },
            {
              listItem: 'Therapists & Counsellors',
              subItems: ['Understand the connection between emotions, mental health, and physical wellbeing.'],
            },
            {
              listItem: 'Ayurveda Enthusiasts',
              subItems: ['Perfect for those seeking a structured introduction to Ayurveda.'],
            },
            {
              listItem: 'Personal Wellness Seekers',
              subItems: ['Learn practical tools to support your own health and wellbeing.'],
            },
            {
              listItem: 'Women Seeking Holistic Wellness',
              subItems: ['Gain insights into menstrual health, fertility, hormonal balance, and menopause.'],
            },
            {
              listItem: 'Caregivers & Parents',
              subItems: ['Support family wellness using practical Ayurvedic approaches.'],
            },
            {
              listItem: 'Anyone Interested in Preventive Health',
              subItems: ['Learn how to maintain health and prevent disease through daily and seasonal living practices.'],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'TEACHING METHODOLOGY & CERTIFICATION',
          text: [''
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Teaching Methodology',
          text: ['The program combines classical Ayurvedic teachings with practical applications for modern living through:'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Interactive Learning Sessions',
              subItems: [],
            },
            {
              listItem: 'Practical Lifestyle Applications',
              subItems: [],
            },
            {
              listItem: 'Constitution Analysis',
              subItems: [],
            },
            {
              listItem: 'Case Discussions',
              subItems: [],
            },
            {
              listItem: 'Self-Assessment Exercises',
              subItems: [],
            },
            {
              listItem: 'Wellness Planning Frameworks',
              subItems: [],
            },
            {
              listItem: 'Guided Assignments ',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Certification',
          text: ['Students who successfully complete the program will receive a: Certificate in Foundations of Ayurveda (150 Hours)'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'EXAMINATION & ELIGIBILITY',
          text: [''
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Eligibility',
          text: ['Open to all interested learners. No prior Ayurvedic knowledge is required.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Assessment',
          points: [
            {
              listItem: 'Assignments',
              subItems: [],
            },
            {
              listItem: 'Participation',
              subItems: [],
            },
            {
              listItem: 'Practical Application Exercises',
              subItems: [],
            },
            {
              listItem: 'Program Completion Requirements',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Certification Eligibility',
          text: ['Participants who successfully complete the program requirements will receive certification.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'OUR UNIQUE OFFERINGS',
          text: [''
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Traditional Wisdom, Modern Relevance',
          text: ['Learn authentic Ayurvedic principles rooted in classical texts while applying them to contemporary lifestyles.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Practical & Action-Oriented Learning',
          text: ['Move beyond theory with tools you can immediately apply to your own health, family wellness, and professional practice.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Holistic Health Perspective',
          text: ['Understand the interconnectedness of body, mind, emotions, nutrition, lifestyle, and environment.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Personalized Wellness Approach',
          text: ['Learn how to create individualized recommendations based on constitution, lifestyle, and unique health needs.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Root-Cause Understanding',
          text: ['Discover how Ayurveda identifies and addresses the underlying causes of imbalance rather than merely managing symptoms.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'WHY LEARN WITH THE YOGA INSTITUTE?',
          text: [''
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'A Legacy of Holistic Wellness Education',
          text: ['Founded in 1918, The Yoga Institute is the worlds oldest organised yoga centre dedicated to promoting holistic health and wellbeing.'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'What Sets Us Apart',
          points: [
            {
              listItem: '107+ Years of Legacy',
              subItems: [],
            },
            {
              listItem: 'Authentic Indian Wisdom Traditions',
              subItems: [],
            },
            {
              listItem: 'Holistic Mind-Body Approach',
              subItems: [],
            },
            {
              listItem: 'Experienced Faculty',
              subItems: [],
            },
            {
              listItem: 'Practical Lifestyle-Based Learning',
              subItems: [],
            },
            {
              listItem: 'Global Community of Learners',
              subItems: [],
            },
            {
              listItem: 'Trusted Educational Institution',
              subItems: [],
            }
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'MEET YOUR FACULTY',
          text: ['Learn from experienced educators and wellness experts who bring together traditional Ayurvedic knowledge, practical application, and years of teaching experience.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'FREQUENTLY ASKED QUESTIONS',
          text: [],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '1. Do I need prior Ayurvedic knowledge?',
          text: [
            'No. The program is designed for beginners as well as professionals.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '2. Will recordings be available?',
          text: [
            'Yes, recorded sessions will be available for participants.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '3. Is this course suitable for wellness professionals?',
          text: [
            'Yes. The course provides foundational knowledge that can complement existing wellness practices.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '4. Will I receive certification?',
          text: [
            'Yes. Participants who successfully complete the program requirements will receive certification.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '5. Can I apply Ayurveda in daily life after the course?',
          text: [
            'Absolutely. The program focuses on practical tools that can be integrated into everyday living.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'BEGIN YOUR AYURVEDA JOURNEY',
          text: [
            'Discover a deeper understanding of health, balance, and conscious living through the timeless wisdom of Ayurveda.',
            'Join a growing community committed to holistic wellbeing and lifelong learning.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Enroll Now',
          text: [
            ''
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'DISCLAIMER',
          text: [
            'This certification program is intended for educational and wellness purposes only. It does not qualify participants to diagnose, treat, cure, or prescribe for medical conditions. Participants are encouraged to consult qualified healthcare professionals for medical concerns.'
          ],
        },
      }
    ],
  },

  // 7: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Emo-Energy Rebalancing',
  //   key: 'emo-energy-rebalancing',
  //   isRegular: true,
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: '',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: 'GENERAL_AUTO_EMAIL',
  //     },
  //   },
  //   // image: `${baseDomain}${courseAssets.courseAssets115}`,
  //   // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
  //   image: `${Emo_energy}`,
  //   cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/Emo_energy+_+246+X+135.jpg`,
  //   mostPopular: false,
  //   language: 'English',
  //   metaDescription:
  //     'A program designed to prepare the ground for introspection',
  //   rating: 5,
  //   colorCode: '#C48E8C',
  //   timing: '9:00 am - 6:00 pm - On Campus',
  //   fees: {
  //     onlineFee: 0,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 5000 },
  //     // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
  //   },
  //   category: 'classes',
  //   clevertapData: {
  //     name: 'Emo-Energy Rebalancing Workshop - On Campus',
  //     courseType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
  //     courseSubType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
  //     courseCategory: 'Self Help',
  //     courseCertificate: 'NO',
  //     courseTopCategory: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
  //     coursePreRequisite: ''
  //   },
  //   dates: [
  //     // 'April 19th – April 20th 2025',
  //     // 'May 17th – May 18th 2025',
  //     // 'June 21th – June 22th 2025',
  //     // 'July 19th – July 20th 2025',
  //     // 'July 26th – July 27th 2025',
  //     // 'Aug 16th – Aug 17th 2025',
  //     // 'Sept 20th – Sept 21th 2025',
  //     'Oct 18th – Oct 19th 2025',
  //     'Nov 15th – Nov 16th 2025',
  //     'Dec 20th – Dec 21th 2025',

  //   ],
  //   online: false,
  //   onCampus: true,
  //   nonResidential: true,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     // {
  //     //   type: 'paragraph',
  //     //   content: {
  //     //     title: 'About The Class:',
  //     //     text: [
  //     //     ],
  //     //   },
  //     // },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Overview',
  //         text: [
  //           '● Understand and learn the fundamentals of emotional management, energy balancing and master the practical ways to achieve emotional and energy balance.',
  //           '● This 5 day Emo Energy Balancing Workshop is designed to prepare the ground for introspection. It helps you to go inwards, connect with your own self, and learn and understand the techniques used to interact with the outside world.',
  //           '● The course is well-equipped with games, guided activities, and homework for experiencing first hand the effects of these simple emotion and energy balancing techniques.',

  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Learn',
  //         text: [
  //           '● Yogic concepts like the Pancha koshas, Bhavas, Parikarmas',
  //           '● The sequential stages of stress',
  //           '● How to create internal silence',
  //           '● Identify your need for communication',
  //           '● Patterns of communication as energy exchanges',
  //           '● Yogic techniques like Nishpanda bhava and Pratipaksha bhavana',
  //           '● The 4 pillars of yogic life',
  //           '● An Introduction to chakra healing',
  //           '● Asana practice',
  //           '● Pranayama practice',
  //           '● Guided meditations',


  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'WHO IS THIS COURSE FOR ?',
  //         text: ['This program is ideal for beginners as well as those who are already on the path of yoga. All you need is a willingness to question your beliefs, openness to exploring a new perspective on stress and anxiety, and an inclination to jumpstart your journey towards a happier and healthier self.'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Pre – Requisite',
  //         text: [
  //           '● The only pre-requisite for joining this program is a high sense of Responsibility Motivation towards Self-Growth',
  //           '● IF you plan to join Chakra Healing (Level 2) then Emo-Energy Balancing workshop and Swadhyay',
  //           '(Level 1) both courses are mandatory',

  //         ],
  //       },
  //     },

  //   ],
  // },
  8: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Emo-Energy Rebalancing',
    key: 'emo-energy-rebalancing-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${Emo_energy}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/Emo_energy+_+246+X+135.jpg`,
    mostPopular: false,
    metaDescription:
      'A program designed to prepare the ground for introspection',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Morning 10:00 am – 1:00 pm, Evening 5:30 - 8:30 PM - online',
    fees: {
      onlineFee: 4500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Emo-Energy Rebalancing Workshop - Online',
      courseType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseSubType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      coursePreRequisite: ''
    },
    language: 'English',
    dates: [
      // 'April 19th – April 20th 2025',
      // 'May 5th – May 9th 2025 Morning',
      // 'June 2nd – June 6th 2025 Evening',
      // 'July 7th – July 11th 2025 Morning',
      // 'Aug 4th – Aug 8th 2025 Evening',
      // 'Sept 1st – Sept 5th 2025 Morning',
      // 'Oct 6th – Oct 10th 2025 Evening',
      'Nov 10th – Nov 14th 2025 Morning',
      'Dec 1st – Dec 5th 2025 Evening',

    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'About The Class:',
      //     text: [
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            '● Understand and learn the fundamentals of emotional management, energy balancing and master the practical ways to achieve emotional and energy balance.',
            '● This 5 day Emo Energy Balancing Workshop is designed to prepare the ground for introspection. It helps you to go inwards, connect with your own self, and learn and understand the techniques used to interact with the outside world.',
            '● The course is well-equipped with games, guided activities, and homework for experiencing first hand the effects of these simple emotion and energy balancing techniques.',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Learn',
          text: [
            '● Yogic concepts like the Pancha koshas, Bhavas, Parikarmas',
            '● The sequential stages of stress',
            '● How to create internal silence',
            '● Identify your need for communication',
            '● Patterns of communication as energy exchanges',
            '● Yogic techniques like Nishpanda bhava and Pratipaksha bhavana',
            '● The 4 pillars of yogic life',
            '● An Introduction to chakra healing',
            '● Asana practice',
            '● Pranayama practice',
            '● Guided meditations',


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'WHO IS THIS COURSE FOR ?',
          text: ['This program is ideal for beginners as well as those who are already on the path of yoga. All you need is a willingness to question your beliefs, openness to exploring a new perspective on stress and anxiety, and an inclination to jumpstart your journey towards a happier and healthier self.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Pre – Requisite',
          text: [
            '● The only pre-requisite for joining this program is a high sense of Responsibility Motivation towards Self-Growth',
            '● IF you plan to join Chakra Healing (Level 2) then Emo-Energy Balancing workshop and Swadhyay',
            '(Level 1) both courses are mandatory',

          ],
        },
      },

    ],
  },
  // 9: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Swadhyay',
  //   key: 'swadhyay',
  //   isRegular: true,
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: 'GENERAL_AUTO_EMAIL',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: 'GENERAL_AUTO_EMAIL',
  //     },
  //   },
  //   // image: `${baseDomain}${courseAssets.courseAssets115}`,
  //   // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
  //   image: `${swadhyay}`,
  //   cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/swadhyay_+246+X+135.jpg`,
  //   mostPopular: false,
  //   metaDescription:
  //     'Learn how to self-introspect to break free from your limiting beliefs which hold',
  //   rating: 5,
  //   colorCode: '#C48E8C',
  //   timing: '9:00 am - 6:00 pm - On Campus',
  //   fees: {
  //     // onlineFee: 1500,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 18000 },
  //     // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
  //   },
  //   category: 'classes',
  //   clevertapData: {
  //     name: 'Swadhyay - On Campus',
  //     courseType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
  //     courseSubType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
  //     courseCategory: 'Self Help',
  //     courseCertificate: 'NO',
  //     courseTopCategory: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
  //     coursePreRequisite: ''
  //   },
  //   language: 'English',
  //   dates: [
  //     // 'May 7th – May 11th 2025',
  //     // '9th July – 13th July 2025',
  //     // '16th July to 20th July 2025',
  //     // 'Sept 10th – Sept 14th 2025',
  //     // 'Nov 5th – Nov 9th 2025'
  //   ],
  //   online: false,
  //   onCampus: true,
  //   nonResidential: true,
  //   residential: false,
  //   certficate: false,
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Learn',
  //         text: [
  //           '●	The difference between Anxiety and Fear',
  //           '●	Yogic concepts like chitta bhoomi, avidya, and kleshas',
  //           '●	Our current belief systems and how they have been shaped',
  //           '●	Finding out what it is that is creating an imbalance within',
  //           '●	The purpose of behaviour',
  //           '●	How to create positive affirmations for our individualised needs',
  //           '●	How to set focused and meaningful goals',
  //           '●	The tools for developing self-awareness',
  //           '●	Guided meditations',
  //           '●	Asana practice',

  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Who is This Course for ?',
  //         text: ['This is a program for those who want to create a shift in their awareness and use that to find their answers. It is suitable for complete beginners as well as those already on the path of yoga. All you need is the courage to look within, an openness to question long held beliefs, and faith in your potentials.'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Pre – Requisite',
  //         text: [
  //           '●	The only pre-requisite for joining this program is a high sense of Responsibility  Motivation towards Self-Growth',
  //           '●	If you plan to join Chakra Healing (Level 2) then Emo-Energy Balancing workshop and Swadhyay both courses are mandatory',

  //         ],
  //       },
  //     },

  //   ],
  // },
  10: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Swadhyay',
    key: 'swadhyay-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${swadhyay}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/swadhyay_+246+X+135.jpg`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'Learn how to self-introspect to break free from your limiting beliefs which hold',
    rating: 5,
    colorCode: '#C48E8C',
    timing: '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    fees: {
      onlineFee: 15000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Swadhyay - Online',
      courseType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseSubType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025',
      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: 'Learn',
          text: [
            '●	The difference between Anxiety and Fear',
            '●	Yogic concepts like chitta bhoomi, avidya, and kleshas',
            '●	Our current belief systems and how they have been shaped',
            '●	Finding out what it is that is creating an imbalance within',
            '●	The purpose of behaviour',
            '●	How to create positive affirmations for our individualised needs',
            '●	How to set focused and meaningful goals',
            '●	The tools for developing self-awareness',
            '●	Guided meditations',
            '●	Asana practice',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Who is This Course for ?',
          text: ['This is a program for those who want to create a shift in their awareness and use that to find their answers. It is suitable for complete beginners as well as those already on the path of yoga. All you need is the courage to look within, an openness to question long held beliefs, and faith in your potentials.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Pre – Requisite',
          text: [
            '●	The only pre-requisite for joining this program is a high sense of Responsibility  Motivation towards Self-Growth',
            '●	If you plan to join Chakra Healing (Level 2) then Emo-Energy Balancing workshop and Swadhyay both courses are mandatory',

          ],
        },
      },

    ],
  },
  11: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Integral Chakra Psychology',
    key: 'integral-chakra-psychology',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${integral_chakra}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/integral_chakra_+246+X+135.png`,
    mostPopular: false,
    metaDescription:
      'Heal your 7 chakras by studying its behaviour patterns, know its potential',
    rating: 5,
    colorCode: '#C48E8C',
    language: 'English',
    timing: '9:00 am – 6:00 pm - Online',
    fees: {
      onlineFee: 30000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Integral Chakra Psychology',
      courseType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseSubType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      coursePreRequisite: ''
    },
    dates: [
      // 'July 21st – August 22nd 2025',
      'Nov 17th – Dec 19th 2025'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [

      {
        type: 'paragraph',
        content: {
          title: 'Overview',
          text: [
            'This 5 weeks/75 hours program is designed to help you achieve deeper balancing and healing of each Chakra to attain your goals. This program is well-equipped with a detailed study of each Chakra in context with certain Yoga concepts that will help you learn and understand better the laws of creation.'

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Learn',
          text: [
            '●	Samskaras responsible for the activation of sensitivities and expectations of each Chakra',
            '●	Behavioural expressions of each Chakra',
            '●	Relation of each Chakra with the others, leading to further behavioural patterns',
            '●	Health conditions in relation to each Chakra',
            '●	The logical concept of working on the emotions related to each Chakra',
            '●	Introducing the concept of Transcending Homeostasis',

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Who is This Course for?',
          text: ['This is a program for those who want to create a shift in their awareness and use that to find their answers. It is suitable for complete beginners as well as those already on the path of yoga. All you need is the courage to look within, an openness to question long held beliefs, and faith in your potentials.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Pre–Requisite',
          text: ['Emo-Energy Balancing Workshop and Swadhyay (Level 1) ​Minimum attendance required for certificate:- 80%. (2 full sessions / 75 hrs)'],
        },
      },
    ],
  },
  12: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: 'Friday: 5 pm to 8 pm and Saturday: 2:30 pm to 5:30 pm',
    // textdescription2: 'Evening batch (Only May Month) :  Wednesday, Friday & Saturday: 6:00 pm - 7:00 pm (IST)',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Certification in Applied Nutrition and Dietetics',
    key: 'certificate-course-in-applied-nutrition-and-dietetics',
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQs+(1).pdf",
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: 'GENERAL_AUTO_EMAIL',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    image: `${new_certificate_course}`,
    cardImage: `${new_certificate_course}`,
    metaDescription: 'Blending Scientific Nutrition and Ayurveda for Holistic Well-being.',
    mostPopular: true,
    rating: 5,
    colorCode: '#759F80',
    timing: ' ',
    fees: {
      onlineFee: 20000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    clevertapData: {
      name: 'Certification in Applied Nutrition and Dietetics ',
      courseType: 'Certificate',
      courseSubType: 'Special Course - Pranayama',
      courseCategory: 'Educational',
      courseCertificate: 'Certificate',
      courseTopCategory: 'Certificate Yoga Therapy Course - Online',
      coursePreRequisite: ''
    },
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/Batch+2+Nutrition+Course+Syllabus.pdf",
    category: 'certificate-course',
    dates: [
      // '5th Aug to 26th Sep 2024· Morning', 
      // '7th Aug to 28th Sep 2024· Evening',
      // '6th November 2024 to 28th December 2024· Evening',
      // '11th Nov 2024 to 2nd Jan 2025· Morning',
      // '3rd February to 27th March 2025· Morning',
      // '5th May to 26th June 2025· Morning',
      // '7th May to 28th June 2025· Evening',
      // '4th August to 25th September 2025· Morning',
      // '3rd Oct to 20th Dec 2025',
      // '2nd Jan to 21st Mar 2026',
      // '3rd April to 20th June 2026',
      '3rd July to 18th Sept 2026',
      '2nd Oct to 18th Dec 2026 '
    ],

    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,

    tenure: 'Weekly 3 Days',
    courseType: 'Certificate Yoga Therapy Course - Online',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: 'Special Course - Pranayama',
    newName: 'Certification in Applied Nutrition and Dietetics',
    days: [
      'Wednesday',
      'Friday',
      'Saturday',
      'Mondays',
      'Tuesdays',
      'Thursdays'
    ],

    time: [
      '6:00 pm - 7:00 pm (IST)',
      '11:30 am - 12:30 pm (IST)'
    ],
    enrollInfo: {
      duration: "3 months",
      timings: [
        {
          day: "Friday and Saturday",
          time: "5 pm to 8 pm and 2:30 pm to 5:30 pm"
        },
        // {
        //   day: "Evening batch (Only May Month) : Wednesday, Friday & Saturday",
        //   time: "6:00 pm - 7:00 pm (IST)"
        // }
      ]
    }
    ,

    courseCertificate: 'Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: false,
      nonResidentialMode: false
    },

    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'At The Yoga Institute, a 106-year-old legacy of wisdom and holistic living, every teaching has always been rooted in the timeless principles of Yoga and Ayurveda. For generations, these sciences have guided individuals toward balance, health, and harmony. In today’s fast-paced world, lifestyle diseases, fad diets, and confusing food trends have left people more uncertain than ever about what to eat. While science advances every day, many still struggle with poor gut health, low energy, and imbalanced nutrition. This makes a structured, holistic approach to food - the need of the hour.',
            'Certification in Applied Nutrition and Dietetics is designed to bring together the best of both worlds: the depth of ancient Ayurvedic knowledge and the precision of modern nutritional science. As times have evolved, nutrition and dietetics have become crucial in understanding health, and this program merges them seamlessly with sattvik food principles.',
            'The crux of this nutrition and dietetics course is to help learners build a holistic perspective, where age-old wisdom and evidence-based science work hand in hand to promote sustainable health and wellbeing. It serves as a bridge for anyone interested in food and nutrition, sattvik food practices, and practical applications of Ayurveda and modern dietetics.'
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Fees',
          text: [
            'INR 20,000/-'
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Key Features:',
          points: [
            {
              listItem: 'Experience the harmony of Ayurveda and modern nutrition and dietetics in one integrated program.',
              subItems: [],
            },
            {
              listItem: 'Learn through a flexible online course for interactive sessions.',
              subItems: [],
            },
            {
              listItem: 'Every session is designed to give you tools you can use immediately in daily life - whether at work, while traveling, or with family.',
              subItems: [],
            },
            {
              listItem: 'Understand how nutrition goes beyond calories, shaping emotions, energy, and overall wellbeing through mindful and yogic practices.',
              subItems: []
            },
            {
              listItem: 'Develop the ability to assess modern diet trends like Keto or Intermittent Fasting through both scientific evidence and Ayurvedic wisdom.',
              subItems: [],
            },
            {
              listItem: 'Gain clarity to design simple, balanced diets for yourself and your loved ones, across all life stages.',
              subItems: [],
            },
            {
              listItem: 'Move from just “eating right” to building a complete relationship with food: emotionally, mentally, and spiritually.',
              subItems: [],
            },
          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'This course is designed for:',
          points: [
            {
              listItem: 'Yoga practitioners seeking scientific nutrition grounding',
              subItems: [],
            },
            {
              listItem: 'Young professionals keen to apply holistic nutrition in daily life',
              subItems: [],
            },
            {
              listItem: 'Householders & homemakers wanting practical nutrition for themselves and loved ones',
              subItems: [],
            },
            {
              listItem: 'Anyone interested in sattvik food, food and nutrition, and holistic dietetics through an accessible online course',
              subItems: []
            },
          ],
        },
      },


      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Course Timings and fees:'],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Yoga Course',
      //     text: [
      //       'The morning sessions take place on Mondays, Tuesdays, and Thursdays from 11:30am to 12:30pm.',

      //       // 'We also have one evening batch which is held only once a year. In 2025 the evening batch will be in the month of May' ,

      //       // 'Evening batch timings : Wednesdays, Fridays, and Saturdays from 6:00pm to 7:00pm',

      //       // '24 sessions of one hour each',
      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'NOTE',
      //     text: [
      //       'THE PRINTED MANUAL IS COMPULSORY FOR ALL ASPIRING YOGA STUDENTS; HOWEVER, THE KIT IS MANDATORY BUT NOT NECESSARY TO BE BOUGHT FROM THE INSTITUTE. (THE COURIER CHARGES SHALL BE INCURRED BY THE STUDENTS.)',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'NOTE',
      //     text: [
      //       'All study material available for the yoga students for any course in physical (hard copy) only. The same can be collected by the student directly from the Institute or can be delivered to them by courier, charges of which will have to be borne by the student.',
      //     ],
      //   },
      // },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },



      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Course Structure: 200-Hour Teacher Training Program',
      //     text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.']
      //   }
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course curriculum here:',
      //     url: 'https://drive.google.com/drive/folders/1X7Ij_bUK2V2lSCCxb0eMwYscOz78SvpC',
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Course Attendance Criteria',
      //     points: [
      //       {
      //         listItem: 'Students are expected to attend all sessions during the one-month course. In case of an emergency, they may avail the attendance policy, which allows up to 3 days of leave for the entire course.',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Examination & Certification',
      //     points: [
      //       {
      //         listItem:
      //           'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Students who pass the final exam successfully, will be:',
      //         subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
      //           'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
      //           'Qualified to register with Yoga Alliance (RYT 200)'
      //         ],
      //       },
      //       {
      //         listItem:
      //           'Exam Details',
      //         subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
      //           {
      //             subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
      //             leafItems: [
      //               'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
      //               'They will have to appear for both in case of a 3rd attempt.'
      //             ]
      //           },
      //           {
      //             subItem: 'Students can register for either Online or On-Campus exams.',
      //             leafItems: [
      //               'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
      //             ]
      //           },
      //           'Examiners will evaluate students only as per the final approved list.'

      //         ],
      //       },
      //       {
      //         listItem:
      //           'Exam Schedule',
      //         subItems: ['On-Campus Final exams (both theory and practical’s) will be conducted on the last working day of each month, or as announced (in case of exigencies), between 10am (IST) and 2 pm IST.',
      //           'A Mock test will be held 7 -14 days prior to the course end date, to familiarise students with the exam process.',
      //           'The examination timings will be announced in advance by the course coordinator.'
      //         ],
      //       },
      //     ],
      //   },
      // },


    ],
    teaching: [

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Mode: Online Course',
              subItems: [],
            },
            {
              listItem: 'Days & Time: Friday: 5 pm to 8 pm IST and Saturday: 2:30 pm to 5:30 pm IST',
              subItems: [],
            },
            {
              listItem: 'Students will receive access to each lecture recording via a specialized TYI LMS link for 1 month.',
              subItems: [],
            },
            {
              listItem: 'On successful completion, participants will receive a certificate accredited by Yoga Alliance (YACEP) ',
              subItems: [],
            },
            {
              listItem: 'Teaching Methodology: Live interactive sessions, case studies, and application-based learning',
              subItems: []
            },


          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: 'Prerequisites',
          points: [
            {
              listItem: 'Interest in food, health & wellness',
              subItems: [],
            },
            {
              listItem: 'Openness to learn both modern science & Ayurveda together',
              subItems: [],
            },
            {
              listItem: 'Basic English understanding for nutrition terms, No prior knowledge of Ayurveda or nutrition required. ',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Examination & Eligibility',
          text: [
            'Examinations will be conducted in the last week of the three-month nutrition and dietetics course and will include both theory and practical assessments.',
            'To be eligible for the exams, students must:'

          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Successfully complete all course submissions and classwork.',
              subItems: [],
            },
            {
              listItem: 'Maintain a minimum of 75% attendance.',
              subItems: [],
            },
            {
              listItem: 'Complete the assigned case studies within the given timelines. ',
              subItems: [],
            },



          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Only students who fulfill these requirements will be permitted to appear for the final examinations.',

          ],
        },
      },

    ],
    offerings: [
      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem: 'Students will have the rare opportunity to interact directly with spiritual Guru Dr. Hansaji Yogendra, gaining invaluable guidance and clarity on their questions and doubts.',
      //         subItems: []
      //       },
      //       {
      //         listItem: 'Our team of over 30 expert yoga trainers for the 200-Hour Yoga Teacher Training course embody the yogic way of life and excel at sharing their knowledge in a simple, practical manner. With decades of experience, they bring immense value and deep insight to every new learner.',
      //         subItems: []
      //       },
      //       {
      //         listItem: 'Beyond the core yoga curriculum, the class environment offers rich learning through interactions with Sadhakas of all ages and backgrounds. Each individual brings unique life experiences, making the journey truly enriching.',
      //         subItems: []
      //       },
      //       {
      //         listItem: 'This one-of-a-kind experience will groom you to calmly and mindfully handle people and situations.',
      //         subItems: []
      //       }
      //     ]
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['“This is an exclusive experience, and the wisdom you gain here will guide you all your life!”'],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title:
      //       'Our Amenities / Our Facilities',
      //     points: [
      //       {
      //         listItem: 'Yoga Library: Explore one of the largest collections of spiritual and philosophical works, with 7000+ books to expand your knowledge.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Meditation Pods: Immerse yourself in meditation within pods, designed with the theme of the Pancha-Mahabhutas (five natural elements).',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Museum: The very first Yoga Museum, inaugurated by Shri Giani Zail Singh (President of India) in 1987, stands as a living tribute to the authenticity and heritage of Classical Yoga.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Acupressure Path: Give your feet a natural massage and activate your vital energies.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Gazebo: Enjoy the soothing sounds of flowing water and take in the peace and at this relaxation area.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Naivedyam (Dining Area): Enjoy wholesome Sattvik meals, specially prepared for your nourishment',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Yoga Book Store: Shop in a wide selection of TYI publications. Find yourself the best yogic attire and mats.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Nutri Diet Clinic: Our Nutri Diet Clinic offers personalized wellness support, including Body Mass Index (BMI) checkups, tailored diet plans, and yoga session recommendations curated by experts to suit your individual needs and health goals.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Physiotherapy Clinic: On-Campus physiotherapy with expert care to keep you flexible, active, and at your best.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Spacious Yoga Halls: We have very beautiful and spacious halls where all sessions are conducted, providing a comfortable and inspiring setting for deep practice.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Lush Green Campus: The institute is surrounded by abundant greenery, with several trees planted by our founder, creating a serene and spiritually uplifting environment. A dedicated terrace garden also offers a refreshing space to practice Yoga while soaking in the sunlight.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Walking Lane: A peaceful lane within the institute’s compound allows participants to take mindful walks amidst nature, offering moments of reflection and relaxation between sessions.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Residential Facilities: Clean and comfortable accommodation options are available for residential participants, making your stay restful and convenient.',
      //         subItems: [],
      //       },
      //       {
      //         listItem: 'Internet Room: Shared internet facility available for residential students.',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'By the end of the Nutrition and Dietetics Course, you’ll be able to:',

          ],
        },
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Plan balanced and practical diets for yourself, your family, and loved ones.',
              subItems: [],
            },
            {
              listItem: 'Guide others in making better food choices using both modern nutrition and Ayurveda.',
              subItems: [],
            },
            {
              listItem: 'Identify human constitution (Prakriti) and the three body types (Vāta, Pitta, Kapha) to personalize food habits. ',
              subItems: [],
            },
            {
              listItem: 'Create simple diet plans for common health issues like weight management, low energy, or gut health.',
              subItems: []
            },
            {
              listItem: 'Support nutrition across life stages from children to elderly, including pregnancy and lactation.',
              subItems: [],
            },
            {
              listItem: 'Evaluate popular diet trends (Keto, Intermittent Fasting, Detox, etc.) and suggest safe, balanced alternatives.',
              subItems: [],
            },
            {
              listItem: 'Use tools like ABCD assessment to understand dietary needs and track progress. ',
              subItems: [],
            },
            {
              listItem: 'Apply sattvik food philosophy, mindful eating, and food psychology in real-life settings (office, travel, dining out).',
              subItems: []
            },
            {
              listItem: 'Build confidence to explain nutrition concepts simply, blending scientific facts with Ayurvedic wisdom.',
              subItems: []
            },


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Disclaimer',
          text: [
            'This course is for educational purposes only. It does not certify you as a nutritionist, nor does it authorize you to provide nutrition plans to clients. The program is intended to help you understand your own food and nutrition and design simple diet plans for yourself and your family. For complex or multiple health conditions, please consult a qualified dietitian or healthcare professional.',

          ],
        },
      },
    ],
    regsitraion: [],
    faq: [],
  },
  13: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Yoga Psychotherapy course',
    key: 'certificate-program-in-yoga-therapy-course',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${swadhyay}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/swadhyay_+246+X+135.jpg`,
    mostPopular: false,
    language: 'English',
    newName: 'Yoga Psychotherapy course',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    ],

    enrollInfo: {
      duration: "3 weeks Workshop + 1-week Practicum",
      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },

    metaDescription:
      'Svādhyāya & Emo-Energy Reset (Basic Module)',
    rating: 5,
    colorCode: '#C48E8C',
    timing: '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    fees: {
      // Yoga Psychotherapy Programs page (Level 1 - Online) shows ₹41,000
      onlineFee: 41000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Certificate Program In Yoga Therapy Course',
      courseType: 'Certificate Program In Yoga Therapy Course',
      courseSubType: 'Certificate Program In Yoga Therapy Course',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Certificate Program In Yoga Therapy Course',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      'Oct 27th – Nov 7th 2025 - SWA',
      'Nov 10th – Nov 14th 2025 - EMO',
      'Dec 1st – Dec 5th 2025 - EMO',
      'Oct 18th – Oct 19th 2025 - EMO',
      'Nov 15th – Nov 16th 2025 - EMO',
      'Dec 20th – Dec 21th 2025 - EMO',
      'Nov 17th – Dec 19th 2025 - CHA'
      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Svādhyāya & Emo-Energy Reset (Basic Module), is the first step towards being in charge of our Destiny which is possible only when we are Aware and In-charge of our Thoughts, Emotions and Energies.   ',
            'This 3 + 1-week basic module is aimed at training ourselves to be aware of our thought processes, control them and there by harness our own latent potentials. If Awareness is about looking at your-self in the mirror, then this Basic Module is a training towards Decoding what the mirror is showing us and Resetting our Thoughts, Emotions & Energies to be in a position to Unlock our Highest Potentials.  '
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Contents of the Basic Module:',
          points: [
            {
              listItem:
                'Concept of Unlimited Potentials – we always keep on hearing that we have unlimited potentials within us. What do these potentials mean and how do we recognise it is the first step on this journey of manifesting these potentials?   ',
              subItems: [],
            },
            {
              listItem:
                'Owning Responsibility – the entire process of manifesting our true potentials is is about owning certain responsibilities towards ourselves. Why is this responsibility important and how is it to be fulfilled, needs to be understood right in the beginning of our journey towards self growth?  ',
              subItems: [],
            },
            {
              listItem:
                'Understanding the scope & limitations – if owning responsibility would   have been the only contributory factor then we all would have been   successful long back. Obviously, manifestation of success is not as simple as it seems. We hence also need to be aware of the obstacles that can create obstacles on the path of our journey and the means to overcome them.  ',
              subItems: [],
            },
            {
              listItem:
                ' Introduction to Koshas, Prana, Nadi (Energy Channels) and Chakra – we   not only exist at different levels, but the obstacles to our   manifestations can occur at these different levels. Similarly, the tools to overcome obstacles are also available at these same different kosha levels. An understanding of these Koshas allows us a multi-pronged approach to tap into our potentials and manifest the same.    ',
              subItems: [],
            },
            {
              listItem:
                ' Creating Stability: working on ourselves needs a stable state of mind   leading to patience that facilitates a responsive rather than a reactive behaviour towards others as also ourselves. You will be taught to create this stability through;     ',

              subItems: ['Physical Stability ', 'Energy Conservation ', 'Emotional Stability  '],
            },
            {
              listItem:
                'Turning Inwards – after working on our stability, the next step would be  to turn our attention inwards to focus on our Behaviour with regards to   its Purpose, Formation & Constituents as also;      ',
              subItems: [],
            },
            {
              listItem:
                'Understanding Anxiety & Conflicts which would help us understand the    reasons of stress in a way that simplifies the path of working on it.       ',
              subItems: [],
            },
            {
              listItem:
                'Defence Mechanisms & Blind Spots – Over 80% of our anxieties are Covert (hidden). Our Defence Mechanisms are also a part of behaviour which play the role of hiding those aspects of our mind that it finds either illogical or uncomfortable to accept. Understanding the way these defence mechanisms work is important to help us uncover our Blind Spots.          ',
              subItems: [],
            },
            {
              listItem:
                'Determining the scope of change – the scope of Empowerment depends on the extent to which we can bring about a change in our behaviour. Learning the secret to bring about maximum positive change in ourselves will be taught in this session           ',
              subItems: [],
            },
            {
              listItem:
                'Training in Introspection –What we are usually aware about is just what we are taught in the various philosophical books and religious scriptures. If at all we are aware of our thoughts, it is again usually limited to just our external states of emotions and the experience of distress. This exercise will be teaching you to deep dive into the mind and identify the thoughts that could coming in the way of your positive manifestations. This is the most important step that is often missed.            ',
              subItems: [],
            },
            {
              listItem:
                'Practicing Saṃyama – Saṃyama is about creating a state of meditative   focus, through a congruence between our conscious and sub-conscious thought processes. It is only when this state of Saṃyama is created, that the possibility of manifestation of our potentials increases manifold.             ',
              subItems: [],
            },
          ],
        },
      },


    ],
  },

  14: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Yoga Psychotherapy & Counselling',
    key: 'yoga-psychotherapy-counselling',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${swadhyay}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/swadhyay_+246+X+135.jpg`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    fees: {
      onlineFee: 45000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Yoga Psychotherapy & Counselling',
    days: [
      ''
    ],
    time: [
      '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    ],

    enrollInfo: {
      duration: "-",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Yoga Psychotherapy & Counselling',
      courseType: 'Yoga Psychotherapy & Counselling',
      courseSubType: 'Yoga Psychotherapy & Counselling',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Yoga Psychotherapy & Counselling',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      'Jan 10th – Jan 11th 2026',
      'Jan 17th – Jan 18th 2026',
      'Jan 24th – Jan 25th 2026',
      'Jan 31th – Feb 1st 2026',
      'Feb 07th – Feb 08th 2026',
      'Feb 14th – Feb 15th 2026',
      'Feb 21th – Feb 22th 2026',
      'Feb 28th – Mar 1st 2026',
      'Jun 13th – Jun 14st 2026',
      'Jun 20th – Jun 21th 2026',
      'Jun 27th – Jun 28st 2026',
      'Jul 4th – Jul 5th 2026',
      'Jul 11th – Jul 12th 2026',
      'Jul 18th – Jul 19th 2026',
      'Jul 25th – Jul 26th 2026',
      'Aug 1st – Aug 2nd 2026',

      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
            'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
            'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
            'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
            'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'THE PROGRAM:    ',
          text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '2 Contact Sessions and     ',
              subItems: [],
            },
            {
              listItem:
                '2 Non-Contact Sessions  ',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '1st Contact Training -    ',
          text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Introduction to the concept of Counselling and types of counselling       ',
              subItems: [],
            },
            {
              listItem:
                'Counselling with respect to the Koshas   ',
              subItems: [],
            },
            {
              listItem:
                'Studying the Carkhuff model of Client Oriented Therapy   ',
              subItems: [],
            },
            {
              listItem:
                'Understanding importance of Attitude training in counseling  ',
              subItems: [],
            },
            {
              listItem:
                'Practicing the skills of case taking  ',
              subItems: [],
            },
            {
              listItem:
                'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
              subItems: [],
            },
            {
              listItem:
                'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '1st Non-Contact Training –    ',
          text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Completing 1st 10 of the 20 interviews         ',
              subItems: [],
            },
            {
              listItem:
                'Initiating a social project    ',
              subItems: [],
            },
            {
              listItem:
                'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
              subItems: [],
            },


          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '2nd Contact Training –      ',
          text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Fine tuning - Goal Setting and Goal Steps          ',
              subItems: [],
            },
            {
              listItem:
                'History of Contemporary Psychology and Counseling      ',
              subItems: [],
            },
            {
              listItem:
                'Neurotic Vs Psychotic conditions and scope of counseling     ',
              subItems: [],
            },
            {
              listItem:
                'Learning Disorders – Autism, ADHD, Dyslexia            ',
              subItems: [],
            },
            {
              listItem:
                'Common Psychological Assessment tests       ',
              subItems: [],
            },
            {
              listItem:
                'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
              subItems: [],
            },
            {
              listItem:
                'Understanding the Yoga perspective       ',
              subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
            },


          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '2nd Non-Contact Training       ',
          text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Eligibility:  ',
          points: [
            {
              listItem:
                'To join the Program - Completion of Yoga Psychotherapy Program            ',
              subItems: [],
            },
            {
              listItem:
                'For receiving the Higher Diploma        ',
              subItems: [],
            },
            {
              listItem:
                'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
              subItems: ['21 day Better Living Program  ', '7-day residential program  '],
            },
            {
              listItem:
                'Assistant Yoga Psychotherapist Certificate              ',
              subItems: [],
            },
            {
              listItem:
                'Minimum 80% attendance       ',
              subItems: [],
            },
            {
              listItem:
                'Completion of all the assignments        ',
              subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
            },



          ],
        },
      },

    ],
  },
  15: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Certificate Program in Psychotherapy (Level 1) + Higher Diploma in Yoga Psychotherapy & Counselling',
    key: 'higher-diploma-yoga',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${swadhyay}`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/files/TYI+image+Folder+/swadhyay_+246+X+135.jpg`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'Svādhyāya & Emo-Energy Reset (Basic Module)',
    rating: 5,
    colorCode: '#C48E8C',
    newName: 'Certificate Program in Psychotherapy (Level 1) + Higher Diploma in Yoga Psychotherapy & Counselling',
    days: [
      ''
    ],
    time: [
      '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    ],

    enrollInfo: {
      duration: "-",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },
    timing: '10.00 am to 1.00 pm, 5.30 pm to 8.30 pm (Join any one batch time) - Online',
    fees: {
      onlineFee: 81000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Swadhyay - Online',
      courseType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseSubType: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'YOGA - CONTINUING PERSONAL DEVELOPMENT',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      'Oct 27th – Nov 7th 2025 - SWA',
      'Nov 10th – Nov 14th 2025 - EMO',
      'Dec 1st – Dec 5th 2025 - EMO',
      'Oct 18th – Oct 19th 2025 - EMO',
      'Nov 15th – Nov 16th 2025 - EMO',
      'Dec 20th – Dec 21th 2025 - EMO',
      'Nov 17th – Dec 19th 2025 - CHA',
      'Jan 10th – Jan 11th 2026',
      'Jan 17th – Jan 18th 2026',
      'Jan 24th – Jan 25th 2026',
      'Jan 31th – Feb 1st 2026',
      'Feb 07th – Feb 08th 2026',
      'Feb 14th – Feb 15th 2026',
      'Feb 21th – Feb 22th 2026',
      'Feb 28th – Mar 1st 2026',
      'Jun 13th – Jun 14st 2026',
      'Jun 20th – Jun 21th 2026',
      'Jun 27th – Jun 28st 2026',
      'Jul 4th – Jul 5th 2026',
      'Jul 11th – Jul 12th 2026',
      'Jul 18th – Jul 19th 2026',
      'Jul 25th – Jul 26th 2026',
      'Aug 1st – Aug 2nd 2026',
      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Svādhyāya & Emo-Energy Reset (Basic Module), is the first step towards being in charge of our Destiny which is possible only when we are Aware and In-charge of our Thoughts, Emotions and Energies.   ',
            'This 3 + 1-week basic module is aimed at training ourselves to be aware of our thought processes, control them and there by harness our own latent potentials. If Awareness is about looking at your-self in the mirror, then this Basic Module is a training towards Decoding what the mirror is showing us and Resetting our Thoughts, Emotions & Energies to be in a position to Unlock our Highest Potentials.  '
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Contents of the Basic Module:',
          points: [
            {
              listItem:
                'Concept of Unlimited Potentials – we always keep on hearing that we have unlimited potentials within us. What do these potentials mean and how do we recognise it is the first step on this journey of manifesting these potentials?   ',
              subItems: [],
            },
            {
              listItem:
                'Owning Responsibility – the entire process of manifesting our true potentials is is about owning certain responsibilities towards ourselves. Why is this responsibility important and how is it to be fulfilled, needs to be understood right in the beginning of our journey towards self growth?  ',
              subItems: [],
            },
            {
              listItem:
                'Understanding the scope & limitations – if owning responsibility would   have been the only contributory factor then we all would have been   successful long back. Obviously, manifestation of success is not as simple as it seems. We hence also need to be aware of the obstacles that can create obstacles on the path of our journey and the means to overcome them.  ',
              subItems: [],
            },
            {
              listItem:
                ' Introduction to Koshas, Prana, Nadi (Energy Channels) and Chakra – we   not only exist at different levels, but the obstacles to our   manifestations can occur at these different levels. Similarly, the tools to overcome obstacles are also available at these same different kosha levels. An understanding of these Koshas allows us a multi-pronged approach to tap into our potentials and manifest the same.    ',
              subItems: [],
            },
            {
              listItem:
                ' Creating Stability: working on ourselves needs a stable state of mind   leading to patience that facilitates a responsive rather than a reactive behaviour towards others as also ourselves. You will be taught to create this stability through;     ',

              subItems: ['Physical Stability ', 'Energy Conservation ', 'Emotional Stability  '],
            },
            {
              listItem:
                'Turning Inwards – after working on our stability, the next step would be  to turn our attention inwards to focus on our Behaviour with regards to   its Purpose, Formation & Constituents as also;      ',
              subItems: [],
            },
            {
              listItem:
                'Understanding Anxiety & Conflicts which would help us understand the    reasons of stress in a way that simplifies the path of working on it.       ',
              subItems: [],
            },
            {
              listItem:
                'Defence Mechanisms & Blind Spots – Over 80% of our anxieties are Covert (hidden). Our Defence Mechanisms are also a part of behaviour which play the role of hiding those aspects of our mind that it finds either illogical or uncomfortable to accept. Understanding the way these defence mechanisms work is important to help us uncover our Blind Spots.          ',
              subItems: [],
            },
            {
              listItem:
                'Determining the scope of change – the scope of Empowerment depends on the extent to which we can bring about a change in our behaviour. Learning the secret to bring about maximum positive change in ourselves will be taught in this session           ',
              subItems: [],
            },
            {
              listItem:
                'Training in Introspection –What we are usually aware about is just what we are taught in the various philosophical books and religious scriptures. If at all we are aware of our thoughts, it is again usually limited to just our external states of emotions and the experience of distress. This exercise will be teaching you to deep dive into the mind and identify the thoughts that could coming in the way of your positive manifestations. This is the most important step that is often missed.            ',
              subItems: [],
            },
            {
              listItem:
                'Practicing Saṃyama – Saṃyama is about creating a state of meditative   focus, through a congruence between our conscious and sub-conscious thought processes. It is only when this state of Saṃyama is created, that the possibility of manifestation of our potentials increases manifold.             ',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
            'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
            'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
            'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
            'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'THE PROGRAM:    ',
          text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                '2 Contact Sessions and     ',
              subItems: [],
            },
            {
              listItem:
                '2 Non-Contact Sessions  ',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '1st Contact Training -    ',
          text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Introduction to the concept of Counselling and types of counselling       ',
              subItems: [],
            },
            {
              listItem:
                'Counselling with respect to the Koshas   ',
              subItems: [],
            },
            {
              listItem:
                'Studying the Carkhuff model of Client Oriented Therapy   ',
              subItems: [],
            },
            {
              listItem:
                'Understanding importance of Attitude training in counseling  ',
              subItems: [],
            },
            {
              listItem:
                'Practicing the skills of case taking  ',
              subItems: [],
            },
            {
              listItem:
                'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
              subItems: [],
            },
            {
              listItem:
                'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
              subItems: [],
            },

          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '1st Non-Contact Training –    ',
          text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Completing 1st 10 of the 20 interviews         ',
              subItems: [],
            },
            {
              listItem:
                'Initiating a social project    ',
              subItems: [],
            },
            {
              listItem:
                'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
              subItems: [],
            },


          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '2nd Contact Training –      ',
          text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Fine tuning - Goal Setting and Goal Steps          ',
              subItems: [],
            },
            {
              listItem:
                'History of Contemporary Psychology and Counseling      ',
              subItems: [],
            },
            {
              listItem:
                'Neurotic Vs Psychotic conditions and scope of counseling     ',
              subItems: [],
            },
            {
              listItem:
                'Learning Disorders – Autism, ADHD, Dyslexia            ',
              subItems: [],
            },
            {
              listItem:
                'Common Psychological Assessment tests       ',
              subItems: [],
            },
            {
              listItem:
                'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
              subItems: [],
            },
            {
              listItem:
                'Understanding the Yoga perspective       ',
              subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
            },


          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: '2nd Non-Contact Training       ',
          text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Eligibility:  ',
          points: [
            {
              listItem:
                'To join the Program - Completion of Yoga Psychotherapy Program            ',
              subItems: [],
            },
            {
              listItem:
                'For receiving the Higher Diploma        ',
              subItems: [],
            },
            {
              listItem:
                'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
              subItems: ['21 day Better Living Program  ', '7-day residential program  '],
            },
            {
              listItem:
                'Assistant Yoga Psychotherapist Certificate              ',
              subItems: [],
            },
            {
              listItem:
                'Minimum 80% attendance       ',
              subItems: [],
            },
            {
              listItem:
                'Completion of all the assignments        ',
              subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
            },



          ],
        },
      },


    ],
  },
  16: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Forest Yoga Retreat',
    key: 'forest-yoga-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'FOREST_YOGA_RETREAT_ONE',
      templateOffline: {
        templateResidential: 'FOREST_YOGA_RETREAT_ONE',
        templateNonResidential: 'FOREST_YOGA_RETREAT_ONE',
      },
    },
    image: "/images/ForestYoga.jpg",
    cardImage: "/images/ForestYoga.jpg",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Aibaug - Forest Yoga',
      courseType: 'Yoga Retreats',
      courseSubType: 'Yoga Retreats',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Yoga Retreats',
      coursePreRequisite: ''
    },
    dates: [
      // '1st Feb 2025 to 2nd Feb 2025', 
      // '22nd Feb 2025 to 23rd Feb 2025', 
      // '8th Mar 2025 to 9th Mar 2025',
      // '22nd Mar 2025 to 23rd Mar 2025',
      // '5th April 2025 to 6th April 2025',
      // '19th April 2025 to 20th April 2025',
      // '3rd May 2025 to 4th May 2025',
      // '10th May 2025 to 11th May 2025',
      // '24th May 2025 to 25th May 2025',
      // '31st May 2025 to 1st June 2025',
      // '7th June 2025 to 8th June 2025',
      // '14th June 2025 to 15th June 2025',
      // '28th June 2025 to 29th June 2025',
      // '5th July 2025 to 6th July 2025',
      // '12th July 2025 to 13th July 2025',
      // '26th July 2025 to 27th July 2025',
      // '2nd Aug 2025 to 3rd Aug 2025',
      // '23rd Aug 2025 to 24th Aug 2025',
      // '30th Aug 2025 to 31th Aug 2025',
      // '6th Sept 2025 to 7th Sept 2025',
      // '13th Sept 2025 to 14th Sept 2025',
      // '27th Sept 2025 to 28th Sept 2025',
      // '4th Oct 2025 to 5th Oct 2025',
      // '11th Oct 2025 to 12th Oct 2025',
      // '25th Oct 2025 to 26th Oct 2025',
      // '1st Nov 2025 to 2nd Nov 2025',
      // '8th Nov 2025 to 9th Nov 2025',
      // '22th Nov 2025 to 23th Nov 2025',
      // '29th Nov 2025 to 30th Nov 2025',
      // '6th Dec 2025 to 7th Dec 2025',
      // '20th Dec 2025 to 21th Dec 2025 ',
      // '3rd Jan 2026 to 4th Jan 2026',
      // '10th Jan 2026 to 11th Jan 2026',
      // '24th Jan 2026 to 25th Jan 2026',
      // '30th Jan 2026 to 31st Jan 2026',
      //                 '7th Feb 2026 to 8th Feb 2026',
      //                 '14th Feb 2026 to 15th Feb 2026',
      // '28th Feb 2026 to 1st Mar 2026',
      // '7th Mar 2026 to 8th Mar 2026',
      // '14th Mar 2026 to 15th Mar 2026',

      // '28th Mar 2026 to 29th Mar 2026',

      // '4th Apr 2026 to 5th Apr 2026','11th Apr 2026 to 12th Apr 2026',

      // '25th Apr 2026 to 26th Apr 2026',

      // '2nd May 2026 to 3rd May 2026','9th May 2026 to 10th May 2026',
      '23rd May 2026 to 24th May 2026',
      '30th May 2026 to 31st May 2026',

      '6th Jun 2026 to 7th Jun 2026', '13th Jun 2026 to 14th Jun 2026',

      '27th Jun 2026 to 28th Jun 2026',

      '4th Jul 2026 to 5th Jul 2026', '11th Jul 2026 to 12th Jul 2026',

      '25th Jul 2026 to 26th Jul 2026',
      ' 1st Aug and 2nd Aug 2026',

      ' 8th Aug and 9th Aug 2026',

      ' 22nd Aug and 23rd Aug 2026',

      ' 29th Aug and 30th Aug 2026',

      ' 5th Sept and 6th Sept 2026',

      ' 12th Sept and 13th Sept 2026',

      ' 26th Sept and 27th Sept 2026',

      ' 3rd Oct and 4th Oct 2026',

      ' 10th Oct and 11th Oct 2026',

      ' 24th Oct and 25th Oct 2026',

      ' 31st Oct and 1st Nov 2026',

      ' 7th Nov and 8th Nov 2026',

      ' 14th Nov and 15th Nov 2026',

      ' 28th Nov and 29th Nov 2026',

      ' 5th Dec and 6th Dec 2026',

      ' 12th Dec and 13th Dec 2026',

      ' 26th Dec and 27th Dec 2026',
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (1st day) to 7:00 PM (2nd day)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  17: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Healthy Weight Loss & Wellness Retreat',
    key: 'healthy-weightloss-wellness-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'healthy-weightloss-wellness-retreat',
      templateOffline: {
        templateResidential: 'healthy-weightloss-wellness-retreat',
        templateNonResidential: 'healthy-weightloss-wellness-retreat',
      },
    },
    image: "/images/healthyWeighloss.jpg",
    cardImage: "/images/healthyWeighloss.jpg",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Aibaug - Heathy Weight Loss',
      courseType: 'Yoga Retreats',
      courseSubType: 'Yoga Retreats',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Yoga Retreats',
      coursePreRequisite: ''
    },
    dates: [
      // '25th Jan 2025 to 26th Jan 2025', 
      // '8th Feb 2025 to 9th Feb 2025', 
      // '15th Mar 2025 to 16th Mar 2025',
      // '29th Mar 2025 to 30th Mar 2025',
      // '12th Apr 2025 to 13th Apr 2025',
      // '26th Apr 2025 to 27th Apr 2025',
      // '17th May 2025 to 18th May 2025',
      // '21th June 2025 to 22th June 2025',
      // '19th July 2025 to 20th July 2025',
      // '16th Aug 2025 to 17th Aug 2025',
      // '20th Sept 2025 to 21th Sept 2025',
      // '18th Oct 2025 to 19th Oct 2025',
      // '15th Nov 2025 to 16th Nov 2025',
      // '13th Dec 2025 to 14th Dec 2025',
      // '27th Dec 2025 to 28th Dec 2025',
      // '17th Jan 2026 to 18th Jan 2026',
      // '21st Feb 2026 to 22nd Feb 2026',
      // '21st Mar 2026 to 22nd Mar 2026',
      // '18th Apr 2026 to 19th Apr 2026',
      '16th May 2026 to 17th May 2026',
      '20th Jun 2026 to 21st Jun 2026',
      '18th Jul 2026 to 19th Jul 2026',
      '15th Aug and 16th Aug 2026',

      '19th Sept and 20th Sept 2026',

      '17th Oct and 18th Oct 2026',

      '21st Nov and 22nd Nov 2026',

      '19th Dec and 20th Dec 2026',
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (1st day) to 7:00 PM (2nd day)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  18: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    key: 'certificate-in-biomechanics-of-yoga-asanas',
    // templateId: 'COURSE200_1M_TTC',
    templateId: {
      templateOnline: 'COURSE200_1M_ONLINE_TTC',
      templateOffline: {
        templateResidential: 'COURSE200_RES_TTC',
        templateNonResidential: 'COURSE200_NONRES_TTC',
      },
    },
    weekDays: true,
    curriculumUrl: "https://nispand.s3.ap-south-1.amazonaws.com/SYLLABUS.pdf",
    faqurl: "https://nispand.s3.ap-south-1.amazonaws.com/FAQs+BOA.pdf",
    batch: 1,
    metaDescription:
      'Dive into the depths of understanding Functional anatomy and Biomechanics of Yoga Asanas, one step at a time.',
    image: `https://nispand.s3.ap-south-1.amazonaws.com/Untitled+design+(12).png`,
    cardImage: `https://nispand.s3.ap-south-1.amazonaws.com/Untitled+design+(12).png`,
    mostPopular: true,
    rating: 5,
    colorCode: '#E38F73',

    timing: 'Saturday 5:30 PM to 08:30 PM, Sunday 1 PM to 4 PM',
    fees: {
      onlineFee: 25000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 25000 },
    },
    newFees: {
      onlineFee: 25000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 25000 },
    },
    clevertapData: {
      name: 'Certification in Biomechanics of Yoga Asanas',
      courseType: 'TTC',
      courseSubType: 'Certification in Biomechanics of Yoga Asanas',
      courseCategory: 'Educational',
      courseCertificate: 'TTC/Certificate',
      courseTopCategory: '(RYT 200- Basic)',
      coursePreRequisite: ''
    },
    category: 'ttc',
    title: 'Certification in Biomechanics of Yoga Asanas',
    dates: [

      // '1st Jan to 31st Jan 2024',
      // '1st Feb to 29th Feb 2024',
      // '1st Mar to 31st Mar 2024',
      // '1st Apr to 30th Apr 2024',
      // '1st May to 31st May 2024',
      // '1st Jun to 30th Jun 2024 ',
      // '1st Jul to 31st Jul 2024 ',
      // '1st Aug to 31st Aug 2024',
      // '1st Sep to 30th Sep 2024 ',
      // '1st Oct to 31st Oct 2024',
      // '2nd Nov to 30th Nov 2024',
      // '2nd Dec to 31st Dec 2024',
      // '1st Jan to 31st Jan 2025',
      // '1st Feb to 28th Feb 2025',
      // '1st Mar to 31st Mar 2025',
      // '1st Apr to 30th Apr 2025',
      // '1st May to 31st May 2025',
      // '2nd Jun to 30th Jun 2025',
      // '1st Jul to 31st Jul 2025',
      // '1st Aug to 30th Aug 2025',
      // '1st Sep to 30th Sep 2025',
      // '1st Oct to 31st Oct 2025',
      // '1st Nov to 29th Nov 2025',
      // '1st Dec to 31st Dec 2025',
      // '1st Jan to 31st Jan 2026',
      // '2nd February to 28th February 2026',
      // '2nd March to 31st March 2026',
      // '1st April to 30th April 2026',
      // '1st May to 31st May 2026',
      // '1st June to 30th June 2026',
      // '1st July to 31st July 2026',
      // '1st August to 30th August 2026',
      // '1st September to 30th September 2026',
      // '1st October to 31st October 2026',
      // '2nd November to 29th November 2026',
      // '1st December to 31st December 2026'
      // '11th Apr 2026 to 19th Jul 2026'
      // '1st August to 8th Nov, 2026'
      '1st Aug to 8th Nov 2026'

    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,

    tenure: '1 month',
    courseType: '(RYT 200- Basic)',
    language: 'English',
    preRequisite: 'None',
    courseCategory: 'Educational',
    courseSubType: '200 Hour Yoga Teacher Training',
    newName: 'Certification in Biomechanics of Yoga Asanas',
    days: [
      'Saturday & Sunday'
    ],
    time: [
      'Saturday 5:30 PM to 08:30 PM, Sunday 1 PM to 4 PM'
    ],

    enrollInfo: {
      duration: "3 months",
      timings: [
        {
          day: "Saturday & Sunday",
          time: "Saturday 5:30 PM to 08:30 PM, Sunday 1 PM to 4 PM"
        }
      ]
    },

    courseCertificate: 'TTC/Certificate',
    onlineInfo: {
      courseMode: true,
    },
    residentialInfo: {
      courseMode: false,
      residentialMode: false
    },
    nonResidentialInfo: {
      courseMode: true,
      nonResidentialMode: true
    },

    certficate: false,
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'At The Yoga Institute, with its 107-year legacy of authentic yogic wisdom and holistic living, learning has always been guided by a harmonious blend of tradition, experience and evolving understanding.',
            'Yoga, when practiced with awareness and understanding, becomes a powerful tool for building strength, stability, and harmony within the body and mind. In today’s world, where movement patterns are often compromised by sedentary habits and repetitive strains, there is a growing need to practice and teach yoga with clarity, precision, and confidence.',
            'The Certification in Biomechanics of Yoga Asanas offers a fresh, insightful approach to understanding how the body moves and responds during yoga practice, right from understanding the dynamics of movement to the muscles involved in creating them, this course covers it all. By exploring the science of movement alongside classical yogic principles, this course helps learners appreciate the role of alignment, muscle engagement, joint stability, and breath coordination in creating safe and effective asana practice',
            'This program thoughtfully integrates modern biomechanics and functional anatomy with traditional yoga practices, allowing learners to understand why asanas work, how they support the body, what are the trick movements that need to be avoided and how they can be adapted to individual needs. Through this knowledge, practitioners gain the ability to refine posture, enhance balance, and move with greater ease and efficiency.',
            'The essence of this course lies in empowering learners to practice and teach asanas with greater awareness, sensitivity, and sustainability. It supports long-term physical wellbeing by promoting injury prevention, functional strength, and conscious movement. Ideal for yoga practitioners, teachers, and movement enthusiasts, this certification serves as a bridge between yogic wisdom and contemporary movement science, enabling yoga asanas to be experienced as a truly therapeutic, and transformative practice'
          ],
        },
      },

      {
        type: 'paragraph',
        content: {
          title: 'Course',
          text: [
            'Certification in Biomechanics of Yoga Asanas',
          ],
        },
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Duration',
      //     text: [o
      //       '1 Month | Course commences on Commences on the 1st day of each month',
      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Date',
      //     text: ['1st Aug 2022 to 31st Aug 2022'],
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'Timings',
          text: ['Saturday 5:30 PM to 08:30 PM ',
            'Sunday 1 PM to 4 PM'
          ],
        },
      },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Fees Structure',
      //      points: [
      //       {
      //         listItem:
      //           'Online: Rs. 27,500.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'On Campus (non-Residential): Rs. 33,000/- (Inclusive of course fee, study material, lunch, and snacks).',
      //         subItems: [],
      //       },
      //        {
      //         listItem:
      //           'On Campus (residential): Rs. 60,000/- (Inclusive of course fee, study material, accommodation on triple occupancy basis and 4 meals a day).',
      //         subItems: [],
      //       },
      //     ],
      //   },
      // },
      {
        type: 'u-list',
        content: {
          title: 'Fees Structure',
          points: [
            {
              listItem:
                'Online: Rs. 25,000',
              subItems: [],
            },
            {
              listItem:
                'On Campus (non-Residential): Rs. 25,000/-',
              subItems: [],
            },

          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisite',
          text: ['Completed 200 hrs Yoga Teachers Training Course'
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Key Features',
          points: [
            {
              listItem:
                'Experience a meaningful integration of Yoga Asana practice with biomechanics and functional anatomy in one cohesive program',
              subItems: [],
            },
            {
              listItem:
                'Learn through a flexible on campus program designed to support interactive learning and practical understanding',
              subItems: [],
            },
            {
              listItem:
                ' Each session is structured to provide tools that can be applied immediately in personal practice and teaching- whether in classes, workshops or one-on-one sessions',
              subItems: [],
            },
            {
              listItem:
                ' Enhance your understanding about how forces, alignment, muscle engagement, joint mechanics, and breath co-ordination influence safety and effectiveness of Asana practice',
              subItems: [],
            },
            {
              listItem:
                ' Develop the ability to observe, assess and refine asanas by understanding movement patterns, stability, mobility, muscle work and load distribution',
              subItems: [],
            },
            {
              listItem:
                ' Gain clarity to modify and adapt asanas for different body types, age groups and physical conditions with confidence and sensitivity',
              subItems: [],
            },
            {
              listItem:
                ' Move beyond performing postures to cultivating mindful, efficient and sustainable movement- physically, mentally, energetically',
              subItems: [],
            },
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'This Course is Designed for',
          points: [
            {
              listItem:
                'Yoga practitioners seeking a deeper, science-backed understanding of asanas.',
              subItems: [],
            },
            {
              listItem:
                'Yoga teachers  and trainees who wish to enhance alignment cues, adjustments, and injury-prevention strategies in their teaching.',
              subItems: [],
            },
            {
              listItem:
                '  Movement professionals interested in integrating biomechanics with mindful movement practices.',
              subItems: [],
            },
            {
              listItem:
                ' Health and wellness enthusiasts looking to build a safer, more informed and long-term yoga practice.',
              subItems: [],
            },
            {
              listItem:
                '   Physiotherapists and fitness professionals interested in increasing their understanding of Yoga Asanas',
              subItems: [],
            },
            {
              listItem:
                ' Anyone interested in understanding how and why the body moves the way it does in yoga, through an accessible on site course.',
              subItems: [],
            },

          ],
        },
      },
    ],
    curriculum: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '200 Hour Yoga Teacher Training Curriculum',
      //     text: [],
      //   },
      // },
      // {
      //   type: 'url',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course Curriculum here:',
      //     url: 'https://nispand.s3.ap-south-1.amazonaws.com/Syllabus+BTTC.pdf',
      //   },
      // },
      {
        type: 'paragraph',
        content: {
          title: 'link',
          text: ['']
        }
      },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'Course Structure: 200-Hour Teacher Training Program',
      //     text: ['This 200-hour Teacher Training Program includes approximately 160 hours of in-depth classroom instruction, with the remaining hours focused on experiential learning through activities, self-practice, and reflective exercises, all designed to deepen your understanding and enhance your teaching skills.']
      //   }
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     text: 'Access the detailed One Month Yoga Teacher Training Course curriculum here:',
      //     url: 'https://drive.google.com/drive/folders/1X7Ij_bUK2V2lSCCxb0eMwYscOz78SvpC',
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Course Attendance Criteria',
      //     points: [
      //       {
      //         listItem: 'Students are expected to attend all sessions during the one-month course. In case of an emergency, they may avail the attendance policy, which allows up to 3 days of leave for the entire course.',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },
      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Examination & Certification',
      //     points: [
      //       {
      //         listItem:
      //           'Upon successful completion of the attendance criteria and submission of the required assignments and presentations, the student will be eligible to appear for the examination.',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Students who pass the final exam successfully, will be:',
      //         subItems: ['Awarded a certificate – Basic Yoga Teacher Training Certificate (200 hours) by The Yoga Institute.',
      //           'Conforming to the Yoga Certification Board (YCB) Certification - Level 1.',
      //           'Qualified to register with Yoga Alliance (RYT 200)'
      //         ],
      //       },
      //       {
      //         listItem:
      //           'Exam Details',
      //         subItems: ['Students will have to appear for the final exams within 60 days from the course end date.',
      //           {
      //             subItem: 'Students will be permitted a maximum of 3 attempts, to clear the final exams, failing which they will have to repeat the course.',
      //             leafItems: [
      //               'In the 2nd attempt, they will be exempted from either theory or practicals, if they have cleared it in their 1st attempt.',
      //               'They will have to appear for both in case of a 3rd attempt.'
      //             ]
      //           },
      //           {
      //             subItem: 'Students can register for either Online or On-Campus exams.',
      //             leafItems: [
      //               'Once finalized, students will not be permitted to switch from online to on campus and vice versa.',
      //             ]
      //           },
      //           'Examiners will evaluate students only as per the final approved list.'

      //         ],
      //       },
      //       {
      //         listItem:
      //           'Exam Schedule',
      //         subItems: ['On-Campus Final exams (both theory and practical’s) will be conducted on the last working day of each month, or as announced (in case of exigencies), between 10am (IST) and 2 pm IST.',
      //           'A Mock test will be held 7 -14 days prior to the course end date, to familiarise students with the exam process.',
      //           'The examination timings will be announced in advance by the course coordinator.'
      //         ],
      //       },
      //     ],
      //   },
      // },


    ],
    teaching: [

      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem:
                'Mode: Offline Course',
              subItems: [],
            },
            {
              listItem:
                'Days & Time: Saturday 5:30 PM to 08:30 PM, Sunday 1 PM to 4 PM',

            },
            {
              listItem:
                ' On successful completion, participants will receive a certificate in Biomechanics of Yoga Asanas from The Yoga Institute',

            },
            {
              listItem:
                'Teaching Methodology: Live interactive sessions, guided practical demonstrations, movement analysis, case based discussions and application-oriented learning',

            },
            {
              listItem:
                'The course emphasizes experiential understanding encouraging learners to observe, feel and analyse movement rather than memorizing alignment cues',

            },
          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Prerequisites',
          points: [
            {
              listItem:
                'A genuine interest in yoga practice, movement, health and body awareness',
              subItems: [],
            },
            {
              listItem:
                'Openness to learning and integrating both Yoga asanas and movement science',

            },
            {
              listItem:
                'Basic English Comprehension to understand anatomical, biomechanical and instructional terminology',

            },
            {
              listItem:
                'No prior background in anatomy or biomechanics required',

            },

          ],
        },
      },

      {
        type: 'u-list',
        content: {
          title: 'Examination & Eligibility',
          points: [
            {
              listItem:
                'Assessments will be conducted during the final phase of the course and will include both theoretical understanding and practical application of biomechanics in asana practice.',
              subItems: [],
            },
            {
              listItem:
                'To be eligible for the final assessment, participants must:',

              subItems: [
                'Successfully complete all course submissions and assigned practical work.',
                'Maintain a minimum of 75% attendance in live sessions.',
                'Complete the assigned case studies and movement analysis tasks within the stipulated timelines.',
                'Only participants who meet these requirements will be permitted to appear for the final assessment and receive certification.'
              ]

            },


          ],
        },
      },

    ],
    offerings: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: ['By the end of the Biomechanics of Yoga Asanas course, you will be able to:']
        }
      },
      {
        type: 'u-list',
        content: {
          title: '',
          points: [
            {
              listItem: 'Plan and practice asanas with greater awareness, safety, and efficiency for yourself and others.',
              subItems: []
            },
            {
              listItem: 'Guide practitioners in refining posture and movement using principles of biomechanics and functional anatomy.',
              subItems: []
            },
            {
              listItem: 'Understand joint mechanics, muscle engagement, stability, mobility, and force distribution in commonly practiced asanas.',
              subItems: []
            },
            {
              listItem: ' Identify individual movement patterns and adapt asanas to suit different body types, age groups, and physical abilities.',
              subItems: []
            },
            {
              listItem: ' Create safe and mindful modifications for common challenges such as joint discomfort, stiffness, limited mobility, or instability.',
              subItems: []
            },
            {
              listItem: ' Apply biomechanical principles to prevent strain and support long-term musculoskeletal health in yoga practice.',
              subItems: []
            },
            {
              listItem: ' Observe and analyze movement in real-life settings—group classes, one-on-one sessions, and self-practice.',
              subItems: []
            },
            {
              listItem: ' Build confidence to explain asanas clearly and simply, blending traditional yogic understanding with modern movement science.',
              subItems: []
            }
          ]
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Disclaimer',
          text: ['This course is intended for educational purposes only. It does not qualify participants as medical professionals, physiotherapists, or rehabilitation specialists, nor does it authorize diagnosis or treatment of medical conditions.The program is designed to help learners deepen their understanding of movement, alignment, and safety in yoga practice and teaching. For individuals with injuries, chronic pain, or complex medical conditions, guidance from a qualified healthcare professional is recommended.'],
        },
      },


    ],
    regsitraion: [],
    faq: [],
    moreInfo: {
      duration: "01 Month",
      mode: "Online & On Campus",
      language: "English",
      timing: "10:00 am - 6:00 pm (IST)",
      days: "Monday - Saturday",
      navigate: "/one-month-ttc",
    },
  },

}
const alibaug = {
  // 1: {
  //   id: '',
  //   textdescription6: '',
  //   textdescription7: '',
  //   textdescription8: '',
  //   textdescription9: '',
  //   textdescription10: '',
  //   textdescription1: '',
  //   textdescription2: '',
  //   textdescription3: '',
  //   textdescription4: '',
  //   textdescription5: '',
  //   title: 'Detox and Cleanse Yoga Retreat',
  //   key: 'detox-cleanse-yoga-retreat',
  //   isRegular: true,
  //   tenure: '2 day',
  //   weekends: false,
  //   batch: 1,
  //   // templateId: 'GENERAL_AUTO_EMAIL',
  //   templateId: {
  //     templateOnline: '',
  //     templateOffline: {
  //       templateResidential: '',
  //       templateNonResidential: '',
  //     },
  //   },
  //   image: `/images/DetoxCleanse.jpg`,
  //   cardImage: `/images/DetoxCleanse.jpg`,
  //   mostPopular: false,
  //   metaDescription:
  //     'Towards the end, there is an enlightening question and answer session. ',
  //   rating: 5,
  //   colorCode: '#B77E7E',
  //   timing: '1 Night, 2 Days',
  //   fees: {
  //     onlineFee: 10000,
  //     offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
  //   },
  //   category: 'classes',
  //   dates: ['4th Jan 2025 to 5th Jan 2025'
  //   ],
  //   online: false,
  //   onCampus: false,
  //   nonResidential: false,
  //   residential: false,
  //   certficate: false,
  //   newName: '',
  //   enrollInfo: {
  //     duration: "1 Night, 2 Days",
  //     timings: [
  //       {
  //         day: "",
  //         time: "8:00 AM (4th) to 7:00 PM (5th)"
  //       }
  //     ]
  //   },
  //   details: [
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: '',
  //         text: [
  //           'Towards the end, there is an enlightening question and answer session.',
  //         ],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'About the programme',
  //         text: [' Every Sunday between 9.30 am and 10.30am'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Prerequisites',
  //         text: ['The programme is open to all. No age bar.'],
  //       },
  //     },
  //     {
  //       type: 'paragraph',
  //       content: {
  //         title: 'Registration',
  //         text: [' free entry - on the spot registration.'],
  //       },
  //     },
  //   ],
  // },
  2: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Deep Dive Yoga and Meditation Retreat',
    key: 'deep-dive-yoga-meditation-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: '',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `/images/DeepOneYoga.jpg`,
    cardImage: `/images/DeepOneYoga.jpg`,
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: ['1st Mar 2025 to 2nd Mar 2025'
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (1st day) to 7:00 PM (2nd day)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  3: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Forest Yoga Retreat',
    key: 'forest-yoga-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'FOREST_YOGA_RETREAT_ONE',
      templateOffline: {
        templateResidential: 'FOREST_YOGA_RETREAT_ONE',
        templateNonResidential: 'FOREST_YOGA_RETREAT_ONE',
      },
    },
    image: "/images/ForestYoga.jpg",
    cardImage: "/images/ForestYoga.jpg",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    newFees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Aibaug - Forest Yoga',
      courseType: 'Yoga Retreats',
      courseSubType: 'Yoga Retreats',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Yoga Retreats',
      coursePreRequisite: ''
    },
    dates: [
      // '1st Feb 2025 to 2nd Feb 2025', 
      // '22nd Feb 2025 to 23rd Feb 2025', 
      // '8th Mar 2025 to 9th Mar 2025',
      // '22nd Mar 2025 to 23rd Mar 2025',
      // '5th April 2025 to 6th April 2025',
      // '19th April 2025 to 20th April 2025',
      // '3rd May 2025 to 4th May 2025',
      // '10th May 2025 to 11th May 2025',
      // '24th May 2025 to 25th May 2025',
      // '31st May 2025 to 1st June 2025',
      // '7th June 2025 to 8th June 2025',
      // '14th June 2025 to 15th June 2025',
      // '28th June 2025 to 29th June 2025',
      // '5th July 2025 to 6th July 2025',
      // '12th July 2025 to 13th July 2025',
      // '26th July 2025 to 27th July 2025',
      // '2nd Aug 2025 to 3rd Aug 2025',
      // '23rd Aug 2025 to 24th Aug 2025',
      // '30th Aug 2025 to 31th Aug 2025',
      // '6th Sept 2025 to 7th Sept 2025',
      // '13th Sept 2025 to 14th Sept 2025',
      // '27th Sept 2025 to 28th Sept 2025',
      // '4th Oct 2025 to 5th Oct 2025',
      // '11th Oct 2025 to 12th Oct 2025',
      // '25th Oct 2025 to 26th Oct 2025',
      // '1st Nov 2025 to 2nd Nov 2025',
      // '8th Nov 2025 to 9th Nov 2025',
      '22th Nov 2025 to 23th Nov 2025',
      '29th Nov 2025 to 30th Nov 2025',
      '6th Dec 2025 to 7th Dec 2025',
      '20th Dec 2025 to 21th Dec 2025 ',
      '3rd Jan 2026 to 4th Jan 2026',
      '10th Jan 2026 to 11th Jan 2026',
      '24th Jan 2026 to 25th Jan 2026',
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (1st day) to 7:00 PM (2nd day)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  4: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Healthy Weight Loss & Wellness Retreat',
    key: 'healthy-weightloss-wellness-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'healthy-weightloss-wellness-retreat',
      templateOffline: {
        templateResidential: 'healthy-weightloss-wellness-retreat',
        templateNonResidential: 'healthy-weightloss-wellness-retreat',
      },
    },
    image: "/images/healthyWeighloss.jpg",
    cardImage: "/images/healthyWeighloss.jpg",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    clevertapData: {
      name: 'Aibaug - Heathy Weight Loss',
      courseType: 'Yoga Retreats',
      courseSubType: 'Yoga Retreats',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Yoga Retreats',
      coursePreRequisite: ''
    },
    dates: [
      // '25th Jan 2025 to 26th Jan 2025', 
      // '8th Feb 2025 to 9th Feb 2025', 
      // '15th Mar 2025 to 16th Mar 2025',
      // '29th Mar 2025 to 30th Mar 2025',
      // '12th Apr 2025 to 13th Apr 2025',
      // '26th Apr 2025 to 27th Apr 2025',
      // '17th May 2025 to 18th May 2025',
      // '21th June 2025 to 22th June 2025',
      // '19th July 2025 to 20th July 2025',
      // '16th Aug 2025 to 17th Aug 2025',
      // '20th Sept 2025 to 21th Sept 2025',
      // '18th Oct 2025 to 19th Oct 2025',
      '15th Nov 2025 to 16th Nov 2025',
      '13th Dec 2025 to 14th Dec 2025',
      '27th Dec 2025 to 28th Dec 2025',
      '17th Jan 2026 to 18th Jan 2026',
      '21st Feb 2026 to 22nd Feb 2026',
      '21st Mar 2026 to 22nd Mar 2026',
      '18th Apr 2026 to 19th Apr 2026',
      '16th May 2026 to 17th May 2026',
      '20th Jun 2026 to 21st Jun 2026',
      '18th Jul 2026 to 19th Jul 2026',
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (1st day) to 7:00 PM (2nd day)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  5: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '2-Days Relax & Restore Yoga Retreat',
    key: '2-days-relax-restore-yoga-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: 'GENERAL_AUTO_EMAIL',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    image: "/images/healthyWeighloss.jpg",
    cardImage: "/images/healthyWeighloss.jpg",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 10000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: ['15th Feb 2025 to 16th Feb 2025'
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (15th) to 7:00 PM (16th)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  6: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Senior Citizens Retreat',
    key: 'senior-citizens-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: 'GENERAL_AUTO_EMAIL',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    image: "https://nispand.s3.ap-south-1.amazonaws.com/TYI_Seniorcitizens_Yoga_Retreat+(1).webp",
    cardImage: "https://nispand.s3.ap-south-1.amazonaws.com/TYI_Seniorcitizens_Yoga_Retreat+(1).webp",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 8500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: [
      // '15th Oct 2025 to 16th Oct 2025',
      // '5th Nov 2025 to 6th Nov 2025',
      // '14th Jan 2026 to 15th Jan 2026',

      // '11th Feb 2026 to 12th Feb 2026',

      // '11th Mar 2026 to 12th Mar 2026',

      // '8th Apr 2026 to 9th Apr 2026',

      // '6th May 2026 to 7th May 2026',

      '10th Jun 2026 to 11th Jun 2026',

      '8th Jul 2026 to 9th Jul 2026',
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (15th) to 7:00 PM (16th)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  7: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Midweek Yoga Nature Retreat',
    key: 'midweek-yoga-nature-retreat',
    isRegular: true,
    tenure: '2 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: 'GENERAL_AUTO_EMAIL',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    image: " https://nispand.s3.ap-south-1.amazonaws.com/TYI_Midweek_Yoga_Retreat.webp",
    cardImage: " https://nispand.s3.ap-south-1.amazonaws.com/TYI_Midweek_Yoga_Retreat.webp",
    mostPopular: false,
    metaDescription:
      'Towards the end, there is an enlightening question and answer session. ',
    rating: 5,
    colorCode: '#B77E7E',
    timing: '1 Night, 2 Days',
    fees: {
      onlineFee: 8500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: [
      // '29th Oct 2025 to 30th Oct 2025',
      // '19th Nov 2025 to 20th Nov 2025',
      // '28th Jan 2026 to 29th Jan 2026',

      // '25th Feb 2026 to 26th Feb 2026',

      // '25th Mar 2026 to 26th Mar 2026',

      // '22nd Apr 2026 to 23rd Apr 2026',

      '20th May 2026 to 21st May 2026',

      '24th Jun 2026 to 25th Jun 2026',

      '22nd Jul 2026 to 23rd Jul 2026',
    ],
    online: false,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Night, 2 Days",
      timings: [
        {
          day: "",
          time: "8:00 AM (15th) to 7:00 PM (16th)"
        }
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The Yoga Institute’s Founder, Shri Yogendraji introduced Satsang with an objective for people to come together and find solutions for their worldly problems. It takes place on Sundays and is open to all so that everyone can benefit from the 1-hour session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'The highlighted aspect of Satsang is a discourse by the Spiritual Guru and Director of TYI, Dr. Hansaji whoshares her enlightening wisdom on various topics including health &amp; wellness, relationships, career, food,parenting, family and so on. Through her compassionate and personalized approach, Dr. Hansaji has helped countless individuals overcome their challenges and find greater health and well-being.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'You can get your queries resolved by Dr. Hansaji as she is dedicated to helping you find the support and guidance you need to thrive. She helps people solve their problems by focusing on the root cause of their issues, rather than simply addressing symptoms. She understands that many physical and emotional problems are interconnected and that by addressing the underlying causes, individuals can experience long-term relief.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga is a powerful tool for managing physical, mental and emotional challenges and helping individuals find greater peace and balance in their lives. Satsang helps bring positivity and awareness into our lives. Dr. Hansaji shares profound wisdom of the ancient scriptures and a Yogic way of living which enhances the lives of all the satsangis and is relevant in the present time and age.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Towards the end, there is an enlightening question and answer session.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'About the programme',
          text: [' Every Sunday between 9.30 am and 10.30am'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Prerequisites',
          text: ['The programme is open to all. No age bar.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: 'Registration',
          text: [' free entry - on the spot registration.'],
        },
      },
    ],
  },
  8: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
    key: 'swadhyaya-and-emo-energy-reset-basic-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 19000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "3 weeks Workshop + 1-week Practicum",

      timings: [
        {
          day: "Mon to Fri (online)",
          time: "10 am to 1 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm "
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      courseType: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      courseSubType: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025',
      // 'Nov 10th – Nov 14th 2025 Morning',
      // 'Dec 1st – Dec 5th 2025 Evening',
      //       'Jan 12th - Jan 30th 2026',

      // 'Feb 16th - Mar 7th 2026',


      // 'Dec 8th – Dec 19th 2025',
      'Jun 15th to Jul 3rd 2026',
      'Aug 3rd to Aug 21st 2026',
      'Sep 21st to Oct 9th 2026'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    onlineDates: [
      'Jun 15th to Jul 3rd 2026',
      'Aug 3rd to Aug 21st 2026',
      'Sep 21st to Oct 9th 2026'
    ],
    // offlineDates: [
    //   'May 2nd to May 8th 2026',
    // ],
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  9: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 2 - Higher Diploma in Yoga Psychotherapy & Counselling',
    key: 'higher-diploma-in-yoga-psychotherapy-Counselling',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 45000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 2 - Higher Diploma in Yoga Psychotherapy & Counselling',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 2 - Higher Diploma in Yoga Psychotherapy & Counselling',
      courseType: 'Level 2 - Higher Diploma in Yoga Psychotherapy & Counselling',
      courseSubType: 'Level 2 - Higher Diploma in Yoga Psychotherapy & Counselling',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 2 - Higher Diploma in Yoga Psychotherapy & Counselling',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',

      // 'Jun 13th – Jun 14st 2026',
      // 'Jun 13th - Aug 2nd 2026',
      // 'Jun 20th – Jun 21th 2026',
      // 'Jun 27th – Jun 28st 2026',
      // 'Jul 4th – Jul 5th 2026',
      // 'Jul 11th – Jul 12th 2026',
      // 'Jul 18th – Jul 19th 2026',
      // 'Jul 25th – Jul 26th 2026',
      // 'Aug 1st – Aug 2nd 2026',





      // 'Dec 8th – Dec 19th 2025',
      '9 Jan 2027 to 30 Nov 2027 (DIPLOMA)'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  10: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 - Integral Chakra Psychology (Advanced Module)',
    key: 'integral-chakra-psychology-advanced-module',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 30000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 - Integral Chakra Psychology (Advanced Module)',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "3 weeks Workshop + 1-week Practicum",

      timings: [
        {
          day: "Mon to Fri (online)",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 - Integral Chakra Psychology (Advanced Module)',
      courseType: 'Level 1 - Integral Chakra Psychology (Advanced Module)',
      courseSubType: 'Level 1 - Integral Chakra Psychology (Advanced Module)',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 - Integral Chakra Psychology (Advanced Module)',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // '20 Jun 2025 - 30 Sep 2025',
      // '30 Sep 2025 - 05 Dec 2025',
      // 'Nov 17th – Dec 19th 2025',
      // 'Mar 23rd - Apr 24th 2026',
      'Nov 16th - Dec 18th 2026 (ADVANCE - ICP)'


      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  11: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 - Combined (Basic Module + Advanced Module)',
    key: 'combined-basic-module-advanced-module',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      // Yoga Psychotherapy Programs page shows:
      // - Level 1 (Online) Basic + Advanced: ₹41,000
      // - Level 1 (Offline) Basic + Advanced: ₹43,000
      onlineFee: 41000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 43000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 - Combined (Basic Module + Advanced Module)',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "3 weeks Workshop + 1-week Practicum",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 - Combined (Basic Module + Advanced Module)',
      courseType: 'Level 1 - Combined (Basic Module + Advanced Module)',
      courseSubType: 'Level 1 - Combined (Basic Module + Advanced Module)',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 - Combined (Basic Module + Advanced Module)',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025 - SWA',
      // 'Nov 10th – Nov 14th 2025 - EMO',
      // 'Dec 1st – Dec 5th 2025 - EMO',
      // 'Oct 18th – Oct 19th 2025 - EMO',
      // 'Nov 15th – Nov 16th 2025 - EMO',
      // 'Dec 20th – Dec 21th 2025 - EMO',
      // 'Nov 17th – Dec 19th 2025 - CHA'
      // 'Jan 12th to Jan 30th 2026 (Swadhay + Emo)',

      //  'Feb 16th to Mar 7th 2026 (Swadhay + Emo)'


      // 'Dec 8th – Dec 19th 2025',
      // 'Jun 15th to Jul 3rd 2026 (Swadhay + Emo)',
      'Aug 3rd to Aug 21st 2026 (Swadhay + Emo)',
      'Sep 21st to Oct 9th 2026 (Swadhay + Emo)',
      'Nov 16th to Dec 18th 2026 (ADVANCE - ICP)'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  12: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 & Level 2 - Combined',
    key: 'level-1-and-level-2-combined-online',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 81000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 & Level 2 - Combined',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        },
        {
          day: "Dates are tentative",
          time: ""
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 & Level 2 - Combined',
      courseType: 'Level 1 & Level 2 - Combined',
      courseSubType: 'Level 1 & Level 2 - Combined',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 & Level 2 - Combined',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025 - SWA',
      // 'Nov 10th – Nov 14th 2025 - EMO',
      // 'Dec 1st – Dec 5th 2025 - EMO',
      // 'Oct 18th – Oct 19th 2025 - EMO',
      // 'Nov 15th – Nov 16th 2025 - EMO',
      // 'Dec 20th – Dec 21th 2025 - EMO',
      // 'Nov 17th – Dec 19th 2025 - CHA',
      // 'Jan 10th – Jan 11th 2026',
      // 'Jan 17th – Jan 18th 2026',
      // 'Jan 24th – Jan 25th 2026',
      // 'Jan 31th – Feb 1st 2026',
      // 'Feb 07th – Feb 08th 2026',
      // 'Feb 14th – Feb 15th 2026',
      // 'Feb 21th – Feb 22th 2026',
      // 'Feb 28th – Mar 1st 2026',
      // 'Mar 23rd - Apr 24th 2026 (Integral Chakra)',
      //  'Jun 15th - Jul 3rd 2026 (Swadhay + Emo)',



      // 'Jun 13th – Jun 14st 2026',
      // 'Jun 20th – Jun 21th 2026',
      // 'Jun 27th – Jun 28st 2026',
      // 'Jul 4th – Jul 5th 2026',
      // 'Jul 11th – Jul 12th 2026',
      // 'Jul 18th – Jul 19th 2026',
      // 'Jul 25th – Jul 26th 2026',
      // 'Aug 1st – Aug 2nd 2026',
      //   'Aug 3rd - Aug 21st 2026 (Swadhay + Emo)',
      // 'Sep 21st - Oct 9th 2026 (Swadhay + Emo)',
      // 'Nov 16th - Dec 18th 2026 (Integral Chakra)',


      // 'Dec 8th – Dec 19th 2025',
      // '15 June to 3 July 2026 (EMO & SWADHYAY)',
      '3 Aug to 21 Aug 2026 (EMO & SWADHYAY)',
      '21 Sept to 9 Oct 2026 (EMO & SWADHYAY)',
      '16 Nov to 18 Dec 2026 (ADVANCE - ICP)',
      '9 Jan 2027 to 30 Nov 2027 (DIPLOMA)'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  13: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Single Consultation',
    key: 'single-consultation',
    confirmNextNote:
      'Appointment day and timings will be confirmed after you have registered for the counselling session.\n' +
      'You may give your preferred day and timings and we will try to do our best to fulfill that.\n' +
      'However, kindly note that the average period for getting an appointment is 2-3 days',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 3000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Single Consultation',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "",

      timings: [
        {
          day: "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
          time: "Flexible scheduling available"
        },
        // {
        //   day: "",
        //   time: "5.30 pm to 8.30 pm"
        // }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Single Consultation',
      courseType: 'Single Consultation',
      courseSubType: 'Single Consultation',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Single Consultation',
      coursePreRequisite: ''
    },
    dates: [
      '09:00 AM - 10:00 AM',
      '10:00 AM - 11:00 AM',
      '11:00 AM - 12:00 PM',
      '12:00 PM - 1:00 PM',
      '1:00 PM - 2:00 PM',
      '2:00 PM - 3:00 PM',
      '3:00 PM - 4:00 PM',
      '4:00 PM - 5:00 PM',
      '5:00 PM - 6:00 PM'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  14: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Extended Consultation',
    key: 'extended-consultation',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 7500,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Extended Consultation',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "",

      timings: [
        {
          day: "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
          time: "Flexible scheduling available"
        },
        // {
        //   day: "",
        //   time: "5.30 pm to 8.30 pm"
        // }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Extended Consultation',
      courseType: 'Extended Consultation',
      courseSubType: 'Extended Consultation',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Extended Consultation',
      coursePreRequisite: ''
    },
    dates: [
      '9:00 AM - 10:00 AM',
      '10:00 AM - 11:00 AM',
      '11:00 AM - 12:00 PM',
      '12:00 PM - 1:00 PM',
      '1:00 PM - 2:00 PM',
      '2:00 PM - 3:00 PM',
      '3:00 PM - 4:00 PM',
      '4:00 PM - 5:00 PM',
      '5:00 PM - 6:00 PM'
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  15: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'IBY Course MA',
    key: 'iby-course-ma',
    // isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${baseDomain}${iybCourse.mainImage}`,
    cardImage: `${baseDomain}${iybCourse.mainImage}`,
    mostPopular: false,
    language: 'English, Hindi',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 40000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 40000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'IBY Course MA',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "2 Years (4 semesters)",

      timings: [
        {
          day: "Monday, Wednesday, Friday & Saturday",
          time: "3pm to 8pm"
        },
        // {
        //   day: "",
        //   time: "5.30 pm to 8.30 pm"
        // }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'IBY Course MA',
      courseType: 'IBY Course MA',
      courseSubType: 'IBY Course MA',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'IBY Course MA',
      coursePreRequisite: ''
    },
    dates: [
      'Dec 2024 - Feb 2025',
      'Mar 2025 - Feb 2026'
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  16: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'IBY Course BA',
    key: 'iby-course-ba',
    // isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${baseDomain}${iybCourse.mainImage}`,
    cardImage: `${baseDomain}${iybCourse.mainImage}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 33000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 33000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'IBY Course BA',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "4 years (8 semesters)",

      timings: [
        {
          day: "Monday - Friday",
          time: "10am to 2.30pm"
        },
        // {
        //   day: "",
        //   time: "5.30 pm to 8.30 pm"
        // }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'IBY Course BA',
      courseType: 'IBY Course BA',
      courseSubType: 'IBY Course BA',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'IBY Course BA',
      coursePreRequisite: ''
    },
    dates: [
      'Dec 2024 - Feb 2025',
      'Mar 2025 - Feb 2026'
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  17: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
    key: 'swadhyaya-and-emo-energy-reset-basic-offline',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 25000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "1 week",

      timings: [
        {
          day: "May 2nd (Sat) to 8th (Fri) ",
          time: "9:00am to 8:00pm"
        },


        // {
        //   day: "",
        //   time: "5.30 pm to 8.30 pm"
        // }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      courseType: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      courseSubType: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 - Swadhyaya & Emo-Energy Reset (Basic Moudle)',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025',
      // 'Nov 10th – Nov 14th 2025 Morning',
      // 'Dec 1st – Dec 5th 2025 Evening',
      //       'Jan 12th - Jan 30th 2026',

      // 'Feb 16th - Mar 7th 2026',


      // 'Dec 8th – Dec 19th 2025',
      // 'Jun 15th to Jul 3rd 2026',
      // 'Aug 3rd to Aug 21st 2026',
      // 'Sep 21st to Oct 9th 2026'
      // 'May 2nd to May 8th 2026',
      'Oct 24th to Oct 30th'
    ],
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    // onlineDates: [
    //   'Jun 15th to Jul 3rd 2026',
    //   'Aug 3rd to Aug 21st 2026',
    //   'Sep 21st to Oct 9th 2026'
    // ],
    offlineDates: [
      'May 2nd to May 8th 2026',
    ],
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  18: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 & Level 2 - Combined',
    key: 'level-1-and-level-2-combined-offline',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 87000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 & Level 2 - Combined',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        },
        {
          day: "Dates are tentative",
          time: ""
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 & Level 2 - Combined',
      courseType: 'Level 1 & Level 2 - Combined',
      courseSubType: 'Level 1 & Level 2 - Combined',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 & Level 2 - Combined',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025 - SWA',
      // 'Nov 10th – Nov 14th 2025 - EMO',
      // 'Dec 1st – Dec 5th 2025 - EMO',
      // 'Oct 18th – Oct 19th 2025 - EMO',
      // 'Nov 15th – Nov 16th 2025 - EMO',
      // 'Dec 20th – Dec 21th 2025 - EMO',
      // 'Nov 17th – Dec 19th 2025 - CHA',
      // 'Jan 10th – Jan 11th 2026',
      // 'Jan 17th – Jan 18th 2026',
      // 'Jan 24th – Jan 25th 2026',
      // 'Jan 31th – Feb 1st 2026',
      // 'Feb 07th – Feb 08th 2026',
      // 'Feb 14th – Feb 15th 2026',
      // 'Feb 21th – Feb 22th 2026',
      // 'Feb 28th – Mar 1st 2026',
      // 'Mar 23rd - Apr 24th 2026 (Integral Chakra)',

      // 'May 2nd - May 8th 2026 (Swadhay + Emo)',
      // 'Jun 13th – Jun 14st 2026',
      // 'Jun 20th – Jun 21th 2026',
      // 'Jun 27th – Jun 28st 2026',
      // 'Jul 4th – Jul 5th 2026',
      // 'Jul 11th – Jul 12th 2026',
      // 'Jul 18th – Jul 19th 2026',
      // 'Jul 25th – Jul 26th 2026',
      // 'Aug 1st – Aug 2nd 2026',
      // 'Nov 16th - Dec 18th 2026 (Integral Chakra)',


      // 'Dec 8th – Dec 19th 2025',
      '24 Oct to 30 oct 2026 (EMO &  SWADHYAY)',
      '16 nov to 18 dec 2026 (ADVANCE - ICP)',
      '9 Jan 2027 to 30 Nov 2027 (DIPLOMA)'
    ],
    online: false,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  19: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '150 Hours Yoga Therapy Certificate Course',
    key: '150-hours-yoga-therapy-certificate-course',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 41000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 41000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: '150 Hours Yoga Therapy Certificate Course',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "4 months",

      timings: [
        {
          day: "Monday, Wednesday, Friday",
          time: "5:30 pm to 7:30 pm (IST)"
        },

      ]
    },
    category: 'classes',
    clevertapData: {
      name: '150 Hours Yoga Therapy Certificate Course',
      courseType: '150 Hours Yoga Therapy Certificate Course',
      courseSubType: '150 Hours Yoga Therapy Certificate Course',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: '150 Hours Yoga Therapy Certificate Course',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025 - SWA',
      // 'Nov 10th – Nov 14th 2025 - EMO',
      // 'Dec 1st – Dec 5th 2025 - EMO',
      // 'Oct 18th – Oct 19th 2025 - EMO',
      // 'Nov 15th – Nov 16th 2025 - EMO',
      // 'Dec 20th – Dec 21th 2025 - EMO',
      // 'Nov 17th – Dec 19th 2025 - CHA',
      // 'Jan 10th – Jan 11th 2026',
      // 'Jan 17th – Jan 18th 2026',
      // 'Jan 24th – Jan 25th 2026',
      // 'Jan 31th – Feb 1st 2026',
      // 'Feb 07th – Feb 08th 2026',
      // 'Feb 14th – Feb 15th 2026',
      // 'Feb 21th – Feb 22th 2026',
      // 'Feb 28th – Mar 1st 2026',
      // '4th May - 26th Aug 2026',
      '31st Aug - 23rd Dec 2026'


      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  20: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: '300 Hours Yoga Therapy Certificate Course',
    key: '300-hours-yoga-therapy-certificate-course',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      onlineFee: 51000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 51000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: '300 Hours Yoga Therapy Certificate Course',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "4 months",

      timings: [
        {
          day: "Monday, Wednesday, Friday",
          time: "5:30 pm to 7:30 pm (IST)"
        },

      ]
    },
    category: 'classes',
    clevertapData: {
      name: '300 Hours Yoga Therapy Certificate Course',
      courseType: '300 Hours Yoga Therapy Certificate Course',
      courseSubType: '300 Hours Yoga Therapy Certificate Course',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: '300 Hours Yoga Therapy Certificate Course',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025 - SWA',
      // 'Nov 10th – Nov 14th 2025 - EMO',
      // 'Dec 1st – Dec 5th 2025 - EMO',
      // 'Oct 18th – Oct 19th 2025 - EMO',
      // 'Nov 15th – Nov 16th 2025 - EMO',
      // 'Dec 20th – Dec 21th 2025 - EMO',
      // 'Nov 17th – Dec 19th 2025 - CHA',
      // 'Jan 10th – Jan 11th 2026',
      // 'Jan 17th – Jan 18th 2026',
      // 'Jan 24th – Jan 25th 2026',
      // 'Jan 31th – Feb 1st 2026',
      // 'Feb 07th – Feb 08th 2026',
      // 'Feb 14th – Feb 15th 2026',
      // 'Feb 21th – Feb 22th 2026',
      // 'Feb 28th – Mar 1st 2026',
      // '4th May - 26th Aug 2026',
      '31st Aug - 23rd Dec 2026'


      // 'Dec 8th – Dec 19th 2025',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
  21: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Level 1 - Combined (Basic Module + Advanced Module)',
    key: 'combined-basic-module-advanced-module-offline',
    isRegular: true,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: 'GENERAL_AUTO_EMAIL',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: 'GENERAL_AUTO_EMAIL',
      },
    },
    // image: `${baseDomain}${courseAssets.courseAssets115}`,
    // cardImage: `${baseDomain}${courseAssets.courseAssets115}`,
    image: `${level1}`,
    cardImage: `${level1}`,
    mostPopular: false,
    language: 'English',
    metaDescription:
      'A Pathway to Inner Balance and Holistic Well-being ',
    rating: 5,
    colorCode: '#C48E8C',
    timing: 'Flexible scheduling available',
    fees: {
      // Yoga Psychotherapy Programs page shows:
      // - Level 1 (Online) Basic + Advanced: ₹41,000
      // - Level 1 (Offline) Basic + Advanced: ₹43,000
      onlineFee: 47000,
      offlineFee: { residentialFee: 0, nonResidentialFee: 47000 },
      // internationalFee: { residentialFee: 0, nonResidentialFee: 329837 },
    },
    newName: 'Level 1 - Combined (Basic Module + Advanced Module)',
    days: [
      ''
    ],
    time: [
      'Flexible scheduling available',
    ],

    enrollInfo: {
      duration: "3 weeks Workshop + 1-week Practicum",

      timings: [
        {
          day: "",
          time: "10.00 am to 1.00 pm"
        },
        {
          day: "",
          time: "5.30 pm to 8.30 pm"
        }
      ]
    },
    category: 'classes',
    clevertapData: {
      name: 'Level 1 - Combined (Basic Module + Advanced Module)',
      courseType: 'Level 1 - Combined (Basic Module + Advanced Module)',
      courseSubType: 'Level 1 - Combined (Basic Module + Advanced Module)',
      courseCategory: 'Self Help',
      courseCertificate: 'NO',
      courseTopCategory: 'Level 1 - Combined (Basic Module + Advanced Module)',
      coursePreRequisite: ''
    },
    dates: [
      // 'June 9th – June 20th 2025',
      // 'June 30th - July 11th 2025',
      // 'Oct 6th – Oct 17th 2025',
      // 'Oct 27th – Nov 7th 2025 - SWA',
      // 'Nov 10th – Nov 14th 2025 - EMO',
      // 'Dec 1st – Dec 5th 2025 - EMO',
      // 'Oct 18th – Oct 19th 2025 - EMO',
      // 'Nov 15th – Nov 16th 2025 - EMO',
      // 'Dec 20th – Dec 21th 2025 - EMO',
      // 'Nov 17th – Dec 19th 2025 - CHA'
      // 'Jan 12th to Jan 30th 2026 (Swadhay + Emo)',

      //  'Feb 16th to Mar 7th 2026 (Swadhay + Emo)'


      // 'Dec 8th – Dec 19th 2025',
      'Oct 24th to Oct 30th 2026 (Swadhay + Emo)',
      'Nov 16th – Dec 18th 2026 (ADVANCE - ICP)',
    ],
    online: true,
    onCampus: false,
    nonResidential: false,
    residential: false,
    certficate: false,
    details: [
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '',
      //     text: ['Our external circumstances often reflect our internal state. Recognizing that creation happens at the thought level allows us to understand the roots of stress, anxiety, and emotional turmoil. Yogic Counselling helps individuals dismantle these negative patterns through self-inquiry (Swadhyaya), energy rebalancing, and practical psychological tools—all aimed at realigning the mind, body, and spirit.     ',
      //     'It is hence only when we have healed ourselves through the Yoga Psychotherapy   Program, that are we then in a position to heal others. The Higher Diploma Program in Yoga Counselling is thus a culmination of the rigor (Tapa) that a student has so far put oneself through, on the journey of Self-Empowerment.   ',
      //     'This is also the practical part of working towards developing Effective   Communications and Leadership Qualities which put us in a better position to contribute towards the healing of others. This program is thus applicable not only for counsellors, but also for parents, teachers, friends or even simple well-wishers.  ',
      //     'The Need for Yoga Teachers to Be Trained in Counselling Skills: There is presently a lot of stigma and hence a taboo associated with Mental Health and its awareness. A majority of the population, hence is usually unaware of their   mental health. Even if aware of some emotional health issue, they find it difficult to approach a counsellor or a psychiatrist to seek help due the anxiety of being labelled as ‘insane.’  ',
      //       'A yoga teacher is hence in the best position to make yoga students not only aware of their emotional issues, but also to help them feel comfortable speaking about it and if possible, see a way to come out of it.  '


      //     ],
      //   },
      // },
      // {
      //   type: 'paragraph',
      //   content: {
      //     title: 'THE PROGRAM:    ',
      //     text: ['This Diploma Program integrates the best of Contemporary Psychology with the present-day application of the Eastern World View. The program has been divided in two parts;       ',


      //     ],
      //   },
      // },

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           '2 Contact Sessions and     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           '2 Non-Contact Sessions  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Contact Training -    ',
      //     text: ['The program will begin with the first contact session where students will be attending the Online. These sessions will be held over a period of 8 weekends (16 sessions) and will include;         ',


      //     ],
      //   },
      // },  

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Introduction to the concept of Counselling and types of counselling       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Counselling with respect to the Koshas   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Studying the Carkhuff model of Client Oriented Therapy   ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding importance of Attitude training in counseling  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Practicing the skills of case taking  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Developing leadership qualities that include good communication skills and the ability to motivate others  ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Orientation to the assignments that have to be completed during the 1st non-contact session period.  ',
      //         subItems: [],
      //       },

      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '1st Non-Contact Training –    ',
      //     text: ['In this period, the student will have to complete assignments that provide a practical training to the learnings obtained from the 1st contact training. The duration of this non-contact training will be for 3 months, during which include completion of certain assignments and some field work. There will however be sessions with mentors appointed for guidance in case of any doubts or difficulties. The assignments to be completed include;           ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Completing 1st 10 of the 20 interviews         ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Initiating a social project    ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Submitting the interviews and the project report that includes your learnings from the personal experience of completing the assignments.    ',
      //         subItems: [],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Contact Training –      ',
      //     text: ['This again includes online sessions for another 8 weekends (16 sessions). The purpose of these sessions will be to learn the associated skills and have a comprehensive knowledge that would be necessary for being a successful counsellor. This training will include sessions on;             ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: '',
      //     points: [
      //       {
      //         listItem:
      //           'Fine tuning - Goal Setting and Goal Steps          ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'History of Contemporary Psychology and Counseling      ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Neurotic Vs Psychotic conditions and scope of counseling     ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Learning Disorders – Autism, ADHD, Dyslexia            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Common Psychological Assessment tests       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Introduction to other Counseling Techniques (TA, NLP, Hypnosis, EFT)       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Understanding the Yoga perspective       ',
      //         subItems: ['About the mind,  ', 'The causes of limitations of the mind  ', 'Different techniques offered in Yoga, to work on the mind  ', 'Different types of meditations   ', 'Going beyond the mind', 'Powers of our mind   ', 'States and experiences beyond the mind, etc.  ', 'Congruence & Saṃyama  '],
      //       },


      //     ],
      //   },
      // },

      // {
      //   type: 'paragraph',
      //   content: {
      //     title: '2nd Non-Contact Training       ',
      //     text: ['This will form the second part of assignments, wherein the student will have to complete the remaining 10 interviews and 20 counselling cases in a prescribed format of counseling. Support and guidance from the mentors will however be available again in case of any doubts or difficulties. Students will be allowed to attend and observe live counseling sessions at the institute or other venues available. A period of maximum 3 months will be granted to the students to complete these assignments and submit the completed case papers.              ',


      //     ],
      //   },
      // },    

      // {
      //   type: 'u-list',
      //   content: {
      //     title: 'Eligibility:  ',
      //     points: [
      //       {
      //         listItem:
      //           'To join the Program - Completion of Yoga Psychotherapy Program            ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'For receiving the Higher Diploma        ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'At least a Basic TTC (200 hours) certificate from TYI (if the student has received the TTC certificate from any other Yoga school (other than TYI), then they need to attend either of the two programs at TYI;       ',
      //         subItems: ['21 day Better Living Program  ', '7-day residential program  '],
      //       },
      //       {
      //         listItem:
      //           'Assistant Yoga Psychotherapist Certificate              ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Minimum 80% attendance       ',
      //         subItems: [],
      //       },
      //       {
      //         listItem:
      //           'Completion of all the assignments        ',
      //         subItems: ['20 interviews  ', '20 counselling cases  ', 'Submission of social project  '],
      //       },



      //     ],
      //   },
      // },

    ],
  },
}

const specialEvents = {
  1: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Full moon meditation',
    key: 'fullmoon-meditation',
    isRegular: false,
    tenure: '1 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: '',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${homeAssets.homeAsset14}`,
    cardImage: `${homeAssets.fullmoonCard}`,//${baseDomain}
    mostPopular: false,
    metaDescription:
      'Harness the full moon’s energy with our free meditation event/session. ',
    rating: 5,
    colorCode: '#DDAB58',
    timing: '',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: [
      // '12th Feb 2025',
      // '13th Mar 2025',
      // '13th Apr 2025',
      // '12th Apr 2025',
      // '12th May 2025',
      //  '11th Jun 2025',
      //  '10th Jul 2025', 
      //  '9th Aug 2025', 
      //  '7th Sept 2025',
      // '6th Oct 2025', 
      // '5th Nov 2025', 
      // '3rd Jan 2026'
      // '1st Feb 2026',
      // '3rd Feb 2026',

      // '2nd Mar 2026',

      // '2nd Apr 2026',

      //  '1st May 2026',
      // '30th May 2026',
      '29th Jun 2026',

      '29th Jul 2026',

      '28th Aug 2026',


    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Day",
      timings: [
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Looking to reign in your rampant thoughts and mood swings and train your mental faculties to be more efficient and peaceful? Then, join us every full moon day to sit under the celestial glow and do meditation.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Since the beginning of civilization humans have been fascinated with our nearest celestial neighbour – Moon. It has found its place in children’s stories, lovers’ stories, mystical arts, and much more. And it is not without reason. Moon has the power to influence our thoughts and our rhythms. Under its soothing and calming light ancient gurus sat down to meditate and mull over the intricacies of life and gave us philosophies that we follow even to this day.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'However, in the hustle-bustle of today’s life and because of rising city skylines, we seldom get exposed to this enriching source of energy. On every full moon day, we at the Yoga Institute sit under this divine light to meditate and find balance and alignment under the heaven’s celestial glow! Unburden yourself by joining us for practicing meditation on full moon nights and feel your stress and worries melting away under the soft cool night breeze. Let the moon help you relax and rejuvenate your mind and body.',
          ],
        },
      },

    ],
  },
  2: {
    id: '',
    textdescription6: '',
    textdescription7: '',
    textdescription8: '',
    textdescription9: '',
    textdescription10: '',
    textdescription1: '',
    textdescription2: '',
    textdescription3: '',
    textdescription4: '',
    textdescription5: '',
    title: 'Yoga By The Bay',
    key: 'yoga-by-the-bay',
    isRegular: false,
    tenure: '1 day',
    weekends: false,
    batch: 1,
    // templateId: 'GENERAL_AUTO_EMAIL',
    templateId: {
      templateOnline: '',
      templateOffline: {
        templateResidential: '',
        templateNonResidential: '',
      },
    },
    image: `${baseDomain}${homeAssets.homeAsset12}`,
    cardImage: `${baseDomain}${homeAssets.homeAsset12}`,
    mostPopular: false,
    metaDescription:
      'Experience refreshing yoga by the bay—free, open, and rejuvenating!',
    rating: 5,
    colorCode: '#DDAB58',
    timing: '',
    fees: {
      onlineFee: 0,
      offlineFee: { residentialFee: 0, nonResidentialFee: 0 },
    },
    category: 'classes',
    dates: [
      '26th April 2026',
      '31st May 2026',
      '28th June 2026',
      '26th July 2026',
      '30th August 2026',
    ],
    online: true,
    onCampus: true,
    nonResidential: true,
    residential: false,
    certficate: false,
    newName: '',
    enrollInfo: {
      duration: "1 Day",
      timings: [
      ]
    },
    details: [
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Meditating alone is beneficial but meditating and practicing yoga as part of a group can impress upon the psyche in ways unimaginable. Join us to be part of this profound experience called Yoga by the Bay.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Yoga and the sea are two things that bring immense joy, calm, and relaxation to the human body. Imagine the effect and the impact two of them will have when they come together. Yoga by the Bay is one such initiative where we practice the yogic way of life immersed in the mesmerising symphony of the crashing sea waves, chirping birds, and whistling winds.'],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Come out with us and give your practice a new dimension. Let your being become one with the vastness of the divine. Experience true peace in the throbbing heart of Mumbai along with hundreds of seekers.',
          ],
        },
      },
      {
        type: 'paragraph',
        content: {
          title: '',
          text: [
            'Meet us opposite the ‘Pizza by the Bay – Marine Lines’ restaurant and be part of this profound experience.',
          ],
        },
      },

    ],
  }
}

export const c200hr = Object.values(ttc200hr)
export const c500hr = Object.values(ttc500hr)
export const c900hr = Object.values(ttc900hr)
export const campsArr = Object.values(camps)
export const classesArr = Object.values(classes)
export const extraArr = Object.values(extra)
export const certificateArr = Object.values(certificate)
export const alibaugArr = Object.values(alibaug)
export const sepecialEventArr = Object.values(specialEvents)
export const AllCourses = [
  ...certificateArr,
  ...extraArr,
  ...c200hr,
  ...c500hr,
  ...c900hr,
  ...campsArr,
  ...classesArr,
  ...sepecialEventArr
]
export const mostPopular = [
  extraArr[0], c200hr[4], c500hr[0],
  ...certificateArr,
  extraArr.shift(),
  ...c200hr,
  c200hr.slice(0, 4),  // Get elements before index 4
  c200hr.slice(5),
  ...c900hr,
  ...campsArr,
  ...classesArr,
]